export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Cursor: any;
  Datetime: any;
  JSON: any;
  UUID: any;
};

/** All input for the `addUserStoryTerms` mutation. */
export type GqlAddUserStoryTermsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  story?: InputMaybe<Scalars['Int']>;
  terms?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `addUserStoryTerms` mutation. */
export type GqlAddUserStoryTermsPayload = {
  __typename?: 'AddUserStoryTermsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToProducts: Maybe<Array<Maybe<GqlTermToProduct>>>;
};

export type GqlAssocHome = {
  __typename?: 'AssocHome';
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  /** Reads a single `Organization` that is related to this `AssocHome`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  type: SectionLayoutType;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `AssocHome` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlAssocHomeCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SectionLayoutType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AssocHome` object types. All fields are combined with a logical ‘and.’ */
export type GqlAssocHomeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlAssocHomeFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlAssocHomeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlAssocHomeFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlSectionLayoutTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `AssocHome` */
export type GqlAssocHomeInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  order: Scalars['Int'];
  organizationId: Scalars['UUID'];
  type: SectionLayoutType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `AssocHome`. Fields that are set will be updated. */
export type GqlAssocHomePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<SectionLayoutType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `AssocHome` values. */
export type GqlAssocHomesConnection = {
  __typename?: 'AssocHomesConnection';
  /** A list of edges which contains the `AssocHome` and cursor to aid in pagination. */
  edges: Array<GqlAssocHomesEdge>;
  /** A list of `AssocHome` objects. */
  nodes: Array<Maybe<GqlAssocHome>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `AssocHome` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AssocHome` edge in the connection. */
export type GqlAssocHomesEdge = {
  __typename?: 'AssocHomesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AssocHome` at the end of the edge. */
  node: Maybe<GqlAssocHome>;
};

/** Methods to use when ordering `AssocHome`. */
export enum AssocHomesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlAssocSection = GqlNode & {
  __typename?: 'AssocSection';
  /** Reads a single `Organization` that is related to this `AssocSection`. */
  association: Maybe<GqlOrganization>;
  associationId: Scalars['UUID'];
  createdAt: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `ProductToAssocSection`. */
  productToAssocSections: Array<GqlProductToAssocSection>;
  /** Reads and enables pagination through a set of `ProductToAssocSection`. */
  productToAssocSectionsConnection: GqlProductToAssocSectionsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToAssocSectionAssocSectionIdAndProductId: GqlAssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToAssocSectionAssocSectionIdAndProductIdList: Array<GqlProduct>;
  subtitle: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Maybe<Scalars['Datetime']>;
};


export type GqlAssocSectionProductToAssocSectionsArgs = {
  condition: InputMaybe<GqlProductToAssocSectionCondition>;
  filter: InputMaybe<GqlProductToAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};


export type GqlAssocSectionProductToAssocSectionsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToAssocSectionCondition>;
  filter: InputMaybe<GqlProductToAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};


export type GqlAssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlAssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};

/**
 * A condition to be used against `AssocSection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlAssocSectionCondition = {
  /** Checks for equality with the object’s `associationId` field. */
  associationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `subtitle` field. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AssocSection` object types. All fields are combined with a logical ‘and.’ */
export type GqlAssocSectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlAssocSectionFilter>>;
  /** Filter by the object’s `associationId` field. */
  associationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlAssocSectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlAssocSectionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `subtitle` field. */
  subtitle?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `AssocSection` */
export type GqlAssocSectionInput = {
  associationId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `AssocSection`. Fields that are set will be updated. */
export type GqlAssocSectionPatch = {
  associationId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Product` values, with data from `ProductToAssocSection`. */
export type GqlAssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdManyToManyConnection = {
  __typename?: 'AssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToAssocSection`, and the cursor to aid in pagination. */
  edges: Array<GqlAssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToAssocSection`. */
export type GqlAssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdManyToManyEdge = {
  __typename?: 'AssocSectionProductsByProductToAssocSectionAssocSectionIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  order: Maybe<Scalars['Int']>;
};

/** A connection to a list of `AssocSection` values. */
export type GqlAssocSectionsConnection = {
  __typename?: 'AssocSectionsConnection';
  /** A list of edges which contains the `AssocSection` and cursor to aid in pagination. */
  edges: Array<GqlAssocSectionsEdge>;
  /** A list of `AssocSection` objects. */
  nodes: Array<Maybe<GqlAssocSection>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `AssocSection` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AssocSection` edge in the connection. */
export type GqlAssocSectionsEdge = {
  __typename?: 'AssocSectionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AssocSection` at the end of the edge. */
  node: Maybe<GqlAssocSection>;
};

/** Methods to use when ordering `AssocSection`. */
export enum AssocSectionsOrderBy {
  AssociationIdAsc = 'ASSOCIATION_ID_ASC',
  AssociationIdDesc = 'ASSOCIATION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubtitleAsc = 'SUBTITLE_ASC',
  SubtitleDesc = 'SUBTITLE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlAssociationToOrganization = GqlNode & {
  __typename?: 'AssociationToOrganization';
  appMetadata: Scalars['JSON'];
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  association: Maybe<GqlOrganization>;
  associationId: Scalars['UUID'];
  createdAt: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  status: Maybe<MemberStatus>;
  updatedAt: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `AssociationToOrganization` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type GqlAssociationToOrganizationCondition = {
  /** Checks for equality with the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `associationId` field. */
  associationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MemberStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `AssociationToOrganization` object types. All fields are combined with a logical ‘and.’ */
export type GqlAssociationToOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlAssociationToOrganizationFilter>>;
  /** Filter by the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `associationId` field. */
  associationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlAssociationToOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlAssociationToOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlMemberStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `AssociationToOrganization` */
export type GqlAssociationToOrganizationInput = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  associationId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  organizationId: Scalars['UUID'];
  status?: InputMaybe<MemberStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `AssociationToOrganization`. Fields that are set will be updated. */
export type GqlAssociationToOrganizationPatch = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  associationId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<MemberStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `AssociationToOrganization` values. */
export type GqlAssociationToOrganizationsConnection = {
  __typename?: 'AssociationToOrganizationsConnection';
  /** A list of edges which contains the `AssociationToOrganization` and cursor to aid in pagination. */
  edges: Array<GqlAssociationToOrganizationsEdge>;
  /** A list of `AssociationToOrganization` objects. */
  nodes: Array<Maybe<GqlAssociationToOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `AssociationToOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AssociationToOrganization` edge in the connection. */
export type GqlAssociationToOrganizationsEdge = {
  __typename?: 'AssociationToOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AssociationToOrganization` at the end of the edge. */
  node: Maybe<GqlAssociationToOrganization>;
};

/** Methods to use when ordering `AssociationToOrganization`. */
export enum AssociationToOrganizationsOrderBy {
  AppMetadataAsc = 'APP_METADATA_ASC',
  AppMetadataDesc = 'APP_METADATA_DESC',
  AssociationIdAsc = 'ASSOCIATION_ID_ASC',
  AssociationIdDesc = 'ASSOCIATION_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlAwardBadge = {
  __typename?: 'AwardBadge';
  id: Scalars['Int'];
  logo: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `ProductToAwardBadge`. */
  productToAwardBadges: Array<GqlProductToAwardBadge>;
  /** Reads and enables pagination through a set of `ProductToAwardBadge`. */
  productToAwardBadgesConnection: GqlProductToAwardBadgesConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToAwardBadgeAwardBadgeIdAndProductId: GqlAwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToAwardBadgeAwardBadgeIdAndProductIdList: Array<GqlProduct>;
  slug: Scalars['String'];
};


export type GqlAwardBadgeProductToAwardBadgesArgs = {
  condition: InputMaybe<GqlProductToAwardBadgeCondition>;
  filter: InputMaybe<GqlProductToAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};


export type GqlAwardBadgeProductToAwardBadgesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToAwardBadgeCondition>;
  filter: InputMaybe<GqlProductToAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};


export type GqlAwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlAwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};

/**
 * A condition to be used against `AwardBadge` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlAwardBadgeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `logo` field. */
  logo?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `AwardBadge` object types. All fields are combined with a logical ‘and.’ */
export type GqlAwardBadgeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlAwardBadgeFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlAwardBadgeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlAwardBadgeFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
};

/** An input for mutations affecting `AwardBadge` */
export type GqlAwardBadgeInput = {
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** Represents an update to a `AwardBadge`. Fields that are set will be updated. */
export type GqlAwardBadgePatch = {
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Product` values, with data from `ProductToAwardBadge`. */
export type GqlAwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdManyToManyConnection = {
  __typename?: 'AwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToAwardBadge`, and the cursor to aid in pagination. */
  edges: Array<GqlAwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToAwardBadge`. */
export type GqlAwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdManyToManyEdge = {
  __typename?: 'AwardBadgeProductsByProductToAwardBadgeAwardBadgeIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `AwardBadge` values. */
export type GqlAwardBadgesConnection = {
  __typename?: 'AwardBadgesConnection';
  /** A list of edges which contains the `AwardBadge` and cursor to aid in pagination. */
  edges: Array<GqlAwardBadgesEdge>;
  /** A list of `AwardBadge` objects. */
  nodes: Array<Maybe<GqlAwardBadge>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `AwardBadge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AwardBadge` edge in the connection. */
export type GqlAwardBadgesEdge = {
  __typename?: 'AwardBadgesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AwardBadge` at the end of the edge. */
  node: Maybe<GqlAwardBadge>;
};

/** Methods to use when ordering `AwardBadge`. */
export enum AwardBadgesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LogoAsc = 'LOGO_ASC',
  LogoDesc = 'LOGO_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

export type GqlBestFor = GqlNode & {
  __typename?: 'BestFor';
  /** Reads and enables pagination through a set of `BestForToProduct`. */
  bestForToProducts: Array<GqlBestForToProduct>;
  /** Reads and enables pagination through a set of `BestForToProduct`. */
  bestForToProductsConnection: GqlBestForToProductsConnection;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Product`. */
  productsByBestForToProductBestForIdAndProductId: GqlBestForProductsByBestForToProductBestForIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByBestForToProductBestForIdAndProductIdList: Array<GqlProduct>;
  slug: Scalars['String'];
};


export type GqlBestForBestForToProductsArgs = {
  condition: InputMaybe<GqlBestForToProductCondition>;
  filter: InputMaybe<GqlBestForToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<BestForToProductsOrderBy>>;
};


export type GqlBestForBestForToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlBestForToProductCondition>;
  filter: InputMaybe<GqlBestForToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};


export type GqlBestForProductsByBestForToProductBestForIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlBestForProductsByBestForToProductBestForIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};

/** A condition to be used against `BestFor` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlBestForCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `BestFor` object types. All fields are combined with a logical ‘and.’ */
export type GqlBestForFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlBestForFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlBestForFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlBestForFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
};

/** An input for mutations affecting `BestFor` */
export type GqlBestForInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  slug: Scalars['String'];
};

/** Represents an update to a `BestFor`. Fields that are set will be updated. */
export type GqlBestForPatch = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Product` values, with data from `BestForToProduct`. */
export type GqlBestForProductsByBestForToProductBestForIdAndProductIdManyToManyConnection = {
  __typename?: 'BestForProductsByBestForToProductBestForIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `BestForToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlBestForProductsByBestForToProductBestForIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `BestForToProduct`. */
export type GqlBestForProductsByBestForToProductBestForIdAndProductIdManyToManyEdge = {
  __typename?: 'BestForProductsByBestForToProductBestForIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

export type GqlBestForToProduct = GqlNode & {
  __typename?: 'BestForToProduct';
  /** Reads a single `BestFor` that is related to this `BestForToProduct`. */
  bestFor: Maybe<GqlBestFor>;
  bestForId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `BestForToProduct`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `BestForToProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlBestForToProductCondition = {
  /** Checks for equality with the object’s `bestForId` field. */
  bestForId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `BestForToProduct` object types. All fields are combined with a logical ‘and.’ */
export type GqlBestForToProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlBestForToProductFilter>>;
  /** Filter by the object’s `bestForId` field. */
  bestForId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlBestForToProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlBestForToProductFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `BestForToProduct` */
export type GqlBestForToProductInput = {
  bestForId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** Represents an update to a `BestForToProduct`. Fields that are set will be updated. */
export type GqlBestForToProductPatch = {
  bestForId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `BestForToProduct` values. */
export type GqlBestForToProductsConnection = {
  __typename?: 'BestForToProductsConnection';
  /** A list of edges which contains the `BestForToProduct` and cursor to aid in pagination. */
  edges: Array<GqlBestForToProductsEdge>;
  /** A list of `BestForToProduct` objects. */
  nodes: Array<Maybe<GqlBestForToProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `BestForToProduct` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BestForToProduct` edge in the connection. */
export type GqlBestForToProductsEdge = {
  __typename?: 'BestForToProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `BestForToProduct` at the end of the edge. */
  node: Maybe<GqlBestForToProduct>;
};

/** Methods to use when ordering `BestForToProduct`. */
export enum BestForToProductsOrderBy {
  BestForIdAsc = 'BEST_FOR_ID_ASC',
  BestForIdDesc = 'BEST_FOR_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

/** A connection to a list of `BestFor` values. */
export type GqlBestForsConnection = {
  __typename?: 'BestForsConnection';
  /** A list of edges which contains the `BestFor` and cursor to aid in pagination. */
  edges: Array<GqlBestForsEdge>;
  /** A list of `BestFor` objects. */
  nodes: Array<Maybe<GqlBestFor>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `BestFor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BestFor` edge in the connection. */
export type GqlBestForsEdge = {
  __typename?: 'BestForsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `BestFor` at the end of the edge. */
  node: Maybe<GqlBestFor>;
};

/** Methods to use when ordering `BestFor`. */
export enum BestForsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type GqlBooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** A connection to a list of `Category` values. */
export type GqlCategoriesConnection = {
  __typename?: 'CategoriesConnection';
  /** A list of edges which contains the `Category` and cursor to aid in pagination. */
  edges: Array<GqlCategoriesEdge>;
  /** A list of `Category` objects. */
  nodes: Array<Maybe<GqlCategory>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Category` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Category` edge in the connection. */
export type GqlCategoriesEdge = {
  __typename?: 'CategoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Category` at the end of the edge. */
  node: Maybe<GqlCategory>;
};

/** Methods to use when ordering `Category`. */
export enum CategoriesOrderBy {
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentCategoryIdAsc = 'PARENT_CATEGORY_ID_ASC',
  ParentCategoryIdDesc = 'PARENT_CATEGORY_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  TierAsc = 'TIER_ASC',
  TierDesc = 'TIER_DESC',
  TopCategoryIdAsc = 'TOP_CATEGORY_ID_ASC',
  TopCategoryIdDesc = 'TOP_CATEGORY_ID_DESC'
}

export type GqlCategory = GqlNode & {
  __typename?: 'Category';
  /** Reads and enables pagination through a set of `CategoryToProduct`. */
  categoryToProducts: Array<GqlCategoryToProduct>;
  /** Reads and enables pagination through a set of `CategoryToProduct`. */
  categoryToProductsConnection: GqlCategoryToProductsConnection;
  description: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  parentCategoryId: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByCategoryToProductCategoryIdAndProductId: GqlCategoryProductsByCategoryToProductCategoryIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByCategoryToProductCategoryIdAndProductIdList: Array<GqlProduct>;
  slug: Maybe<Scalars['String']>;
  tier: Scalars['Int'];
  topCategoryId: Maybe<Scalars['Int']>;
};


export type GqlCategoryCategoryToProductsArgs = {
  condition: InputMaybe<GqlCategoryToProductCondition>;
  filter: InputMaybe<GqlCategoryToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<CategoryToProductsOrderBy>>;
};


export type GqlCategoryCategoryToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlCategoryToProductCondition>;
  filter: InputMaybe<GqlCategoryToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};


export type GqlCategoryProductsByCategoryToProductCategoryIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlCategoryProductsByCategoryToProductCategoryIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};

/**
 * A condition to be used against `Category` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlCategoryCondition = {
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentCategoryId` field. */
  parentCategoryId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tier` field. */
  tier?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `topCategoryId` field. */
  topCategoryId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Category` object types. All fields are combined with a logical ‘and.’ */
export type GqlCategoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlCategoryFilter>>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlCategoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlCategoryFilter>>;
  /** Filter by the object’s `parentCategoryId` field. */
  parentCategoryId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `tier` field. */
  tier?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `topCategoryId` field. */
  topCategoryId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `Category` */
export type GqlCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  parentCategoryId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  tier: Scalars['Int'];
  topCategoryId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Category`. Fields that are set will be updated. */
export type GqlCategoryPatch = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentCategoryId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  tier?: InputMaybe<Scalars['Int']>;
  topCategoryId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Product` values, with data from `CategoryToProduct`. */
export type GqlCategoryProductsByCategoryToProductCategoryIdAndProductIdManyToManyConnection = {
  __typename?: 'CategoryProductsByCategoryToProductCategoryIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `CategoryToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlCategoryProductsByCategoryToProductCategoryIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `CategoryToProduct`. */
export type GqlCategoryProductsByCategoryToProductCategoryIdAndProductIdManyToManyEdge = {
  __typename?: 'CategoryProductsByCategoryToProductCategoryIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

export type GqlCategoryToProduct = GqlNode & {
  __typename?: 'CategoryToProduct';
  /** Reads a single `Category` that is related to this `CategoryToProduct`. */
  category: Maybe<GqlCategory>;
  categoryId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `CategoryToProduct`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `CategoryToProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlCategoryToProductCondition = {
  /** Checks for equality with the object’s `categoryId` field. */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `CategoryToProduct` object types. All fields are combined with a logical ‘and.’ */
export type GqlCategoryToProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlCategoryToProductFilter>>;
  /** Filter by the object’s `categoryId` field. */
  categoryId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlCategoryToProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlCategoryToProductFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `CategoryToProduct` */
export type GqlCategoryToProductInput = {
  categoryId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** Represents an update to a `CategoryToProduct`. Fields that are set will be updated. */
export type GqlCategoryToProductPatch = {
  categoryId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `CategoryToProduct` values. */
export type GqlCategoryToProductsConnection = {
  __typename?: 'CategoryToProductsConnection';
  /** A list of edges which contains the `CategoryToProduct` and cursor to aid in pagination. */
  edges: Array<GqlCategoryToProductsEdge>;
  /** A list of `CategoryToProduct` objects. */
  nodes: Array<Maybe<GqlCategoryToProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `CategoryToProduct` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CategoryToProduct` edge in the connection. */
export type GqlCategoryToProductsEdge = {
  __typename?: 'CategoryToProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `CategoryToProduct` at the end of the edge. */
  node: Maybe<GqlCategoryToProduct>;
};

/** Methods to use when ordering `CategoryToProduct`. */
export enum CategoryToProductsOrderBy {
  CategoryIdAsc = 'CATEGORY_ID_ASC',
  CategoryIdDesc = 'CATEGORY_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export enum CompanyListingStatus {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  None = 'NONE',
  Review = 'REVIEW',
  Unpaid = 'UNPAID'
}

/** A filter to be used against CompanyListingStatus fields. All fields are combined with a logical ‘and.’ */
export type GqlCompanyListingStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<CompanyListingStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<CompanyListingStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<CompanyListingStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<CompanyListingStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<CompanyListingStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<CompanyListingStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<CompanyListingStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<CompanyListingStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<CompanyListingStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<CompanyListingStatus>>;
};

export type GqlConnectCustomer = GqlNode & {
  __typename?: 'ConnectCustomer';
  accountId: Scalars['String'];
  connectCustomerId: Scalars['String'];
  createdAt: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `ConnectCustomer`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  testMode: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `ConnectCustomer`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `ConnectCustomer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlConnectCustomerCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `connectCustomerId` field. */
  connectCustomerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ConnectCustomer` object types. All fields are combined with a logical ‘and.’ */
export type GqlConnectCustomerFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<GqlStringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlConnectCustomerFilter>>;
  /** Filter by the object’s `connectCustomerId` field. */
  connectCustomerId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlConnectCustomerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlConnectCustomerFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ConnectCustomer` */
export type GqlConnectCustomerInput = {
  accountId: Scalars['String'];
  connectCustomerId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['Int'];
};

/** Represents an update to a `ConnectCustomer`. Fields that are set will be updated. */
export type GqlConnectCustomerPatch = {
  accountId?: InputMaybe<Scalars['String']>;
  connectCustomerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ConnectCustomer` values. */
export type GqlConnectCustomersConnection = {
  __typename?: 'ConnectCustomersConnection';
  /** A list of edges which contains the `ConnectCustomer` and cursor to aid in pagination. */
  edges: Array<GqlConnectCustomersEdge>;
  /** A list of `ConnectCustomer` objects. */
  nodes: Array<Maybe<GqlConnectCustomer>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectCustomer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectCustomer` edge in the connection. */
export type GqlConnectCustomersEdge = {
  __typename?: 'ConnectCustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectCustomer` at the end of the edge. */
  node: Maybe<GqlConnectCustomer>;
};

/** Methods to use when ordering `ConnectCustomer`. */
export enum ConnectCustomersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  ConnectCustomerIdAsc = 'CONNECT_CUSTOMER_ID_ASC',
  ConnectCustomerIdDesc = 'CONNECT_CUSTOMER_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlConnectPurchase = GqlNode & {
  __typename?: 'ConnectPurchase';
  connectProductId: Scalars['String'];
  createdAt: Scalars['Datetime'];
  customerId: Scalars['String'];
  expiresAt: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `ConnectPurchase`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListings: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsConnection: GqlOrganizationListingsConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingConnectPurchaseIdAndAssociationId: GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingConnectPurchaseIdAndAssociationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingConnectPurchaseIdAndOrganizationId: GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingConnectPurchaseIdAndAssociationId: GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingConnectPurchaseIdAndAssociationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingConnectPurchaseIdAndOrganizationId: GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingConnectPurchaseIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads a single `User` that is related to this `ConnectPurchase`. */
  owner: Maybe<GqlUser>;
  ownerId: Maybe<Scalars['Int']>;
  paymentStatus: PaymentStatus;
  priceId: Scalars['String'];
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductListingConnectPurchaseIdAndProductId: GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductListingConnectPurchaseIdAndProductIdList: Array<GqlProduct>;
  /** Purchaser may not own the customer ID */
  purchaserId: Maybe<Scalars['Int']>;
  subscriptionId: Maybe<Scalars['String']>;
  testMode: Scalars['Boolean'];
  theoremProductId: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
};


export type GqlConnectPurchaseOrganizationListingsArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlConnectPurchaseProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlConnectPurchaseProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};

/**
 * A condition to be used against `ConnectPurchase` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlConnectPurchaseCondition = {
  /** Checks for equality with the object’s `connectProductId` field. */
  connectProductId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerId` field. */
  customerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `paymentStatus` field. */
  paymentStatus?: InputMaybe<PaymentStatus>;
  /** Checks for equality with the object’s `priceId` field. */
  priceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `purchaserId` field. */
  purchaserId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `theoremProductId` field. */
  theoremProductId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ConnectPurchase` object types. All fields are combined with a logical ‘and.’ */
export type GqlConnectPurchaseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlConnectPurchaseFilter>>;
  /** Filter by the object’s `connectProductId` field. */
  connectProductId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `customerId` field. */
  customerId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlConnectPurchaseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlConnectPurchaseFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `paymentStatus` field. */
  paymentStatus?: InputMaybe<GqlPaymentStatusFilter>;
  /** Filter by the object’s `priceId` field. */
  priceId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `purchaserId` field. */
  purchaserId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `theoremProductId` field. */
  theoremProductId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `ConnectPurchase` */
export type GqlConnectPurchaseInput = {
  connectProductId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  priceId: Scalars['String'];
  /** Purchaser may not own the customer ID */
  purchaserId?: InputMaybe<Scalars['Int']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  theoremProductId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Organization` values, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyConnection = {
  __typename?: 'ConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `OrganizationListing`, and the cursor to aid in pagination. */
  edges: Array<GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyEdge = {
  __typename?: 'ConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsByAssociationId: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsByAssociationIdConnection: GqlOrganizationListingsConnection;
};


/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyEdgeOrganizationListingsByAssociationIdArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndAssociationIdManyToManyEdgeOrganizationListingsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `OrganizationListing`, and the cursor to aid in pagination. */
  edges: Array<GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListings: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsConnection: GqlOrganizationListingsConnection;
};


/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyEdgeOrganizationListingsArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlConnectPurchaseOrganizationsByOrganizationListingConnectPurchaseIdAndOrganizationIdManyToManyEdgeOrganizationListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyConnection = {
  __typename?: 'ConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyEdge = {
  __typename?: 'ConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsByAssociationId: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsByAssociationIdConnection: GqlProductListingsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyEdgeProductListingsByAssociationIdArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndAssociationIdManyToManyEdgeProductListingsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseOrganizationsByProductListingConnectPurchaseIdAndOrganizationIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** Represents an update to a `ConnectPurchase`. Fields that are set will be updated. */
export type GqlConnectPurchasePatch = {
  connectProductId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  priceId?: InputMaybe<Scalars['String']>;
  /** Purchaser may not own the customer ID */
  purchaserId?: InputMaybe<Scalars['Int']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  theoremProductId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Product` values, with data from `ProductListing`. */
export type GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyConnection = {
  __typename?: 'ConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyEdge = {
  __typename?: 'ConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlConnectPurchaseProductsByProductListingConnectPurchaseIdAndProductIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A connection to a list of `ConnectPurchase` values. */
export type GqlConnectPurchasesConnection = {
  __typename?: 'ConnectPurchasesConnection';
  /** A list of edges which contains the `ConnectPurchase` and cursor to aid in pagination. */
  edges: Array<GqlConnectPurchasesEdge>;
  /** A list of `ConnectPurchase` objects. */
  nodes: Array<Maybe<GqlConnectPurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectPurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectPurchase` edge in the connection. */
export type GqlConnectPurchasesEdge = {
  __typename?: 'ConnectPurchasesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectPurchase` at the end of the edge. */
  node: Maybe<GqlConnectPurchase>;
};

/** Methods to use when ordering `ConnectPurchase`. */
export enum ConnectPurchasesOrderBy {
  ConnectProductIdAsc = 'CONNECT_PRODUCT_ID_ASC',
  ConnectProductIdDesc = 'CONNECT_PRODUCT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OwnerIdAsc = 'OWNER_ID_ASC',
  OwnerIdDesc = 'OWNER_ID_DESC',
  PaymentStatusAsc = 'PAYMENT_STATUS_ASC',
  PaymentStatusDesc = 'PAYMENT_STATUS_DESC',
  PriceIdAsc = 'PRICE_ID_ASC',
  PriceIdDesc = 'PRICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  PurchaserIdAsc = 'PURCHASER_ID_ASC',
  PurchaserIdDesc = 'PURCHASER_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  TheoremProductIdAsc = 'THEOREM_PRODUCT_ID_ASC',
  TheoremProductIdDesc = 'THEOREM_PRODUCT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** All input for the create `AssocHome` mutation. */
export type GqlCreateAssocHomeInput = {
  /** The `AssocHome` to be created by this mutation. */
  assocHome: GqlAssocHomeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AssocHome` mutation. */
export type GqlCreateAssocHomePayload = {
  __typename?: 'CreateAssocHomePayload';
  /** The `AssocHome` that was created by this mutation. */
  assocHome: Maybe<GqlAssocHome>;
  /** An edge for our `AssocHome`. May be used by Relay 1. */
  assocHomeEdge: Maybe<GqlAssocHomesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `AssocHome`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `AssocHome` mutation. */
export type GqlCreateAssocHomePayloadAssocHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocHomesOrderBy>>;
};

/** All input for the create `AssocSection` mutation. */
export type GqlCreateAssocSectionInput = {
  /** The `AssocSection` to be created by this mutation. */
  assocSection: GqlAssocSectionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AssocSection` mutation. */
export type GqlCreateAssocSectionPayload = {
  __typename?: 'CreateAssocSectionPayload';
  /** The `AssocSection` that was created by this mutation. */
  assocSection: Maybe<GqlAssocSection>;
  /** An edge for our `AssocSection`. May be used by Relay 1. */
  assocSectionEdge: Maybe<GqlAssocSectionsEdge>;
  /** Reads a single `Organization` that is related to this `AssocSection`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `AssocSection` mutation. */
export type GqlCreateAssocSectionPayloadAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};

/** All input for the create `AssociationToOrganization` mutation. */
export type GqlCreateAssociationToOrganizationInput = {
  /** The `AssociationToOrganization` to be created by this mutation. */
  associationToOrganization: GqlAssociationToOrganizationInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AssociationToOrganization` mutation. */
export type GqlCreateAssociationToOrganizationPayload = {
  __typename?: 'CreateAssociationToOrganizationPayload';
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  association: Maybe<GqlOrganization>;
  /** The `AssociationToOrganization` that was created by this mutation. */
  associationToOrganization: Maybe<GqlAssociationToOrganization>;
  /** An edge for our `AssociationToOrganization`. May be used by Relay 1. */
  associationToOrganizationEdge: Maybe<GqlAssociationToOrganizationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `AssociationToOrganization` mutation. */
export type GqlCreateAssociationToOrganizationPayloadAssociationToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};

/** All input for the create `AwardBadge` mutation. */
export type GqlCreateAwardBadgeInput = {
  /** The `AwardBadge` to be created by this mutation. */
  awardBadge: GqlAwardBadgeInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `AwardBadge` mutation. */
export type GqlCreateAwardBadgePayload = {
  __typename?: 'CreateAwardBadgePayload';
  /** The `AwardBadge` that was created by this mutation. */
  awardBadge: Maybe<GqlAwardBadge>;
  /** An edge for our `AwardBadge`. May be used by Relay 1. */
  awardBadgeEdge: Maybe<GqlAwardBadgesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `AwardBadge` mutation. */
export type GqlCreateAwardBadgePayloadAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<AwardBadgesOrderBy>>;
};

/** All input for the create `BestFor` mutation. */
export type GqlCreateBestForInput = {
  /** The `BestFor` to be created by this mutation. */
  bestFor: GqlBestForInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BestFor` mutation. */
export type GqlCreateBestForPayload = {
  __typename?: 'CreateBestForPayload';
  /** The `BestFor` that was created by this mutation. */
  bestFor: Maybe<GqlBestFor>;
  /** An edge for our `BestFor`. May be used by Relay 1. */
  bestForEdge: Maybe<GqlBestForsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `BestFor` mutation. */
export type GqlCreateBestForPayloadBestForEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForsOrderBy>>;
};

/** All input for the create `BestForToProduct` mutation. */
export type GqlCreateBestForToProductInput = {
  /** The `BestForToProduct` to be created by this mutation. */
  bestForToProduct: GqlBestForToProductInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `BestForToProduct` mutation. */
export type GqlCreateBestForToProductPayload = {
  __typename?: 'CreateBestForToProductPayload';
  /** Reads a single `BestFor` that is related to this `BestForToProduct`. */
  bestFor: Maybe<GqlBestFor>;
  /** The `BestForToProduct` that was created by this mutation. */
  bestForToProduct: Maybe<GqlBestForToProduct>;
  /** An edge for our `BestForToProduct`. May be used by Relay 1. */
  bestForToProductEdge: Maybe<GqlBestForToProductsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `BestForToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `BestForToProduct` mutation. */
export type GqlCreateBestForToProductPayloadBestForToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};

/** All input for the create `Category` mutation. */
export type GqlCreateCategoryInput = {
  /** The `Category` to be created by this mutation. */
  category: GqlCategoryInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `Category` mutation. */
export type GqlCreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  /** The `Category` that was created by this mutation. */
  category: Maybe<GqlCategory>;
  /** An edge for our `Category`. May be used by Relay 1. */
  categoryEdge: Maybe<GqlCategoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `Category` mutation. */
export type GqlCreateCategoryPayloadCategoryEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};

/** All input for the create `CategoryToProduct` mutation. */
export type GqlCreateCategoryToProductInput = {
  /** The `CategoryToProduct` to be created by this mutation. */
  categoryToProduct: GqlCategoryToProductInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our create `CategoryToProduct` mutation. */
export type GqlCreateCategoryToProductPayload = {
  __typename?: 'CreateCategoryToProductPayload';
  /** Reads a single `Category` that is related to this `CategoryToProduct`. */
  category: Maybe<GqlCategory>;
  /** The `CategoryToProduct` that was created by this mutation. */
  categoryToProduct: Maybe<GqlCategoryToProduct>;
  /** An edge for our `CategoryToProduct`. May be used by Relay 1. */
  categoryToProductEdge: Maybe<GqlCategoryToProductsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `CategoryToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `CategoryToProduct` mutation. */
export type GqlCreateCategoryToProductPayloadCategoryToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};

/** All input for the create `ConnectCustomer` mutation. */
export type GqlCreateConnectCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ConnectCustomer` to be created by this mutation. */
  connectCustomer: GqlConnectCustomerInput;
};

/** The output of our create `ConnectCustomer` mutation. */
export type GqlCreateConnectCustomerPayload = {
  __typename?: 'CreateConnectCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectCustomer` that was created by this mutation. */
  connectCustomer: Maybe<GqlConnectCustomer>;
  /** An edge for our `ConnectCustomer`. May be used by Relay 1. */
  connectCustomerEdge: Maybe<GqlConnectCustomersEdge>;
  /** Reads a single `Organization` that is related to this `ConnectCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ConnectCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `ConnectCustomer` mutation. */
export type GqlCreateConnectCustomerPayloadConnectCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};

/** All input for the create `ConnectPurchase` mutation. */
export type GqlCreateConnectPurchaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ConnectPurchase` to be created by this mutation. */
  connectPurchase: GqlConnectPurchaseInput;
};

/** The output of our create `ConnectPurchase` mutation. */
export type GqlCreateConnectPurchasePayload = {
  __typename?: 'CreateConnectPurchasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectPurchase` that was created by this mutation. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** An edge for our `ConnectPurchase`. May be used by Relay 1. */
  connectPurchaseEdge: Maybe<GqlConnectPurchasesEdge>;
  /** Reads a single `Organization` that is related to this `ConnectPurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `ConnectPurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ConnectPurchase` mutation. */
export type GqlCreateConnectPurchasePayloadConnectPurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};

/** All input for the create `DiversityCertification` mutation. */
export type GqlCreateDiversityCertificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DiversityCertification` to be created by this mutation. */
  diversityCertification: GqlDiversityCertificationInput;
};

/** The output of our create `DiversityCertification` mutation. */
export type GqlCreateDiversityCertificationPayload = {
  __typename?: 'CreateDiversityCertificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DiversityCertification` that was created by this mutation. */
  diversityCertification: Maybe<GqlDiversityCertification>;
  /** An edge for our `DiversityCertification`. May be used by Relay 1. */
  diversityCertificationEdge: Maybe<GqlDiversityCertificationsEdge>;
  /** Reads a single `Organization` that is related to this `DiversityCertification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `DiversityCertification` mutation. */
export type GqlCreateDiversityCertificationPayloadDiversityCertificationEdgeArgs = {
  orderBy?: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};

/** All input for the create `Feature` mutation. */
export type GqlCreateFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Feature` to be created by this mutation. */
  feature: GqlFeatureInput;
};

/** The output of our create `Feature` mutation. */
export type GqlCreateFeaturePayload = {
  __typename?: 'CreateFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Feature` that was created by this mutation. */
  feature: Maybe<GqlFeature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge: Maybe<GqlFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `Feature` mutation. */
export type GqlCreateFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the create `FeatureToProduct` mutation. */
export type GqlCreateFeatureToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FeatureToProduct` to be created by this mutation. */
  featureToProduct: GqlFeatureToProductInput;
};

/** The output of our create `FeatureToProduct` mutation. */
export type GqlCreateFeatureToProductPayload = {
  __typename?: 'CreateFeatureToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Feature` that is related to this `FeatureToProduct`. */
  feature: Maybe<GqlFeature>;
  /** The `FeatureToProduct` that was created by this mutation. */
  featureToProduct: Maybe<GqlFeatureToProduct>;
  /** An edge for our `FeatureToProduct`. May be used by Relay 1. */
  featureToProductEdge: Maybe<GqlFeatureToProductsEdge>;
  /** Reads a single `Product` that is related to this `FeatureToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `FeatureToProduct` mutation. */
export type GqlCreateFeatureToProductPayloadFeatureToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};

/** All input for the create `LawfirmService` mutation. */
export type GqlCreateLawfirmServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LawfirmService` to be created by this mutation. */
  lawfirmService: GqlLawfirmServiceInput;
};

/** The output of our create `LawfirmService` mutation. */
export type GqlCreateLawfirmServicePayload = {
  __typename?: 'CreateLawfirmServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `LawfirmService` that was created by this mutation. */
  lawfirmService: Maybe<GqlLawfirmService>;
  /** An edge for our `LawfirmService`. May be used by Relay 1. */
  lawfirmServiceEdge: Maybe<GqlLawfirmServicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `LawfirmService` mutation. */
export type GqlCreateLawfirmServicePayloadLawfirmServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<LawfirmServicesOrderBy>>;
};

/** All input for the create `ListingCreator` mutation. */
export type GqlCreateListingCreatorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ListingCreator` to be created by this mutation. */
  listingCreator: GqlListingCreatorInput;
};

/** The output of our create `ListingCreator` mutation. */
export type GqlCreateListingCreatorPayload = {
  __typename?: 'CreateListingCreatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ListingCreator` that was created by this mutation. */
  listingCreator: Maybe<GqlListingCreator>;
  /** An edge for our `ListingCreator`. May be used by Relay 1. */
  listingCreatorEdge: Maybe<GqlListingCreatorsEdge>;
  /** Reads a single `Organization` that is related to this `ListingCreator`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ListingCreator` mutation. */
export type GqlCreateListingCreatorPayloadListingCreatorEdgeArgs = {
  orderBy?: InputMaybe<Array<ListingCreatorsOrderBy>>;
};

/** All input for the create `Location` mutation. */
export type GqlCreateLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Location` to be created by this mutation. */
  location: GqlLocationInput;
};

/** The output of our create `Location` mutation. */
export type GqlCreateLocationPayload = {
  __typename?: 'CreateLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Location` that was created by this mutation. */
  location: Maybe<GqlLocation>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge: Maybe<GqlLocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `Location` mutation. */
export type GqlCreateLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** All input for the create `Notification` mutation. */
export type GqlCreateNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Notification` to be created by this mutation. */
  notification: GqlNotificationInput;
};

/** The output of our create `Notification` mutation. */
export type GqlCreateNotificationPayload = {
  __typename?: 'CreateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Notification` that was created by this mutation. */
  notification: Maybe<GqlNotification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<GqlNotificationsEdge>;
  /** Reads a single `Organization` that is related to this `Notification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `Notification`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `Notification` mutation. */
export type GqlCreateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the create `NoviMember` mutation. */
export type GqlCreateNoviMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NoviMember` to be created by this mutation. */
  noviMember: GqlNoviMemberInput;
};

/** The output of our create `NoviMember` mutation. */
export type GqlCreateNoviMemberPayload = {
  __typename?: 'CreateNoviMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `NoviMember` that was created by this mutation. */
  noviMember: Maybe<GqlNoviMember>;
  /** An edge for our `NoviMember`. May be used by Relay 1. */
  noviMemberEdge: Maybe<GqlNoviMembersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `NoviMember`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `NoviMember` mutation. */
export type GqlCreateNoviMemberPayloadNoviMemberEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviMembersOrderBy>>;
};

/** All input for the create `NoviOrganization` mutation. */
export type GqlCreateNoviOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NoviOrganization` to be created by this mutation. */
  noviOrganization: GqlNoviOrganizationInput;
};

/** The output of our create `NoviOrganization` mutation. */
export type GqlCreateNoviOrganizationPayload = {
  __typename?: 'CreateNoviOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `NoviOrganization` that was created by this mutation. */
  noviOrganization: Maybe<GqlNoviOrganization>;
  /** An edge for our `NoviOrganization`. May be used by Relay 1. */
  noviOrganizationEdge: Maybe<GqlNoviOrganizationsEdge>;
  /** Reads a single `Organization` that is related to this `NoviOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `NoviOrganization` mutation. */
export type GqlCreateNoviOrganizationPayloadNoviOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};

/** All input for the create `Organization` mutation. */
export type GqlCreateOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Organization` to be created by this mutation. */
  organization: GqlOrganizationInput;
};

/** All input for the create `OrganizationListing` mutation. */
export type GqlCreateOrganizationListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrganizationListing` to be created by this mutation. */
  organizationListing: GqlOrganizationListingInput;
};

/** The output of our create `OrganizationListing` mutation. */
export type GqlCreateOrganizationListingPayload = {
  __typename?: 'CreateOrganizationListingPayload';
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `OrganizationListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationListing` that was created by this mutation. */
  organizationListing: Maybe<GqlOrganizationListing>;
  /** An edge for our `OrganizationListing`. May be used by Relay 1. */
  organizationListingEdge: Maybe<GqlOrganizationListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `OrganizationListing` mutation. */
export type GqlCreateOrganizationListingPayloadOrganizationListingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** The output of our create `Organization` mutation. */
export type GqlCreateOrganizationPayload = {
  __typename?: 'CreateOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Term` that is related to this `Organization`. */
  mainTerm: Maybe<GqlTerm>;
  /** The `Organization` that was created by this mutation. */
  organization: Maybe<GqlOrganization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge: Maybe<GqlOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `Organization` mutation. */
export type GqlCreateOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the create `OrganizationTechstack` mutation. */
export type GqlCreateOrganizationTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrganizationTechstack` to be created by this mutation. */
  organizationTechstack: GqlOrganizationTechstackInput;
};

/** The output of our create `OrganizationTechstack` mutation. */
export type GqlCreateOrganizationTechstackPayload = {
  __typename?: 'CreateOrganizationTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `OrganizationTechstack`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationTechstack` that was created by this mutation. */
  organizationTechstack: Maybe<GqlOrganizationTechstack>;
  /** An edge for our `OrganizationTechstack`. May be used by Relay 1. */
  organizationTechstackEdge: Maybe<GqlOrganizationTechstacksEdge>;
  /** Reads a single `Product` that is related to this `OrganizationTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `OrganizationTechstack` mutation. */
export type GqlCreateOrganizationTechstackPayloadOrganizationTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};

/** All input for the create `PersonalTechstack` mutation. */
export type GqlCreatePersonalTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PersonalTechstack` to be created by this mutation. */
  personalTechstack: GqlPersonalTechstackInput;
};

/** The output of our create `PersonalTechstack` mutation. */
export type GqlCreatePersonalTechstackPayload = {
  __typename?: 'CreatePersonalTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PersonalTechstack` that was created by this mutation. */
  personalTechstack: Maybe<GqlPersonalTechstack>;
  /** An edge for our `PersonalTechstack`. May be used by Relay 1. */
  personalTechstackEdge: Maybe<GqlPersonalTechstacksEdge>;
  /** Reads a single `Product` that is related to this `PersonalTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `PersonalTechstack`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `PersonalTechstack` mutation. */
export type GqlCreatePersonalTechstackPayloadPersonalTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};

/** All input for the `createPersonalTechstacks` mutation. */
export type GqlCreatePersonalTechstacksInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productIds: Array<InputMaybe<Scalars['Int']>>;
  userId: Scalars['Int'];
};

/** The output of our `createPersonalTechstacks` mutation. */
export type GqlCreatePersonalTechstacksPayload = {
  __typename?: 'CreatePersonalTechstacksPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  personalTechstacks: Maybe<Array<Maybe<GqlPersonalTechstack>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the create `PracticeGroup` mutation. */
export type GqlCreatePracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PracticeGroup` to be created by this mutation. */
  practiceGroup: GqlPracticeGroupInput;
};

/** The output of our create `PracticeGroup` mutation. */
export type GqlCreatePracticeGroupPayload = {
  __typename?: 'CreatePracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PracticeGroup` that was created by this mutation. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** An edge for our `PracticeGroup`. May be used by Relay 1. */
  practiceGroupEdge: Maybe<GqlPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `PracticeGroup` mutation. */
export type GqlCreatePracticeGroupPayloadPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};

/** All input for the create `PremiumInfoToTerm` mutation. */
export type GqlCreatePremiumInfoToTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PremiumInfoToTerm` to be created by this mutation. */
  premiumInfoToTerm: GqlPremiumInfoToTermInput;
};

/** The output of our create `PremiumInfoToTerm` mutation. */
export type GqlCreatePremiumInfoToTermPayload = {
  __typename?: 'CreatePremiumInfoToTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PremiumProductInfo` that is related to this `PremiumInfoToTerm`. */
  premiumInfo: Maybe<GqlPremiumProductInfo>;
  /** The `PremiumInfoToTerm` that was created by this mutation. */
  premiumInfoToTerm: Maybe<GqlPremiumInfoToTerm>;
  /** An edge for our `PremiumInfoToTerm`. May be used by Relay 1. */
  premiumInfoToTermEdge: Maybe<GqlPremiumInfoToTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `PremiumInfoToTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our create `PremiumInfoToTerm` mutation. */
export type GqlCreatePremiumInfoToTermPayloadPremiumInfoToTermEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};

/** All input for the create `PremiumProductInfo` mutation. */
export type GqlCreatePremiumProductInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PremiumProductInfo` to be created by this mutation. */
  premiumProductInfo: GqlPremiumProductInfoInput;
};

/** The output of our create `PremiumProductInfo` mutation. */
export type GqlCreatePremiumProductInfoPayload = {
  __typename?: 'CreatePremiumProductInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PremiumProductInfo` that was created by this mutation. */
  premiumProductInfo: Maybe<GqlPremiumProductInfo>;
  /** An edge for our `PremiumProductInfo`. May be used by Relay 1. */
  premiumProductInfoEdge: Maybe<GqlPremiumProductInfosEdge>;
  /** Reads a single `Product` that is related to this `PremiumProductInfo`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `PremiumProductInfo` mutation. */
export type GqlCreatePremiumProductInfoPayloadPremiumProductInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};

/** All input for the create `ProductAwardDetail` mutation. */
export type GqlCreateProductAwardDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductAwardDetail` to be created by this mutation. */
  productAwardDetail: GqlProductAwardDetailInput;
};

/** The output of our create `ProductAwardDetail` mutation. */
export type GqlCreateProductAwardDetailPayload = {
  __typename?: 'CreateProductAwardDetailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductAwardDetail`. */
  product: Maybe<GqlProduct>;
  /** The `ProductAwardDetail` that was created by this mutation. */
  productAwardDetail: Maybe<GqlProductAwardDetail>;
  /** An edge for our `ProductAwardDetail`. May be used by Relay 1. */
  productAwardDetailEdge: Maybe<GqlProductAwardDetailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductAwardDetail` mutation. */
export type GqlCreateProductAwardDetailPayloadProductAwardDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};

/** All input for the create `ProductFeatureByTerm` mutation. */
export type GqlCreateProductFeatureByTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductFeatureByTerm` to be created by this mutation. */
  productFeatureByTerm: GqlProductFeatureByTermInput;
};

/** The output of our create `ProductFeatureByTerm` mutation. */
export type GqlCreateProductFeatureByTermPayload = {
  __typename?: 'CreateProductFeatureByTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `ProductFeatureByTerm`. */
  network: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductFeatureByTerm`. */
  product: Maybe<GqlProduct>;
  /** The `ProductFeatureByTerm` that was created by this mutation. */
  productFeatureByTerm: Maybe<GqlProductFeatureByTerm>;
  /** An edge for our `ProductFeatureByTerm`. May be used by Relay 1. */
  productFeatureByTermEdge: Maybe<GqlProductFeatureByTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `ProductFeatureByTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our create `ProductFeatureByTerm` mutation. */
export type GqlCreateProductFeatureByTermPayloadProductFeatureByTermEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** All input for the create `Product` mutation. */
export type GqlCreateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Product` to be created by this mutation. */
  product: GqlProductInput;
};

/** All input for the create `ProductListing` mutation. */
export type GqlCreateProductListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductListing` to be created by this mutation. */
  productListing: GqlProductListingInput;
};

/** The output of our create `ProductListing` mutation. */
export type GqlCreateProductListingPayload = {
  __typename?: 'CreateProductListingPayload';
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `ProductListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductListing` that was created by this mutation. */
  productListing: Maybe<GqlProductListing>;
  /** An edge for our `ProductListing`. May be used by Relay 1. */
  productListingEdge: Maybe<GqlProductListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductListing` mutation. */
export type GqlCreateProductListingPayloadProductListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** The output of our create `Product` mutation. */
export type GqlCreateProductPayload = {
  __typename?: 'CreateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Product` that was created by this mutation. */
  product: Maybe<GqlProduct>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge: Maybe<GqlProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `Product` mutation. */
export type GqlCreateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the create `ProductSection` mutation. */
export type GqlCreateProductSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductSection` to be created by this mutation. */
  productSection: GqlProductSectionInput;
};

/** The output of our create `ProductSection` mutation. */
export type GqlCreateProductSectionPayload = {
  __typename?: 'CreateProductSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProductSection` that was created by this mutation. */
  productSection: Maybe<GqlProductSection>;
  /** An edge for our `ProductSection`. May be used by Relay 1. */
  productSectionEdge: Maybe<GqlProductSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductSection` mutation. */
export type GqlCreateProductSectionPayloadProductSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductSectionsOrderBy>>;
};

/** All input for the create `ProductToAssocSection` mutation. */
export type GqlCreateProductToAssocSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToAssocSection` to be created by this mutation. */
  productToAssocSection: GqlProductToAssocSectionInput;
};

/** The output of our create `ProductToAssocSection` mutation. */
export type GqlCreateProductToAssocSectionPayload = {
  __typename?: 'CreateProductToAssocSectionPayload';
  /** Reads a single `AssocSection` that is related to this `ProductToAssocSection`. */
  assocSection: Maybe<GqlAssocSection>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToAssocSection`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAssocSection` that was created by this mutation. */
  productToAssocSection: Maybe<GqlProductToAssocSection>;
  /** An edge for our `ProductToAssocSection`. May be used by Relay 1. */
  productToAssocSectionEdge: Maybe<GqlProductToAssocSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToAssocSection` mutation. */
export type GqlCreateProductToAssocSectionPayloadProductToAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};

/** All input for the create `ProductToAwardBadge` mutation. */
export type GqlCreateProductToAwardBadgeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToAwardBadge` to be created by this mutation. */
  productToAwardBadge: GqlProductToAwardBadgeInput;
};

/** The output of our create `ProductToAwardBadge` mutation. */
export type GqlCreateProductToAwardBadgePayload = {
  __typename?: 'CreateProductToAwardBadgePayload';
  /** Reads a single `AwardBadge` that is related to this `ProductToAwardBadge`. */
  awardBadge: Maybe<GqlAwardBadge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToAwardBadge`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAwardBadge` that was created by this mutation. */
  productToAwardBadge: Maybe<GqlProductToAwardBadge>;
  /** An edge for our `ProductToAwardBadge`. May be used by Relay 1. */
  productToAwardBadgeEdge: Maybe<GqlProductToAwardBadgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToAwardBadge` mutation. */
export type GqlCreateProductToAwardBadgePayloadProductToAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};

/** All input for the create `ProductToClient` mutation. */
export type GqlCreateProductToClientInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToClient` to be created by this mutation. */
  productToClient: GqlProductToClientInput;
};

/** The output of our create `ProductToClient` mutation. */
export type GqlCreateProductToClientPayload = {
  __typename?: 'CreateProductToClientPayload';
  /** Reads a single `Organization` that is related to this `ProductToClient`. */
  client: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToClient`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToClient` that was created by this mutation. */
  productToClient: Maybe<GqlProductToClient>;
  /** An edge for our `ProductToClient`. May be used by Relay 1. */
  productToClientEdge: Maybe<GqlProductToClientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToClient` mutation. */
export type GqlCreateProductToClientPayloadProductToClientEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};

/** All input for the create `ProductToCompetitor` mutation. */
export type GqlCreateProductToCompetitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToCompetitor` to be created by this mutation. */
  productToCompetitor: GqlProductToCompetitorInput;
};

/** The output of our create `ProductToCompetitor` mutation. */
export type GqlCreateProductToCompetitorPayload = {
  __typename?: 'CreateProductToCompetitorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  competitor: Maybe<GqlProduct>;
  /** Reads a single `Organization` that is related to this `ProductToCompetitor`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToCompetitor` that was created by this mutation. */
  productToCompetitor: Maybe<GqlProductToCompetitor>;
  /** An edge for our `ProductToCompetitor`. May be used by Relay 1. */
  productToCompetitorEdge: Maybe<GqlProductToCompetitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToCompetitor` mutation. */
export type GqlCreateProductToCompetitorPayloadProductToCompetitorEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** All input for the create `ProductToIntegration` mutation. */
export type GqlCreateProductToIntegrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToIntegration` to be created by this mutation. */
  productToIntegration: GqlProductToIntegrationInput;
};

/** The output of our create `ProductToIntegration` mutation. */
export type GqlCreateProductToIntegrationPayload = {
  __typename?: 'CreateProductToIntegrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  integration: Maybe<GqlProduct>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToIntegration` that was created by this mutation. */
  productToIntegration: Maybe<GqlProductToIntegration>;
  /** An edge for our `ProductToIntegration`. May be used by Relay 1. */
  productToIntegrationEdge: Maybe<GqlProductToIntegrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToIntegration` mutation. */
export type GqlCreateProductToIntegrationPayloadProductToIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};

/** All input for the `createProductToIntegrations` mutation. */
export type GqlCreateProductToIntegrationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integrationIds: Array<InputMaybe<Scalars['Int']>>;
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
};

/** The output of our `createProductToIntegrations` mutation. */
export type GqlCreateProductToIntegrationsPayload = {
  __typename?: 'CreateProductToIntegrationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  productToIntegrations: Maybe<Array<Maybe<GqlProductToIntegration>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the create `ProductToOrganization` mutation. */
export type GqlCreateProductToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToOrganization` to be created by this mutation. */
  productToOrganization: GqlProductToOrganizationInput;
};

/** The output of our create `ProductToOrganization` mutation. */
export type GqlCreateProductToOrganizationPayload = {
  __typename?: 'CreateProductToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `ProductToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToOrganization`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToOrganization` that was created by this mutation. */
  productToOrganization: Maybe<GqlProductToOrganization>;
  /** An edge for our `ProductToOrganization`. May be used by Relay 1. */
  productToOrganizationEdge: Maybe<GqlProductToOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToOrganization` mutation. */
export type GqlCreateProductToOrganizationPayloadProductToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};

/** All input for the create `ProductToPracticeGroup` mutation. */
export type GqlCreateProductToPracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToPracticeGroup` to be created by this mutation. */
  productToPracticeGroup: GqlProductToPracticeGroupInput;
};

/** The output of our create `ProductToPracticeGroup` mutation. */
export type GqlCreateProductToPracticeGroupPayload = {
  __typename?: 'CreateProductToPracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PracticeGroup` that is related to this `ProductToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Reads a single `Product` that is related to this `ProductToPracticeGroup`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToPracticeGroup` that was created by this mutation. */
  productToPracticeGroup: Maybe<GqlProductToPracticeGroup>;
  /** An edge for our `ProductToPracticeGroup`. May be used by Relay 1. */
  productToPracticeGroupEdge: Maybe<GqlProductToPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our create `ProductToPracticeGroup` mutation. */
export type GqlCreateProductToPracticeGroupPayloadProductToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};

/** All input for the create `ProductToSuiteListing` mutation. */
export type GqlCreateProductToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToSuiteListing` to be created by this mutation. */
  productToSuiteListing: GqlProductToSuiteListingInput;
};

/** The output of our create `ProductToSuiteListing` mutation. */
export type GqlCreateProductToSuiteListingPayload = {
  __typename?: 'CreateProductToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToSuiteListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToSuiteListing` that was created by this mutation. */
  productToSuiteListing: Maybe<GqlProductToSuiteListing>;
  /** An edge for our `ProductToSuiteListing`. May be used by Relay 1. */
  productToSuiteListingEdge: Maybe<GqlProductToSuiteListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `ProductToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
};


/** The output of our create `ProductToSuiteListing` mutation. */
export type GqlCreateProductToSuiteListingPayloadProductToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};

/** All input for the create `ProductToUser` mutation. */
export type GqlCreateProductToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToUser` to be created by this mutation. */
  productToUser: GqlProductToUserInput;
};

/** The output of our create `ProductToUser` mutation. */
export type GqlCreateProductToUserPayload = {
  __typename?: 'CreateProductToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToUser`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToUser` that was created by this mutation. */
  productToUser: Maybe<GqlProductToUser>;
  /** An edge for our `ProductToUser`. May be used by Relay 1. */
  productToUserEdge: Maybe<GqlProductToUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ProductToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `ProductToUser` mutation. */
export type GqlCreateProductToUserPayloadProductToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};

/** All input for the `createProductsToOrganization` mutation. */
export type GqlCreateProductsToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  productIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `createProductsToOrganization` mutation. */
export type GqlCreateProductsToOrganizationPayload = {
  __typename?: 'CreateProductsToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  productToOrganizations: Maybe<Array<Maybe<GqlProductToOrganization>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the create `Rfp` mutation. */
export type GqlCreateRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Rfp` to be created by this mutation. */
  rfp: GqlRfpInput;
};

/** The output of our create `Rfp` mutation. */
export type GqlCreateRfpPayload = {
  __typename?: 'CreateRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Rfp` that was created by this mutation. */
  rfp: Maybe<GqlRfp>;
  /** An edge for our `Rfp`. May be used by Relay 1. */
  rfpEdge: Maybe<GqlRfpsEdge>;
  /** Reads a single `User` that is related to this `Rfp`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `Rfp` mutation. */
export type GqlCreateRfpPayloadRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};

/** All input for the create `RfpToProduct` mutation. */
export type GqlCreateRfpToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RfpToProduct` to be created by this mutation. */
  rfpToProduct: GqlRfpToProductInput;
};

/** The output of our create `RfpToProduct` mutation. */
export type GqlCreateRfpToProductPayload = {
  __typename?: 'CreateRfpToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `RfpToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `RfpToProduct`. */
  rfp: Maybe<GqlRfp>;
  /** The `RfpToProduct` that was created by this mutation. */
  rfpToProduct: Maybe<GqlRfpToProduct>;
  /** An edge for our `RfpToProduct`. May be used by Relay 1. */
  rfpToProductEdge: Maybe<GqlRfpToProductsEdge>;
};


/** The output of our create `RfpToProduct` mutation. */
export type GqlCreateRfpToProductPayloadRfpToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};

/** All input for the `createRfpToProducts` mutation. */
export type GqlCreateRfpToProductsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productIds: Array<InputMaybe<Scalars['Int']>>;
  rfpId: Scalars['Int'];
};

/** The output of our `createRfpToProducts` mutation. */
export type GqlCreateRfpToProductsPayload = {
  __typename?: 'CreateRfpToProductsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  rfpToProducts: Maybe<Array<Maybe<GqlRfpToProduct>>>;
};

/** All input for the create `Scheduler` mutation. */
export type GqlCreateSchedulerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Scheduler` to be created by this mutation. */
  scheduler: GqlSchedulerInput;
};

/** The output of our create `Scheduler` mutation. */
export type GqlCreateSchedulerPayload = {
  __typename?: 'CreateSchedulerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Scheduler` that was created by this mutation. */
  scheduler: Maybe<GqlScheduler>;
  /** An edge for our `Scheduler`. May be used by Relay 1. */
  schedulerEdge: Maybe<GqlSchedulersEdge>;
  /** Reads a single `User` that is related to this `Scheduler`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `Scheduler` mutation. */
export type GqlCreateSchedulerPayloadSchedulerEdgeArgs = {
  orderBy?: InputMaybe<Array<SchedulersOrderBy>>;
};

/** All input for the create `SectionLayout` mutation. */
export type GqlCreateSectionLayoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SectionLayout` to be created by this mutation. */
  sectionLayout: GqlSectionLayoutInput;
};

/** The output of our create `SectionLayout` mutation. */
export type GqlCreateSectionLayoutPayload = {
  __typename?: 'CreateSectionLayoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SectionLayout` that was created by this mutation. */
  sectionLayout: Maybe<GqlSectionLayout>;
  /** An edge for our `SectionLayout`. May be used by Relay 1. */
  sectionLayoutEdge: Maybe<GqlSectionLayoutsEdge>;
};


/** The output of our create `SectionLayout` mutation. */
export type GqlCreateSectionLayoutPayloadSectionLayoutEdgeArgs = {
  orderBy?: InputMaybe<Array<SectionLayoutsOrderBy>>;
};

/** All input for the create `SimpleService` mutation. */
export type GqlCreateSimpleServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SimpleService` to be created by this mutation. */
  simpleService: GqlSimpleServiceInput;
};

/** The output of our create `SimpleService` mutation. */
export type GqlCreateSimpleServicePayload = {
  __typename?: 'CreateSimpleServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `SimpleService`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SimpleService` that was created by this mutation. */
  simpleService: Maybe<GqlSimpleService>;
  /** An edge for our `SimpleService`. May be used by Relay 1. */
  simpleServiceEdge: Maybe<GqlSimpleServicesEdge>;
  /** Reads a single `Term` that is related to this `SimpleService`. */
  term: Maybe<GqlTerm>;
};


/** The output of our create `SimpleService` mutation. */
export type GqlCreateSimpleServicePayloadSimpleServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};

/** All input for the create `StackshareOption` mutation. */
export type GqlCreateStackshareOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StackshareOption` to be created by this mutation. */
  stackshareOption: GqlStackshareOptionInput;
};

/** The output of our create `StackshareOption` mutation. */
export type GqlCreateStackshareOptionPayload = {
  __typename?: 'CreateStackshareOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StackshareOption` that was created by this mutation. */
  stackshareOption: Maybe<GqlStackshareOption>;
  /** An edge for our `StackshareOption`. May be used by Relay 1. */
  stackshareOptionEdge: Maybe<GqlStackshareOptionsEdge>;
};


/** The output of our create `StackshareOption` mutation. */
export type GqlCreateStackshareOptionPayloadStackshareOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<StackshareOptionsOrderBy>>;
};

/** All input for the create `StripeAccount` mutation. */
export type GqlCreateStripeAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripeAccount` to be created by this mutation. */
  stripeAccount: GqlStripeAccountInput;
};

/** The output of our create `StripeAccount` mutation. */
export type GqlCreateStripeAccountPayload = {
  __typename?: 'CreateStripeAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeAccount`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeAccount` that was created by this mutation. */
  stripeAccount: Maybe<GqlStripeAccount>;
  /** An edge for our `StripeAccount`. May be used by Relay 1. */
  stripeAccountEdge: Maybe<GqlStripeAccountsEdge>;
  /** Reads a single `User` that is related to this `StripeAccount`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `StripeAccount` mutation. */
export type GqlCreateStripeAccountPayloadStripeAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};

/** All input for the create `StripeCustomer` mutation. */
export type GqlCreateStripeCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripeCustomer` to be created by this mutation. */
  stripeCustomer: GqlStripeCustomerInput;
};

/** The output of our create `StripeCustomer` mutation. */
export type GqlCreateStripeCustomerPayload = {
  __typename?: 'CreateStripeCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeCustomer` that was created by this mutation. */
  stripeCustomer: Maybe<GqlStripeCustomer>;
  /** An edge for our `StripeCustomer`. May be used by Relay 1. */
  stripeCustomerEdge: Maybe<GqlStripeCustomersEdge>;
  /** Reads a single `User` that is related to this `StripeCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `StripeCustomer` mutation. */
export type GqlCreateStripeCustomerPayloadStripeCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** All input for the create `StripePurchase` mutation. */
export type GqlCreateStripePurchaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripePurchase` to be created by this mutation. */
  stripePurchase: GqlStripePurchaseInput;
};

/** The output of our create `StripePurchase` mutation. */
export type GqlCreateStripePurchasePayload = {
  __typename?: 'CreateStripePurchasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripePurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `StripePurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripePurchase` that was created by this mutation. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** An edge for our `StripePurchase`. May be used by Relay 1. */
  stripePurchaseEdge: Maybe<GqlStripePurchasesEdge>;
};


/** The output of our create `StripePurchase` mutation. */
export type GqlCreateStripePurchasePayloadStripePurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};

/** All input for the create `StripeSeat` mutation. */
export type GqlCreateStripeSeatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripeSeat` to be created by this mutation. */
  stripeSeat: GqlStripeSeatInput;
};

/** The output of our create `StripeSeat` mutation. */
export type GqlCreateStripeSeatPayload = {
  __typename?: 'CreateStripeSeatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeSeat`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeSeat` that was created by this mutation. */
  stripeSeat: Maybe<GqlStripeSeat>;
  /** An edge for our `StripeSeat`. May be used by Relay 1. */
  stripeSeatEdge: Maybe<GqlStripeSeatsEdge>;
  /** Reads a single `User` that is related to this `StripeSeat`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `StripeSeat` mutation. */
export type GqlCreateStripeSeatPayloadStripeSeatEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** All input for the create `SuiteListing` mutation. */
export type GqlCreateSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuiteListing` to be created by this mutation. */
  suiteListing: GqlSuiteListingInput;
};

/** The output of our create `SuiteListing` mutation. */
export type GqlCreateSuiteListingPayload = {
  __typename?: 'CreateSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `SuiteListing`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `StripePurchase` that is related to this `SuiteListing`. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** The `SuiteListing` that was created by this mutation. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** An edge for our `SuiteListing`. May be used by Relay 1. */
  suiteListingEdge: Maybe<GqlSuiteListingsEdge>;
};


/** The output of our create `SuiteListing` mutation. */
export type GqlCreateSuiteListingPayloadSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

/** All input for the create `Taxonomy` mutation. */
export type GqlCreateTaxonomyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Taxonomy` to be created by this mutation. */
  taxonomy: GqlTaxonomyInput;
};

/** The output of our create `Taxonomy` mutation. */
export type GqlCreateTaxonomyPayload = {
  __typename?: 'CreateTaxonomyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Taxonomy` that is related to this `Taxonomy`. */
  parent: Maybe<GqlTaxonomy>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Taxonomy` that was created by this mutation. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** An edge for our `Taxonomy`. May be used by Relay 1. */
  taxonomyEdge: Maybe<GqlTaxonomiesEdge>;
};


/** The output of our create `Taxonomy` mutation. */
export type GqlCreateTaxonomyPayloadTaxonomyEdgeArgs = {
  orderBy?: InputMaybe<Array<TaxonomiesOrderBy>>;
};

/** All input for the create `Techstack` mutation. */
export type GqlCreateTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Techstack` to be created by this mutation. */
  techstack: GqlTechstackInput;
};

/** The output of our create `Techstack` mutation. */
export type GqlCreateTechstackPayload = {
  __typename?: 'CreateTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `Techstack`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `Techstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Techstack` that was created by this mutation. */
  techstack: Maybe<GqlTechstack>;
  /** An edge for our `Techstack`. May be used by Relay 1. */
  techstackEdge: Maybe<GqlTechstacksEdge>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByAddedBy: Maybe<GqlUser>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByOwnedBy: Maybe<GqlUser>;
};


/** The output of our create `Techstack` mutation. */
export type GqlCreateTechstackPayloadTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** All input for the create `TempDatum` mutation. */
export type GqlCreateTempDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TempDatum` to be created by this mutation. */
  tempDatum: GqlTempDatumInput;
};

/** The output of our create `TempDatum` mutation. */
export type GqlCreateTempDatumPayload = {
  __typename?: 'CreateTempDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TempDatum` that was created by this mutation. */
  tempDatum: Maybe<GqlTempDatum>;
  /** An edge for our `TempDatum`. May be used by Relay 1. */
  tempDatumEdge: Maybe<GqlTempDataEdge>;
};


/** The output of our create `TempDatum` mutation. */
export type GqlCreateTempDatumPayloadTempDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<TempDataOrderBy>>;
};

/** All input for the create `Term` mutation. */
export type GqlCreateTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Term` to be created by this mutation. */
  term: GqlTermInput;
};

/** The output of our create `Term` mutation. */
export type GqlCreateTermPayload = {
  __typename?: 'CreateTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Taxonomy` that is related to this `Term`. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** The `Term` that was created by this mutation. */
  term: Maybe<GqlTerm>;
  /** An edge for our `Term`. May be used by Relay 1. */
  termEdge: Maybe<GqlTermsEdge>;
};


/** The output of our create `Term` mutation. */
export type GqlCreateTermPayloadTermEdgeArgs = {
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};

/** All input for the create `TermToOrganization` mutation. */
export type GqlCreateTermToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToOrganization` to be created by this mutation. */
  termToOrganization: GqlTermToOrganizationInput;
};

/** The output of our create `TermToOrganization` mutation. */
export type GqlCreateTermToOrganizationPayload = {
  __typename?: 'CreateTermToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToOrganization`. */
  term: Maybe<GqlTerm>;
  /** The `TermToOrganization` that was created by this mutation. */
  termToOrganization: Maybe<GqlTermToOrganization>;
  /** An edge for our `TermToOrganization`. May be used by Relay 1. */
  termToOrganizationEdge: Maybe<GqlTermToOrganizationsEdge>;
};


/** The output of our create `TermToOrganization` mutation. */
export type GqlCreateTermToOrganizationPayloadTermToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};

/** All input for the create `TermToProduct` mutation. */
export type GqlCreateTermToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToProduct` to be created by this mutation. */
  termToProduct: GqlTermToProductInput;
};

/** The output of our create `TermToProduct` mutation. */
export type GqlCreateTermToProductPayload = {
  __typename?: 'CreateTermToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TermToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToProduct`. */
  term: Maybe<GqlTerm>;
  /** The `TermToProduct` that was created by this mutation. */
  termToProduct: Maybe<GqlTermToProduct>;
  /** An edge for our `TermToProduct`. May be used by Relay 1. */
  termToProductEdge: Maybe<GqlTermToProductsEdge>;
};


/** The output of our create `TermToProduct` mutation. */
export type GqlCreateTermToProductPayloadTermToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};

/** All input for the create `TermToRfp` mutation. */
export type GqlCreateTermToRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToRfp` to be created by this mutation. */
  termToRfp: GqlTermToRfpInput;
};

/** The output of our create `TermToRfp` mutation. */
export type GqlCreateTermToRfpPayload = {
  __typename?: 'CreateTermToRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `TermToRfp`. */
  rfp: Maybe<GqlRfp>;
  /** Reads a single `Term` that is related to this `TermToRfp`. */
  term: Maybe<GqlTerm>;
  /** The `TermToRfp` that was created by this mutation. */
  termToRfp: Maybe<GqlTermToRfp>;
  /** An edge for our `TermToRfp`. May be used by Relay 1. */
  termToRfpEdge: Maybe<GqlTermToRfpsEdge>;
};


/** The output of our create `TermToRfp` mutation. */
export type GqlCreateTermToRfpPayloadTermToRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};

/** All input for the create `TermToSuiteListing` mutation. */
export type GqlCreateTermToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToSuiteListing` to be created by this mutation. */
  termToSuiteListing: GqlTermToSuiteListingInput;
};

/** The output of our create `TermToSuiteListing` mutation. */
export type GqlCreateTermToSuiteListingPayload = {
  __typename?: 'CreateTermToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `TermToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** Reads a single `Term` that is related to this `TermToSuiteListing`. */
  term: Maybe<GqlTerm>;
  /** The `TermToSuiteListing` that was created by this mutation. */
  termToSuiteListing: Maybe<GqlTermToSuiteListing>;
  /** An edge for our `TermToSuiteListing`. May be used by Relay 1. */
  termToSuiteListingEdge: Maybe<GqlTermToSuiteListingsEdge>;
};


/** The output of our create `TermToSuiteListing` mutation. */
export type GqlCreateTermToSuiteListingPayloadTermToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};

/** All input for the create `TermToTestDrive` mutation. */
export type GqlCreateTermToTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToTestDrive` to be created by this mutation. */
  termToTestDrive: GqlTermToTestDriveInput;
};

/** The output of our create `TermToTestDrive` mutation. */
export type GqlCreateTermToTestDrivePayload = {
  __typename?: 'CreateTermToTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToTestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TermToTestDrive` that was created by this mutation. */
  termToTestDrive: Maybe<GqlTermToTestDrive>;
  /** An edge for our `TermToTestDrive`. May be used by Relay 1. */
  termToTestDriveEdge: Maybe<GqlTermToTestDrivesEdge>;
  /** Reads a single `TestDrive` that is related to this `TermToTestDrive`. */
  testDrive: Maybe<GqlTestDrive>;
};


/** The output of our create `TermToTestDrive` mutation. */
export type GqlCreateTermToTestDrivePayloadTermToTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};

/** All input for the create `TermToUser` mutation. */
export type GqlCreateTermToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToUser` to be created by this mutation. */
  termToUser: GqlTermToUserInput;
};

/** The output of our create `TermToUser` mutation. */
export type GqlCreateTermToUserPayload = {
  __typename?: 'CreateTermToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToUser`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUser`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUser` that was created by this mutation. */
  termToUser: Maybe<GqlTermToUser>;
  /** An edge for our `TermToUser`. May be used by Relay 1. */
  termToUserEdge: Maybe<GqlTermToUsersEdge>;
  /** Reads a single `User` that is related to this `TermToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our create `TermToUser` mutation. */
export type GqlCreateTermToUserPayloadTermToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** All input for the create `TermToUserStory` mutation. */
export type GqlCreateTermToUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToUserStory` to be created by this mutation. */
  termToUserStory: GqlTermToUserStoryInput;
};

/** The output of our create `TermToUserStory` mutation. */
export type GqlCreateTermToUserStoryPayload = {
  __typename?: 'CreateTermToUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUserStory`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUserStory` that was created by this mutation. */
  termToUserStory: Maybe<GqlTermToUserStory>;
  /** An edge for our `TermToUserStory`. May be used by Relay 1. */
  termToUserStoryEdge: Maybe<GqlTermToUserStoriesEdge>;
  /** Reads a single `UserStory` that is related to this `TermToUserStory`. */
  userStory: Maybe<GqlUserStory>;
};


/** The output of our create `TermToUserStory` mutation. */
export type GqlCreateTermToUserStoryPayloadTermToUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};

/** All input for the create `TermToVendorStackshare` mutation. */
export type GqlCreateTermToVendorStackshareInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToVendorStackshare` to be created by this mutation. */
  termToVendorStackshare: GqlTermToVendorStackshareInput;
};

/** The output of our create `TermToVendorStackshare` mutation. */
export type GqlCreateTermToVendorStacksharePayload = {
  __typename?: 'CreateTermToVendorStacksharePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToVendorStackshare`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToVendorStackshare`. */
  term: Maybe<GqlTerm>;
  /** The `TermToVendorStackshare` that was created by this mutation. */
  termToVendorStackshare: Maybe<GqlTermToVendorStackshare>;
  /** An edge for our `TermToVendorStackshare`. May be used by Relay 1. */
  termToVendorStackshareEdge: Maybe<GqlTermToVendorStacksharesEdge>;
};


/** The output of our create `TermToVendorStackshare` mutation. */
export type GqlCreateTermToVendorStacksharePayloadTermToVendorStackshareEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};

/** All input for the `createTermsToOrganization` mutation. */
export type GqlCreateTermsToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `createTermsToOrganization` mutation. */
export type GqlCreateTermsToOrganizationPayload = {
  __typename?: 'CreateTermsToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToOrganizations: Maybe<Array<Maybe<GqlTermToOrganization>>>;
};

/** All input for the `createTermsToProduct` mutation. */
export type GqlCreateTermsToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `createTermsToProduct` mutation. */
export type GqlCreateTermsToProductPayload = {
  __typename?: 'CreateTermsToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToProducts: Maybe<Array<Maybe<GqlTermToProduct>>>;
};

/** All input for the `createTermsToRfp` mutation. */
export type GqlCreateTermsToRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  rfpId: Scalars['Int'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `createTermsToRfp` mutation. */
export type GqlCreateTermsToRfpPayload = {
  __typename?: 'CreateTermsToRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToRfps: Maybe<Array<Maybe<GqlTermToRfp>>>;
};

/** All input for the `createTermsToSuiteListing` mutation. */
export type GqlCreateTermsToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  suiteListingId: Scalars['Int'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `createTermsToSuiteListing` mutation. */
export type GqlCreateTermsToSuiteListingPayload = {
  __typename?: 'CreateTermsToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToSuiteListings: Maybe<Array<Maybe<GqlTermToSuiteListing>>>;
};

/** All input for the `createTermsToTestDrive` mutation. */
export type GqlCreateTermsToTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termIds: Array<InputMaybe<Scalars['Int']>>;
  testDriveId: Scalars['Int'];
};

/** The output of our `createTermsToTestDrive` mutation. */
export type GqlCreateTermsToTestDrivePayload = {
  __typename?: 'CreateTermsToTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToTestDrives: Maybe<Array<Maybe<GqlTermToTestDrive>>>;
};

/** All input for the `createTermsToUser` mutation. */
export type GqlCreateTermsToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termIds: Array<InputMaybe<Scalars['Int']>>;
  userId: Scalars['Int'];
};

/** The output of our `createTermsToUser` mutation. */
export type GqlCreateTermsToUserPayload = {
  __typename?: 'CreateTermsToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToUsers: Maybe<Array<Maybe<GqlTermToUser>>>;
};

/** All input for the create `Termscout` mutation. */
export type GqlCreateTermscoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Termscout` to be created by this mutation. */
  termscout: GqlTermscoutInput;
};

/** The output of our create `Termscout` mutation. */
export type GqlCreateTermscoutPayload = {
  __typename?: 'CreateTermscoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `Termscout`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Termscout` that was created by this mutation. */
  termscout: Maybe<GqlTermscout>;
  /** An edge for our `Termscout`. May be used by Relay 1. */
  termscoutEdge: Maybe<GqlTermscoutsEdge>;
};


/** The output of our create `Termscout` mutation. */
export type GqlCreateTermscoutPayloadTermscoutEdgeArgs = {
  orderBy?: InputMaybe<Array<TermscoutsOrderBy>>;
};

/** All input for the create `TestDrive` mutation. */
export type GqlCreateTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TestDrive` to be created by this mutation. */
  testDrive: GqlTestDriveInput;
};

/** The output of our create `TestDrive` mutation. */
export type GqlCreateTestDrivePayload = {
  __typename?: 'CreateTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TestDrive` that was created by this mutation. */
  testDrive: Maybe<GqlTestDrive>;
  /** An edge for our `TestDrive`. May be used by Relay 1. */
  testDriveEdge: Maybe<GqlTestDrivesEdge>;
};


/** The output of our create `TestDrive` mutation. */
export type GqlCreateTestDrivePayloadTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** All input for the create `TheoremProduct` mutation. */
export type GqlCreateTheoremProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TheoremProduct` to be created by this mutation. */
  theoremProduct: GqlTheoremProductInput;
};

/** The output of our create `TheoremProduct` mutation. */
export type GqlCreateTheoremProductPayload = {
  __typename?: 'CreateTheoremProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TheoremProduct` that was created by this mutation. */
  theoremProduct: Maybe<GqlTheoremProduct>;
  /** An edge for our `TheoremProduct`. May be used by Relay 1. */
  theoremProductEdge: Maybe<GqlTheoremProductsEdge>;
};


/** The output of our create `TheoremProduct` mutation. */
export type GqlCreateTheoremProductPayloadTheoremProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TheoremProductsOrderBy>>;
};

/** All input for the create `UseCase` mutation. */
export type GqlCreateUseCaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UseCase` to be created by this mutation. */
  useCase: GqlUseCaseInput;
};

/** The output of our create `UseCase` mutation. */
export type GqlCreateUseCasePayload = {
  __typename?: 'CreateUseCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UseCase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UseCase`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UseCase`. */
  termByPracticeGroup: Maybe<GqlTerm>;
  /** The `UseCase` that was created by this mutation. */
  useCase: Maybe<GqlUseCase>;
  /** An edge for our `UseCase`. May be used by Relay 1. */
  useCaseEdge: Maybe<GqlUseCasesEdge>;
  /** Reads a single `User` that is related to this `UseCase`. */
  userByAuthor: Maybe<GqlUser>;
};


/** The output of our create `UseCase` mutation. */
export type GqlCreateUseCasePayloadUseCaseEdgeArgs = {
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** All input for the create `User` mutation. */
export type GqlCreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be created by this mutation. */
  user: GqlUserInput;
};

/** The output of our create `User` mutation. */
export type GqlCreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `User`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByCurrentOrganization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `User` that was created by this mutation. */
  user: Maybe<GqlUser>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge: Maybe<GqlUsersEdge>;
};


/** The output of our create `User` mutation. */
export type GqlCreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the create `UserStory` mutation. */
export type GqlCreateUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserStory` to be created by this mutation. */
  userStory: GqlUserStoryInput;
};

/** The output of our create `UserStory` mutation. */
export type GqlCreateUserStoryPayload = {
  __typename?: 'CreateUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UserStory`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UserStory`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserStory`. */
  userByAuthor: Maybe<GqlUser>;
  /** The `UserStory` that was created by this mutation. */
  userStory: Maybe<GqlUserStory>;
  /** An edge for our `UserStory`. May be used by Relay 1. */
  userStoryEdge: Maybe<GqlUserStoriesEdge>;
};


/** The output of our create `UserStory` mutation. */
export type GqlCreateUserStoryPayloadUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** All input for the create `UserToOrgStack` mutation. */
export type GqlCreateUserToOrgStackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserToOrgStack` to be created by this mutation. */
  userToOrgStack: GqlUserToOrgStackInput;
};

/** The output of our create `UserToOrgStack` mutation. */
export type GqlCreateUserToOrgStackPayload = {
  __typename?: 'CreateUserToOrgStackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UserToOrgStack`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserToOrgStack`. */
  user: Maybe<GqlUser>;
  /** The `UserToOrgStack` that was created by this mutation. */
  userToOrgStack: Maybe<GqlUserToOrgStack>;
  /** An edge for our `UserToOrgStack`. May be used by Relay 1. */
  userToOrgStackEdge: Maybe<GqlUserToOrgStacksEdge>;
};


/** The output of our create `UserToOrgStack` mutation. */
export type GqlCreateUserToOrgStackPayloadUserToOrgStackEdgeArgs = {
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};

/** All input for the create `UsersToOrganization` mutation. */
export type GqlCreateUsersToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UsersToOrganization` to be created by this mutation. */
  usersToOrganization: GqlUsersToOrganizationInput;
};

/** The output of our create `UsersToOrganization` mutation. */
export type GqlCreateUsersToOrganizationPayload = {
  __typename?: 'CreateUsersToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `UsersToOrganization`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `UsersToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UsersToOrganization`. */
  termByJobTitle: Maybe<GqlTerm>;
  /** Reads a single `User` that is related to this `UsersToOrganization`. */
  user: Maybe<GqlUser>;
  /** The `UsersToOrganization` that was created by this mutation. */
  usersToOrganization: Maybe<GqlUsersToOrganization>;
  /** An edge for our `UsersToOrganization`. May be used by Relay 1. */
  usersToOrganizationEdge: Maybe<GqlUsersToOrganizationsEdge>;
};


/** The output of our create `UsersToOrganization` mutation. */
export type GqlCreateUsersToOrganizationPayloadUsersToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** All input for the create `UsersToPracticeGroup` mutation. */
export type GqlCreateUsersToPracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UsersToPracticeGroup` to be created by this mutation. */
  usersToPracticeGroup: GqlUsersToPracticeGroupInput;
};

/** The output of our create `UsersToPracticeGroup` mutation. */
export type GqlCreateUsersToPracticeGroupPayload = {
  __typename?: 'CreateUsersToPracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PracticeGroup` that is related to this `UsersToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UsersToPracticeGroup`. */
  user: Maybe<GqlUser>;
  /** The `UsersToPracticeGroup` that was created by this mutation. */
  usersToPracticeGroup: Maybe<GqlUsersToPracticeGroup>;
  /** An edge for our `UsersToPracticeGroup`. May be used by Relay 1. */
  usersToPracticeGroupEdge: Maybe<GqlUsersToPracticeGroupsEdge>;
};


/** The output of our create `UsersToPracticeGroup` mutation. */
export type GqlCreateUsersToPracticeGroupPayloadUsersToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};

/** All input for the create `UsersToTechstack` mutation. */
export type GqlCreateUsersToTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UsersToTechstack` to be created by this mutation. */
  usersToTechstack: GqlUsersToTechstackInput;
};

/** The output of our create `UsersToTechstack` mutation. */
export type GqlCreateUsersToTechstackPayload = {
  __typename?: 'CreateUsersToTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Techstack` that is related to this `UsersToTechstack`. */
  techstack: Maybe<GqlTechstack>;
  /** Reads a single `User` that is related to this `UsersToTechstack`. */
  user: Maybe<GqlUser>;
  /** The `UsersToTechstack` that was created by this mutation. */
  usersToTechstack: Maybe<GqlUsersToTechstack>;
  /** An edge for our `UsersToTechstack`. May be used by Relay 1. */
  usersToTechstackEdge: Maybe<GqlUsersToTechstacksEdge>;
};


/** The output of our create `UsersToTechstack` mutation. */
export type GqlCreateUsersToTechstackPayloadUsersToTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};

/** All input for the `createUsersToTechstacks` mutation. */
export type GqlCreateUsersToTechstacksInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  techstackIds: Array<InputMaybe<Scalars['Int']>>;
  userId: Scalars['Int'];
};

/** The output of our `createUsersToTechstacks` mutation. */
export type GqlCreateUsersToTechstacksPayload = {
  __typename?: 'CreateUsersToTechstacksPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  usersToTechstacks: Maybe<Array<Maybe<GqlUsersToTechstack>>>;
};

/** All input for the create `VendorStackshareLogo` mutation. */
export type GqlCreateVendorStackshareLogoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VendorStackshareLogo` to be created by this mutation. */
  vendorStackshareLogo: GqlVendorStackshareLogoInput;
};

/** The output of our create `VendorStackshareLogo` mutation. */
export type GqlCreateVendorStackshareLogoPayload = {
  __typename?: 'CreateVendorStackshareLogoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `VendorStackshareLogo`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `VendorStackshareLogo` that was created by this mutation. */
  vendorStackshareLogo: Maybe<GqlVendorStackshareLogo>;
  /** An edge for our `VendorStackshareLogo`. May be used by Relay 1. */
  vendorStackshareLogoEdge: Maybe<GqlVendorStackshareLogosEdge>;
};


/** The output of our create `VendorStackshareLogo` mutation. */
export type GqlCreateVendorStackshareLogoPayloadVendorStackshareLogoEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type GqlDatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

/** All input for the `deleteAssocHomeById` mutation. */
export type GqlDeleteAssocHomeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `AssocHome` mutation. */
export type GqlDeleteAssocHomePayload = {
  __typename?: 'DeleteAssocHomePayload';
  /** The `AssocHome` that was deleted by this mutation. */
  assocHome: Maybe<GqlAssocHome>;
  /** An edge for our `AssocHome`. May be used by Relay 1. */
  assocHomeEdge: Maybe<GqlAssocHomesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAssocHomeNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `AssocHome`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `AssocHome` mutation. */
export type GqlDeleteAssocHomePayloadAssocHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocHomesOrderBy>>;
};

/** All input for the `deleteAssocSectionByNodeId` mutation. */
export type GqlDeleteAssocSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AssocSection` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteAssocSection` mutation. */
export type GqlDeleteAssocSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `AssocSection` mutation. */
export type GqlDeleteAssocSectionPayload = {
  __typename?: 'DeleteAssocSectionPayload';
  /** The `AssocSection` that was deleted by this mutation. */
  assocSection: Maybe<GqlAssocSection>;
  /** An edge for our `AssocSection`. May be used by Relay 1. */
  assocSectionEdge: Maybe<GqlAssocSectionsEdge>;
  /** Reads a single `Organization` that is related to this `AssocSection`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAssocSectionNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `AssocSection` mutation. */
export type GqlDeleteAssocSectionPayloadAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};

/** All input for the `deleteAssociationToOrganizationByNodeId` mutation. */
export type GqlDeleteAssociationToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AssociationToOrganization` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteAssociationToOrganization` mutation. */
export type GqlDeleteAssociationToOrganizationInput = {
  associationId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
};

/** The output of our delete `AssociationToOrganization` mutation. */
export type GqlDeleteAssociationToOrganizationPayload = {
  __typename?: 'DeleteAssociationToOrganizationPayload';
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  association: Maybe<GqlOrganization>;
  /** The `AssociationToOrganization` that was deleted by this mutation. */
  associationToOrganization: Maybe<GqlAssociationToOrganization>;
  /** An edge for our `AssociationToOrganization`. May be used by Relay 1. */
  associationToOrganizationEdge: Maybe<GqlAssociationToOrganizationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAssociationToOrganizationNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `AssociationToOrganization` mutation. */
export type GqlDeleteAssociationToOrganizationPayloadAssociationToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};

/** All input for the `deleteAwardBadgeById` mutation. */
export type GqlDeleteAwardBadgeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** All input for the `deleteAwardBadgeBySlug` mutation. */
export type GqlDeleteAwardBadgeBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
};

/** The output of our delete `AwardBadge` mutation. */
export type GqlDeleteAwardBadgePayload = {
  __typename?: 'DeleteAwardBadgePayload';
  /** The `AwardBadge` that was deleted by this mutation. */
  awardBadge: Maybe<GqlAwardBadge>;
  /** An edge for our `AwardBadge`. May be used by Relay 1. */
  awardBadgeEdge: Maybe<GqlAwardBadgesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedAwardBadgeNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `AwardBadge` mutation. */
export type GqlDeleteAwardBadgePayloadAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<AwardBadgesOrderBy>>;
};

/** All input for the `deleteBestForByNodeId` mutation. */
export type GqlDeleteBestForByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BestFor` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBestFor` mutation. */
export type GqlDeleteBestForInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `BestFor` mutation. */
export type GqlDeleteBestForPayload = {
  __typename?: 'DeleteBestForPayload';
  /** The `BestFor` that was deleted by this mutation. */
  bestFor: Maybe<GqlBestFor>;
  /** An edge for our `BestFor`. May be used by Relay 1. */
  bestForEdge: Maybe<GqlBestForsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedBestForNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `BestFor` mutation. */
export type GqlDeleteBestForPayloadBestForEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForsOrderBy>>;
};

/** All input for the `deleteBestForToProductByNodeId` mutation. */
export type GqlDeleteBestForToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BestForToProduct` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteBestForToProduct` mutation. */
export type GqlDeleteBestForToProductInput = {
  bestForId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
};

/** The output of our delete `BestForToProduct` mutation. */
export type GqlDeleteBestForToProductPayload = {
  __typename?: 'DeleteBestForToProductPayload';
  /** Reads a single `BestFor` that is related to this `BestForToProduct`. */
  bestFor: Maybe<GqlBestFor>;
  /** The `BestForToProduct` that was deleted by this mutation. */
  bestForToProduct: Maybe<GqlBestForToProduct>;
  /** An edge for our `BestForToProduct`. May be used by Relay 1. */
  bestForToProductEdge: Maybe<GqlBestForToProductsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedBestForToProductNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `BestForToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `BestForToProduct` mutation. */
export type GqlDeleteBestForToProductPayloadBestForToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};

/** All input for the `deleteCategories` mutation. */
export type GqlDeleteCategoriesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteCategories` mutation. */
export type GqlDeleteCategoriesPayload = {
  __typename?: 'DeleteCategoriesPayload';
  category: Maybe<GqlCategory>;
  /** An edge for our `Category`. May be used by Relay 1. */
  categoryEdge: Maybe<GqlCategoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our `deleteCategories` mutation. */
export type GqlDeleteCategoriesPayloadCategoryEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};

/** All input for the `deleteCategoryByNodeId` mutation. */
export type GqlDeleteCategoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Category` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCategory` mutation. */
export type GqlDeleteCategoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Category` mutation. */
export type GqlDeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  /** The `Category` that was deleted by this mutation. */
  category: Maybe<GqlCategory>;
  /** An edge for our `Category`. May be used by Relay 1. */
  categoryEdge: Maybe<GqlCategoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedCategoryNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `Category` mutation. */
export type GqlDeleteCategoryPayloadCategoryEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};

/** All input for the `deleteCategoryToProductByNodeId` mutation. */
export type GqlDeleteCategoryToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CategoryToProduct` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCategoryToProduct` mutation. */
export type GqlDeleteCategoryToProductInput = {
  categoryId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
};

/** The output of our delete `CategoryToProduct` mutation. */
export type GqlDeleteCategoryToProductPayload = {
  __typename?: 'DeleteCategoryToProductPayload';
  /** Reads a single `Category` that is related to this `CategoryToProduct`. */
  category: Maybe<GqlCategory>;
  /** The `CategoryToProduct` that was deleted by this mutation. */
  categoryToProduct: Maybe<GqlCategoryToProduct>;
  /** An edge for our `CategoryToProduct`. May be used by Relay 1. */
  categoryToProductEdge: Maybe<GqlCategoryToProductsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedCategoryToProductNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `CategoryToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `CategoryToProduct` mutation. */
export type GqlDeleteCategoryToProductPayloadCategoryToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};

/** All input for the `deleteConnectCustomerByNodeId` mutation. */
export type GqlDeleteConnectCustomerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ConnectCustomer` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteConnectCustomerByUserIdAndAccountIdAndOrganizationId` mutation. */
export type GqlDeleteConnectCustomerByUserIdAndAccountIdAndOrganizationIdInput = {
  accountId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** All input for the `deleteConnectCustomer` mutation. */
export type GqlDeleteConnectCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ConnectCustomer` mutation. */
export type GqlDeleteConnectCustomerPayload = {
  __typename?: 'DeleteConnectCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectCustomer` that was deleted by this mutation. */
  connectCustomer: Maybe<GqlConnectCustomer>;
  /** An edge for our `ConnectCustomer`. May be used by Relay 1. */
  connectCustomerEdge: Maybe<GqlConnectCustomersEdge>;
  deletedConnectCustomerNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `ConnectCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ConnectCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `ConnectCustomer` mutation. */
export type GqlDeleteConnectCustomerPayloadConnectCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};

/** All input for the `deleteConnectPurchaseByNodeId` mutation. */
export type GqlDeleteConnectPurchaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ConnectPurchase` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteConnectPurchase` mutation. */
export type GqlDeleteConnectPurchaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ConnectPurchase` mutation. */
export type GqlDeleteConnectPurchasePayload = {
  __typename?: 'DeleteConnectPurchasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectPurchase` that was deleted by this mutation. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** An edge for our `ConnectPurchase`. May be used by Relay 1. */
  connectPurchaseEdge: Maybe<GqlConnectPurchasesEdge>;
  deletedConnectPurchaseNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `ConnectPurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `ConnectPurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ConnectPurchase` mutation. */
export type GqlDeleteConnectPurchasePayloadConnectPurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};

/** All input for the `deleteCoreStacks` mutation. */
export type GqlDeleteCoreStacksInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteCoreStacks` mutation. */
export type GqlDeleteCoreStacksPayload = {
  __typename?: 'DeleteCoreStacksPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  testDrive: Maybe<GqlTestDrive>;
  /** An edge for our `TestDrive`. May be used by Relay 1. */
  testDriveEdge: Maybe<GqlTestDrivesEdge>;
};


/** The output of our `deleteCoreStacks` mutation. */
export type GqlDeleteCoreStacksPayloadTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** All input for the `deleteDiversityCertificationByNodeId` mutation. */
export type GqlDeleteDiversityCertificationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DiversityCertification` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteDiversityCertification` mutation. */
export type GqlDeleteDiversityCertificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `DiversityCertification` mutation. */
export type GqlDeleteDiversityCertificationPayload = {
  __typename?: 'DeleteDiversityCertificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedDiversityCertificationNodeId: Maybe<Scalars['ID']>;
  /** The `DiversityCertification` that was deleted by this mutation. */
  diversityCertification: Maybe<GqlDiversityCertification>;
  /** An edge for our `DiversityCertification`. May be used by Relay 1. */
  diversityCertificationEdge: Maybe<GqlDiversityCertificationsEdge>;
  /** Reads a single `Organization` that is related to this `DiversityCertification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `DiversityCertification` mutation. */
export type GqlDeleteDiversityCertificationPayloadDiversityCertificationEdgeArgs = {
  orderBy?: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};

/** All input for the `deleteFeatureByNodeId` mutation. */
export type GqlDeleteFeatureByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Feature` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFeature` mutation. */
export type GqlDeleteFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Feature` mutation. */
export type GqlDeleteFeaturePayload = {
  __typename?: 'DeleteFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedFeatureNodeId: Maybe<Scalars['ID']>;
  /** The `Feature` that was deleted by this mutation. */
  feature: Maybe<GqlFeature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge: Maybe<GqlFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `Feature` mutation. */
export type GqlDeleteFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the `deleteFeatureToProductByNodeId` mutation. */
export type GqlDeleteFeatureToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeatureToProduct` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFeatureToProduct` mutation. */
export type GqlDeleteFeatureToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  featureId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** The output of our delete `FeatureToProduct` mutation. */
export type GqlDeleteFeatureToProductPayload = {
  __typename?: 'DeleteFeatureToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedFeatureToProductNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Feature` that is related to this `FeatureToProduct`. */
  feature: Maybe<GqlFeature>;
  /** The `FeatureToProduct` that was deleted by this mutation. */
  featureToProduct: Maybe<GqlFeatureToProduct>;
  /** An edge for our `FeatureToProduct`. May be used by Relay 1. */
  featureToProductEdge: Maybe<GqlFeatureToProductsEdge>;
  /** Reads a single `Product` that is related to this `FeatureToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `FeatureToProduct` mutation. */
export type GqlDeleteFeatureToProductPayloadFeatureToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};

/** All input for the `deleteLawfirmServiceByNodeId` mutation. */
export type GqlDeleteLawfirmServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LawfirmService` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteLawfirmService` mutation. */
export type GqlDeleteLawfirmServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `LawfirmService` mutation. */
export type GqlDeleteLawfirmServicePayload = {
  __typename?: 'DeleteLawfirmServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedLawfirmServiceNodeId: Maybe<Scalars['ID']>;
  /** The `LawfirmService` that was deleted by this mutation. */
  lawfirmService: Maybe<GqlLawfirmService>;
  /** An edge for our `LawfirmService`. May be used by Relay 1. */
  lawfirmServiceEdge: Maybe<GqlLawfirmServicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `LawfirmService` mutation. */
export type GqlDeleteLawfirmServicePayloadLawfirmServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<LawfirmServicesOrderBy>>;
};

/** All input for the `deleteListingCreatorById` mutation. */
export type GqlDeleteListingCreatorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ListingCreator` mutation. */
export type GqlDeleteListingCreatorPayload = {
  __typename?: 'DeleteListingCreatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedListingCreatorNodeId: Maybe<Scalars['ID']>;
  /** The `ListingCreator` that was deleted by this mutation. */
  listingCreator: Maybe<GqlListingCreator>;
  /** An edge for our `ListingCreator`. May be used by Relay 1. */
  listingCreatorEdge: Maybe<GqlListingCreatorsEdge>;
  /** Reads a single `Organization` that is related to this `ListingCreator`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ListingCreator` mutation. */
export type GqlDeleteListingCreatorPayloadListingCreatorEdgeArgs = {
  orderBy?: InputMaybe<Array<ListingCreatorsOrderBy>>;
};

/** All input for the `deleteLocationByNodeId` mutation. */
export type GqlDeleteLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Location` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteLocation` mutation. */
export type GqlDeleteLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Location` mutation. */
export type GqlDeleteLocationPayload = {
  __typename?: 'DeleteLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedLocationNodeId: Maybe<Scalars['ID']>;
  /** The `Location` that was deleted by this mutation. */
  location: Maybe<GqlLocation>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge: Maybe<GqlLocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `Location` mutation. */
export type GqlDeleteLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** All input for the `deleteNotificationByNodeId` mutation. */
export type GqlDeleteNotificationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Notification` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteNotification` mutation. */
export type GqlDeleteNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Notification` mutation. */
export type GqlDeleteNotificationPayload = {
  __typename?: 'DeleteNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedNotificationNodeId: Maybe<Scalars['ID']>;
  /** The `Notification` that was deleted by this mutation. */
  notification: Maybe<GqlNotification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<GqlNotificationsEdge>;
  /** Reads a single `Organization` that is related to this `Notification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `Notification`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `Notification` mutation. */
export type GqlDeleteNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `deleteNoviMemberByNodeId` mutation. */
export type GqlDeleteNoviMemberByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `NoviMember` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteNoviMember` mutation. */
export type GqlDeleteNoviMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  noviMemberId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** The output of our delete `NoviMember` mutation. */
export type GqlDeleteNoviMemberPayload = {
  __typename?: 'DeleteNoviMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedNoviMemberNodeId: Maybe<Scalars['ID']>;
  /** The `NoviMember` that was deleted by this mutation. */
  noviMember: Maybe<GqlNoviMember>;
  /** An edge for our `NoviMember`. May be used by Relay 1. */
  noviMemberEdge: Maybe<GqlNoviMembersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `NoviMember`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `NoviMember` mutation. */
export type GqlDeleteNoviMemberPayloadNoviMemberEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviMembersOrderBy>>;
};

/** All input for the `deleteNoviOrganizationByNodeId` mutation. */
export type GqlDeleteNoviOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `NoviOrganization` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteNoviOrganization` mutation. */
export type GqlDeleteNoviOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
};

/** The output of our delete `NoviOrganization` mutation. */
export type GqlDeleteNoviOrganizationPayload = {
  __typename?: 'DeleteNoviOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedNoviOrganizationNodeId: Maybe<Scalars['ID']>;
  /** The `NoviOrganization` that was deleted by this mutation. */
  noviOrganization: Maybe<GqlNoviOrganization>;
  /** An edge for our `NoviOrganization`. May be used by Relay 1. */
  noviOrganizationEdge: Maybe<GqlNoviOrganizationsEdge>;
  /** Reads a single `Organization` that is related to this `NoviOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `NoviOrganization` mutation. */
export type GqlDeleteNoviOrganizationPayloadNoviOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};

/** All input for the `deleteOrganizationByAuth0OrgId` mutation. */
export type GqlDeleteOrganizationByAuth0OrgIdInput = {
  auth0OrgId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** All input for the `deleteOrganizationByNodeId` mutation. */
export type GqlDeleteOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Organization` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrganization` mutation. */
export type GqlDeleteOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteOrganizationListingByNodeId` mutation. */
export type GqlDeleteOrganizationListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrganizationListing` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrganizationListing` mutation. */
export type GqlDeleteOrganizationListingInput = {
  associationId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
};

/** The output of our delete `OrganizationListing` mutation. */
export type GqlDeleteOrganizationListingPayload = {
  __typename?: 'DeleteOrganizationListingPayload';
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `OrganizationListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  deletedOrganizationListingNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationListing` that was deleted by this mutation. */
  organizationListing: Maybe<GqlOrganizationListing>;
  /** An edge for our `OrganizationListing`. May be used by Relay 1. */
  organizationListingEdge: Maybe<GqlOrganizationListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `OrganizationListing` mutation. */
export type GqlDeleteOrganizationListingPayloadOrganizationListingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** The output of our delete `Organization` mutation. */
export type GqlDeleteOrganizationPayload = {
  __typename?: 'DeleteOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedOrganizationNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Term` that is related to this `Organization`. */
  mainTerm: Maybe<GqlTerm>;
  /** The `Organization` that was deleted by this mutation. */
  organization: Maybe<GqlOrganization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge: Maybe<GqlOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `Organization` mutation. */
export type GqlDeleteOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the `deleteOrganizationTechstackByNodeId` mutation. */
export type GqlDeleteOrganizationTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrganizationTechstack` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteOrganizationTechstack` mutation. */
export type GqlDeleteOrganizationTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our delete `OrganizationTechstack` mutation. */
export type GqlDeleteOrganizationTechstackPayload = {
  __typename?: 'DeleteOrganizationTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedOrganizationTechstackNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `OrganizationTechstack`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationTechstack` that was deleted by this mutation. */
  organizationTechstack: Maybe<GqlOrganizationTechstack>;
  /** An edge for our `OrganizationTechstack`. May be used by Relay 1. */
  organizationTechstackEdge: Maybe<GqlOrganizationTechstacksEdge>;
  /** Reads a single `Product` that is related to this `OrganizationTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `OrganizationTechstack` mutation. */
export type GqlDeleteOrganizationTechstackPayloadOrganizationTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};

/** All input for the `deleteOrganizations` mutation. */
export type GqlDeleteOrganizationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

/** The output of our `deleteOrganizations` mutation. */
export type GqlDeleteOrganizationsPayload = {
  __typename?: 'DeleteOrganizationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  organizations: Maybe<Array<Maybe<GqlOrganization>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the `deletePersonalTechstackByNodeId` mutation. */
export type GqlDeletePersonalTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PersonalTechstack` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePersonalTechstack` mutation. */
export type GqlDeletePersonalTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our delete `PersonalTechstack` mutation. */
export type GqlDeletePersonalTechstackPayload = {
  __typename?: 'DeletePersonalTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPersonalTechstackNodeId: Maybe<Scalars['ID']>;
  /** The `PersonalTechstack` that was deleted by this mutation. */
  personalTechstack: Maybe<GqlPersonalTechstack>;
  /** An edge for our `PersonalTechstack`. May be used by Relay 1. */
  personalTechstackEdge: Maybe<GqlPersonalTechstacksEdge>;
  /** Reads a single `Product` that is related to this `PersonalTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `PersonalTechstack`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `PersonalTechstack` mutation. */
export type GqlDeletePersonalTechstackPayloadPersonalTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};

/** All input for the `deletePersonalTechstacks` mutation. */
export type GqlDeletePersonalTechstacksInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productIds: Array<InputMaybe<Scalars['Int']>>;
  userId: Scalars['Int'];
};

/** The output of our `deletePersonalTechstacks` mutation. */
export type GqlDeletePersonalTechstacksPayload = {
  __typename?: 'DeletePersonalTechstacksPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  personalTechstacks: Maybe<Array<Maybe<GqlPersonalTechstack>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the `deletePracticeGroupByNodeId` mutation. */
export type GqlDeletePracticeGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PracticeGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePracticeGroup` mutation. */
export type GqlDeletePracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `PracticeGroup` mutation. */
export type GqlDeletePracticeGroupPayload = {
  __typename?: 'DeletePracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPracticeGroupNodeId: Maybe<Scalars['ID']>;
  /** The `PracticeGroup` that was deleted by this mutation. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** An edge for our `PracticeGroup`. May be used by Relay 1. */
  practiceGroupEdge: Maybe<GqlPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `PracticeGroup` mutation. */
export type GqlDeletePracticeGroupPayloadPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};

/** All input for the `deletePremiumInfoToTermByNodeId` mutation. */
export type GqlDeletePremiumInfoToTermByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PremiumInfoToTerm` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePremiumInfoToTerm` mutation. */
export type GqlDeletePremiumInfoToTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  premiumInfoId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our delete `PremiumInfoToTerm` mutation. */
export type GqlDeletePremiumInfoToTermPayload = {
  __typename?: 'DeletePremiumInfoToTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPremiumInfoToTermNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `PremiumProductInfo` that is related to this `PremiumInfoToTerm`. */
  premiumInfo: Maybe<GqlPremiumProductInfo>;
  /** The `PremiumInfoToTerm` that was deleted by this mutation. */
  premiumInfoToTerm: Maybe<GqlPremiumInfoToTerm>;
  /** An edge for our `PremiumInfoToTerm`. May be used by Relay 1. */
  premiumInfoToTermEdge: Maybe<GqlPremiumInfoToTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `PremiumInfoToTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our delete `PremiumInfoToTerm` mutation. */
export type GqlDeletePremiumInfoToTermPayloadPremiumInfoToTermEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};

/** All input for the `deletePremiumProductInfoByIdAndProductId` mutation. */
export type GqlDeletePremiumProductInfoByIdAndProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  productId: Scalars['Int'];
};

/** All input for the `deletePremiumProductInfoByNodeId` mutation. */
export type GqlDeletePremiumProductInfoByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PremiumProductInfo` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePremiumProductInfo` mutation. */
export type GqlDeletePremiumProductInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `PremiumProductInfo` mutation. */
export type GqlDeletePremiumProductInfoPayload = {
  __typename?: 'DeletePremiumProductInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedPremiumProductInfoNodeId: Maybe<Scalars['ID']>;
  /** The `PremiumProductInfo` that was deleted by this mutation. */
  premiumProductInfo: Maybe<GqlPremiumProductInfo>;
  /** An edge for our `PremiumProductInfo`. May be used by Relay 1. */
  premiumProductInfoEdge: Maybe<GqlPremiumProductInfosEdge>;
  /** Reads a single `Product` that is related to this `PremiumProductInfo`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `PremiumProductInfo` mutation. */
export type GqlDeletePremiumProductInfoPayloadPremiumProductInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};

/** All input for the `deleteProductAwardDetailByNodeId` mutation. */
export type GqlDeleteProductAwardDetailByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductAwardDetail` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductAwardDetail` mutation. */
export type GqlDeleteProductAwardDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  year: Scalars['Int'];
};

/** The output of our delete `ProductAwardDetail` mutation. */
export type GqlDeleteProductAwardDetailPayload = {
  __typename?: 'DeleteProductAwardDetailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductAwardDetailNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductAwardDetail`. */
  product: Maybe<GqlProduct>;
  /** The `ProductAwardDetail` that was deleted by this mutation. */
  productAwardDetail: Maybe<GqlProductAwardDetail>;
  /** An edge for our `ProductAwardDetail`. May be used by Relay 1. */
  productAwardDetailEdge: Maybe<GqlProductAwardDetailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductAwardDetail` mutation. */
export type GqlDeleteProductAwardDetailPayloadProductAwardDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};

/** All input for the `deleteProductByNodeId` mutation. */
export type GqlDeleteProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Product` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductFeatureByTermByNodeId` mutation. */
export type GqlDeleteProductFeatureByTermByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductFeatureByTerm` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductFeatureByTerm` mutation. */
export type GqlDeleteProductFeatureByTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  networkId: Scalars['UUID'];
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our delete `ProductFeatureByTerm` mutation. */
export type GqlDeleteProductFeatureByTermPayload = {
  __typename?: 'DeleteProductFeatureByTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductFeatureByTermNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `ProductFeatureByTerm`. */
  network: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductFeatureByTerm`. */
  product: Maybe<GqlProduct>;
  /** The `ProductFeatureByTerm` that was deleted by this mutation. */
  productFeatureByTerm: Maybe<GqlProductFeatureByTerm>;
  /** An edge for our `ProductFeatureByTerm`. May be used by Relay 1. */
  productFeatureByTermEdge: Maybe<GqlProductFeatureByTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `ProductFeatureByTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our delete `ProductFeatureByTerm` mutation. */
export type GqlDeleteProductFeatureByTermPayloadProductFeatureByTermEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** All input for the `deleteProduct` mutation. */
export type GqlDeleteProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** All input for the `deleteProductListingByNodeId` mutation. */
export type GqlDeleteProductListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductListing` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductListingByProductIdAndAssociationId` mutation. */
export type GqlDeleteProductListingByProductIdAndAssociationIdInput = {
  associationId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
};

/** All input for the `deleteProductListing` mutation. */
export type GqlDeleteProductListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ProductListing` mutation. */
export type GqlDeleteProductListingPayload = {
  __typename?: 'DeleteProductListingPayload';
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `ProductListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  deletedProductListingNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductListing` that was deleted by this mutation. */
  productListing: Maybe<GqlProductListing>;
  /** An edge for our `ProductListing`. May be used by Relay 1. */
  productListingEdge: Maybe<GqlProductListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductListing` mutation. */
export type GqlDeleteProductListingPayloadProductListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** The output of our delete `Product` mutation. */
export type GqlDeleteProductPayload = {
  __typename?: 'DeleteProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductNodeId: Maybe<Scalars['ID']>;
  /** The `Product` that was deleted by this mutation. */
  product: Maybe<GqlProduct>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge: Maybe<GqlProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `Product` mutation. */
export type GqlDeleteProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `deleteProductSectionByNodeId` mutation. */
export type GqlDeleteProductSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductSection` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductSection` mutation. */
export type GqlDeleteProductSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `ProductSection` mutation. */
export type GqlDeleteProductSectionPayload = {
  __typename?: 'DeleteProductSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductSectionNodeId: Maybe<Scalars['ID']>;
  /** The `ProductSection` that was deleted by this mutation. */
  productSection: Maybe<GqlProductSection>;
  /** An edge for our `ProductSection`. May be used by Relay 1. */
  productSectionEdge: Maybe<GqlProductSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductSection` mutation. */
export type GqlDeleteProductSectionPayloadProductSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductSectionsOrderBy>>;
};

/** All input for the `deleteProductToAssocSectionByNodeId` mutation. */
export type GqlDeleteProductToAssocSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToAssocSection` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToAssocSection` mutation. */
export type GqlDeleteProductToAssocSectionInput = {
  assocSectionId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToAssocSection` mutation. */
export type GqlDeleteProductToAssocSectionPayload = {
  __typename?: 'DeleteProductToAssocSectionPayload';
  /** Reads a single `AssocSection` that is related to this `ProductToAssocSection`. */
  assocSection: Maybe<GqlAssocSection>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToAssocSectionNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductToAssocSection`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAssocSection` that was deleted by this mutation. */
  productToAssocSection: Maybe<GqlProductToAssocSection>;
  /** An edge for our `ProductToAssocSection`. May be used by Relay 1. */
  productToAssocSectionEdge: Maybe<GqlProductToAssocSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToAssocSection` mutation. */
export type GqlDeleteProductToAssocSectionPayloadProductToAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};

/** All input for the `deleteProductToAwardBadgeByNodeId` mutation. */
export type GqlDeleteProductToAwardBadgeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToAwardBadge` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToAwardBadge` mutation. */
export type GqlDeleteProductToAwardBadgeInput = {
  awardBadgeId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToAwardBadge` mutation. */
export type GqlDeleteProductToAwardBadgePayload = {
  __typename?: 'DeleteProductToAwardBadgePayload';
  /** Reads a single `AwardBadge` that is related to this `ProductToAwardBadge`. */
  awardBadge: Maybe<GqlAwardBadge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToAwardBadgeNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductToAwardBadge`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAwardBadge` that was deleted by this mutation. */
  productToAwardBadge: Maybe<GqlProductToAwardBadge>;
  /** An edge for our `ProductToAwardBadge`. May be used by Relay 1. */
  productToAwardBadgeEdge: Maybe<GqlProductToAwardBadgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToAwardBadge` mutation. */
export type GqlDeleteProductToAwardBadgePayloadProductToAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};

/** All input for the `deleteProductToClientByNodeId` mutation. */
export type GqlDeleteProductToClientByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToClient` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToClient` mutation. */
export type GqlDeleteProductToClientInput = {
  clientId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToClient` mutation. */
export type GqlDeleteProductToClientPayload = {
  __typename?: 'DeleteProductToClientPayload';
  /** Reads a single `Organization` that is related to this `ProductToClient`. */
  client: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToClientNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductToClient`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToClient` that was deleted by this mutation. */
  productToClient: Maybe<GqlProductToClient>;
  /** An edge for our `ProductToClient`. May be used by Relay 1. */
  productToClientEdge: Maybe<GqlProductToClientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToClient` mutation. */
export type GqlDeleteProductToClientPayloadProductToClientEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};

/** All input for the `deleteProductToCompetitorByNodeId` mutation. */
export type GqlDeleteProductToCompetitorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToCompetitor` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToCompetitor` mutation. */
export type GqlDeleteProductToCompetitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  competitorId: Scalars['Int'];
  locked: Scalars['Boolean'];
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToCompetitor` mutation. */
export type GqlDeleteProductToCompetitorPayload = {
  __typename?: 'DeleteProductToCompetitorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  competitor: Maybe<GqlProduct>;
  deletedCompetitorNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `ProductToCompetitor`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToCompetitor` that was deleted by this mutation. */
  productToCompetitor: Maybe<GqlProductToCompetitor>;
  /** An edge for our `ProductToCompetitor`. May be used by Relay 1. */
  productToCompetitorEdge: Maybe<GqlProductToCompetitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToCompetitor` mutation. */
export type GqlDeleteProductToCompetitorPayloadProductToCompetitorEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** All input for the `deleteProductToIntegrationByNodeId` mutation. */
export type GqlDeleteProductToIntegrationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToIntegration` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToIntegration` mutation. */
export type GqlDeleteProductToIntegrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integrationId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToIntegration` mutation. */
export type GqlDeleteProductToIntegrationPayload = {
  __typename?: 'DeleteProductToIntegrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedIntegrationNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  integration: Maybe<GqlProduct>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToIntegration` that was deleted by this mutation. */
  productToIntegration: Maybe<GqlProductToIntegration>;
  /** An edge for our `ProductToIntegration`. May be used by Relay 1. */
  productToIntegrationEdge: Maybe<GqlProductToIntegrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToIntegration` mutation. */
export type GqlDeleteProductToIntegrationPayloadProductToIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};

/** All input for the `deleteProductToIntegrations` mutation. */
export type GqlDeleteProductToIntegrationsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integrationIds: Array<InputMaybe<Scalars['Int']>>;
  productId: Scalars['Int'];
};

/** The output of our `deleteProductToIntegrations` mutation. */
export type GqlDeleteProductToIntegrationsPayload = {
  __typename?: 'DeleteProductToIntegrationsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  productToIntegrations: Maybe<Array<Maybe<GqlProductToIntegration>>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the `deleteProductToOrganizationByNodeId` mutation. */
export type GqlDeleteProductToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToOrganization` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToOrganization` mutation. */
export type GqlDeleteProductToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToOrganization` mutation. */
export type GqlDeleteProductToOrganizationPayload = {
  __typename?: 'DeleteProductToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToOrganizationNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `ProductToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToOrganization`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToOrganization` that was deleted by this mutation. */
  productToOrganization: Maybe<GqlProductToOrganization>;
  /** An edge for our `ProductToOrganization`. May be used by Relay 1. */
  productToOrganizationEdge: Maybe<GqlProductToOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToOrganization` mutation. */
export type GqlDeleteProductToOrganizationPayloadProductToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};

/** All input for the `deleteProductToPracticeGroupByNodeId` mutation. */
export type GqlDeleteProductToPracticeGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToPracticeGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToPracticeGroup` mutation. */
export type GqlDeleteProductToPracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  practiceGroupId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** The output of our delete `ProductToPracticeGroup` mutation. */
export type GqlDeleteProductToPracticeGroupPayload = {
  __typename?: 'DeleteProductToPracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToPracticeGroupNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `PracticeGroup` that is related to this `ProductToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Reads a single `Product` that is related to this `ProductToPracticeGroup`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToPracticeGroup` that was deleted by this mutation. */
  productToPracticeGroup: Maybe<GqlProductToPracticeGroup>;
  /** An edge for our `ProductToPracticeGroup`. May be used by Relay 1. */
  productToPracticeGroupEdge: Maybe<GqlProductToPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our delete `ProductToPracticeGroup` mutation. */
export type GqlDeleteProductToPracticeGroupPayloadProductToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};

/** All input for the `deleteProductToSuiteListingByNodeId` mutation. */
export type GqlDeleteProductToSuiteListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToSuiteListing` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToSuiteListing` mutation. */
export type GqlDeleteProductToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  suiteListingId: Scalars['Int'];
};

/** The output of our delete `ProductToSuiteListing` mutation. */
export type GqlDeleteProductToSuiteListingPayload = {
  __typename?: 'DeleteProductToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToSuiteListingNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductToSuiteListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToSuiteListing` that was deleted by this mutation. */
  productToSuiteListing: Maybe<GqlProductToSuiteListing>;
  /** An edge for our `ProductToSuiteListing`. May be used by Relay 1. */
  productToSuiteListingEdge: Maybe<GqlProductToSuiteListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `ProductToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
};


/** The output of our delete `ProductToSuiteListing` mutation. */
export type GqlDeleteProductToSuiteListingPayloadProductToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};

/** All input for the `deleteProductToUserByNodeId` mutation. */
export type GqlDeleteProductToUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteProductToUser` mutation. */
export type GqlDeleteProductToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our delete `ProductToUser` mutation. */
export type GqlDeleteProductToUserPayload = {
  __typename?: 'DeleteProductToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedProductToUserNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `ProductToUser`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToUser` that was deleted by this mutation. */
  productToUser: Maybe<GqlProductToUser>;
  /** An edge for our `ProductToUser`. May be used by Relay 1. */
  productToUserEdge: Maybe<GqlProductToUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ProductToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `ProductToUser` mutation. */
export type GqlDeleteProductToUserPayloadProductToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};

/** All input for the `deleteProducts` mutation. */
export type GqlDeleteProductsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteProducts` mutation. */
export type GqlDeleteProductsPayload = {
  __typename?: 'DeleteProductsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  product: Maybe<GqlProduct>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge: Maybe<GqlProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our `deleteProducts` mutation. */
export type GqlDeleteProductsPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `deleteRfpByNodeId` mutation. */
export type GqlDeleteRfpByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Rfp` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteRfp` mutation. */
export type GqlDeleteRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Rfp` mutation. */
export type GqlDeleteRfpPayload = {
  __typename?: 'DeleteRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedRfpNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Rfp` that was deleted by this mutation. */
  rfp: Maybe<GqlRfp>;
  /** An edge for our `Rfp`. May be used by Relay 1. */
  rfpEdge: Maybe<GqlRfpsEdge>;
  /** Reads a single `User` that is related to this `Rfp`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `Rfp` mutation. */
export type GqlDeleteRfpPayloadRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};

/** All input for the `deleteRfpToProductByNodeId` mutation. */
export type GqlDeleteRfpToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RfpToProduct` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteRfpToProduct` mutation. */
export type GqlDeleteRfpToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  rfpId: Scalars['Int'];
};

/** The output of our delete `RfpToProduct` mutation. */
export type GqlDeleteRfpToProductPayload = {
  __typename?: 'DeleteRfpToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedRfpToProductNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `RfpToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `RfpToProduct`. */
  rfp: Maybe<GqlRfp>;
  /** The `RfpToProduct` that was deleted by this mutation. */
  rfpToProduct: Maybe<GqlRfpToProduct>;
  /** An edge for our `RfpToProduct`. May be used by Relay 1. */
  rfpToProductEdge: Maybe<GqlRfpToProductsEdge>;
};


/** The output of our delete `RfpToProduct` mutation. */
export type GqlDeleteRfpToProductPayloadRfpToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};

/** All input for the `deleteSchedulerByNodeId` mutation. */
export type GqlDeleteSchedulerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Scheduler` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteScheduler` mutation. */
export type GqlDeleteSchedulerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Scheduler` mutation. */
export type GqlDeleteSchedulerPayload = {
  __typename?: 'DeleteSchedulerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSchedulerNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Scheduler` that was deleted by this mutation. */
  scheduler: Maybe<GqlScheduler>;
  /** An edge for our `Scheduler`. May be used by Relay 1. */
  schedulerEdge: Maybe<GqlSchedulersEdge>;
  /** Reads a single `User` that is related to this `Scheduler`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `Scheduler` mutation. */
export type GqlDeleteSchedulerPayloadSchedulerEdgeArgs = {
  orderBy?: InputMaybe<Array<SchedulersOrderBy>>;
};

/** All input for the `deleteSectionLayoutByNodeId` mutation. */
export type GqlDeleteSectionLayoutByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SectionLayout` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSectionLayout` mutation. */
export type GqlDeleteSectionLayoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SectionLayout` mutation. */
export type GqlDeleteSectionLayoutPayload = {
  __typename?: 'DeleteSectionLayoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSectionLayoutNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SectionLayout` that was deleted by this mutation. */
  sectionLayout: Maybe<GqlSectionLayout>;
  /** An edge for our `SectionLayout`. May be used by Relay 1. */
  sectionLayoutEdge: Maybe<GqlSectionLayoutsEdge>;
};


/** The output of our delete `SectionLayout` mutation. */
export type GqlDeleteSectionLayoutPayloadSectionLayoutEdgeArgs = {
  orderBy?: InputMaybe<Array<SectionLayoutsOrderBy>>;
};

/** All input for the `deleteSimpleServiceByNodeId` mutation. */
export type GqlDeleteSimpleServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SimpleService` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSimpleServiceByOrganizationIdAndTermId` mutation. */
export type GqlDeleteSimpleServiceByOrganizationIdAndTermIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};

/** All input for the `deleteSimpleService` mutation. */
export type GqlDeleteSimpleServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SimpleService` mutation. */
export type GqlDeleteSimpleServicePayload = {
  __typename?: 'DeleteSimpleServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSimpleServiceNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `SimpleService`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SimpleService` that was deleted by this mutation. */
  simpleService: Maybe<GqlSimpleService>;
  /** An edge for our `SimpleService`. May be used by Relay 1. */
  simpleServiceEdge: Maybe<GqlSimpleServicesEdge>;
  /** Reads a single `Term` that is related to this `SimpleService`. */
  term: Maybe<GqlTerm>;
};


/** The output of our delete `SimpleService` mutation. */
export type GqlDeleteSimpleServicePayloadSimpleServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};

/** All input for the `deleteStackshareOptionByNodeId` mutation. */
export type GqlDeleteStackshareOptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StackshareOption` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteStackshareOption` mutation. */
export type GqlDeleteStackshareOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `StackshareOption` mutation. */
export type GqlDeleteStackshareOptionPayload = {
  __typename?: 'DeleteStackshareOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedStackshareOptionNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StackshareOption` that was deleted by this mutation. */
  stackshareOption: Maybe<GqlStackshareOption>;
  /** An edge for our `StackshareOption`. May be used by Relay 1. */
  stackshareOptionEdge: Maybe<GqlStackshareOptionsEdge>;
};


/** The output of our delete `StackshareOption` mutation. */
export type GqlDeleteStackshareOptionPayloadStackshareOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<StackshareOptionsOrderBy>>;
};

/** All input for the `deleteStripeAccountByNodeId` mutation. */
export type GqlDeleteStripeAccountByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripeAccount` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteStripeAccount` mutation. */
export type GqlDeleteStripeAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `StripeAccount` mutation. */
export type GqlDeleteStripeAccountPayload = {
  __typename?: 'DeleteStripeAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedStripeAccountNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `StripeAccount`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeAccount` that was deleted by this mutation. */
  stripeAccount: Maybe<GqlStripeAccount>;
  /** An edge for our `StripeAccount`. May be used by Relay 1. */
  stripeAccountEdge: Maybe<GqlStripeAccountsEdge>;
  /** Reads a single `User` that is related to this `StripeAccount`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `StripeAccount` mutation. */
export type GqlDeleteStripeAccountPayloadStripeAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};

/** All input for the `deleteStripeCustomerByNodeId` mutation. */
export type GqlDeleteStripeCustomerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripeCustomer` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteStripeCustomer` mutation. */
export type GqlDeleteStripeCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `StripeCustomer` mutation. */
export type GqlDeleteStripeCustomerPayload = {
  __typename?: 'DeleteStripeCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedStripeCustomerNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `StripeCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeCustomer` that was deleted by this mutation. */
  stripeCustomer: Maybe<GqlStripeCustomer>;
  /** An edge for our `StripeCustomer`. May be used by Relay 1. */
  stripeCustomerEdge: Maybe<GqlStripeCustomersEdge>;
  /** Reads a single `User` that is related to this `StripeCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `StripeCustomer` mutation. */
export type GqlDeleteStripeCustomerPayloadStripeCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** All input for the `deleteStripePurchaseByNodeId` mutation. */
export type GqlDeleteStripePurchaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripePurchase` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteStripePurchase` mutation. */
export type GqlDeleteStripePurchaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `StripePurchase` mutation. */
export type GqlDeleteStripePurchasePayload = {
  __typename?: 'DeleteStripePurchasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedStripePurchaseNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `StripePurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `StripePurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripePurchase` that was deleted by this mutation. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** An edge for our `StripePurchase`. May be used by Relay 1. */
  stripePurchaseEdge: Maybe<GqlStripePurchasesEdge>;
};


/** The output of our delete `StripePurchase` mutation. */
export type GqlDeleteStripePurchasePayloadStripePurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};

/** All input for the `deleteStripeSeatByNodeId` mutation. */
export type GqlDeleteStripeSeatByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripeSeat` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteStripeSeat` mutation. */
export type GqlDeleteStripeSeatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `StripeSeat` mutation. */
export type GqlDeleteStripeSeatPayload = {
  __typename?: 'DeleteStripeSeatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedStripeSeatNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `StripeSeat`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeSeat` that was deleted by this mutation. */
  stripeSeat: Maybe<GqlStripeSeat>;
  /** An edge for our `StripeSeat`. May be used by Relay 1. */
  stripeSeatEdge: Maybe<GqlStripeSeatsEdge>;
  /** Reads a single `User` that is related to this `StripeSeat`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `StripeSeat` mutation. */
export type GqlDeleteStripeSeatPayloadStripeSeatEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** All input for the `deleteStripeSeats` mutation. */
export type GqlDeleteStripeSeatsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteStripeSeats` mutation. */
export type GqlDeleteStripeSeatsPayload = {
  __typename?: 'DeleteStripeSeatsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeSeat`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  stripeSeat: Maybe<GqlStripeSeat>;
  /** An edge for our `StripeSeat`. May be used by Relay 1. */
  stripeSeatEdge: Maybe<GqlStripeSeatsEdge>;
  /** Reads a single `User` that is related to this `StripeSeat`. */
  user: Maybe<GqlUser>;
};


/** The output of our `deleteStripeSeats` mutation. */
export type GqlDeleteStripeSeatsPayloadStripeSeatEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** All input for the `deleteSuiteListingByNodeId` mutation. */
export type GqlDeleteSuiteListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SuiteListing` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteSuiteListing` mutation. */
export type GqlDeleteSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `SuiteListing` mutation. */
export type GqlDeleteSuiteListingPayload = {
  __typename?: 'DeleteSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedSuiteListingNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `SuiteListing`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `StripePurchase` that is related to this `SuiteListing`. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** The `SuiteListing` that was deleted by this mutation. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** An edge for our `SuiteListing`. May be used by Relay 1. */
  suiteListingEdge: Maybe<GqlSuiteListingsEdge>;
};


/** The output of our delete `SuiteListing` mutation. */
export type GqlDeleteSuiteListingPayloadSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

/** All input for the `deleteTaxonomyByNodeId` mutation. */
export type GqlDeleteTaxonomyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Taxonomy` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTaxonomy` mutation. */
export type GqlDeleteTaxonomyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Taxonomy` mutation. */
export type GqlDeleteTaxonomyPayload = {
  __typename?: 'DeleteTaxonomyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTaxonomyNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Taxonomy` that is related to this `Taxonomy`. */
  parent: Maybe<GqlTaxonomy>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Taxonomy` that was deleted by this mutation. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** An edge for our `Taxonomy`. May be used by Relay 1. */
  taxonomyEdge: Maybe<GqlTaxonomiesEdge>;
};


/** The output of our delete `Taxonomy` mutation. */
export type GqlDeleteTaxonomyPayloadTaxonomyEdgeArgs = {
  orderBy?: InputMaybe<Array<TaxonomiesOrderBy>>;
};

/** All input for the `deleteTechstackByNodeId` mutation. */
export type GqlDeleteTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Techstack` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTechstackByOrganizationIdAndProductId` mutation. */
export type GqlDeleteTechstackByOrganizationIdAndProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
};

/** All input for the `deleteTechstack` mutation. */
export type GqlDeleteTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Techstack` mutation. */
export type GqlDeleteTechstackPayload = {
  __typename?: 'DeleteTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTechstackNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `Techstack`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `Techstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Techstack` that was deleted by this mutation. */
  techstack: Maybe<GqlTechstack>;
  /** An edge for our `Techstack`. May be used by Relay 1. */
  techstackEdge: Maybe<GqlTechstacksEdge>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByAddedBy: Maybe<GqlUser>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByOwnedBy: Maybe<GqlUser>;
};


/** The output of our delete `Techstack` mutation. */
export type GqlDeleteTechstackPayloadTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** All input for the `deleteTempDatumById` mutation. */
export type GqlDeleteTempDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `TempDatum` mutation. */
export type GqlDeleteTempDatumPayload = {
  __typename?: 'DeleteTempDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTempDatumNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TempDatum` that was deleted by this mutation. */
  tempDatum: Maybe<GqlTempDatum>;
  /** An edge for our `TempDatum`. May be used by Relay 1. */
  tempDatumEdge: Maybe<GqlTempDataEdge>;
};


/** The output of our delete `TempDatum` mutation. */
export type GqlDeleteTempDatumPayloadTempDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<TempDataOrderBy>>;
};

/** All input for the `deleteTermByNodeId` mutation. */
export type GqlDeleteTermByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Term` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTerm` mutation. */
export type GqlDeleteTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Term` mutation. */
export type GqlDeleteTermPayload = {
  __typename?: 'DeleteTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Taxonomy` that is related to this `Term`. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** The `Term` that was deleted by this mutation. */
  term: Maybe<GqlTerm>;
  /** An edge for our `Term`. May be used by Relay 1. */
  termEdge: Maybe<GqlTermsEdge>;
};


/** The output of our delete `Term` mutation. */
export type GqlDeleteTermPayloadTermEdgeArgs = {
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};

/** All input for the `deleteTermToOrganizationByNodeId` mutation. */
export type GqlDeleteTermToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToOrganization` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToOrganization` mutation. */
export type GqlDeleteTermToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};

/** The output of our delete `TermToOrganization` mutation. */
export type GqlDeleteTermToOrganizationPayload = {
  __typename?: 'DeleteTermToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToOrganizationNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `TermToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToOrganization`. */
  term: Maybe<GqlTerm>;
  /** The `TermToOrganization` that was deleted by this mutation. */
  termToOrganization: Maybe<GqlTermToOrganization>;
  /** An edge for our `TermToOrganization`. May be used by Relay 1. */
  termToOrganizationEdge: Maybe<GqlTermToOrganizationsEdge>;
};


/** The output of our delete `TermToOrganization` mutation. */
export type GqlDeleteTermToOrganizationPayloadTermToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};

/** All input for the `deleteTermToProductByNodeId` mutation. */
export type GqlDeleteTermToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToProduct` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToProduct` mutation. */
export type GqlDeleteTermToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our delete `TermToProduct` mutation. */
export type GqlDeleteTermToProductPayload = {
  __typename?: 'DeleteTermToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToProductNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `TermToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToProduct`. */
  term: Maybe<GqlTerm>;
  /** The `TermToProduct` that was deleted by this mutation. */
  termToProduct: Maybe<GqlTermToProduct>;
  /** An edge for our `TermToProduct`. May be used by Relay 1. */
  termToProductEdge: Maybe<GqlTermToProductsEdge>;
};


/** The output of our delete `TermToProduct` mutation. */
export type GqlDeleteTermToProductPayloadTermToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};

/** All input for the `deleteTermToRfpByNodeId` mutation. */
export type GqlDeleteTermToRfpByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToRfp` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToRfp` mutation. */
export type GqlDeleteTermToRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  rfpId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our delete `TermToRfp` mutation. */
export type GqlDeleteTermToRfpPayload = {
  __typename?: 'DeleteTermToRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToRfpNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `TermToRfp`. */
  rfp: Maybe<GqlRfp>;
  /** Reads a single `Term` that is related to this `TermToRfp`. */
  term: Maybe<GqlTerm>;
  /** The `TermToRfp` that was deleted by this mutation. */
  termToRfp: Maybe<GqlTermToRfp>;
  /** An edge for our `TermToRfp`. May be used by Relay 1. */
  termToRfpEdge: Maybe<GqlTermToRfpsEdge>;
};


/** The output of our delete `TermToRfp` mutation. */
export type GqlDeleteTermToRfpPayloadTermToRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};

/** All input for the `deleteTermToSuiteListingByNodeId` mutation. */
export type GqlDeleteTermToSuiteListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToSuiteListing` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToSuiteListing` mutation. */
export type GqlDeleteTermToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  suiteListingId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our delete `TermToSuiteListing` mutation. */
export type GqlDeleteTermToSuiteListingPayload = {
  __typename?: 'DeleteTermToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToSuiteListingNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `TermToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** Reads a single `Term` that is related to this `TermToSuiteListing`. */
  term: Maybe<GqlTerm>;
  /** The `TermToSuiteListing` that was deleted by this mutation. */
  termToSuiteListing: Maybe<GqlTermToSuiteListing>;
  /** An edge for our `TermToSuiteListing`. May be used by Relay 1. */
  termToSuiteListingEdge: Maybe<GqlTermToSuiteListingsEdge>;
};


/** The output of our delete `TermToSuiteListing` mutation. */
export type GqlDeleteTermToSuiteListingPayloadTermToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};

/** All input for the `deleteTermToTestDriveByNodeId` mutation. */
export type GqlDeleteTermToTestDriveByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToTestDrive` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToTestDrive` mutation. */
export type GqlDeleteTermToTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termId: Scalars['Int'];
  testDriveId: Scalars['Int'];
};

/** The output of our delete `TermToTestDrive` mutation. */
export type GqlDeleteTermToTestDrivePayload = {
  __typename?: 'DeleteTermToTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToTestDriveNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToTestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TermToTestDrive` that was deleted by this mutation. */
  termToTestDrive: Maybe<GqlTermToTestDrive>;
  /** An edge for our `TermToTestDrive`. May be used by Relay 1. */
  termToTestDriveEdge: Maybe<GqlTermToTestDrivesEdge>;
  /** Reads a single `TestDrive` that is related to this `TermToTestDrive`. */
  testDrive: Maybe<GqlTestDrive>;
};


/** The output of our delete `TermToTestDrive` mutation. */
export type GqlDeleteTermToTestDrivePayloadTermToTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};

/** All input for the `deleteTermToUserByNodeId` mutation. */
export type GqlDeleteTermToUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToUser` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToUser` mutation. */
export type GqlDeleteTermToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our delete `TermToUser` mutation. */
export type GqlDeleteTermToUserPayload = {
  __typename?: 'DeleteTermToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToUserNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `TermToUser`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUser`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUser` that was deleted by this mutation. */
  termToUser: Maybe<GqlTermToUser>;
  /** An edge for our `TermToUser`. May be used by Relay 1. */
  termToUserEdge: Maybe<GqlTermToUsersEdge>;
  /** Reads a single `User` that is related to this `TermToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our delete `TermToUser` mutation. */
export type GqlDeleteTermToUserPayloadTermToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** All input for the `deleteTermToUserStoryByNodeId` mutation. */
export type GqlDeleteTermToUserStoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToUserStory` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToUserStory` mutation. */
export type GqlDeleteTermToUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termId: Scalars['Int'];
  userStoryId: Scalars['Int'];
};

/** The output of our delete `TermToUserStory` mutation. */
export type GqlDeleteTermToUserStoryPayload = {
  __typename?: 'DeleteTermToUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToUserStoryNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUserStory`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUserStory` that was deleted by this mutation. */
  termToUserStory: Maybe<GqlTermToUserStory>;
  /** An edge for our `TermToUserStory`. May be used by Relay 1. */
  termToUserStoryEdge: Maybe<GqlTermToUserStoriesEdge>;
  /** Reads a single `UserStory` that is related to this `TermToUserStory`. */
  userStory: Maybe<GqlUserStory>;
};


/** The output of our delete `TermToUserStory` mutation. */
export type GqlDeleteTermToUserStoryPayloadTermToUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};

/** All input for the `deleteTermToVendorStackshareByNodeId` mutation. */
export type GqlDeleteTermToVendorStackshareByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToVendorStackshare` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermToVendorStackshare` mutation. */
export type GqlDeleteTermToVendorStackshareInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `TermToVendorStackshare` mutation. */
export type GqlDeleteTermToVendorStacksharePayload = {
  __typename?: 'DeleteTermToVendorStacksharePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermToVendorStackshareNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `TermToVendorStackshare`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToVendorStackshare`. */
  term: Maybe<GqlTerm>;
  /** The `TermToVendorStackshare` that was deleted by this mutation. */
  termToVendorStackshare: Maybe<GqlTermToVendorStackshare>;
  /** An edge for our `TermToVendorStackshare`. May be used by Relay 1. */
  termToVendorStackshareEdge: Maybe<GqlTermToVendorStacksharesEdge>;
};


/** The output of our delete `TermToVendorStackshare` mutation. */
export type GqlDeleteTermToVendorStacksharePayloadTermToVendorStackshareEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};

/** All input for the `deleteTermsToOrganization` mutation. */
export type GqlDeleteTermsToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `deleteTermsToOrganization` mutation. */
export type GqlDeleteTermsToOrganizationPayload = {
  __typename?: 'DeleteTermsToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToOrganizations: Maybe<Array<Maybe<GqlTermToOrganization>>>;
};

/** All input for the `deleteTermsToProduct` mutation. */
export type GqlDeleteTermsToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `deleteTermsToProduct` mutation. */
export type GqlDeleteTermsToProductPayload = {
  __typename?: 'DeleteTermsToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToProducts: Maybe<Array<Maybe<GqlTermToProduct>>>;
};

/** All input for the `deleteTermsToSuiteListing` mutation. */
export type GqlDeleteTermsToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  suiteListingId: Scalars['Int'];
  termIds: Array<InputMaybe<Scalars['Int']>>;
};

/** The output of our `deleteTermsToSuiteListing` mutation. */
export type GqlDeleteTermsToSuiteListingPayload = {
  __typename?: 'DeleteTermsToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToSuiteListings: Maybe<Array<Maybe<GqlTermToSuiteListing>>>;
};

/** All input for the `deleteTermsToTestDrive` mutation. */
export type GqlDeleteTermsToTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termIds: Array<InputMaybe<Scalars['Int']>>;
  testDriveId: Scalars['Int'];
};

/** The output of our `deleteTermsToTestDrive` mutation. */
export type GqlDeleteTermsToTestDrivePayload = {
  __typename?: 'DeleteTermsToTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToTestDrives: Maybe<Array<Maybe<GqlTermToTestDrive>>>;
};

/** All input for the `deleteTermsToUser` mutation. */
export type GqlDeleteTermsToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  termIds: Array<InputMaybe<Scalars['Int']>>;
  userId: Scalars['Int'];
};

/** The output of our `deleteTermsToUser` mutation. */
export type GqlDeleteTermsToUserPayload = {
  __typename?: 'DeleteTermsToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToUsers: Maybe<Array<Maybe<GqlTermToUser>>>;
};

/** All input for the `deleteTermscoutByNodeId` mutation. */
export type GqlDeleteTermscoutByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Termscout` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTermscout` mutation. */
export type GqlDeleteTermscoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `Termscout` mutation. */
export type GqlDeleteTermscoutPayload = {
  __typename?: 'DeleteTermscoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTermscoutNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `Termscout`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Termscout` that was deleted by this mutation. */
  termscout: Maybe<GqlTermscout>;
  /** An edge for our `Termscout`. May be used by Relay 1. */
  termscoutEdge: Maybe<GqlTermscoutsEdge>;
};


/** The output of our delete `Termscout` mutation. */
export type GqlDeleteTermscoutPayloadTermscoutEdgeArgs = {
  orderBy?: InputMaybe<Array<TermscoutsOrderBy>>;
};

/** All input for the `deleteTestDriveByNodeId` mutation. */
export type GqlDeleteTestDriveByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TestDrive` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTestDrive` mutation. */
export type GqlDeleteTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `TestDrive` mutation. */
export type GqlDeleteTestDrivePayload = {
  __typename?: 'DeleteTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTestDriveNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TestDrive` that was deleted by this mutation. */
  testDrive: Maybe<GqlTestDrive>;
  /** An edge for our `TestDrive`. May be used by Relay 1. */
  testDriveEdge: Maybe<GqlTestDrivesEdge>;
};


/** The output of our delete `TestDrive` mutation. */
export type GqlDeleteTestDrivePayloadTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** All input for the `deleteTestDrives` mutation. */
export type GqlDeleteTestDrivesInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteTestDrives` mutation. */
export type GqlDeleteTestDrivesPayload = {
  __typename?: 'DeleteTestDrivesPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  testDrive: Maybe<GqlTestDrive>;
  /** An edge for our `TestDrive`. May be used by Relay 1. */
  testDriveEdge: Maybe<GqlTestDrivesEdge>;
};


/** The output of our `deleteTestDrives` mutation. */
export type GqlDeleteTestDrivesPayloadTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** All input for the `deleteTheoremProductByNodeId` mutation. */
export type GqlDeleteTheoremProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TheoremProduct` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTheoremProductByStripeProductId` mutation. */
export type GqlDeleteTheoremProductByStripeProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  stripeProductId: Scalars['String'];
};

/** All input for the `deleteTheoremProductByTestStripeProductId` mutation. */
export type GqlDeleteTheoremProductByTestStripeProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  testStripeProductId: Scalars['String'];
};

/** All input for the `deleteTheoremProduct` mutation. */
export type GqlDeleteTheoremProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `TheoremProduct` mutation. */
export type GqlDeleteTheoremProductPayload = {
  __typename?: 'DeleteTheoremProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedTheoremProductNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TheoremProduct` that was deleted by this mutation. */
  theoremProduct: Maybe<GqlTheoremProduct>;
  /** An edge for our `TheoremProduct`. May be used by Relay 1. */
  theoremProductEdge: Maybe<GqlTheoremProductsEdge>;
};


/** The output of our delete `TheoremProduct` mutation. */
export type GqlDeleteTheoremProductPayloadTheoremProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TheoremProductsOrderBy>>;
};

/** All input for the `deleteTheoremProducts` mutation. */
export type GqlDeleteTheoremProductsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteTheoremProducts` mutation. */
export type GqlDeleteTheoremProductsPayload = {
  __typename?: 'DeleteTheoremProductsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  theoremProduct: Maybe<GqlTheoremProduct>;
  /** An edge for our `TheoremProduct`. May be used by Relay 1. */
  theoremProductEdge: Maybe<GqlTheoremProductsEdge>;
};


/** The output of our `deleteTheoremProducts` mutation. */
export type GqlDeleteTheoremProductsPayloadTheoremProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TheoremProductsOrderBy>>;
};

/** All input for the `deleteUseCaseByNodeId` mutation. */
export type GqlDeleteUseCaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UseCase` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUseCase` mutation. */
export type GqlDeleteUseCaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `UseCase` mutation. */
export type GqlDeleteUseCasePayload = {
  __typename?: 'DeleteUseCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUseCaseNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `UseCase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UseCase`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UseCase`. */
  termByPracticeGroup: Maybe<GqlTerm>;
  /** The `UseCase` that was deleted by this mutation. */
  useCase: Maybe<GqlUseCase>;
  /** An edge for our `UseCase`. May be used by Relay 1. */
  useCaseEdge: Maybe<GqlUseCasesEdge>;
  /** Reads a single `User` that is related to this `UseCase`. */
  userByAuthor: Maybe<GqlUser>;
};


/** The output of our delete `UseCase` mutation. */
export type GqlDeleteUseCasePayloadUseCaseEdgeArgs = {
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** All input for the `deleteUserByNodeId` mutation. */
export type GqlDeleteUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUser` mutation. */
export type GqlDeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `User` mutation. */
export type GqlDeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUserNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Location` that is related to this `User`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByCurrentOrganization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `User` that was deleted by this mutation. */
  user: Maybe<GqlUser>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge: Maybe<GqlUsersEdge>;
};


/** The output of our delete `User` mutation. */
export type GqlDeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUserStoryByNodeId` mutation. */
export type GqlDeleteUserStoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserStory` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserStory` mutation. */
export type GqlDeleteUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `UserStory` mutation. */
export type GqlDeleteUserStoryPayload = {
  __typename?: 'DeleteUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUserStoryNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `UserStory`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UserStory`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserStory`. */
  userByAuthor: Maybe<GqlUser>;
  /** The `UserStory` that was deleted by this mutation. */
  userStory: Maybe<GqlUserStory>;
  /** An edge for our `UserStory`. May be used by Relay 1. */
  userStoryEdge: Maybe<GqlUserStoriesEdge>;
};


/** The output of our delete `UserStory` mutation. */
export type GqlDeleteUserStoryPayloadUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** All input for the `deleteUserToOrgStackByNodeId` mutation. */
export type GqlDeleteUserToOrgStackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserToOrgStack` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserToOrgStack` mutation. */
export type GqlDeleteUserToOrgStackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** The output of our delete `UserToOrgStack` mutation. */
export type GqlDeleteUserToOrgStackPayload = {
  __typename?: 'DeleteUserToOrgStackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUserToOrgStackNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `UserToOrgStack`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserToOrgStack`. */
  user: Maybe<GqlUser>;
  /** The `UserToOrgStack` that was deleted by this mutation. */
  userToOrgStack: Maybe<GqlUserToOrgStack>;
  /** An edge for our `UserToOrgStack`. May be used by Relay 1. */
  userToOrgStackEdge: Maybe<GqlUserToOrgStacksEdge>;
};


/** The output of our delete `UserToOrgStack` mutation. */
export type GqlDeleteUserToOrgStackPayloadUserToOrgStackEdgeArgs = {
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};

/** All input for the `deleteUsers` mutation. */
export type GqlDeleteUsersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** The output of our `deleteUsers` mutation. */
export type GqlDeleteUsersPayload = {
  __typename?: 'DeleteUsersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `User`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByCurrentOrganization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  user: Maybe<GqlUser>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge: Maybe<GqlUsersEdge>;
};


/** The output of our `deleteUsers` mutation. */
export type GqlDeleteUsersPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `deleteUsersToOrganizationByNodeId` mutation. */
export type GqlDeleteUsersToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UsersToOrganization` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUsersToOrganization` mutation. */
export type GqlDeleteUsersToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** The output of our delete `UsersToOrganization` mutation. */
export type GqlDeleteUsersToOrganizationPayload = {
  __typename?: 'DeleteUsersToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUsersToOrganizationNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Location` that is related to this `UsersToOrganization`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `UsersToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UsersToOrganization`. */
  termByJobTitle: Maybe<GqlTerm>;
  /** Reads a single `User` that is related to this `UsersToOrganization`. */
  user: Maybe<GqlUser>;
  /** The `UsersToOrganization` that was deleted by this mutation. */
  usersToOrganization: Maybe<GqlUsersToOrganization>;
  /** An edge for our `UsersToOrganization`. May be used by Relay 1. */
  usersToOrganizationEdge: Maybe<GqlUsersToOrganizationsEdge>;
};


/** The output of our delete `UsersToOrganization` mutation. */
export type GqlDeleteUsersToOrganizationPayloadUsersToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** All input for the `deleteUsersToPracticeGroupByNodeId` mutation. */
export type GqlDeleteUsersToPracticeGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UsersToPracticeGroup` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUsersToPracticeGroup` mutation. */
export type GqlDeleteUsersToPracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  practiceGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our delete `UsersToPracticeGroup` mutation. */
export type GqlDeleteUsersToPracticeGroupPayload = {
  __typename?: 'DeleteUsersToPracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUsersToPracticeGroupNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `PracticeGroup` that is related to this `UsersToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UsersToPracticeGroup`. */
  user: Maybe<GqlUser>;
  /** The `UsersToPracticeGroup` that was deleted by this mutation. */
  usersToPracticeGroup: Maybe<GqlUsersToPracticeGroup>;
  /** An edge for our `UsersToPracticeGroup`. May be used by Relay 1. */
  usersToPracticeGroupEdge: Maybe<GqlUsersToPracticeGroupsEdge>;
};


/** The output of our delete `UsersToPracticeGroup` mutation. */
export type GqlDeleteUsersToPracticeGroupPayloadUsersToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};

/** All input for the `deleteUsersToTechstackByNodeId` mutation. */
export type GqlDeleteUsersToTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UsersToTechstack` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUsersToTechstack` mutation. */
export type GqlDeleteUsersToTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  techstackId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our delete `UsersToTechstack` mutation. */
export type GqlDeleteUsersToTechstackPayload = {
  __typename?: 'DeleteUsersToTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedUsersToTechstackNodeId: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Techstack` that is related to this `UsersToTechstack`. */
  techstack: Maybe<GqlTechstack>;
  /** Reads a single `User` that is related to this `UsersToTechstack`. */
  user: Maybe<GqlUser>;
  /** The `UsersToTechstack` that was deleted by this mutation. */
  usersToTechstack: Maybe<GqlUsersToTechstack>;
  /** An edge for our `UsersToTechstack`. May be used by Relay 1. */
  usersToTechstackEdge: Maybe<GqlUsersToTechstacksEdge>;
};


/** The output of our delete `UsersToTechstack` mutation. */
export type GqlDeleteUsersToTechstackPayloadUsersToTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};

/** All input for the `deleteUsersToTechstacks` mutation. */
export type GqlDeleteUsersToTechstacksInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  techstackIds: Array<InputMaybe<Scalars['Int']>>;
  userId: Scalars['Int'];
};

/** The output of our `deleteUsersToTechstacks` mutation. */
export type GqlDeleteUsersToTechstacksPayload = {
  __typename?: 'DeleteUsersToTechstacksPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  usersToTechstacks: Maybe<Array<Maybe<GqlUsersToTechstack>>>;
};

/** All input for the `deleteVendorStackshareLogoByNodeId` mutation. */
export type GqlDeleteVendorStackshareLogoByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VendorStackshareLogo` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteVendorStackshareLogo` mutation. */
export type GqlDeleteVendorStackshareLogoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The output of our delete `VendorStackshareLogo` mutation. */
export type GqlDeleteVendorStackshareLogoPayload = {
  __typename?: 'DeleteVendorStackshareLogoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  deletedVendorStackshareLogoNodeId: Maybe<Scalars['ID']>;
  /** Reads a single `Organization` that is related to this `VendorStackshareLogo`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `VendorStackshareLogo` that was deleted by this mutation. */
  vendorStackshareLogo: Maybe<GqlVendorStackshareLogo>;
  /** An edge for our `VendorStackshareLogo`. May be used by Relay 1. */
  vendorStackshareLogoEdge: Maybe<GqlVendorStackshareLogosEdge>;
};


/** The output of our delete `VendorStackshareLogo` mutation. */
export type GqlDeleteVendorStackshareLogoPayloadVendorStackshareLogoEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};

export type GqlDiversityCertification = GqlNode & {
  __typename?: 'DiversityCertification';
  businessTaxName: Maybe<Scalars['String']>;
  certNumber: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Datetime']>;
  description: Maybe<Scalars['String']>;
  expirationDate: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `DiversityCertification`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  provider: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `DiversityCertification` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlDiversityCertificationCondition = {
  /** Checks for equality with the object’s `businessTaxName` field. */
  businessTaxName?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `certNumber` field. */
  certNumber?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `DiversityCertification` object types. All fields are combined with a logical ‘and.’ */
export type GqlDiversityCertificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlDiversityCertificationFilter>>;
  /** Filter by the object’s `businessTaxName` field. */
  businessTaxName?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `certNumber` field. */
  certNumber?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `expirationDate` field. */
  expirationDate?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlDiversityCertificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlDiversityCertificationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `DiversityCertification` */
export type GqlDiversityCertificationInput = {
  businessTaxName?: InputMaybe<Scalars['String']>;
  certNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  provider?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `DiversityCertification`. Fields that are set will be updated. */
export type GqlDiversityCertificationPatch = {
  businessTaxName?: InputMaybe<Scalars['String']>;
  certNumber?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  provider?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `DiversityCertification` values. */
export type GqlDiversityCertificationsConnection = {
  __typename?: 'DiversityCertificationsConnection';
  /** A list of edges which contains the `DiversityCertification` and cursor to aid in pagination. */
  edges: Array<GqlDiversityCertificationsEdge>;
  /** A list of `DiversityCertification` objects. */
  nodes: Array<Maybe<GqlDiversityCertification>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `DiversityCertification` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DiversityCertification` edge in the connection. */
export type GqlDiversityCertificationsEdge = {
  __typename?: 'DiversityCertificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `DiversityCertification` at the end of the edge. */
  node: Maybe<GqlDiversityCertification>;
};

/** Methods to use when ordering `DiversityCertification`. */
export enum DiversityCertificationsOrderBy {
  BusinessTaxNameAsc = 'BUSINESS_TAX_NAME_ASC',
  BusinessTaxNameDesc = 'BUSINESS_TAX_NAME_DESC',
  CertNumberAsc = 'CERT_NUMBER_ASC',
  CertNumberDesc = 'CERT_NUMBER_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  ExpirationDateAsc = 'EXPIRATION_DATE_ASC',
  ExpirationDateDesc = 'EXPIRATION_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlFeature = GqlNode & {
  __typename?: 'Feature';
  /** Reads and enables pagination through a set of `FeatureToProduct`. */
  featureToProducts: Array<GqlFeatureToProduct>;
  /** Reads and enables pagination through a set of `FeatureToProduct`. */
  featureToProductsConnection: GqlFeatureToProductsConnection;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Product`. */
  productsByFeatureToProductFeatureIdAndProductId: GqlFeatureProductsByFeatureToProductFeatureIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByFeatureToProductFeatureIdAndProductIdList: Array<GqlProduct>;
  slug: Scalars['String'];
};


export type GqlFeatureFeatureToProductsArgs = {
  condition: InputMaybe<GqlFeatureToProductCondition>;
  filter: InputMaybe<GqlFeatureToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<FeatureToProductsOrderBy>>;
};


export type GqlFeatureFeatureToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlFeatureToProductCondition>;
  filter: InputMaybe<GqlFeatureToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};


export type GqlFeatureProductsByFeatureToProductFeatureIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlFeatureProductsByFeatureToProductFeatureIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};

/** A condition to be used against `Feature` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlFeatureCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Feature` object types. All fields are combined with a logical ‘and.’ */
export type GqlFeatureFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlFeatureFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlFeatureFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlFeatureFilter>>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
};

/** An input for mutations affecting `Feature` */
export type GqlFeatureInput = {
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Feature`. Fields that are set will be updated. */
export type GqlFeaturePatch = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Product` values, with data from `FeatureToProduct`. */
export type GqlFeatureProductsByFeatureToProductFeatureIdAndProductIdManyToManyConnection = {
  __typename?: 'FeatureProductsByFeatureToProductFeatureIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `FeatureToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlFeatureProductsByFeatureToProductFeatureIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `FeatureToProduct`. */
export type GqlFeatureProductsByFeatureToProductFeatureIdAndProductIdManyToManyEdge = {
  __typename?: 'FeatureProductsByFeatureToProductFeatureIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

export type GqlFeatureToProduct = GqlNode & {
  __typename?: 'FeatureToProduct';
  /** Reads a single `Feature` that is related to this `FeatureToProduct`. */
  feature: Maybe<GqlFeature>;
  featureId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `FeatureToProduct`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `FeatureToProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlFeatureToProductCondition = {
  /** Checks for equality with the object’s `featureId` field. */
  featureId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `FeatureToProduct` object types. All fields are combined with a logical ‘and.’ */
export type GqlFeatureToProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlFeatureToProductFilter>>;
  /** Filter by the object’s `featureId` field. */
  featureId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlFeatureToProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlFeatureToProductFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `FeatureToProduct` */
export type GqlFeatureToProductInput = {
  featureId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** Represents an update to a `FeatureToProduct`. Fields that are set will be updated. */
export type GqlFeatureToProductPatch = {
  featureId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `FeatureToProduct` values. */
export type GqlFeatureToProductsConnection = {
  __typename?: 'FeatureToProductsConnection';
  /** A list of edges which contains the `FeatureToProduct` and cursor to aid in pagination. */
  edges: Array<GqlFeatureToProductsEdge>;
  /** A list of `FeatureToProduct` objects. */
  nodes: Array<Maybe<GqlFeatureToProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `FeatureToProduct` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FeatureToProduct` edge in the connection. */
export type GqlFeatureToProductsEdge = {
  __typename?: 'FeatureToProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `FeatureToProduct` at the end of the edge. */
  node: Maybe<GqlFeatureToProduct>;
};

/** Methods to use when ordering `FeatureToProduct`. */
export enum FeatureToProductsOrderBy {
  FeatureIdAsc = 'FEATURE_ID_ASC',
  FeatureIdDesc = 'FEATURE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

/** A connection to a list of `Feature` values. */
export type GqlFeaturesConnection = {
  __typename?: 'FeaturesConnection';
  /** A list of edges which contains the `Feature` and cursor to aid in pagination. */
  edges: Array<GqlFeaturesEdge>;
  /** A list of `Feature` objects. */
  nodes: Array<Maybe<GqlFeature>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Feature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Feature` edge in the connection. */
export type GqlFeaturesEdge = {
  __typename?: 'FeaturesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Feature` at the end of the edge. */
  node: Maybe<GqlFeature>;
};

/** Methods to use when ordering `Feature`. */
export enum FeaturesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC'
}

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type GqlFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type GqlIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** A filter to be used against Int List fields. All fields are combined with a logical ‘and.’ */
export type GqlIntListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['Int']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['Int']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['Int']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type GqlJsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

export type GqlLawfirmService = GqlNode & {
  __typename?: 'LawfirmService';
  details: Scalars['JSON'];
  id: Scalars['Int'];
  lawfirmId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `LawfirmService` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlLawfirmServiceCondition = {
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lawfirmId` field. */
  lawfirmId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `LawfirmService` object types. All fields are combined with a logical ‘and.’ */
export type GqlLawfirmServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlLawfirmServiceFilter>>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `lawfirmId` field. */
  lawfirmId?: InputMaybe<GqlUuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlLawfirmServiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlLawfirmServiceFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `LawfirmService` */
export type GqlLawfirmServiceInput = {
  details?: InputMaybe<Scalars['JSON']>;
  id: Scalars['Int'];
  lawfirmId: Scalars['UUID'];
  order?: InputMaybe<Scalars['Int']>;
  termId: Scalars['Int'];
};

/** Represents an update to a `LawfirmService`. Fields that are set will be updated. */
export type GqlLawfirmServicePatch = {
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  lawfirmId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `LawfirmService` values. */
export type GqlLawfirmServicesConnection = {
  __typename?: 'LawfirmServicesConnection';
  /** A list of edges which contains the `LawfirmService` and cursor to aid in pagination. */
  edges: Array<GqlLawfirmServicesEdge>;
  /** A list of `LawfirmService` objects. */
  nodes: Array<Maybe<GqlLawfirmService>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `LawfirmService` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `LawfirmService` edge in the connection. */
export type GqlLawfirmServicesEdge = {
  __typename?: 'LawfirmServicesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `LawfirmService` at the end of the edge. */
  node: Maybe<GqlLawfirmService>;
};

/** Methods to use when ordering `LawfirmService`. */
export enum LawfirmServicesOrderBy {
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LawfirmIdAsc = 'LAWFIRM_ID_ASC',
  LawfirmIdDesc = 'LAWFIRM_ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

export type GqlListingCreator = {
  __typename?: 'ListingCreator';
  appMetadata: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** Reads a single `Organization` that is related to this `ListingCreator`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ListingCreator` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlListingCreatorCondition = {
  /** Checks for equality with the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ListingCreator` object types. All fields are combined with a logical ‘and.’ */
export type GqlListingCreatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlListingCreatorFilter>>;
  /** Filter by the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlListingCreatorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlListingCreatorFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `ListingCreator` */
export type GqlListingCreatorInput = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `ListingCreator`. Fields that are set will be updated. */
export type GqlListingCreatorPatch = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ListingCreator` values. */
export type GqlListingCreatorsConnection = {
  __typename?: 'ListingCreatorsConnection';
  /** A list of edges which contains the `ListingCreator` and cursor to aid in pagination. */
  edges: Array<GqlListingCreatorsEdge>;
  /** A list of `ListingCreator` objects. */
  nodes: Array<Maybe<GqlListingCreator>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ListingCreator` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ListingCreator` edge in the connection. */
export type GqlListingCreatorsEdge = {
  __typename?: 'ListingCreatorsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ListingCreator` at the end of the edge. */
  node: Maybe<GqlListingCreator>;
};

/** Methods to use when ordering `ListingCreator`. */
export enum ListingCreatorsOrderBy {
  AppMetadataAsc = 'APP_METADATA_ASC',
  AppMetadataDesc = 'APP_METADATA_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlLocation = GqlNode & {
  __typename?: 'Location';
  city: Maybe<Scalars['String']>;
  country: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isHeadquarter: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `Location`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserLocationIdAndCurrentOrganization: GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserLocationIdAndCurrentOrganizationList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUsersToOrganizationLocationIdAndOrganizationId: GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUsersToOrganizationLocationIdAndOrganizationIdList: Array<GqlOrganization>;
  state: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUsersToOrganizationLocationIdAndJobTitle: GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUsersToOrganizationLocationIdAndJobTitleList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `User`. */
  users: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToOrganizationLocationIdAndUserId: GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToOrganizationLocationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersConnection: GqlUsersConnection;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


export type GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlLocationUsersArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlLocationUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlLocationUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


export type GqlLocationUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/**
 * A condition to be used against `Location` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlLocationCondition = {
  /** Checks for equality with the object’s `city` field. */
  city?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `country` field. */
  country?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `isHeadquarter` field. */
  isHeadquarter?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `Location` object types. All fields are combined with a logical ‘and.’ */
export type GqlLocationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlLocationFilter>>;
  /** Filter by the object’s `city` field. */
  city?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `country` field. */
  country?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `isHeadquarter` field. */
  isHeadquarter?: InputMaybe<GqlBooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlLocationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlLocationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GqlStringFilter>;
};

/** An input for mutations affecting `Location` */
export type GqlLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHeadquarter?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  state?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Organization` values, with data from `User`. */
export type GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyConnection = {
  __typename?: 'LocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `User`, and the cursor to aid in pagination. */
  edges: Array<GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `User`. */
export type GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyEdge = {
  __typename?: 'LocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCurrentOrganization: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCurrentOrganizationConnection: GqlUsersConnection;
};


/** A `Organization` edge in the connection, with data from `User`. */
export type GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyEdgeUsersByCurrentOrganizationArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `User`. */
export type GqlLocationOrganizationsByUserLocationIdAndCurrentOrganizationManyToManyEdgeUsersByCurrentOrganizationConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UsersToOrganization`. */
export type GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'LocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'LocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationOrganizationsByUsersToOrganizationLocationIdAndOrganizationIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** Represents an update to a `Location`. Fields that are set will be updated. */
export type GqlLocationPatch = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  isHeadquarter?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  state?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Term` values, with data from `UsersToOrganization`. */
export type GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyConnection = {
  __typename?: 'LocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyEdge = {
  __typename?: 'LocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitle: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitleConnection: GqlUsersToOrganizationsConnection;
};


/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyEdgeUsersToOrganizationsByJobTitleArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationTermsByUsersToOrganizationLocationIdAndJobTitleManyToManyEdgeUsersToOrganizationsByJobTitleConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UsersToOrganization`. */
export type GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyConnection = {
  __typename?: 'LocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyEdge = {
  __typename?: 'LocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlLocationUsersByUsersToOrganizationLocationIdAndUserIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A connection to a list of `Location` values. */
export type GqlLocationsConnection = {
  __typename?: 'LocationsConnection';
  /** A list of edges which contains the `Location` and cursor to aid in pagination. */
  edges: Array<GqlLocationsEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Maybe<GqlLocation>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Location` edge in the connection. */
export type GqlLocationsEdge = {
  __typename?: 'LocationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Location` at the end of the edge. */
  node: Maybe<GqlLocation>;
};

/** Methods to use when ordering `Location`. */
export enum LocationsOrderBy {
  CityAsc = 'CITY_ASC',
  CityDesc = 'CITY_DESC',
  CountryAsc = 'COUNTRY_ASC',
  CountryDesc = 'COUNTRY_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsHeadquarterAsc = 'IS_HEADQUARTER_ASC',
  IsHeadquarterDesc = 'IS_HEADQUARTER_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC'
}

export enum MemberStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Inactive = 'INACTIVE',
  Invited = 'INVITED',
  JoinOrg = 'JOIN_ORG',
  Pending = 'PENDING',
  Request = 'REQUEST'
}

/** A filter to be used against MemberStatus fields. All fields are combined with a logical ‘and.’ */
export type GqlMemberStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<MemberStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<MemberStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<MemberStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<MemberStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<MemberStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<MemberStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<MemberStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<MemberStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<MemberStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<MemberStatus>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutation = {
  __typename?: 'Mutation';
  addUserStoryTerms: Maybe<GqlAddUserStoryTermsPayload>;
  /** Creates a single `AssocHome`. */
  createAssocHome: Maybe<GqlCreateAssocHomePayload>;
  /** Creates a single `AssocSection`. */
  createAssocSection: Maybe<GqlCreateAssocSectionPayload>;
  /** Creates a single `AssociationToOrganization`. */
  createAssociationToOrganization: Maybe<GqlCreateAssociationToOrganizationPayload>;
  /** Creates a single `AwardBadge`. */
  createAwardBadge: Maybe<GqlCreateAwardBadgePayload>;
  /** Creates a single `BestFor`. */
  createBestFor: Maybe<GqlCreateBestForPayload>;
  /** Creates a single `BestForToProduct`. */
  createBestForToProduct: Maybe<GqlCreateBestForToProductPayload>;
  /** Creates a single `Category`. */
  createCategory: Maybe<GqlCreateCategoryPayload>;
  /** Creates a single `CategoryToProduct`. */
  createCategoryToProduct: Maybe<GqlCreateCategoryToProductPayload>;
  /** Creates a single `ConnectCustomer`. */
  createConnectCustomer: Maybe<GqlCreateConnectCustomerPayload>;
  /** Creates a single `ConnectPurchase`. */
  createConnectPurchase: Maybe<GqlCreateConnectPurchasePayload>;
  /** Creates a single `DiversityCertification`. */
  createDiversityCertification: Maybe<GqlCreateDiversityCertificationPayload>;
  /** Creates a single `Feature`. */
  createFeature: Maybe<GqlCreateFeaturePayload>;
  /** Creates a single `FeatureToProduct`. */
  createFeatureToProduct: Maybe<GqlCreateFeatureToProductPayload>;
  /** Creates a single `LawfirmService`. */
  createLawfirmService: Maybe<GqlCreateLawfirmServicePayload>;
  /** Creates a single `ListingCreator`. */
  createListingCreator: Maybe<GqlCreateListingCreatorPayload>;
  /** Creates a single `Location`. */
  createLocation: Maybe<GqlCreateLocationPayload>;
  /** Creates a single `Notification`. */
  createNotification: Maybe<GqlCreateNotificationPayload>;
  /** Creates a single `NoviMember`. */
  createNoviMember: Maybe<GqlCreateNoviMemberPayload>;
  /** Creates a single `NoviOrganization`. */
  createNoviOrganization: Maybe<GqlCreateNoviOrganizationPayload>;
  /** Creates a single `Organization`. */
  createOrganization: Maybe<GqlCreateOrganizationPayload>;
  /** Creates a single `OrganizationListing`. */
  createOrganizationListing: Maybe<GqlCreateOrganizationListingPayload>;
  /** Creates a single `OrganizationTechstack`. */
  createOrganizationTechstack: Maybe<GqlCreateOrganizationTechstackPayload>;
  /** Creates a single `PersonalTechstack`. */
  createPersonalTechstack: Maybe<GqlCreatePersonalTechstackPayload>;
  createPersonalTechstacks: Maybe<GqlCreatePersonalTechstacksPayload>;
  /** Creates a single `PracticeGroup`. */
  createPracticeGroup: Maybe<GqlCreatePracticeGroupPayload>;
  /** Creates a single `PremiumInfoToTerm`. */
  createPremiumInfoToTerm: Maybe<GqlCreatePremiumInfoToTermPayload>;
  /** Creates a single `PremiumProductInfo`. */
  createPremiumProductInfo: Maybe<GqlCreatePremiumProductInfoPayload>;
  /** Creates a single `Product`. */
  createProduct: Maybe<GqlCreateProductPayload>;
  /** Creates a single `ProductAwardDetail`. */
  createProductAwardDetail: Maybe<GqlCreateProductAwardDetailPayload>;
  /** Creates a single `ProductFeatureByTerm`. */
  createProductFeatureByTerm: Maybe<GqlCreateProductFeatureByTermPayload>;
  /** Creates a single `ProductListing`. */
  createProductListing: Maybe<GqlCreateProductListingPayload>;
  /** Creates a single `ProductSection`. */
  createProductSection: Maybe<GqlCreateProductSectionPayload>;
  /** Creates a single `ProductToAssocSection`. */
  createProductToAssocSection: Maybe<GqlCreateProductToAssocSectionPayload>;
  /** Creates a single `ProductToAwardBadge`. */
  createProductToAwardBadge: Maybe<GqlCreateProductToAwardBadgePayload>;
  /** Creates a single `ProductToClient`. */
  createProductToClient: Maybe<GqlCreateProductToClientPayload>;
  /** Creates a single `ProductToCompetitor`. */
  createProductToCompetitor: Maybe<GqlCreateProductToCompetitorPayload>;
  /** Creates a single `ProductToIntegration`. */
  createProductToIntegration: Maybe<GqlCreateProductToIntegrationPayload>;
  createProductToIntegrations: Maybe<GqlCreateProductToIntegrationsPayload>;
  /** Creates a single `ProductToOrganization`. */
  createProductToOrganization: Maybe<GqlCreateProductToOrganizationPayload>;
  /** Creates a single `ProductToPracticeGroup`. */
  createProductToPracticeGroup: Maybe<GqlCreateProductToPracticeGroupPayload>;
  /** Creates a single `ProductToSuiteListing`. */
  createProductToSuiteListing: Maybe<GqlCreateProductToSuiteListingPayload>;
  /** Creates a single `ProductToUser`. */
  createProductToUser: Maybe<GqlCreateProductToUserPayload>;
  createProductsToOrganization: Maybe<GqlCreateProductsToOrganizationPayload>;
  /** Creates a single `Rfp`. */
  createRfp: Maybe<GqlCreateRfpPayload>;
  /** Creates a single `RfpToProduct`. */
  createRfpToProduct: Maybe<GqlCreateRfpToProductPayload>;
  createRfpToProducts: Maybe<GqlCreateRfpToProductsPayload>;
  /** Creates a single `Scheduler`. */
  createScheduler: Maybe<GqlCreateSchedulerPayload>;
  /** Creates a single `SectionLayout`. */
  createSectionLayout: Maybe<GqlCreateSectionLayoutPayload>;
  /** Creates a single `SimpleService`. */
  createSimpleService: Maybe<GqlCreateSimpleServicePayload>;
  /** Creates a single `StackshareOption`. */
  createStackshareOption: Maybe<GqlCreateStackshareOptionPayload>;
  /** Creates a single `StripeAccount`. */
  createStripeAccount: Maybe<GqlCreateStripeAccountPayload>;
  /** Creates a single `StripeCustomer`. */
  createStripeCustomer: Maybe<GqlCreateStripeCustomerPayload>;
  /** Creates a single `StripePurchase`. */
  createStripePurchase: Maybe<GqlCreateStripePurchasePayload>;
  /** Creates a single `StripeSeat`. */
  createStripeSeat: Maybe<GqlCreateStripeSeatPayload>;
  /** Creates a single `SuiteListing`. */
  createSuiteListing: Maybe<GqlCreateSuiteListingPayload>;
  /** Creates a single `Taxonomy`. */
  createTaxonomy: Maybe<GqlCreateTaxonomyPayload>;
  /** Creates a single `Techstack`. */
  createTechstack: Maybe<GqlCreateTechstackPayload>;
  /** Creates a single `TempDatum`. */
  createTempDatum: Maybe<GqlCreateTempDatumPayload>;
  /** Creates a single `Term`. */
  createTerm: Maybe<GqlCreateTermPayload>;
  /** Creates a single `TermToOrganization`. */
  createTermToOrganization: Maybe<GqlCreateTermToOrganizationPayload>;
  /** Creates a single `TermToProduct`. */
  createTermToProduct: Maybe<GqlCreateTermToProductPayload>;
  /** Creates a single `TermToRfp`. */
  createTermToRfp: Maybe<GqlCreateTermToRfpPayload>;
  /** Creates a single `TermToSuiteListing`. */
  createTermToSuiteListing: Maybe<GqlCreateTermToSuiteListingPayload>;
  /** Creates a single `TermToTestDrive`. */
  createTermToTestDrive: Maybe<GqlCreateTermToTestDrivePayload>;
  /** Creates a single `TermToUser`. */
  createTermToUser: Maybe<GqlCreateTermToUserPayload>;
  /** Creates a single `TermToUserStory`. */
  createTermToUserStory: Maybe<GqlCreateTermToUserStoryPayload>;
  /** Creates a single `TermToVendorStackshare`. */
  createTermToVendorStackshare: Maybe<GqlCreateTermToVendorStacksharePayload>;
  createTermsToOrganization: Maybe<GqlCreateTermsToOrganizationPayload>;
  createTermsToProduct: Maybe<GqlCreateTermsToProductPayload>;
  createTermsToRfp: Maybe<GqlCreateTermsToRfpPayload>;
  createTermsToSuiteListing: Maybe<GqlCreateTermsToSuiteListingPayload>;
  createTermsToTestDrive: Maybe<GqlCreateTermsToTestDrivePayload>;
  createTermsToUser: Maybe<GqlCreateTermsToUserPayload>;
  /** Creates a single `Termscout`. */
  createTermscout: Maybe<GqlCreateTermscoutPayload>;
  /** Creates a single `TestDrive`. */
  createTestDrive: Maybe<GqlCreateTestDrivePayload>;
  /** Creates a single `TheoremProduct`. */
  createTheoremProduct: Maybe<GqlCreateTheoremProductPayload>;
  /** Creates a single `UseCase`. */
  createUseCase: Maybe<GqlCreateUseCasePayload>;
  /** Creates a single `User`. */
  createUser: Maybe<GqlCreateUserPayload>;
  /** Creates a single `UserStory`. */
  createUserStory: Maybe<GqlCreateUserStoryPayload>;
  /** Creates a single `UserToOrgStack`. */
  createUserToOrgStack: Maybe<GqlCreateUserToOrgStackPayload>;
  /** Creates a single `UsersToOrganization`. */
  createUsersToOrganization: Maybe<GqlCreateUsersToOrganizationPayload>;
  /** Creates a single `UsersToPracticeGroup`. */
  createUsersToPracticeGroup: Maybe<GqlCreateUsersToPracticeGroupPayload>;
  /** Creates a single `UsersToTechstack`. */
  createUsersToTechstack: Maybe<GqlCreateUsersToTechstackPayload>;
  createUsersToTechstacks: Maybe<GqlCreateUsersToTechstacksPayload>;
  /** Creates a single `VendorStackshareLogo`. */
  createVendorStackshareLogo: Maybe<GqlCreateVendorStackshareLogoPayload>;
  /** Deletes a single `AssocHome` using a unique key. */
  deleteAssocHomeById: Maybe<GqlDeleteAssocHomePayload>;
  /** Deletes a single `AssocSection` using a unique key. */
  deleteAssocSection: Maybe<GqlDeleteAssocSectionPayload>;
  /** Deletes a single `AssocSection` using its globally unique id. */
  deleteAssocSectionByNodeId: Maybe<GqlDeleteAssocSectionPayload>;
  /** Deletes a single `AssociationToOrganization` using a unique key. */
  deleteAssociationToOrganization: Maybe<GqlDeleteAssociationToOrganizationPayload>;
  /** Deletes a single `AssociationToOrganization` using its globally unique id. */
  deleteAssociationToOrganizationByNodeId: Maybe<GqlDeleteAssociationToOrganizationPayload>;
  /** Deletes a single `AwardBadge` using a unique key. */
  deleteAwardBadgeById: Maybe<GqlDeleteAwardBadgePayload>;
  /** Deletes a single `AwardBadge` using a unique key. */
  deleteAwardBadgeBySlug: Maybe<GqlDeleteAwardBadgePayload>;
  /** Deletes a single `BestFor` using a unique key. */
  deleteBestFor: Maybe<GqlDeleteBestForPayload>;
  /** Deletes a single `BestFor` using its globally unique id. */
  deleteBestForByNodeId: Maybe<GqlDeleteBestForPayload>;
  /** Deletes a single `BestForToProduct` using a unique key. */
  deleteBestForToProduct: Maybe<GqlDeleteBestForToProductPayload>;
  /** Deletes a single `BestForToProduct` using its globally unique id. */
  deleteBestForToProductByNodeId: Maybe<GqlDeleteBestForToProductPayload>;
  deleteCategories: Maybe<GqlDeleteCategoriesPayload>;
  /** Deletes a single `Category` using a unique key. */
  deleteCategory: Maybe<GqlDeleteCategoryPayload>;
  /** Deletes a single `Category` using its globally unique id. */
  deleteCategoryByNodeId: Maybe<GqlDeleteCategoryPayload>;
  /** Deletes a single `CategoryToProduct` using a unique key. */
  deleteCategoryToProduct: Maybe<GqlDeleteCategoryToProductPayload>;
  /** Deletes a single `CategoryToProduct` using its globally unique id. */
  deleteCategoryToProductByNodeId: Maybe<GqlDeleteCategoryToProductPayload>;
  /** Deletes a single `ConnectCustomer` using a unique key. */
  deleteConnectCustomer: Maybe<GqlDeleteConnectCustomerPayload>;
  /** Deletes a single `ConnectCustomer` using its globally unique id. */
  deleteConnectCustomerByNodeId: Maybe<GqlDeleteConnectCustomerPayload>;
  /** Deletes a single `ConnectCustomer` using a unique key. */
  deleteConnectCustomerByUserIdAndAccountIdAndOrganizationId: Maybe<GqlDeleteConnectCustomerPayload>;
  /** Deletes a single `ConnectPurchase` using a unique key. */
  deleteConnectPurchase: Maybe<GqlDeleteConnectPurchasePayload>;
  /** Deletes a single `ConnectPurchase` using its globally unique id. */
  deleteConnectPurchaseByNodeId: Maybe<GqlDeleteConnectPurchasePayload>;
  deleteCoreStacks: Maybe<GqlDeleteCoreStacksPayload>;
  /** Deletes a single `DiversityCertification` using a unique key. */
  deleteDiversityCertification: Maybe<GqlDeleteDiversityCertificationPayload>;
  /** Deletes a single `DiversityCertification` using its globally unique id. */
  deleteDiversityCertificationByNodeId: Maybe<GqlDeleteDiversityCertificationPayload>;
  /** Deletes a single `Feature` using a unique key. */
  deleteFeature: Maybe<GqlDeleteFeaturePayload>;
  /** Deletes a single `Feature` using its globally unique id. */
  deleteFeatureByNodeId: Maybe<GqlDeleteFeaturePayload>;
  /** Deletes a single `FeatureToProduct` using a unique key. */
  deleteFeatureToProduct: Maybe<GqlDeleteFeatureToProductPayload>;
  /** Deletes a single `FeatureToProduct` using its globally unique id. */
  deleteFeatureToProductByNodeId: Maybe<GqlDeleteFeatureToProductPayload>;
  /** Deletes a single `LawfirmService` using a unique key. */
  deleteLawfirmService: Maybe<GqlDeleteLawfirmServicePayload>;
  /** Deletes a single `LawfirmService` using its globally unique id. */
  deleteLawfirmServiceByNodeId: Maybe<GqlDeleteLawfirmServicePayload>;
  /** Deletes a single `ListingCreator` using a unique key. */
  deleteListingCreatorById: Maybe<GqlDeleteListingCreatorPayload>;
  /** Deletes a single `Location` using a unique key. */
  deleteLocation: Maybe<GqlDeleteLocationPayload>;
  /** Deletes a single `Location` using its globally unique id. */
  deleteLocationByNodeId: Maybe<GqlDeleteLocationPayload>;
  /** Deletes a single `Notification` using a unique key. */
  deleteNotification: Maybe<GqlDeleteNotificationPayload>;
  /** Deletes a single `Notification` using its globally unique id. */
  deleteNotificationByNodeId: Maybe<GqlDeleteNotificationPayload>;
  /** Deletes a single `NoviMember` using a unique key. */
  deleteNoviMember: Maybe<GqlDeleteNoviMemberPayload>;
  /** Deletes a single `NoviMember` using its globally unique id. */
  deleteNoviMemberByNodeId: Maybe<GqlDeleteNoviMemberPayload>;
  /** Deletes a single `NoviOrganization` using a unique key. */
  deleteNoviOrganization: Maybe<GqlDeleteNoviOrganizationPayload>;
  /** Deletes a single `NoviOrganization` using its globally unique id. */
  deleteNoviOrganizationByNodeId: Maybe<GqlDeleteNoviOrganizationPayload>;
  /** Deletes a single `Organization` using a unique key. */
  deleteOrganization: Maybe<GqlDeleteOrganizationPayload>;
  /** Deletes a single `Organization` using a unique key. */
  deleteOrganizationByAuth0OrgId: Maybe<GqlDeleteOrganizationPayload>;
  /** Deletes a single `Organization` using its globally unique id. */
  deleteOrganizationByNodeId: Maybe<GqlDeleteOrganizationPayload>;
  /** Deletes a single `OrganizationListing` using a unique key. */
  deleteOrganizationListing: Maybe<GqlDeleteOrganizationListingPayload>;
  /** Deletes a single `OrganizationListing` using its globally unique id. */
  deleteOrganizationListingByNodeId: Maybe<GqlDeleteOrganizationListingPayload>;
  /** Deletes a single `OrganizationTechstack` using a unique key. */
  deleteOrganizationTechstack: Maybe<GqlDeleteOrganizationTechstackPayload>;
  /** Deletes a single `OrganizationTechstack` using its globally unique id. */
  deleteOrganizationTechstackByNodeId: Maybe<GqlDeleteOrganizationTechstackPayload>;
  deleteOrganizations: Maybe<GqlDeleteOrganizationsPayload>;
  /** Deletes a single `PersonalTechstack` using a unique key. */
  deletePersonalTechstack: Maybe<GqlDeletePersonalTechstackPayload>;
  /** Deletes a single `PersonalTechstack` using its globally unique id. */
  deletePersonalTechstackByNodeId: Maybe<GqlDeletePersonalTechstackPayload>;
  deletePersonalTechstacks: Maybe<GqlDeletePersonalTechstacksPayload>;
  /** Deletes a single `PracticeGroup` using a unique key. */
  deletePracticeGroup: Maybe<GqlDeletePracticeGroupPayload>;
  /** Deletes a single `PracticeGroup` using its globally unique id. */
  deletePracticeGroupByNodeId: Maybe<GqlDeletePracticeGroupPayload>;
  /** Deletes a single `PremiumInfoToTerm` using a unique key. */
  deletePremiumInfoToTerm: Maybe<GqlDeletePremiumInfoToTermPayload>;
  /** Deletes a single `PremiumInfoToTerm` using its globally unique id. */
  deletePremiumInfoToTermByNodeId: Maybe<GqlDeletePremiumInfoToTermPayload>;
  /** Deletes a single `PremiumProductInfo` using a unique key. */
  deletePremiumProductInfo: Maybe<GqlDeletePremiumProductInfoPayload>;
  /** Deletes a single `PremiumProductInfo` using a unique key. */
  deletePremiumProductInfoByIdAndProductId: Maybe<GqlDeletePremiumProductInfoPayload>;
  /** Deletes a single `PremiumProductInfo` using its globally unique id. */
  deletePremiumProductInfoByNodeId: Maybe<GqlDeletePremiumProductInfoPayload>;
  /** Deletes a single `Product` using a unique key. */
  deleteProduct: Maybe<GqlDeleteProductPayload>;
  /** Deletes a single `ProductAwardDetail` using a unique key. */
  deleteProductAwardDetail: Maybe<GqlDeleteProductAwardDetailPayload>;
  /** Deletes a single `ProductAwardDetail` using its globally unique id. */
  deleteProductAwardDetailByNodeId: Maybe<GqlDeleteProductAwardDetailPayload>;
  /** Deletes a single `Product` using its globally unique id. */
  deleteProductByNodeId: Maybe<GqlDeleteProductPayload>;
  /** Deletes a single `ProductFeatureByTerm` using a unique key. */
  deleteProductFeatureByTerm: Maybe<GqlDeleteProductFeatureByTermPayload>;
  /** Deletes a single `ProductFeatureByTerm` using its globally unique id. */
  deleteProductFeatureByTermByNodeId: Maybe<GqlDeleteProductFeatureByTermPayload>;
  /** Deletes a single `ProductListing` using a unique key. */
  deleteProductListing: Maybe<GqlDeleteProductListingPayload>;
  /** Deletes a single `ProductListing` using its globally unique id. */
  deleteProductListingByNodeId: Maybe<GqlDeleteProductListingPayload>;
  /** Deletes a single `ProductListing` using a unique key. */
  deleteProductListingByProductIdAndAssociationId: Maybe<GqlDeleteProductListingPayload>;
  /** Deletes a single `ProductSection` using a unique key. */
  deleteProductSection: Maybe<GqlDeleteProductSectionPayload>;
  /** Deletes a single `ProductSection` using its globally unique id. */
  deleteProductSectionByNodeId: Maybe<GqlDeleteProductSectionPayload>;
  /** Deletes a single `ProductToAssocSection` using a unique key. */
  deleteProductToAssocSection: Maybe<GqlDeleteProductToAssocSectionPayload>;
  /** Deletes a single `ProductToAssocSection` using its globally unique id. */
  deleteProductToAssocSectionByNodeId: Maybe<GqlDeleteProductToAssocSectionPayload>;
  /** Deletes a single `ProductToAwardBadge` using a unique key. */
  deleteProductToAwardBadge: Maybe<GqlDeleteProductToAwardBadgePayload>;
  /** Deletes a single `ProductToAwardBadge` using its globally unique id. */
  deleteProductToAwardBadgeByNodeId: Maybe<GqlDeleteProductToAwardBadgePayload>;
  /** Deletes a single `ProductToClient` using a unique key. */
  deleteProductToClient: Maybe<GqlDeleteProductToClientPayload>;
  /** Deletes a single `ProductToClient` using its globally unique id. */
  deleteProductToClientByNodeId: Maybe<GqlDeleteProductToClientPayload>;
  /** Deletes a single `ProductToCompetitor` using a unique key. */
  deleteProductToCompetitor: Maybe<GqlDeleteProductToCompetitorPayload>;
  /** Deletes a single `ProductToCompetitor` using its globally unique id. */
  deleteProductToCompetitorByNodeId: Maybe<GqlDeleteProductToCompetitorPayload>;
  /** Deletes a single `ProductToIntegration` using a unique key. */
  deleteProductToIntegration: Maybe<GqlDeleteProductToIntegrationPayload>;
  /** Deletes a single `ProductToIntegration` using its globally unique id. */
  deleteProductToIntegrationByNodeId: Maybe<GqlDeleteProductToIntegrationPayload>;
  deleteProductToIntegrations: Maybe<GqlDeleteProductToIntegrationsPayload>;
  /** Deletes a single `ProductToOrganization` using a unique key. */
  deleteProductToOrganization: Maybe<GqlDeleteProductToOrganizationPayload>;
  /** Deletes a single `ProductToOrganization` using its globally unique id. */
  deleteProductToOrganizationByNodeId: Maybe<GqlDeleteProductToOrganizationPayload>;
  /** Deletes a single `ProductToPracticeGroup` using a unique key. */
  deleteProductToPracticeGroup: Maybe<GqlDeleteProductToPracticeGroupPayload>;
  /** Deletes a single `ProductToPracticeGroup` using its globally unique id. */
  deleteProductToPracticeGroupByNodeId: Maybe<GqlDeleteProductToPracticeGroupPayload>;
  /** Deletes a single `ProductToSuiteListing` using a unique key. */
  deleteProductToSuiteListing: Maybe<GqlDeleteProductToSuiteListingPayload>;
  /** Deletes a single `ProductToSuiteListing` using its globally unique id. */
  deleteProductToSuiteListingByNodeId: Maybe<GqlDeleteProductToSuiteListingPayload>;
  /** Deletes a single `ProductToUser` using a unique key. */
  deleteProductToUser: Maybe<GqlDeleteProductToUserPayload>;
  /** Deletes a single `ProductToUser` using its globally unique id. */
  deleteProductToUserByNodeId: Maybe<GqlDeleteProductToUserPayload>;
  deleteProducts: Maybe<GqlDeleteProductsPayload>;
  /** Deletes a single `Rfp` using a unique key. */
  deleteRfp: Maybe<GqlDeleteRfpPayload>;
  /** Deletes a single `Rfp` using its globally unique id. */
  deleteRfpByNodeId: Maybe<GqlDeleteRfpPayload>;
  /** Deletes a single `RfpToProduct` using a unique key. */
  deleteRfpToProduct: Maybe<GqlDeleteRfpToProductPayload>;
  /** Deletes a single `RfpToProduct` using its globally unique id. */
  deleteRfpToProductByNodeId: Maybe<GqlDeleteRfpToProductPayload>;
  /** Deletes a single `Scheduler` using a unique key. */
  deleteScheduler: Maybe<GqlDeleteSchedulerPayload>;
  /** Deletes a single `Scheduler` using its globally unique id. */
  deleteSchedulerByNodeId: Maybe<GqlDeleteSchedulerPayload>;
  /** Deletes a single `SectionLayout` using a unique key. */
  deleteSectionLayout: Maybe<GqlDeleteSectionLayoutPayload>;
  /** Deletes a single `SectionLayout` using its globally unique id. */
  deleteSectionLayoutByNodeId: Maybe<GqlDeleteSectionLayoutPayload>;
  /** Deletes a single `SimpleService` using a unique key. */
  deleteSimpleService: Maybe<GqlDeleteSimpleServicePayload>;
  /** Deletes a single `SimpleService` using its globally unique id. */
  deleteSimpleServiceByNodeId: Maybe<GqlDeleteSimpleServicePayload>;
  /** Deletes a single `SimpleService` using a unique key. */
  deleteSimpleServiceByOrganizationIdAndTermId: Maybe<GqlDeleteSimpleServicePayload>;
  /** Deletes a single `StackshareOption` using a unique key. */
  deleteStackshareOption: Maybe<GqlDeleteStackshareOptionPayload>;
  /** Deletes a single `StackshareOption` using its globally unique id. */
  deleteStackshareOptionByNodeId: Maybe<GqlDeleteStackshareOptionPayload>;
  /** Deletes a single `StripeAccount` using a unique key. */
  deleteStripeAccount: Maybe<GqlDeleteStripeAccountPayload>;
  /** Deletes a single `StripeAccount` using its globally unique id. */
  deleteStripeAccountByNodeId: Maybe<GqlDeleteStripeAccountPayload>;
  /** Deletes a single `StripeCustomer` using a unique key. */
  deleteStripeCustomer: Maybe<GqlDeleteStripeCustomerPayload>;
  /** Deletes a single `StripeCustomer` using its globally unique id. */
  deleteStripeCustomerByNodeId: Maybe<GqlDeleteStripeCustomerPayload>;
  /** Deletes a single `StripePurchase` using a unique key. */
  deleteStripePurchase: Maybe<GqlDeleteStripePurchasePayload>;
  /** Deletes a single `StripePurchase` using its globally unique id. */
  deleteStripePurchaseByNodeId: Maybe<GqlDeleteStripePurchasePayload>;
  /** Deletes a single `StripeSeat` using a unique key. */
  deleteStripeSeat: Maybe<GqlDeleteStripeSeatPayload>;
  /** Deletes a single `StripeSeat` using its globally unique id. */
  deleteStripeSeatByNodeId: Maybe<GqlDeleteStripeSeatPayload>;
  deleteStripeSeats: Maybe<GqlDeleteStripeSeatsPayload>;
  /** Deletes a single `SuiteListing` using a unique key. */
  deleteSuiteListing: Maybe<GqlDeleteSuiteListingPayload>;
  /** Deletes a single `SuiteListing` using its globally unique id. */
  deleteSuiteListingByNodeId: Maybe<GqlDeleteSuiteListingPayload>;
  /** Deletes a single `Taxonomy` using a unique key. */
  deleteTaxonomy: Maybe<GqlDeleteTaxonomyPayload>;
  /** Deletes a single `Taxonomy` using its globally unique id. */
  deleteTaxonomyByNodeId: Maybe<GqlDeleteTaxonomyPayload>;
  /** Deletes a single `Techstack` using a unique key. */
  deleteTechstack: Maybe<GqlDeleteTechstackPayload>;
  /** Deletes a single `Techstack` using its globally unique id. */
  deleteTechstackByNodeId: Maybe<GqlDeleteTechstackPayload>;
  /** Deletes a single `Techstack` using a unique key. */
  deleteTechstackByOrganizationIdAndProductId: Maybe<GqlDeleteTechstackPayload>;
  /** Deletes a single `TempDatum` using a unique key. */
  deleteTempDatumById: Maybe<GqlDeleteTempDatumPayload>;
  /** Deletes a single `Term` using a unique key. */
  deleteTerm: Maybe<GqlDeleteTermPayload>;
  /** Deletes a single `Term` using its globally unique id. */
  deleteTermByNodeId: Maybe<GqlDeleteTermPayload>;
  /** Deletes a single `TermToOrganization` using a unique key. */
  deleteTermToOrganization: Maybe<GqlDeleteTermToOrganizationPayload>;
  /** Deletes a single `TermToOrganization` using its globally unique id. */
  deleteTermToOrganizationByNodeId: Maybe<GqlDeleteTermToOrganizationPayload>;
  /** Deletes a single `TermToProduct` using a unique key. */
  deleteTermToProduct: Maybe<GqlDeleteTermToProductPayload>;
  /** Deletes a single `TermToProduct` using its globally unique id. */
  deleteTermToProductByNodeId: Maybe<GqlDeleteTermToProductPayload>;
  /** Deletes a single `TermToRfp` using a unique key. */
  deleteTermToRfp: Maybe<GqlDeleteTermToRfpPayload>;
  /** Deletes a single `TermToRfp` using its globally unique id. */
  deleteTermToRfpByNodeId: Maybe<GqlDeleteTermToRfpPayload>;
  /** Deletes a single `TermToSuiteListing` using a unique key. */
  deleteTermToSuiteListing: Maybe<GqlDeleteTermToSuiteListingPayload>;
  /** Deletes a single `TermToSuiteListing` using its globally unique id. */
  deleteTermToSuiteListingByNodeId: Maybe<GqlDeleteTermToSuiteListingPayload>;
  /** Deletes a single `TermToTestDrive` using a unique key. */
  deleteTermToTestDrive: Maybe<GqlDeleteTermToTestDrivePayload>;
  /** Deletes a single `TermToTestDrive` using its globally unique id. */
  deleteTermToTestDriveByNodeId: Maybe<GqlDeleteTermToTestDrivePayload>;
  /** Deletes a single `TermToUser` using a unique key. */
  deleteTermToUser: Maybe<GqlDeleteTermToUserPayload>;
  /** Deletes a single `TermToUser` using its globally unique id. */
  deleteTermToUserByNodeId: Maybe<GqlDeleteTermToUserPayload>;
  /** Deletes a single `TermToUserStory` using a unique key. */
  deleteTermToUserStory: Maybe<GqlDeleteTermToUserStoryPayload>;
  /** Deletes a single `TermToUserStory` using its globally unique id. */
  deleteTermToUserStoryByNodeId: Maybe<GqlDeleteTermToUserStoryPayload>;
  /** Deletes a single `TermToVendorStackshare` using a unique key. */
  deleteTermToVendorStackshare: Maybe<GqlDeleteTermToVendorStacksharePayload>;
  /** Deletes a single `TermToVendorStackshare` using its globally unique id. */
  deleteTermToVendorStackshareByNodeId: Maybe<GqlDeleteTermToVendorStacksharePayload>;
  deleteTermsToOrganization: Maybe<GqlDeleteTermsToOrganizationPayload>;
  deleteTermsToProduct: Maybe<GqlDeleteTermsToProductPayload>;
  deleteTermsToSuiteListing: Maybe<GqlDeleteTermsToSuiteListingPayload>;
  deleteTermsToTestDrive: Maybe<GqlDeleteTermsToTestDrivePayload>;
  deleteTermsToUser: Maybe<GqlDeleteTermsToUserPayload>;
  /** Deletes a single `Termscout` using a unique key. */
  deleteTermscout: Maybe<GqlDeleteTermscoutPayload>;
  /** Deletes a single `Termscout` using its globally unique id. */
  deleteTermscoutByNodeId: Maybe<GqlDeleteTermscoutPayload>;
  /** Deletes a single `TestDrive` using a unique key. */
  deleteTestDrive: Maybe<GqlDeleteTestDrivePayload>;
  /** Deletes a single `TestDrive` using its globally unique id. */
  deleteTestDriveByNodeId: Maybe<GqlDeleteTestDrivePayload>;
  deleteTestDrives: Maybe<GqlDeleteTestDrivesPayload>;
  /** Deletes a single `TheoremProduct` using a unique key. */
  deleteTheoremProduct: Maybe<GqlDeleteTheoremProductPayload>;
  /** Deletes a single `TheoremProduct` using its globally unique id. */
  deleteTheoremProductByNodeId: Maybe<GqlDeleteTheoremProductPayload>;
  /** Deletes a single `TheoremProduct` using a unique key. */
  deleteTheoremProductByStripeProductId: Maybe<GqlDeleteTheoremProductPayload>;
  /** Deletes a single `TheoremProduct` using a unique key. */
  deleteTheoremProductByTestStripeProductId: Maybe<GqlDeleteTheoremProductPayload>;
  deleteTheoremProducts: Maybe<GqlDeleteTheoremProductsPayload>;
  /** Deletes a single `UseCase` using a unique key. */
  deleteUseCase: Maybe<GqlDeleteUseCasePayload>;
  /** Deletes a single `UseCase` using its globally unique id. */
  deleteUseCaseByNodeId: Maybe<GqlDeleteUseCasePayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser: Maybe<GqlDeleteUserPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUserByNodeId: Maybe<GqlDeleteUserPayload>;
  /** Deletes a single `UserStory` using a unique key. */
  deleteUserStory: Maybe<GqlDeleteUserStoryPayload>;
  /** Deletes a single `UserStory` using its globally unique id. */
  deleteUserStoryByNodeId: Maybe<GqlDeleteUserStoryPayload>;
  /** Deletes a single `UserToOrgStack` using a unique key. */
  deleteUserToOrgStack: Maybe<GqlDeleteUserToOrgStackPayload>;
  /** Deletes a single `UserToOrgStack` using its globally unique id. */
  deleteUserToOrgStackByNodeId: Maybe<GqlDeleteUserToOrgStackPayload>;
  deleteUsers: Maybe<GqlDeleteUsersPayload>;
  /** Deletes a single `UsersToOrganization` using a unique key. */
  deleteUsersToOrganization: Maybe<GqlDeleteUsersToOrganizationPayload>;
  /** Deletes a single `UsersToOrganization` using its globally unique id. */
  deleteUsersToOrganizationByNodeId: Maybe<GqlDeleteUsersToOrganizationPayload>;
  /** Deletes a single `UsersToPracticeGroup` using a unique key. */
  deleteUsersToPracticeGroup: Maybe<GqlDeleteUsersToPracticeGroupPayload>;
  /** Deletes a single `UsersToPracticeGroup` using its globally unique id. */
  deleteUsersToPracticeGroupByNodeId: Maybe<GqlDeleteUsersToPracticeGroupPayload>;
  /** Deletes a single `UsersToTechstack` using a unique key. */
  deleteUsersToTechstack: Maybe<GqlDeleteUsersToTechstackPayload>;
  /** Deletes a single `UsersToTechstack` using its globally unique id. */
  deleteUsersToTechstackByNodeId: Maybe<GqlDeleteUsersToTechstackPayload>;
  deleteUsersToTechstacks: Maybe<GqlDeleteUsersToTechstacksPayload>;
  /** Deletes a single `VendorStackshareLogo` using a unique key. */
  deleteVendorStackshareLogo: Maybe<GqlDeleteVendorStackshareLogoPayload>;
  /** Deletes a single `VendorStackshareLogo` using its globally unique id. */
  deleteVendorStackshareLogoByNodeId: Maybe<GqlDeleteVendorStackshareLogoPayload>;
  replaceTermToUserStory: Maybe<GqlReplaceTermToUserStoryPayload>;
  /** Updates a single `AssocHome` using a unique key and a patch. */
  updateAssocHomeById: Maybe<GqlUpdateAssocHomePayload>;
  /** Updates a single `AssocSection` using a unique key and a patch. */
  updateAssocSection: Maybe<GqlUpdateAssocSectionPayload>;
  /** Updates a single `AssocSection` using its globally unique id and a patch. */
  updateAssocSectionByNodeId: Maybe<GqlUpdateAssocSectionPayload>;
  /** Updates a single `AssociationToOrganization` using a unique key and a patch. */
  updateAssociationToOrganization: Maybe<GqlUpdateAssociationToOrganizationPayload>;
  /** Updates a single `AssociationToOrganization` using its globally unique id and a patch. */
  updateAssociationToOrganizationByNodeId: Maybe<GqlUpdateAssociationToOrganizationPayload>;
  /** Updates a single `AwardBadge` using a unique key and a patch. */
  updateAwardBadgeById: Maybe<GqlUpdateAwardBadgePayload>;
  /** Updates a single `AwardBadge` using a unique key and a patch. */
  updateAwardBadgeBySlug: Maybe<GqlUpdateAwardBadgePayload>;
  /** Updates a single `BestFor` using a unique key and a patch. */
  updateBestFor: Maybe<GqlUpdateBestForPayload>;
  /** Updates a single `BestFor` using its globally unique id and a patch. */
  updateBestForByNodeId: Maybe<GqlUpdateBestForPayload>;
  /** Updates a single `BestForToProduct` using a unique key and a patch. */
  updateBestForToProduct: Maybe<GqlUpdateBestForToProductPayload>;
  /** Updates a single `BestForToProduct` using its globally unique id and a patch. */
  updateBestForToProductByNodeId: Maybe<GqlUpdateBestForToProductPayload>;
  /** Updates a single `Category` using a unique key and a patch. */
  updateCategory: Maybe<GqlUpdateCategoryPayload>;
  /** Updates a single `Category` using its globally unique id and a patch. */
  updateCategoryByNodeId: Maybe<GqlUpdateCategoryPayload>;
  /** Updates a single `CategoryToProduct` using a unique key and a patch. */
  updateCategoryToProduct: Maybe<GqlUpdateCategoryToProductPayload>;
  /** Updates a single `CategoryToProduct` using its globally unique id and a patch. */
  updateCategoryToProductByNodeId: Maybe<GqlUpdateCategoryToProductPayload>;
  /** Updates a single `ConnectCustomer` using a unique key and a patch. */
  updateConnectCustomer: Maybe<GqlUpdateConnectCustomerPayload>;
  /** Updates a single `ConnectCustomer` using its globally unique id and a patch. */
  updateConnectCustomerByNodeId: Maybe<GqlUpdateConnectCustomerPayload>;
  /** Updates a single `ConnectCustomer` using a unique key and a patch. */
  updateConnectCustomerByUserIdAndAccountIdAndOrganizationId: Maybe<GqlUpdateConnectCustomerPayload>;
  /** Updates a single `ConnectPurchase` using a unique key and a patch. */
  updateConnectPurchase: Maybe<GqlUpdateConnectPurchasePayload>;
  /** Updates a single `ConnectPurchase` using its globally unique id and a patch. */
  updateConnectPurchaseByNodeId: Maybe<GqlUpdateConnectPurchasePayload>;
  /** Updates a single `DiversityCertification` using a unique key and a patch. */
  updateDiversityCertification: Maybe<GqlUpdateDiversityCertificationPayload>;
  /** Updates a single `DiversityCertification` using its globally unique id and a patch. */
  updateDiversityCertificationByNodeId: Maybe<GqlUpdateDiversityCertificationPayload>;
  /** Updates a single `Feature` using a unique key and a patch. */
  updateFeature: Maybe<GqlUpdateFeaturePayload>;
  /** Updates a single `Feature` using its globally unique id and a patch. */
  updateFeatureByNodeId: Maybe<GqlUpdateFeaturePayload>;
  /** Updates a single `FeatureToProduct` using a unique key and a patch. */
  updateFeatureToProduct: Maybe<GqlUpdateFeatureToProductPayload>;
  /** Updates a single `FeatureToProduct` using its globally unique id and a patch. */
  updateFeatureToProductByNodeId: Maybe<GqlUpdateFeatureToProductPayload>;
  /** Updates a single `LawfirmService` using a unique key and a patch. */
  updateLawfirmService: Maybe<GqlUpdateLawfirmServicePayload>;
  /** Updates a single `LawfirmService` using its globally unique id and a patch. */
  updateLawfirmServiceByNodeId: Maybe<GqlUpdateLawfirmServicePayload>;
  updateLawfirmType: Maybe<GqlUpdateLawfirmTypePayload>;
  /** Updates a single `ListingCreator` using a unique key and a patch. */
  updateListingCreatorById: Maybe<GqlUpdateListingCreatorPayload>;
  /** Updates a single `Location` using a unique key and a patch. */
  updateLocation: Maybe<GqlUpdateLocationPayload>;
  /** Updates a single `Location` using its globally unique id and a patch. */
  updateLocationByNodeId: Maybe<GqlUpdateLocationPayload>;
  /** Updates a single `Notification` using a unique key and a patch. */
  updateNotification: Maybe<GqlUpdateNotificationPayload>;
  /** Updates a single `Notification` using its globally unique id and a patch. */
  updateNotificationByNodeId: Maybe<GqlUpdateNotificationPayload>;
  /** Updates a single `NoviMember` using a unique key and a patch. */
  updateNoviMember: Maybe<GqlUpdateNoviMemberPayload>;
  /** Updates a single `NoviMember` using its globally unique id and a patch. */
  updateNoviMemberByNodeId: Maybe<GqlUpdateNoviMemberPayload>;
  /** Updates a single `NoviOrganization` using a unique key and a patch. */
  updateNoviOrganization: Maybe<GqlUpdateNoviOrganizationPayload>;
  /** Updates a single `NoviOrganization` using its globally unique id and a patch. */
  updateNoviOrganizationByNodeId: Maybe<GqlUpdateNoviOrganizationPayload>;
  /** Updates a single `Organization` using a unique key and a patch. */
  updateOrganization: Maybe<GqlUpdateOrganizationPayload>;
  /** Updates a single `Organization` using a unique key and a patch. */
  updateOrganizationByAuth0OrgId: Maybe<GqlUpdateOrganizationPayload>;
  /** Updates a single `Organization` using its globally unique id and a patch. */
  updateOrganizationByNodeId: Maybe<GqlUpdateOrganizationPayload>;
  /** Updates a single `OrganizationListing` using a unique key and a patch. */
  updateOrganizationListing: Maybe<GqlUpdateOrganizationListingPayload>;
  /** Updates a single `OrganizationListing` using its globally unique id and a patch. */
  updateOrganizationListingByNodeId: Maybe<GqlUpdateOrganizationListingPayload>;
  /** Updates a single `OrganizationTechstack` using a unique key and a patch. */
  updateOrganizationTechstack: Maybe<GqlUpdateOrganizationTechstackPayload>;
  /** Updates a single `OrganizationTechstack` using its globally unique id and a patch. */
  updateOrganizationTechstackByNodeId: Maybe<GqlUpdateOrganizationTechstackPayload>;
  /** Updates a single `PersonalTechstack` using a unique key and a patch. */
  updatePersonalTechstack: Maybe<GqlUpdatePersonalTechstackPayload>;
  /** Updates a single `PersonalTechstack` using its globally unique id and a patch. */
  updatePersonalTechstackByNodeId: Maybe<GqlUpdatePersonalTechstackPayload>;
  /** Updates a single `PracticeGroup` using a unique key and a patch. */
  updatePracticeGroup: Maybe<GqlUpdatePracticeGroupPayload>;
  /** Updates a single `PracticeGroup` using its globally unique id and a patch. */
  updatePracticeGroupByNodeId: Maybe<GqlUpdatePracticeGroupPayload>;
  /** Updates a single `PremiumInfoToTerm` using a unique key and a patch. */
  updatePremiumInfoToTerm: Maybe<GqlUpdatePremiumInfoToTermPayload>;
  /** Updates a single `PremiumInfoToTerm` using its globally unique id and a patch. */
  updatePremiumInfoToTermByNodeId: Maybe<GqlUpdatePremiumInfoToTermPayload>;
  /** Updates a single `PremiumProductInfo` using a unique key and a patch. */
  updatePremiumProductInfo: Maybe<GqlUpdatePremiumProductInfoPayload>;
  /** Updates a single `PremiumProductInfo` using a unique key and a patch. */
  updatePremiumProductInfoByIdAndProductId: Maybe<GqlUpdatePremiumProductInfoPayload>;
  /** Updates a single `PremiumProductInfo` using its globally unique id and a patch. */
  updatePremiumProductInfoByNodeId: Maybe<GqlUpdatePremiumProductInfoPayload>;
  /** Updates a single `Product` using a unique key and a patch. */
  updateProduct: Maybe<GqlUpdateProductPayload>;
  /** Updates a single `ProductAwardDetail` using a unique key and a patch. */
  updateProductAwardDetail: Maybe<GqlUpdateProductAwardDetailPayload>;
  /** Updates a single `ProductAwardDetail` using its globally unique id and a patch. */
  updateProductAwardDetailByNodeId: Maybe<GqlUpdateProductAwardDetailPayload>;
  /** Updates a single `Product` using its globally unique id and a patch. */
  updateProductByNodeId: Maybe<GqlUpdateProductPayload>;
  /** Updates a single `ProductFeatureByTerm` using a unique key and a patch. */
  updateProductFeatureByTerm: Maybe<GqlUpdateProductFeatureByTermPayload>;
  /** Updates a single `ProductFeatureByTerm` using its globally unique id and a patch. */
  updateProductFeatureByTermByNodeId: Maybe<GqlUpdateProductFeatureByTermPayload>;
  /** Updates a single `ProductListing` using a unique key and a patch. */
  updateProductListing: Maybe<GqlUpdateProductListingPayload>;
  /** Updates a single `ProductListing` using its globally unique id and a patch. */
  updateProductListingByNodeId: Maybe<GqlUpdateProductListingPayload>;
  /** Updates a single `ProductListing` using a unique key and a patch. */
  updateProductListingByProductIdAndAssociationId: Maybe<GqlUpdateProductListingPayload>;
  /** Updates a single `ProductSection` using a unique key and a patch. */
  updateProductSection: Maybe<GqlUpdateProductSectionPayload>;
  /** Updates a single `ProductSection` using its globally unique id and a patch. */
  updateProductSectionByNodeId: Maybe<GqlUpdateProductSectionPayload>;
  /** Updates a single `ProductToAssocSection` using a unique key and a patch. */
  updateProductToAssocSection: Maybe<GqlUpdateProductToAssocSectionPayload>;
  /** Updates a single `ProductToAssocSection` using its globally unique id and a patch. */
  updateProductToAssocSectionByNodeId: Maybe<GqlUpdateProductToAssocSectionPayload>;
  /** Updates a single `ProductToAwardBadge` using a unique key and a patch. */
  updateProductToAwardBadge: Maybe<GqlUpdateProductToAwardBadgePayload>;
  /** Updates a single `ProductToAwardBadge` using its globally unique id and a patch. */
  updateProductToAwardBadgeByNodeId: Maybe<GqlUpdateProductToAwardBadgePayload>;
  /** Updates a single `ProductToClient` using a unique key and a patch. */
  updateProductToClient: Maybe<GqlUpdateProductToClientPayload>;
  /** Updates a single `ProductToClient` using its globally unique id and a patch. */
  updateProductToClientByNodeId: Maybe<GqlUpdateProductToClientPayload>;
  /** Updates a single `ProductToCompetitor` using a unique key and a patch. */
  updateProductToCompetitor: Maybe<GqlUpdateProductToCompetitorPayload>;
  /** Updates a single `ProductToCompetitor` using its globally unique id and a patch. */
  updateProductToCompetitorByNodeId: Maybe<GqlUpdateProductToCompetitorPayload>;
  /** Updates a single `ProductToIntegration` using a unique key and a patch. */
  updateProductToIntegration: Maybe<GqlUpdateProductToIntegrationPayload>;
  /** Updates a single `ProductToIntegration` using its globally unique id and a patch. */
  updateProductToIntegrationByNodeId: Maybe<GqlUpdateProductToIntegrationPayload>;
  /** Updates a single `ProductToOrganization` using a unique key and a patch. */
  updateProductToOrganization: Maybe<GqlUpdateProductToOrganizationPayload>;
  /** Updates a single `ProductToOrganization` using its globally unique id and a patch. */
  updateProductToOrganizationByNodeId: Maybe<GqlUpdateProductToOrganizationPayload>;
  /** Updates a single `ProductToPracticeGroup` using a unique key and a patch. */
  updateProductToPracticeGroup: Maybe<GqlUpdateProductToPracticeGroupPayload>;
  /** Updates a single `ProductToPracticeGroup` using its globally unique id and a patch. */
  updateProductToPracticeGroupByNodeId: Maybe<GqlUpdateProductToPracticeGroupPayload>;
  /** Updates a single `ProductToSuiteListing` using a unique key and a patch. */
  updateProductToSuiteListing: Maybe<GqlUpdateProductToSuiteListingPayload>;
  /** Updates a single `ProductToSuiteListing` using its globally unique id and a patch. */
  updateProductToSuiteListingByNodeId: Maybe<GqlUpdateProductToSuiteListingPayload>;
  /** Updates a single `ProductToUser` using a unique key and a patch. */
  updateProductToUser: Maybe<GqlUpdateProductToUserPayload>;
  /** Updates a single `ProductToUser` using its globally unique id and a patch. */
  updateProductToUserByNodeId: Maybe<GqlUpdateProductToUserPayload>;
  /** Updates a single `Rfp` using a unique key and a patch. */
  updateRfp: Maybe<GqlUpdateRfpPayload>;
  /** Updates a single `Rfp` using its globally unique id and a patch. */
  updateRfpByNodeId: Maybe<GqlUpdateRfpPayload>;
  /** Updates a single `RfpToProduct` using a unique key and a patch. */
  updateRfpToProduct: Maybe<GqlUpdateRfpToProductPayload>;
  /** Updates a single `RfpToProduct` using its globally unique id and a patch. */
  updateRfpToProductByNodeId: Maybe<GqlUpdateRfpToProductPayload>;
  /** Updates a single `Scheduler` using a unique key and a patch. */
  updateScheduler: Maybe<GqlUpdateSchedulerPayload>;
  /** Updates a single `Scheduler` using its globally unique id and a patch. */
  updateSchedulerByNodeId: Maybe<GqlUpdateSchedulerPayload>;
  /** Updates a single `SectionLayout` using a unique key and a patch. */
  updateSectionLayout: Maybe<GqlUpdateSectionLayoutPayload>;
  /** Updates a single `SectionLayout` using its globally unique id and a patch. */
  updateSectionLayoutByNodeId: Maybe<GqlUpdateSectionLayoutPayload>;
  /** Updates a single `SimpleService` using a unique key and a patch. */
  updateSimpleService: Maybe<GqlUpdateSimpleServicePayload>;
  /** Updates a single `SimpleService` using its globally unique id and a patch. */
  updateSimpleServiceByNodeId: Maybe<GqlUpdateSimpleServicePayload>;
  /** Updates a single `SimpleService` using a unique key and a patch. */
  updateSimpleServiceByOrganizationIdAndTermId: Maybe<GqlUpdateSimpleServicePayload>;
  /** Updates a single `StackshareOption` using a unique key and a patch. */
  updateStackshareOption: Maybe<GqlUpdateStackshareOptionPayload>;
  /** Updates a single `StackshareOption` using its globally unique id and a patch. */
  updateStackshareOptionByNodeId: Maybe<GqlUpdateStackshareOptionPayload>;
  /** Updates a single `StripeAccount` using a unique key and a patch. */
  updateStripeAccount: Maybe<GqlUpdateStripeAccountPayload>;
  /** Updates a single `StripeAccount` using its globally unique id and a patch. */
  updateStripeAccountByNodeId: Maybe<GqlUpdateStripeAccountPayload>;
  /** Updates a single `StripeCustomer` using a unique key and a patch. */
  updateStripeCustomer: Maybe<GqlUpdateStripeCustomerPayload>;
  /** Updates a single `StripeCustomer` using its globally unique id and a patch. */
  updateStripeCustomerByNodeId: Maybe<GqlUpdateStripeCustomerPayload>;
  /** Updates a single `StripePurchase` using a unique key and a patch. */
  updateStripePurchase: Maybe<GqlUpdateStripePurchasePayload>;
  /** Updates a single `StripePurchase` using its globally unique id and a patch. */
  updateStripePurchaseByNodeId: Maybe<GqlUpdateStripePurchasePayload>;
  /** Updates a single `StripeSeat` using a unique key and a patch. */
  updateStripeSeat: Maybe<GqlUpdateStripeSeatPayload>;
  /** Updates a single `StripeSeat` using its globally unique id and a patch. */
  updateStripeSeatByNodeId: Maybe<GqlUpdateStripeSeatPayload>;
  /** Updates a single `SuiteListing` using a unique key and a patch. */
  updateSuiteListing: Maybe<GqlUpdateSuiteListingPayload>;
  /** Updates a single `SuiteListing` using its globally unique id and a patch. */
  updateSuiteListingByNodeId: Maybe<GqlUpdateSuiteListingPayload>;
  /** Updates a single `Taxonomy` using a unique key and a patch. */
  updateTaxonomy: Maybe<GqlUpdateTaxonomyPayload>;
  /** Updates a single `Taxonomy` using its globally unique id and a patch. */
  updateTaxonomyByNodeId: Maybe<GqlUpdateTaxonomyPayload>;
  /** Updates a single `Techstack` using a unique key and a patch. */
  updateTechstack: Maybe<GqlUpdateTechstackPayload>;
  /** Updates a single `Techstack` using its globally unique id and a patch. */
  updateTechstackByNodeId: Maybe<GqlUpdateTechstackPayload>;
  /** Updates a single `Techstack` using a unique key and a patch. */
  updateTechstackByOrganizationIdAndProductId: Maybe<GqlUpdateTechstackPayload>;
  /** Updates a single `TempDatum` using a unique key and a patch. */
  updateTempDatumById: Maybe<GqlUpdateTempDatumPayload>;
  /** Updates a single `Term` using a unique key and a patch. */
  updateTerm: Maybe<GqlUpdateTermPayload>;
  /** Updates a single `Term` using its globally unique id and a patch. */
  updateTermByNodeId: Maybe<GqlUpdateTermPayload>;
  /** Updates a single `TermToOrganization` using a unique key and a patch. */
  updateTermToOrganization: Maybe<GqlUpdateTermToOrganizationPayload>;
  /** Updates a single `TermToOrganization` using its globally unique id and a patch. */
  updateTermToOrganizationByNodeId: Maybe<GqlUpdateTermToOrganizationPayload>;
  /** Updates a single `TermToProduct` using a unique key and a patch. */
  updateTermToProduct: Maybe<GqlUpdateTermToProductPayload>;
  /** Updates a single `TermToProduct` using its globally unique id and a patch. */
  updateTermToProductByNodeId: Maybe<GqlUpdateTermToProductPayload>;
  /** Updates a single `TermToRfp` using a unique key and a patch. */
  updateTermToRfp: Maybe<GqlUpdateTermToRfpPayload>;
  /** Updates a single `TermToRfp` using its globally unique id and a patch. */
  updateTermToRfpByNodeId: Maybe<GqlUpdateTermToRfpPayload>;
  /** Updates a single `TermToSuiteListing` using a unique key and a patch. */
  updateTermToSuiteListing: Maybe<GqlUpdateTermToSuiteListingPayload>;
  /** Updates a single `TermToSuiteListing` using its globally unique id and a patch. */
  updateTermToSuiteListingByNodeId: Maybe<GqlUpdateTermToSuiteListingPayload>;
  /** Updates a single `TermToTestDrive` using a unique key and a patch. */
  updateTermToTestDrive: Maybe<GqlUpdateTermToTestDrivePayload>;
  /** Updates a single `TermToTestDrive` using its globally unique id and a patch. */
  updateTermToTestDriveByNodeId: Maybe<GqlUpdateTermToTestDrivePayload>;
  /** Updates a single `TermToUser` using a unique key and a patch. */
  updateTermToUser: Maybe<GqlUpdateTermToUserPayload>;
  /** Updates a single `TermToUser` using its globally unique id and a patch. */
  updateTermToUserByNodeId: Maybe<GqlUpdateTermToUserPayload>;
  /** Updates a single `TermToUserStory` using a unique key and a patch. */
  updateTermToUserStory: Maybe<GqlUpdateTermToUserStoryPayload>;
  /** Updates a single `TermToUserStory` using its globally unique id and a patch. */
  updateTermToUserStoryByNodeId: Maybe<GqlUpdateTermToUserStoryPayload>;
  /** Updates a single `TermToVendorStackshare` using a unique key and a patch. */
  updateTermToVendorStackshare: Maybe<GqlUpdateTermToVendorStacksharePayload>;
  /** Updates a single `TermToVendorStackshare` using its globally unique id and a patch. */
  updateTermToVendorStackshareByNodeId: Maybe<GqlUpdateTermToVendorStacksharePayload>;
  /** Updates a single `Termscout` using a unique key and a patch. */
  updateTermscout: Maybe<GqlUpdateTermscoutPayload>;
  /** Updates a single `Termscout` using its globally unique id and a patch. */
  updateTermscoutByNodeId: Maybe<GqlUpdateTermscoutPayload>;
  /** Updates a single `TestDrive` using a unique key and a patch. */
  updateTestDrive: Maybe<GqlUpdateTestDrivePayload>;
  /** Updates a single `TestDrive` using its globally unique id and a patch. */
  updateTestDriveByNodeId: Maybe<GqlUpdateTestDrivePayload>;
  /** Updates a single `TheoremProduct` using a unique key and a patch. */
  updateTheoremProduct: Maybe<GqlUpdateTheoremProductPayload>;
  /** Updates a single `TheoremProduct` using its globally unique id and a patch. */
  updateTheoremProductByNodeId: Maybe<GqlUpdateTheoremProductPayload>;
  /** Updates a single `TheoremProduct` using a unique key and a patch. */
  updateTheoremProductByStripeProductId: Maybe<GqlUpdateTheoremProductPayload>;
  /** Updates a single `TheoremProduct` using a unique key and a patch. */
  updateTheoremProductByTestStripeProductId: Maybe<GqlUpdateTheoremProductPayload>;
  /** Updates a single `UseCase` using a unique key and a patch. */
  updateUseCase: Maybe<GqlUpdateUseCasePayload>;
  /** Updates a single `UseCase` using its globally unique id and a patch. */
  updateUseCaseByNodeId: Maybe<GqlUpdateUseCasePayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser: Maybe<GqlUpdateUserPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserByNodeId: Maybe<GqlUpdateUserPayload>;
  /** Updates a single `UserStory` using a unique key and a patch. */
  updateUserStory: Maybe<GqlUpdateUserStoryPayload>;
  /** Updates a single `UserStory` using its globally unique id and a patch. */
  updateUserStoryByNodeId: Maybe<GqlUpdateUserStoryPayload>;
  /** Updates a single `UserToOrgStack` using a unique key and a patch. */
  updateUserToOrgStack: Maybe<GqlUpdateUserToOrgStackPayload>;
  /** Updates a single `UserToOrgStack` using its globally unique id and a patch. */
  updateUserToOrgStackByNodeId: Maybe<GqlUpdateUserToOrgStackPayload>;
  /** Updates a single `UsersToOrganization` using a unique key and a patch. */
  updateUsersToOrganization: Maybe<GqlUpdateUsersToOrganizationPayload>;
  /** Updates a single `UsersToOrganization` using its globally unique id and a patch. */
  updateUsersToOrganizationByNodeId: Maybe<GqlUpdateUsersToOrganizationPayload>;
  /** Updates a single `UsersToPracticeGroup` using a unique key and a patch. */
  updateUsersToPracticeGroup: Maybe<GqlUpdateUsersToPracticeGroupPayload>;
  /** Updates a single `UsersToPracticeGroup` using its globally unique id and a patch. */
  updateUsersToPracticeGroupByNodeId: Maybe<GqlUpdateUsersToPracticeGroupPayload>;
  /** Updates a single `UsersToTechstack` using a unique key and a patch. */
  updateUsersToTechstack: Maybe<GqlUpdateUsersToTechstackPayload>;
  /** Updates a single `UsersToTechstack` using its globally unique id and a patch. */
  updateUsersToTechstackByNodeId: Maybe<GqlUpdateUsersToTechstackPayload>;
  /** Updates a single `VendorStackshareLogo` using a unique key and a patch. */
  updateVendorStackshareLogo: Maybe<GqlUpdateVendorStackshareLogoPayload>;
  /** Updates a single `VendorStackshareLogo` using its globally unique id and a patch. */
  updateVendorStackshareLogoByNodeId: Maybe<GqlUpdateVendorStackshareLogoPayload>;
  /** Upserts a single `AssocHome`. */
  upsertAssocHome: Maybe<GqlUpsertAssocHomePayload>;
  /** Upserts a single `AssocSection`. */
  upsertAssocSection: Maybe<GqlUpsertAssocSectionPayload>;
  /** Upserts a single `AssociationToOrganization`. */
  upsertAssociationToOrganization: Maybe<GqlUpsertAssociationToOrganizationPayload>;
  /** Upserts a single `AwardBadge`. */
  upsertAwardBadge: Maybe<GqlUpsertAwardBadgePayload>;
  /** Upserts a single `BestFor`. */
  upsertBestFor: Maybe<GqlUpsertBestForPayload>;
  /** Upserts a single `BestForToProduct`. */
  upsertBestForToProduct: Maybe<GqlUpsertBestForToProductPayload>;
  /** Upserts a single `Category`. */
  upsertCategory: Maybe<GqlUpsertCategoryPayload>;
  /** Upserts a single `CategoryToProduct`. */
  upsertCategoryToProduct: Maybe<GqlUpsertCategoryToProductPayload>;
  /** Upserts a single `ConnectCustomer`. */
  upsertConnectCustomer: Maybe<GqlUpsertConnectCustomerPayload>;
  /** Upserts a single `ConnectPurchase`. */
  upsertConnectPurchase: Maybe<GqlUpsertConnectPurchasePayload>;
  /** Upserts a single `DiversityCertification`. */
  upsertDiversityCertification: Maybe<GqlUpsertDiversityCertificationPayload>;
  /** Upserts a single `Feature`. */
  upsertFeature: Maybe<GqlUpsertFeaturePayload>;
  /** Upserts a single `FeatureToProduct`. */
  upsertFeatureToProduct: Maybe<GqlUpsertFeatureToProductPayload>;
  /** Upserts a single `LawfirmService`. */
  upsertLawfirmService: Maybe<GqlUpsertLawfirmServicePayload>;
  /** Upserts a single `ListingCreator`. */
  upsertListingCreator: Maybe<GqlUpsertListingCreatorPayload>;
  /** Upserts a single `Location`. */
  upsertLocation: Maybe<GqlUpsertLocationPayload>;
  /** Upserts a single `Notification`. */
  upsertNotification: Maybe<GqlUpsertNotificationPayload>;
  /** Upserts a single `NoviMember`. */
  upsertNoviMember: Maybe<GqlUpsertNoviMemberPayload>;
  /** Upserts a single `NoviOrganization`. */
  upsertNoviOrganization: Maybe<GqlUpsertNoviOrganizationPayload>;
  /** Upserts a single `Organization`. */
  upsertOrganization: Maybe<GqlUpsertOrganizationPayload>;
  /** Upserts a single `OrganizationListing`. */
  upsertOrganizationListing: Maybe<GqlUpsertOrganizationListingPayload>;
  /** Upserts a single `OrganizationTechstack`. */
  upsertOrganizationTechstack: Maybe<GqlUpsertOrganizationTechstackPayload>;
  /** Upserts a single `PersonalTechstack`. */
  upsertPersonalTechstack: Maybe<GqlUpsertPersonalTechstackPayload>;
  /** Upserts a single `PracticeGroup`. */
  upsertPracticeGroup: Maybe<GqlUpsertPracticeGroupPayload>;
  /** Upserts a single `PremiumInfoToTerm`. */
  upsertPremiumInfoToTerm: Maybe<GqlUpsertPremiumInfoToTermPayload>;
  /** Upserts a single `PremiumProductInfo`. */
  upsertPremiumProductInfo: Maybe<GqlUpsertPremiumProductInfoPayload>;
  /** Upserts a single `Product`. */
  upsertProduct: Maybe<GqlUpsertProductPayload>;
  /** Upserts a single `ProductAwardDetail`. */
  upsertProductAwardDetail: Maybe<GqlUpsertProductAwardDetailPayload>;
  /** Upserts a single `ProductFeatureByTerm`. */
  upsertProductFeatureByTerm: Maybe<GqlUpsertProductFeatureByTermPayload>;
  /** Upserts a single `ProductListing`. */
  upsertProductListing: Maybe<GqlUpsertProductListingPayload>;
  /** Upserts a single `ProductSection`. */
  upsertProductSection: Maybe<GqlUpsertProductSectionPayload>;
  /** Upserts a single `ProductToAssocSection`. */
  upsertProductToAssocSection: Maybe<GqlUpsertProductToAssocSectionPayload>;
  /** Upserts a single `ProductToAwardBadge`. */
  upsertProductToAwardBadge: Maybe<GqlUpsertProductToAwardBadgePayload>;
  /** Upserts a single `ProductToClient`. */
  upsertProductToClient: Maybe<GqlUpsertProductToClientPayload>;
  /** Upserts a single `ProductToCompetitor`. */
  upsertProductToCompetitor: Maybe<GqlUpsertProductToCompetitorPayload>;
  /** Upserts a single `ProductToIntegration`. */
  upsertProductToIntegration: Maybe<GqlUpsertProductToIntegrationPayload>;
  /** Upserts a single `ProductToOrganization`. */
  upsertProductToOrganization: Maybe<GqlUpsertProductToOrganizationPayload>;
  /** Upserts a single `ProductToPracticeGroup`. */
  upsertProductToPracticeGroup: Maybe<GqlUpsertProductToPracticeGroupPayload>;
  /** Upserts a single `ProductToSuiteListing`. */
  upsertProductToSuiteListing: Maybe<GqlUpsertProductToSuiteListingPayload>;
  /** Upserts a single `ProductToUser`. */
  upsertProductToUser: Maybe<GqlUpsertProductToUserPayload>;
  /** Upserts a single `Rfp`. */
  upsertRfp: Maybe<GqlUpsertRfpPayload>;
  /** Upserts a single `RfpToProduct`. */
  upsertRfpToProduct: Maybe<GqlUpsertRfpToProductPayload>;
  /** Upserts a single `Scheduler`. */
  upsertScheduler: Maybe<GqlUpsertSchedulerPayload>;
  /** Upserts a single `SectionLayout`. */
  upsertSectionLayout: Maybe<GqlUpsertSectionLayoutPayload>;
  /** Upserts a single `SimpleService`. */
  upsertSimpleService: Maybe<GqlUpsertSimpleServicePayload>;
  /** Upserts a single `StackshareOption`. */
  upsertStackshareOption: Maybe<GqlUpsertStackshareOptionPayload>;
  /** Upserts a single `StripeAccount`. */
  upsertStripeAccount: Maybe<GqlUpsertStripeAccountPayload>;
  /** Upserts a single `StripeCustomer`. */
  upsertStripeCustomer: Maybe<GqlUpsertStripeCustomerPayload>;
  /** Upserts a single `StripePurchase`. */
  upsertStripePurchase: Maybe<GqlUpsertStripePurchasePayload>;
  /** Upserts a single `StripeSeat`. */
  upsertStripeSeat: Maybe<GqlUpsertStripeSeatPayload>;
  /** Upserts a single `SuiteListing`. */
  upsertSuiteListing: Maybe<GqlUpsertSuiteListingPayload>;
  /** Upserts a single `Taxonomy`. */
  upsertTaxonomy: Maybe<GqlUpsertTaxonomyPayload>;
  /** Upserts a single `Techstack`. */
  upsertTechstack: Maybe<GqlUpsertTechstackPayload>;
  /** Upserts a single `TempDatum`. */
  upsertTempDatum: Maybe<GqlUpsertTempDatumPayload>;
  /** Upserts a single `Term`. */
  upsertTerm: Maybe<GqlUpsertTermPayload>;
  /** Upserts a single `TermToOrganization`. */
  upsertTermToOrganization: Maybe<GqlUpsertTermToOrganizationPayload>;
  /** Upserts a single `TermToProduct`. */
  upsertTermToProduct: Maybe<GqlUpsertTermToProductPayload>;
  /** Upserts a single `TermToRfp`. */
  upsertTermToRfp: Maybe<GqlUpsertTermToRfpPayload>;
  /** Upserts a single `TermToSuiteListing`. */
  upsertTermToSuiteListing: Maybe<GqlUpsertTermToSuiteListingPayload>;
  /** Upserts a single `TermToTestDrive`. */
  upsertTermToTestDrive: Maybe<GqlUpsertTermToTestDrivePayload>;
  /** Upserts a single `TermToUser`. */
  upsertTermToUser: Maybe<GqlUpsertTermToUserPayload>;
  /** Upserts a single `TermToUserStory`. */
  upsertTermToUserStory: Maybe<GqlUpsertTermToUserStoryPayload>;
  /** Upserts a single `TermToVendorStackshare`. */
  upsertTermToVendorStackshare: Maybe<GqlUpsertTermToVendorStacksharePayload>;
  /** Upserts a single `Termscout`. */
  upsertTermscout: Maybe<GqlUpsertTermscoutPayload>;
  /** Upserts a single `TestDrive`. */
  upsertTestDrive: Maybe<GqlUpsertTestDrivePayload>;
  /** Upserts a single `TheoremProduct`. */
  upsertTheoremProduct: Maybe<GqlUpsertTheoremProductPayload>;
  /** Upserts a single `UseCase`. */
  upsertUseCase: Maybe<GqlUpsertUseCasePayload>;
  /** Upserts a single `User`. */
  upsertUser: Maybe<GqlUpsertUserPayload>;
  /** Upserts a single `UserStory`. */
  upsertUserStory: Maybe<GqlUpsertUserStoryPayload>;
  /** Upserts a single `UserToOrgStack`. */
  upsertUserToOrgStack: Maybe<GqlUpsertUserToOrgStackPayload>;
  /** Upserts a single `UsersToOrganization`. */
  upsertUsersToOrganization: Maybe<GqlUpsertUsersToOrganizationPayload>;
  /** Upserts a single `UsersToPracticeGroup`. */
  upsertUsersToPracticeGroup: Maybe<GqlUpsertUsersToPracticeGroupPayload>;
  /** Upserts a single `UsersToTechstack`. */
  upsertUsersToTechstack: Maybe<GqlUpsertUsersToTechstackPayload>;
  /** Upserts a single `VendorStackshareLogo`. */
  upsertVendorStackshareLogo: Maybe<GqlUpsertVendorStackshareLogoPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationAddUserStoryTermsArgs = {
  input: GqlAddUserStoryTermsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateAssocHomeArgs = {
  input: GqlCreateAssocHomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateAssocSectionArgs = {
  input: GqlCreateAssocSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateAssociationToOrganizationArgs = {
  input: GqlCreateAssociationToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateAwardBadgeArgs = {
  input: GqlCreateAwardBadgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateBestForArgs = {
  input: GqlCreateBestForInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateBestForToProductArgs = {
  input: GqlCreateBestForToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateCategoryArgs = {
  input: GqlCreateCategoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateCategoryToProductArgs = {
  input: GqlCreateCategoryToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateConnectCustomerArgs = {
  input: GqlCreateConnectCustomerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateConnectPurchaseArgs = {
  input: GqlCreateConnectPurchaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateDiversityCertificationArgs = {
  input: GqlCreateDiversityCertificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateFeatureArgs = {
  input: GqlCreateFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateFeatureToProductArgs = {
  input: GqlCreateFeatureToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateLawfirmServiceArgs = {
  input: GqlCreateLawfirmServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateListingCreatorArgs = {
  input: GqlCreateListingCreatorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateLocationArgs = {
  input: GqlCreateLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateNotificationArgs = {
  input: GqlCreateNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateNoviMemberArgs = {
  input: GqlCreateNoviMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateNoviOrganizationArgs = {
  input: GqlCreateNoviOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateOrganizationArgs = {
  input: GqlCreateOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateOrganizationListingArgs = {
  input: GqlCreateOrganizationListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateOrganizationTechstackArgs = {
  input: GqlCreateOrganizationTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreatePersonalTechstackArgs = {
  input: GqlCreatePersonalTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreatePersonalTechstacksArgs = {
  input: GqlCreatePersonalTechstacksInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreatePracticeGroupArgs = {
  input: GqlCreatePracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreatePremiumInfoToTermArgs = {
  input: GqlCreatePremiumInfoToTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreatePremiumProductInfoArgs = {
  input: GqlCreatePremiumProductInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductArgs = {
  input: GqlCreateProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductAwardDetailArgs = {
  input: GqlCreateProductAwardDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductFeatureByTermArgs = {
  input: GqlCreateProductFeatureByTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductListingArgs = {
  input: GqlCreateProductListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductSectionArgs = {
  input: GqlCreateProductSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToAssocSectionArgs = {
  input: GqlCreateProductToAssocSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToAwardBadgeArgs = {
  input: GqlCreateProductToAwardBadgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToClientArgs = {
  input: GqlCreateProductToClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToCompetitorArgs = {
  input: GqlCreateProductToCompetitorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToIntegrationArgs = {
  input: GqlCreateProductToIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToIntegrationsArgs = {
  input: GqlCreateProductToIntegrationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToOrganizationArgs = {
  input: GqlCreateProductToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToPracticeGroupArgs = {
  input: GqlCreateProductToPracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToSuiteListingArgs = {
  input: GqlCreateProductToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductToUserArgs = {
  input: GqlCreateProductToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateProductsToOrganizationArgs = {
  input: GqlCreateProductsToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateRfpArgs = {
  input: GqlCreateRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateRfpToProductArgs = {
  input: GqlCreateRfpToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateRfpToProductsArgs = {
  input: GqlCreateRfpToProductsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateSchedulerArgs = {
  input: GqlCreateSchedulerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateSectionLayoutArgs = {
  input: GqlCreateSectionLayoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateSimpleServiceArgs = {
  input: GqlCreateSimpleServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateStackshareOptionArgs = {
  input: GqlCreateStackshareOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateStripeAccountArgs = {
  input: GqlCreateStripeAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateStripeCustomerArgs = {
  input: GqlCreateStripeCustomerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateStripePurchaseArgs = {
  input: GqlCreateStripePurchaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateStripeSeatArgs = {
  input: GqlCreateStripeSeatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateSuiteListingArgs = {
  input: GqlCreateSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTaxonomyArgs = {
  input: GqlCreateTaxonomyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTechstackArgs = {
  input: GqlCreateTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTempDatumArgs = {
  input: GqlCreateTempDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermArgs = {
  input: GqlCreateTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToOrganizationArgs = {
  input: GqlCreateTermToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToProductArgs = {
  input: GqlCreateTermToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToRfpArgs = {
  input: GqlCreateTermToRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToSuiteListingArgs = {
  input: GqlCreateTermToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToTestDriveArgs = {
  input: GqlCreateTermToTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToUserArgs = {
  input: GqlCreateTermToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToUserStoryArgs = {
  input: GqlCreateTermToUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermToVendorStackshareArgs = {
  input: GqlCreateTermToVendorStackshareInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermsToOrganizationArgs = {
  input: GqlCreateTermsToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermsToProductArgs = {
  input: GqlCreateTermsToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermsToRfpArgs = {
  input: GqlCreateTermsToRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermsToSuiteListingArgs = {
  input: GqlCreateTermsToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermsToTestDriveArgs = {
  input: GqlCreateTermsToTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermsToUserArgs = {
  input: GqlCreateTermsToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTermscoutArgs = {
  input: GqlCreateTermscoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTestDriveArgs = {
  input: GqlCreateTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateTheoremProductArgs = {
  input: GqlCreateTheoremProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUseCaseArgs = {
  input: GqlCreateUseCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUserArgs = {
  input: GqlCreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUserStoryArgs = {
  input: GqlCreateUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUserToOrgStackArgs = {
  input: GqlCreateUserToOrgStackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUsersToOrganizationArgs = {
  input: GqlCreateUsersToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUsersToPracticeGroupArgs = {
  input: GqlCreateUsersToPracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUsersToTechstackArgs = {
  input: GqlCreateUsersToTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateUsersToTechstacksArgs = {
  input: GqlCreateUsersToTechstacksInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationCreateVendorStackshareLogoArgs = {
  input: GqlCreateVendorStackshareLogoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAssocHomeByIdArgs = {
  input: GqlDeleteAssocHomeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAssocSectionArgs = {
  input: GqlDeleteAssocSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAssocSectionByNodeIdArgs = {
  input: GqlDeleteAssocSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAssociationToOrganizationArgs = {
  input: GqlDeleteAssociationToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAssociationToOrganizationByNodeIdArgs = {
  input: GqlDeleteAssociationToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAwardBadgeByIdArgs = {
  input: GqlDeleteAwardBadgeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteAwardBadgeBySlugArgs = {
  input: GqlDeleteAwardBadgeBySlugInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteBestForArgs = {
  input: GqlDeleteBestForInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteBestForByNodeIdArgs = {
  input: GqlDeleteBestForByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteBestForToProductArgs = {
  input: GqlDeleteBestForToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteBestForToProductByNodeIdArgs = {
  input: GqlDeleteBestForToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteCategoriesArgs = {
  input: GqlDeleteCategoriesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteCategoryArgs = {
  input: GqlDeleteCategoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteCategoryByNodeIdArgs = {
  input: GqlDeleteCategoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteCategoryToProductArgs = {
  input: GqlDeleteCategoryToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteCategoryToProductByNodeIdArgs = {
  input: GqlDeleteCategoryToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteConnectCustomerArgs = {
  input: GqlDeleteConnectCustomerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteConnectCustomerByNodeIdArgs = {
  input: GqlDeleteConnectCustomerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteConnectCustomerByUserIdAndAccountIdAndOrganizationIdArgs = {
  input: GqlDeleteConnectCustomerByUserIdAndAccountIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteConnectPurchaseArgs = {
  input: GqlDeleteConnectPurchaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteConnectPurchaseByNodeIdArgs = {
  input: GqlDeleteConnectPurchaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteCoreStacksArgs = {
  input: GqlDeleteCoreStacksInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteDiversityCertificationArgs = {
  input: GqlDeleteDiversityCertificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteDiversityCertificationByNodeIdArgs = {
  input: GqlDeleteDiversityCertificationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteFeatureArgs = {
  input: GqlDeleteFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteFeatureByNodeIdArgs = {
  input: GqlDeleteFeatureByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteFeatureToProductArgs = {
  input: GqlDeleteFeatureToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteFeatureToProductByNodeIdArgs = {
  input: GqlDeleteFeatureToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteLawfirmServiceArgs = {
  input: GqlDeleteLawfirmServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteLawfirmServiceByNodeIdArgs = {
  input: GqlDeleteLawfirmServiceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteListingCreatorByIdArgs = {
  input: GqlDeleteListingCreatorByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteLocationArgs = {
  input: GqlDeleteLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteLocationByNodeIdArgs = {
  input: GqlDeleteLocationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteNotificationArgs = {
  input: GqlDeleteNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteNotificationByNodeIdArgs = {
  input: GqlDeleteNotificationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteNoviMemberArgs = {
  input: GqlDeleteNoviMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteNoviMemberByNodeIdArgs = {
  input: GqlDeleteNoviMemberByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteNoviOrganizationArgs = {
  input: GqlDeleteNoviOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteNoviOrganizationByNodeIdArgs = {
  input: GqlDeleteNoviOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationArgs = {
  input: GqlDeleteOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationByAuth0OrgIdArgs = {
  input: GqlDeleteOrganizationByAuth0OrgIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationByNodeIdArgs = {
  input: GqlDeleteOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationListingArgs = {
  input: GqlDeleteOrganizationListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationListingByNodeIdArgs = {
  input: GqlDeleteOrganizationListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationTechstackArgs = {
  input: GqlDeleteOrganizationTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationTechstackByNodeIdArgs = {
  input: GqlDeleteOrganizationTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteOrganizationsArgs = {
  input: GqlDeleteOrganizationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePersonalTechstackArgs = {
  input: GqlDeletePersonalTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePersonalTechstackByNodeIdArgs = {
  input: GqlDeletePersonalTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePersonalTechstacksArgs = {
  input: GqlDeletePersonalTechstacksInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePracticeGroupArgs = {
  input: GqlDeletePracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePracticeGroupByNodeIdArgs = {
  input: GqlDeletePracticeGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePremiumInfoToTermArgs = {
  input: GqlDeletePremiumInfoToTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePremiumInfoToTermByNodeIdArgs = {
  input: GqlDeletePremiumInfoToTermByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePremiumProductInfoArgs = {
  input: GqlDeletePremiumProductInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePremiumProductInfoByIdAndProductIdArgs = {
  input: GqlDeletePremiumProductInfoByIdAndProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeletePremiumProductInfoByNodeIdArgs = {
  input: GqlDeletePremiumProductInfoByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductArgs = {
  input: GqlDeleteProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductAwardDetailArgs = {
  input: GqlDeleteProductAwardDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductAwardDetailByNodeIdArgs = {
  input: GqlDeleteProductAwardDetailByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductByNodeIdArgs = {
  input: GqlDeleteProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductFeatureByTermArgs = {
  input: GqlDeleteProductFeatureByTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductFeatureByTermByNodeIdArgs = {
  input: GqlDeleteProductFeatureByTermByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductListingArgs = {
  input: GqlDeleteProductListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductListingByNodeIdArgs = {
  input: GqlDeleteProductListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductListingByProductIdAndAssociationIdArgs = {
  input: GqlDeleteProductListingByProductIdAndAssociationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductSectionArgs = {
  input: GqlDeleteProductSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductSectionByNodeIdArgs = {
  input: GqlDeleteProductSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToAssocSectionArgs = {
  input: GqlDeleteProductToAssocSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToAssocSectionByNodeIdArgs = {
  input: GqlDeleteProductToAssocSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToAwardBadgeArgs = {
  input: GqlDeleteProductToAwardBadgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToAwardBadgeByNodeIdArgs = {
  input: GqlDeleteProductToAwardBadgeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToClientArgs = {
  input: GqlDeleteProductToClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToClientByNodeIdArgs = {
  input: GqlDeleteProductToClientByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToCompetitorArgs = {
  input: GqlDeleteProductToCompetitorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToCompetitorByNodeIdArgs = {
  input: GqlDeleteProductToCompetitorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToIntegrationArgs = {
  input: GqlDeleteProductToIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToIntegrationByNodeIdArgs = {
  input: GqlDeleteProductToIntegrationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToIntegrationsArgs = {
  input: GqlDeleteProductToIntegrationsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToOrganizationArgs = {
  input: GqlDeleteProductToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToOrganizationByNodeIdArgs = {
  input: GqlDeleteProductToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToPracticeGroupArgs = {
  input: GqlDeleteProductToPracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToPracticeGroupByNodeIdArgs = {
  input: GqlDeleteProductToPracticeGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToSuiteListingArgs = {
  input: GqlDeleteProductToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToSuiteListingByNodeIdArgs = {
  input: GqlDeleteProductToSuiteListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToUserArgs = {
  input: GqlDeleteProductToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductToUserByNodeIdArgs = {
  input: GqlDeleteProductToUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteProductsArgs = {
  input: GqlDeleteProductsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteRfpArgs = {
  input: GqlDeleteRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteRfpByNodeIdArgs = {
  input: GqlDeleteRfpByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteRfpToProductArgs = {
  input: GqlDeleteRfpToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteRfpToProductByNodeIdArgs = {
  input: GqlDeleteRfpToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSchedulerArgs = {
  input: GqlDeleteSchedulerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSchedulerByNodeIdArgs = {
  input: GqlDeleteSchedulerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSectionLayoutArgs = {
  input: GqlDeleteSectionLayoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSectionLayoutByNodeIdArgs = {
  input: GqlDeleteSectionLayoutByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSimpleServiceArgs = {
  input: GqlDeleteSimpleServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSimpleServiceByNodeIdArgs = {
  input: GqlDeleteSimpleServiceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSimpleServiceByOrganizationIdAndTermIdArgs = {
  input: GqlDeleteSimpleServiceByOrganizationIdAndTermIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStackshareOptionArgs = {
  input: GqlDeleteStackshareOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStackshareOptionByNodeIdArgs = {
  input: GqlDeleteStackshareOptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeAccountArgs = {
  input: GqlDeleteStripeAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeAccountByNodeIdArgs = {
  input: GqlDeleteStripeAccountByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeCustomerArgs = {
  input: GqlDeleteStripeCustomerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeCustomerByNodeIdArgs = {
  input: GqlDeleteStripeCustomerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripePurchaseArgs = {
  input: GqlDeleteStripePurchaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripePurchaseByNodeIdArgs = {
  input: GqlDeleteStripePurchaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeSeatArgs = {
  input: GqlDeleteStripeSeatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeSeatByNodeIdArgs = {
  input: GqlDeleteStripeSeatByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteStripeSeatsArgs = {
  input: GqlDeleteStripeSeatsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSuiteListingArgs = {
  input: GqlDeleteSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteSuiteListingByNodeIdArgs = {
  input: GqlDeleteSuiteListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTaxonomyArgs = {
  input: GqlDeleteTaxonomyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTaxonomyByNodeIdArgs = {
  input: GqlDeleteTaxonomyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTechstackArgs = {
  input: GqlDeleteTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTechstackByNodeIdArgs = {
  input: GqlDeleteTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTechstackByOrganizationIdAndProductIdArgs = {
  input: GqlDeleteTechstackByOrganizationIdAndProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTempDatumByIdArgs = {
  input: GqlDeleteTempDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermArgs = {
  input: GqlDeleteTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermByNodeIdArgs = {
  input: GqlDeleteTermByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToOrganizationArgs = {
  input: GqlDeleteTermToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToOrganizationByNodeIdArgs = {
  input: GqlDeleteTermToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToProductArgs = {
  input: GqlDeleteTermToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToProductByNodeIdArgs = {
  input: GqlDeleteTermToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToRfpArgs = {
  input: GqlDeleteTermToRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToRfpByNodeIdArgs = {
  input: GqlDeleteTermToRfpByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToSuiteListingArgs = {
  input: GqlDeleteTermToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToSuiteListingByNodeIdArgs = {
  input: GqlDeleteTermToSuiteListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToTestDriveArgs = {
  input: GqlDeleteTermToTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToTestDriveByNodeIdArgs = {
  input: GqlDeleteTermToTestDriveByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToUserArgs = {
  input: GqlDeleteTermToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToUserByNodeIdArgs = {
  input: GqlDeleteTermToUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToUserStoryArgs = {
  input: GqlDeleteTermToUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToUserStoryByNodeIdArgs = {
  input: GqlDeleteTermToUserStoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToVendorStackshareArgs = {
  input: GqlDeleteTermToVendorStackshareInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermToVendorStackshareByNodeIdArgs = {
  input: GqlDeleteTermToVendorStackshareByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermsToOrganizationArgs = {
  input: GqlDeleteTermsToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermsToProductArgs = {
  input: GqlDeleteTermsToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermsToSuiteListingArgs = {
  input: GqlDeleteTermsToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermsToTestDriveArgs = {
  input: GqlDeleteTermsToTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermsToUserArgs = {
  input: GqlDeleteTermsToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermscoutArgs = {
  input: GqlDeleteTermscoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTermscoutByNodeIdArgs = {
  input: GqlDeleteTermscoutByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTestDriveArgs = {
  input: GqlDeleteTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTestDriveByNodeIdArgs = {
  input: GqlDeleteTestDriveByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTestDrivesArgs = {
  input: GqlDeleteTestDrivesInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTheoremProductArgs = {
  input: GqlDeleteTheoremProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTheoremProductByNodeIdArgs = {
  input: GqlDeleteTheoremProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTheoremProductByStripeProductIdArgs = {
  input: GqlDeleteTheoremProductByStripeProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTheoremProductByTestStripeProductIdArgs = {
  input: GqlDeleteTheoremProductByTestStripeProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteTheoremProductsArgs = {
  input: GqlDeleteTheoremProductsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUseCaseArgs = {
  input: GqlDeleteUseCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUseCaseByNodeIdArgs = {
  input: GqlDeleteUseCaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUserArgs = {
  input: GqlDeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUserByNodeIdArgs = {
  input: GqlDeleteUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUserStoryArgs = {
  input: GqlDeleteUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUserStoryByNodeIdArgs = {
  input: GqlDeleteUserStoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUserToOrgStackArgs = {
  input: GqlDeleteUserToOrgStackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUserToOrgStackByNodeIdArgs = {
  input: GqlDeleteUserToOrgStackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersArgs = {
  input: GqlDeleteUsersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToOrganizationArgs = {
  input: GqlDeleteUsersToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToOrganizationByNodeIdArgs = {
  input: GqlDeleteUsersToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToPracticeGroupArgs = {
  input: GqlDeleteUsersToPracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToPracticeGroupByNodeIdArgs = {
  input: GqlDeleteUsersToPracticeGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToTechstackArgs = {
  input: GqlDeleteUsersToTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToTechstackByNodeIdArgs = {
  input: GqlDeleteUsersToTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteUsersToTechstacksArgs = {
  input: GqlDeleteUsersToTechstacksInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteVendorStackshareLogoArgs = {
  input: GqlDeleteVendorStackshareLogoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationDeleteVendorStackshareLogoByNodeIdArgs = {
  input: GqlDeleteVendorStackshareLogoByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationReplaceTermToUserStoryArgs = {
  input: GqlReplaceTermToUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAssocHomeByIdArgs = {
  input: GqlUpdateAssocHomeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAssocSectionArgs = {
  input: GqlUpdateAssocSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAssocSectionByNodeIdArgs = {
  input: GqlUpdateAssocSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAssociationToOrganizationArgs = {
  input: GqlUpdateAssociationToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAssociationToOrganizationByNodeIdArgs = {
  input: GqlUpdateAssociationToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAwardBadgeByIdArgs = {
  input: GqlUpdateAwardBadgeByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateAwardBadgeBySlugArgs = {
  input: GqlUpdateAwardBadgeBySlugInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateBestForArgs = {
  input: GqlUpdateBestForInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateBestForByNodeIdArgs = {
  input: GqlUpdateBestForByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateBestForToProductArgs = {
  input: GqlUpdateBestForToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateBestForToProductByNodeIdArgs = {
  input: GqlUpdateBestForToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateCategoryArgs = {
  input: GqlUpdateCategoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateCategoryByNodeIdArgs = {
  input: GqlUpdateCategoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateCategoryToProductArgs = {
  input: GqlUpdateCategoryToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateCategoryToProductByNodeIdArgs = {
  input: GqlUpdateCategoryToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateConnectCustomerArgs = {
  input: GqlUpdateConnectCustomerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateConnectCustomerByNodeIdArgs = {
  input: GqlUpdateConnectCustomerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateConnectCustomerByUserIdAndAccountIdAndOrganizationIdArgs = {
  input: GqlUpdateConnectCustomerByUserIdAndAccountIdAndOrganizationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateConnectPurchaseArgs = {
  input: GqlUpdateConnectPurchaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateConnectPurchaseByNodeIdArgs = {
  input: GqlUpdateConnectPurchaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateDiversityCertificationArgs = {
  input: GqlUpdateDiversityCertificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateDiversityCertificationByNodeIdArgs = {
  input: GqlUpdateDiversityCertificationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateFeatureArgs = {
  input: GqlUpdateFeatureInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateFeatureByNodeIdArgs = {
  input: GqlUpdateFeatureByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateFeatureToProductArgs = {
  input: GqlUpdateFeatureToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateFeatureToProductByNodeIdArgs = {
  input: GqlUpdateFeatureToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateLawfirmServiceArgs = {
  input: GqlUpdateLawfirmServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateLawfirmServiceByNodeIdArgs = {
  input: GqlUpdateLawfirmServiceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateLawfirmTypeArgs = {
  input: GqlUpdateLawfirmTypeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateListingCreatorByIdArgs = {
  input: GqlUpdateListingCreatorByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateLocationArgs = {
  input: GqlUpdateLocationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateLocationByNodeIdArgs = {
  input: GqlUpdateLocationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateNotificationArgs = {
  input: GqlUpdateNotificationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateNotificationByNodeIdArgs = {
  input: GqlUpdateNotificationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateNoviMemberArgs = {
  input: GqlUpdateNoviMemberInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateNoviMemberByNodeIdArgs = {
  input: GqlUpdateNoviMemberByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateNoviOrganizationArgs = {
  input: GqlUpdateNoviOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateNoviOrganizationByNodeIdArgs = {
  input: GqlUpdateNoviOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationArgs = {
  input: GqlUpdateOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationByAuth0OrgIdArgs = {
  input: GqlUpdateOrganizationByAuth0OrgIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationByNodeIdArgs = {
  input: GqlUpdateOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationListingArgs = {
  input: GqlUpdateOrganizationListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationListingByNodeIdArgs = {
  input: GqlUpdateOrganizationListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationTechstackArgs = {
  input: GqlUpdateOrganizationTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateOrganizationTechstackByNodeIdArgs = {
  input: GqlUpdateOrganizationTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePersonalTechstackArgs = {
  input: GqlUpdatePersonalTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePersonalTechstackByNodeIdArgs = {
  input: GqlUpdatePersonalTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePracticeGroupArgs = {
  input: GqlUpdatePracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePracticeGroupByNodeIdArgs = {
  input: GqlUpdatePracticeGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePremiumInfoToTermArgs = {
  input: GqlUpdatePremiumInfoToTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePremiumInfoToTermByNodeIdArgs = {
  input: GqlUpdatePremiumInfoToTermByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePremiumProductInfoArgs = {
  input: GqlUpdatePremiumProductInfoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePremiumProductInfoByIdAndProductIdArgs = {
  input: GqlUpdatePremiumProductInfoByIdAndProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdatePremiumProductInfoByNodeIdArgs = {
  input: GqlUpdatePremiumProductInfoByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductArgs = {
  input: GqlUpdateProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductAwardDetailArgs = {
  input: GqlUpdateProductAwardDetailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductAwardDetailByNodeIdArgs = {
  input: GqlUpdateProductAwardDetailByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductByNodeIdArgs = {
  input: GqlUpdateProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductFeatureByTermArgs = {
  input: GqlUpdateProductFeatureByTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductFeatureByTermByNodeIdArgs = {
  input: GqlUpdateProductFeatureByTermByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductListingArgs = {
  input: GqlUpdateProductListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductListingByNodeIdArgs = {
  input: GqlUpdateProductListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductListingByProductIdAndAssociationIdArgs = {
  input: GqlUpdateProductListingByProductIdAndAssociationIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductSectionArgs = {
  input: GqlUpdateProductSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductSectionByNodeIdArgs = {
  input: GqlUpdateProductSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToAssocSectionArgs = {
  input: GqlUpdateProductToAssocSectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToAssocSectionByNodeIdArgs = {
  input: GqlUpdateProductToAssocSectionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToAwardBadgeArgs = {
  input: GqlUpdateProductToAwardBadgeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToAwardBadgeByNodeIdArgs = {
  input: GqlUpdateProductToAwardBadgeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToClientArgs = {
  input: GqlUpdateProductToClientInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToClientByNodeIdArgs = {
  input: GqlUpdateProductToClientByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToCompetitorArgs = {
  input: GqlUpdateProductToCompetitorInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToCompetitorByNodeIdArgs = {
  input: GqlUpdateProductToCompetitorByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToIntegrationArgs = {
  input: GqlUpdateProductToIntegrationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToIntegrationByNodeIdArgs = {
  input: GqlUpdateProductToIntegrationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToOrganizationArgs = {
  input: GqlUpdateProductToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToOrganizationByNodeIdArgs = {
  input: GqlUpdateProductToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToPracticeGroupArgs = {
  input: GqlUpdateProductToPracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToPracticeGroupByNodeIdArgs = {
  input: GqlUpdateProductToPracticeGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToSuiteListingArgs = {
  input: GqlUpdateProductToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToSuiteListingByNodeIdArgs = {
  input: GqlUpdateProductToSuiteListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToUserArgs = {
  input: GqlUpdateProductToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateProductToUserByNodeIdArgs = {
  input: GqlUpdateProductToUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateRfpArgs = {
  input: GqlUpdateRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateRfpByNodeIdArgs = {
  input: GqlUpdateRfpByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateRfpToProductArgs = {
  input: GqlUpdateRfpToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateRfpToProductByNodeIdArgs = {
  input: GqlUpdateRfpToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSchedulerArgs = {
  input: GqlUpdateSchedulerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSchedulerByNodeIdArgs = {
  input: GqlUpdateSchedulerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSectionLayoutArgs = {
  input: GqlUpdateSectionLayoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSectionLayoutByNodeIdArgs = {
  input: GqlUpdateSectionLayoutByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSimpleServiceArgs = {
  input: GqlUpdateSimpleServiceInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSimpleServiceByNodeIdArgs = {
  input: GqlUpdateSimpleServiceByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSimpleServiceByOrganizationIdAndTermIdArgs = {
  input: GqlUpdateSimpleServiceByOrganizationIdAndTermIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStackshareOptionArgs = {
  input: GqlUpdateStackshareOptionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStackshareOptionByNodeIdArgs = {
  input: GqlUpdateStackshareOptionByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripeAccountArgs = {
  input: GqlUpdateStripeAccountInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripeAccountByNodeIdArgs = {
  input: GqlUpdateStripeAccountByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripeCustomerArgs = {
  input: GqlUpdateStripeCustomerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripeCustomerByNodeIdArgs = {
  input: GqlUpdateStripeCustomerByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripePurchaseArgs = {
  input: GqlUpdateStripePurchaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripePurchaseByNodeIdArgs = {
  input: GqlUpdateStripePurchaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripeSeatArgs = {
  input: GqlUpdateStripeSeatInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateStripeSeatByNodeIdArgs = {
  input: GqlUpdateStripeSeatByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSuiteListingArgs = {
  input: GqlUpdateSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateSuiteListingByNodeIdArgs = {
  input: GqlUpdateSuiteListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTaxonomyArgs = {
  input: GqlUpdateTaxonomyInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTaxonomyByNodeIdArgs = {
  input: GqlUpdateTaxonomyByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTechstackArgs = {
  input: GqlUpdateTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTechstackByNodeIdArgs = {
  input: GqlUpdateTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTechstackByOrganizationIdAndProductIdArgs = {
  input: GqlUpdateTechstackByOrganizationIdAndProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTempDatumByIdArgs = {
  input: GqlUpdateTempDatumByIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermArgs = {
  input: GqlUpdateTermInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermByNodeIdArgs = {
  input: GqlUpdateTermByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToOrganizationArgs = {
  input: GqlUpdateTermToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToOrganizationByNodeIdArgs = {
  input: GqlUpdateTermToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToProductArgs = {
  input: GqlUpdateTermToProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToProductByNodeIdArgs = {
  input: GqlUpdateTermToProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToRfpArgs = {
  input: GqlUpdateTermToRfpInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToRfpByNodeIdArgs = {
  input: GqlUpdateTermToRfpByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToSuiteListingArgs = {
  input: GqlUpdateTermToSuiteListingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToSuiteListingByNodeIdArgs = {
  input: GqlUpdateTermToSuiteListingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToTestDriveArgs = {
  input: GqlUpdateTermToTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToTestDriveByNodeIdArgs = {
  input: GqlUpdateTermToTestDriveByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToUserArgs = {
  input: GqlUpdateTermToUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToUserByNodeIdArgs = {
  input: GqlUpdateTermToUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToUserStoryArgs = {
  input: GqlUpdateTermToUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToUserStoryByNodeIdArgs = {
  input: GqlUpdateTermToUserStoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToVendorStackshareArgs = {
  input: GqlUpdateTermToVendorStackshareInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermToVendorStackshareByNodeIdArgs = {
  input: GqlUpdateTermToVendorStackshareByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermscoutArgs = {
  input: GqlUpdateTermscoutInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTermscoutByNodeIdArgs = {
  input: GqlUpdateTermscoutByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTestDriveArgs = {
  input: GqlUpdateTestDriveInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTestDriveByNodeIdArgs = {
  input: GqlUpdateTestDriveByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTheoremProductArgs = {
  input: GqlUpdateTheoremProductInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTheoremProductByNodeIdArgs = {
  input: GqlUpdateTheoremProductByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTheoremProductByStripeProductIdArgs = {
  input: GqlUpdateTheoremProductByStripeProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateTheoremProductByTestStripeProductIdArgs = {
  input: GqlUpdateTheoremProductByTestStripeProductIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUseCaseArgs = {
  input: GqlUpdateUseCaseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUseCaseByNodeIdArgs = {
  input: GqlUpdateUseCaseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUserArgs = {
  input: GqlUpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUserByNodeIdArgs = {
  input: GqlUpdateUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUserStoryArgs = {
  input: GqlUpdateUserStoryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUserStoryByNodeIdArgs = {
  input: GqlUpdateUserStoryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUserToOrgStackArgs = {
  input: GqlUpdateUserToOrgStackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUserToOrgStackByNodeIdArgs = {
  input: GqlUpdateUserToOrgStackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUsersToOrganizationArgs = {
  input: GqlUpdateUsersToOrganizationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUsersToOrganizationByNodeIdArgs = {
  input: GqlUpdateUsersToOrganizationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUsersToPracticeGroupArgs = {
  input: GqlUpdateUsersToPracticeGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUsersToPracticeGroupByNodeIdArgs = {
  input: GqlUpdateUsersToPracticeGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUsersToTechstackArgs = {
  input: GqlUpdateUsersToTechstackInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateUsersToTechstackByNodeIdArgs = {
  input: GqlUpdateUsersToTechstackByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateVendorStackshareLogoArgs = {
  input: GqlUpdateVendorStackshareLogoInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpdateVendorStackshareLogoByNodeIdArgs = {
  input: GqlUpdateVendorStackshareLogoByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertAssocHomeArgs = {
  input: GqlUpsertAssocHomeInput;
  where: InputMaybe<GqlUpsertAssocHomeWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertAssocSectionArgs = {
  input: GqlUpsertAssocSectionInput;
  where: InputMaybe<GqlUpsertAssocSectionWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertAssociationToOrganizationArgs = {
  input: GqlUpsertAssociationToOrganizationInput;
  where: InputMaybe<GqlUpsertAssociationToOrganizationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertAwardBadgeArgs = {
  input: GqlUpsertAwardBadgeInput;
  where: InputMaybe<GqlUpsertAwardBadgeWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertBestForArgs = {
  input: GqlUpsertBestForInput;
  where: InputMaybe<GqlUpsertBestForWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertBestForToProductArgs = {
  input: GqlUpsertBestForToProductInput;
  where: InputMaybe<GqlUpsertBestForToProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertCategoryArgs = {
  input: GqlUpsertCategoryInput;
  where: InputMaybe<GqlUpsertCategoryWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertCategoryToProductArgs = {
  input: GqlUpsertCategoryToProductInput;
  where: InputMaybe<GqlUpsertCategoryToProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertConnectCustomerArgs = {
  input: GqlUpsertConnectCustomerInput;
  where: InputMaybe<GqlUpsertConnectCustomerWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertConnectPurchaseArgs = {
  input: GqlUpsertConnectPurchaseInput;
  where: InputMaybe<GqlUpsertConnectPurchaseWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertDiversityCertificationArgs = {
  input: GqlUpsertDiversityCertificationInput;
  where: InputMaybe<GqlUpsertDiversityCertificationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertFeatureArgs = {
  input: GqlUpsertFeatureInput;
  where: InputMaybe<GqlUpsertFeatureWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertFeatureToProductArgs = {
  input: GqlUpsertFeatureToProductInput;
  where: InputMaybe<GqlUpsertFeatureToProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertLawfirmServiceArgs = {
  input: GqlUpsertLawfirmServiceInput;
  where: InputMaybe<GqlUpsertLawfirmServiceWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertListingCreatorArgs = {
  input: GqlUpsertListingCreatorInput;
  where: InputMaybe<GqlUpsertListingCreatorWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertLocationArgs = {
  input: GqlUpsertLocationInput;
  where: InputMaybe<GqlUpsertLocationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertNotificationArgs = {
  input: GqlUpsertNotificationInput;
  where: InputMaybe<GqlUpsertNotificationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertNoviMemberArgs = {
  input: GqlUpsertNoviMemberInput;
  where: InputMaybe<GqlUpsertNoviMemberWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertNoviOrganizationArgs = {
  input: GqlUpsertNoviOrganizationInput;
  where: InputMaybe<GqlUpsertNoviOrganizationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertOrganizationArgs = {
  input: GqlUpsertOrganizationInput;
  where: InputMaybe<GqlUpsertOrganizationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertOrganizationListingArgs = {
  input: GqlUpsertOrganizationListingInput;
  where: InputMaybe<GqlUpsertOrganizationListingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertOrganizationTechstackArgs = {
  input: GqlUpsertOrganizationTechstackInput;
  where: InputMaybe<GqlUpsertOrganizationTechstackWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertPersonalTechstackArgs = {
  input: GqlUpsertPersonalTechstackInput;
  where: InputMaybe<GqlUpsertPersonalTechstackWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertPracticeGroupArgs = {
  input: GqlUpsertPracticeGroupInput;
  where: InputMaybe<GqlUpsertPracticeGroupWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertPremiumInfoToTermArgs = {
  input: GqlUpsertPremiumInfoToTermInput;
  where: InputMaybe<GqlUpsertPremiumInfoToTermWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertPremiumProductInfoArgs = {
  input: GqlUpsertPremiumProductInfoInput;
  where: InputMaybe<GqlUpsertPremiumProductInfoWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductArgs = {
  input: GqlUpsertProductInput;
  where: InputMaybe<GqlUpsertProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductAwardDetailArgs = {
  input: GqlUpsertProductAwardDetailInput;
  where: InputMaybe<GqlUpsertProductAwardDetailWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductFeatureByTermArgs = {
  input: GqlUpsertProductFeatureByTermInput;
  where: InputMaybe<GqlUpsertProductFeatureByTermWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductListingArgs = {
  input: GqlUpsertProductListingInput;
  where: InputMaybe<GqlUpsertProductListingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductSectionArgs = {
  input: GqlUpsertProductSectionInput;
  where: InputMaybe<GqlUpsertProductSectionWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToAssocSectionArgs = {
  input: GqlUpsertProductToAssocSectionInput;
  where: InputMaybe<GqlUpsertProductToAssocSectionWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToAwardBadgeArgs = {
  input: GqlUpsertProductToAwardBadgeInput;
  where: InputMaybe<GqlUpsertProductToAwardBadgeWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToClientArgs = {
  input: GqlUpsertProductToClientInput;
  where: InputMaybe<GqlUpsertProductToClientWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToCompetitorArgs = {
  input: GqlUpsertProductToCompetitorInput;
  where: InputMaybe<GqlUpsertProductToCompetitorWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToIntegrationArgs = {
  input: GqlUpsertProductToIntegrationInput;
  where: InputMaybe<GqlUpsertProductToIntegrationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToOrganizationArgs = {
  input: GqlUpsertProductToOrganizationInput;
  where: InputMaybe<GqlUpsertProductToOrganizationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToPracticeGroupArgs = {
  input: GqlUpsertProductToPracticeGroupInput;
  where: InputMaybe<GqlUpsertProductToPracticeGroupWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToSuiteListingArgs = {
  input: GqlUpsertProductToSuiteListingInput;
  where: InputMaybe<GqlUpsertProductToSuiteListingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertProductToUserArgs = {
  input: GqlUpsertProductToUserInput;
  where: InputMaybe<GqlUpsertProductToUserWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertRfpArgs = {
  input: GqlUpsertRfpInput;
  where: InputMaybe<GqlUpsertRfpWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertRfpToProductArgs = {
  input: GqlUpsertRfpToProductInput;
  where: InputMaybe<GqlUpsertRfpToProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertSchedulerArgs = {
  input: GqlUpsertSchedulerInput;
  where: InputMaybe<GqlUpsertSchedulerWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertSectionLayoutArgs = {
  input: GqlUpsertSectionLayoutInput;
  where: InputMaybe<GqlUpsertSectionLayoutWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertSimpleServiceArgs = {
  input: GqlUpsertSimpleServiceInput;
  where: InputMaybe<GqlUpsertSimpleServiceWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertStackshareOptionArgs = {
  input: GqlUpsertStackshareOptionInput;
  where: InputMaybe<GqlUpsertStackshareOptionWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertStripeAccountArgs = {
  input: GqlUpsertStripeAccountInput;
  where: InputMaybe<GqlUpsertStripeAccountWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertStripeCustomerArgs = {
  input: GqlUpsertStripeCustomerInput;
  where: InputMaybe<GqlUpsertStripeCustomerWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertStripePurchaseArgs = {
  input: GqlUpsertStripePurchaseInput;
  where: InputMaybe<GqlUpsertStripePurchaseWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertStripeSeatArgs = {
  input: GqlUpsertStripeSeatInput;
  where: InputMaybe<GqlUpsertStripeSeatWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertSuiteListingArgs = {
  input: GqlUpsertSuiteListingInput;
  where: InputMaybe<GqlUpsertSuiteListingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTaxonomyArgs = {
  input: GqlUpsertTaxonomyInput;
  where: InputMaybe<GqlUpsertTaxonomyWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTechstackArgs = {
  input: GqlUpsertTechstackInput;
  where: InputMaybe<GqlUpsertTechstackWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTempDatumArgs = {
  input: GqlUpsertTempDatumInput;
  where: InputMaybe<GqlUpsertTempDatumWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermArgs = {
  input: GqlUpsertTermInput;
  where: InputMaybe<GqlUpsertTermWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToOrganizationArgs = {
  input: GqlUpsertTermToOrganizationInput;
  where: InputMaybe<GqlUpsertTermToOrganizationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToProductArgs = {
  input: GqlUpsertTermToProductInput;
  where: InputMaybe<GqlUpsertTermToProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToRfpArgs = {
  input: GqlUpsertTermToRfpInput;
  where: InputMaybe<GqlUpsertTermToRfpWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToSuiteListingArgs = {
  input: GqlUpsertTermToSuiteListingInput;
  where: InputMaybe<GqlUpsertTermToSuiteListingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToTestDriveArgs = {
  input: GqlUpsertTermToTestDriveInput;
  where: InputMaybe<GqlUpsertTermToTestDriveWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToUserArgs = {
  input: GqlUpsertTermToUserInput;
  where: InputMaybe<GqlUpsertTermToUserWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToUserStoryArgs = {
  input: GqlUpsertTermToUserStoryInput;
  where: InputMaybe<GqlUpsertTermToUserStoryWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermToVendorStackshareArgs = {
  input: GqlUpsertTermToVendorStackshareInput;
  where: InputMaybe<GqlUpsertTermToVendorStackshareWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTermscoutArgs = {
  input: GqlUpsertTermscoutInput;
  where: InputMaybe<GqlUpsertTermscoutWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTestDriveArgs = {
  input: GqlUpsertTestDriveInput;
  where: InputMaybe<GqlUpsertTestDriveWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertTheoremProductArgs = {
  input: GqlUpsertTheoremProductInput;
  where: InputMaybe<GqlUpsertTheoremProductWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUseCaseArgs = {
  input: GqlUpsertUseCaseInput;
  where: InputMaybe<GqlUpsertUseCaseWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUserArgs = {
  input: GqlUpsertUserInput;
  where: InputMaybe<GqlUpsertUserWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUserStoryArgs = {
  input: GqlUpsertUserStoryInput;
  where: InputMaybe<GqlUpsertUserStoryWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUserToOrgStackArgs = {
  input: GqlUpsertUserToOrgStackInput;
  where: InputMaybe<GqlUpsertUserToOrgStackWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUsersToOrganizationArgs = {
  input: GqlUpsertUsersToOrganizationInput;
  where: InputMaybe<GqlUpsertUsersToOrganizationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUsersToPracticeGroupArgs = {
  input: GqlUpsertUsersToPracticeGroupInput;
  where: InputMaybe<GqlUpsertUsersToPracticeGroupWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertUsersToTechstackArgs = {
  input: GqlUpsertUsersToTechstackInput;
  where: InputMaybe<GqlUpsertUsersToTechstackWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type GqlMutationUpsertVendorStackshareLogoArgs = {
  input: GqlUpsertVendorStackshareLogoInput;
  where: InputMaybe<GqlUpsertVendorStackshareLogoWhere>;
};

/** An object with a globally unique `ID`. */
export type GqlNode = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export type GqlNotification = GqlNode & {
  __typename?: 'Notification';
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `Notification`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  readAt: Maybe<Scalars['Datetime']>;
  redirectUrl: Maybe<Scalars['String']>;
  template: Scalars['String'];
  trashAt: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Notification`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlNotificationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `readAt` field. */
  readAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `redirectUrl` field. */
  redirectUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `template` field. */
  template?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trashAt` field. */
  trashAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Notification` object types. All fields are combined with a logical ‘and.’ */
export type GqlNotificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlNotificationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlNotificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlNotificationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `readAt` field. */
  readAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `redirectUrl` field. */
  redirectUrl?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `template` field. */
  template?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `trashAt` field. */
  trashAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `Notification` */
export type GqlNotificationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  readAt?: InputMaybe<Scalars['Datetime']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  template: Scalars['String'];
  trashAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['Int'];
};

/** Represents an update to a `Notification`. Fields that are set will be updated. */
export type GqlNotificationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  readAt?: InputMaybe<Scalars['Datetime']>;
  redirectUrl?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  trashAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Notification` values. */
export type GqlNotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<GqlNotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Maybe<GqlNotification>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Notification` edge in the connection. */
export type GqlNotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Notification` at the end of the edge. */
  node: Maybe<GqlNotification>;
};

/** Methods to use when ordering `Notification`. */
export enum NotificationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReadAtAsc = 'READ_AT_ASC',
  ReadAtDesc = 'READ_AT_DESC',
  RedirectUrlAsc = 'REDIRECT_URL_ASC',
  RedirectUrlDesc = 'REDIRECT_URL_DESC',
  TemplateAsc = 'TEMPLATE_ASC',
  TemplateDesc = 'TEMPLATE_DESC',
  TrashAtAsc = 'TRASH_AT_ASC',
  TrashAtDesc = 'TRASH_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlNoviMember = GqlNode & {
  __typename?: 'NoviMember';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  noviMemberId: Scalars['UUID'];
  status: NoviStatus;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `NoviMember`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `NoviMember` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlNoviMemberCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `noviMemberId` field. */
  noviMemberId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<NoviStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `NoviMember` object types. All fields are combined with a logical ‘and.’ */
export type GqlNoviMemberFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlNoviMemberFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlNoviMemberFilter>;
  /** Filter by the object’s `noviMemberId` field. */
  noviMemberId?: InputMaybe<GqlUuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlNoviMemberFilter>>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlNoviStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `NoviMember` */
export type GqlNoviMemberInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  noviMemberId: Scalars['UUID'];
  status?: InputMaybe<NoviStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['Int'];
};

/** Represents an update to a `NoviMember`. Fields that are set will be updated. */
export type GqlNoviMemberPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  noviMemberId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<NoviStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `NoviMember` values. */
export type GqlNoviMembersConnection = {
  __typename?: 'NoviMembersConnection';
  /** A list of edges which contains the `NoviMember` and cursor to aid in pagination. */
  edges: Array<GqlNoviMembersEdge>;
  /** A list of `NoviMember` objects. */
  nodes: Array<Maybe<GqlNoviMember>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `NoviMember` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NoviMember` edge in the connection. */
export type GqlNoviMembersEdge = {
  __typename?: 'NoviMembersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `NoviMember` at the end of the edge. */
  node: Maybe<GqlNoviMember>;
};

/** Methods to use when ordering `NoviMember`. */
export enum NoviMembersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  NoviMemberIdAsc = 'NOVI_MEMBER_ID_ASC',
  NoviMemberIdDesc = 'NOVI_MEMBER_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlNoviOrganization = GqlNode & {
  __typename?: 'NoviOrganization';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  noviId: Scalars['UUID'];
  /** Reads a single `Organization` that is related to this `NoviOrganization`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  status: NoviStatus;
};

/**
 * A condition to be used against `NoviOrganization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlNoviOrganizationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `noviId` field. */
  noviId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<NoviStatus>;
};

/** A filter to be used against `NoviOrganization` object types. All fields are combined with a logical ‘and.’ */
export type GqlNoviOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlNoviOrganizationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlNoviOrganizationFilter>;
  /** Filter by the object’s `noviId` field. */
  noviId?: InputMaybe<GqlUuidFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlNoviOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlNoviStatusFilter>;
};

/** An input for mutations affecting `NoviOrganization` */
export type GqlNoviOrganizationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  noviId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  status?: InputMaybe<NoviStatus>;
};

/** Represents an update to a `NoviOrganization`. Fields that are set will be updated. */
export type GqlNoviOrganizationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  noviId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<NoviStatus>;
};

/** A connection to a list of `NoviOrganization` values. */
export type GqlNoviOrganizationsConnection = {
  __typename?: 'NoviOrganizationsConnection';
  /** A list of edges which contains the `NoviOrganization` and cursor to aid in pagination. */
  edges: Array<GqlNoviOrganizationsEdge>;
  /** A list of `NoviOrganization` objects. */
  nodes: Array<Maybe<GqlNoviOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `NoviOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NoviOrganization` edge in the connection. */
export type GqlNoviOrganizationsEdge = {
  __typename?: 'NoviOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `NoviOrganization` at the end of the edge. */
  node: Maybe<GqlNoviOrganization>;
};

/** Methods to use when ordering `NoviOrganization`. */
export enum NoviOrganizationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  NoviIdAsc = 'NOVI_ID_ASC',
  NoviIdDesc = 'NOVI_ID_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export enum NoviStatus {
  Current = 'CURRENT',
  Inheriting = 'INHERITING',
  Unpaid = 'UNPAID'
}

/** A filter to be used against NoviStatus fields. All fields are combined with a logical ‘and.’ */
export type GqlNoviStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NoviStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NoviStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NoviStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NoviStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NoviStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NoviStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NoviStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NoviStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NoviStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NoviStatus>>;
};

export type GqlOrganization = GqlNode & {
  __typename?: 'Organization';
  appMetadata: Scalars['JSON'];
  /** Reads and enables pagination through a set of `AssocHome`. */
  assocHomes: Array<GqlAssocHome>;
  /** Reads and enables pagination through a set of `AssocHome`. */
  assocHomesConnection: GqlAssocHomesConnection;
  /** Reads and enables pagination through a set of `AssocSection`. */
  assocSectionsByAssociationId: Array<GqlAssocSection>;
  /** Reads and enables pagination through a set of `AssocSection`. */
  assocSectionsByAssociationIdConnection: GqlAssocSectionsConnection;
  /** Reads and enables pagination through a set of `AssociationToOrganization`. */
  associationToOrganizations: Array<GqlAssociationToOrganization>;
  /** Reads and enables pagination through a set of `AssociationToOrganization`. */
  associationToOrganizationsByAssociationId: Array<GqlAssociationToOrganization>;
  /** Reads and enables pagination through a set of `AssociationToOrganization`. */
  associationToOrganizationsByAssociationIdConnection: GqlAssociationToOrganizationsConnection;
  /** Reads and enables pagination through a set of `AssociationToOrganization`. */
  associationToOrganizationsConnection: GqlAssociationToOrganizationsConnection;
  auth0OrgId: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomers: Array<GqlConnectCustomer>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomersConnection: GqlConnectCustomersConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchases: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseId: GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdList: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseId: GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdList: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByProductListingAssociationIdAndConnectPurchaseId: GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByProductListingAssociationIdAndConnectPurchaseIdList: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByProductListingOrganizationIdAndConnectPurchaseId: GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdList: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesConnection: GqlConnectPurchasesConnection;
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  details: Scalars['JSON'];
  /** Reads and enables pagination through a set of `DiversityCertification`. */
  diversityCertifications: Array<GqlDiversityCertification>;
  /** Reads and enables pagination through a set of `DiversityCertification`. */
  diversityCertificationsConnection: GqlDiversityCertificationsConnection;
  domain: Maybe<Scalars['String']>;
  excerpt: Scalars['String'];
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ListingCreator`. */
  listingCreators: Array<GqlListingCreator>;
  /** Reads and enables pagination through a set of `ListingCreator`. */
  listingCreatorsConnection: GqlListingCreatorsConnection;
  listingStatus: CompanyListingStatus;
  /** Reads and enables pagination through a set of `Location`. */
  locations: Array<GqlLocation>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUserCurrentOrganizationAndLocationId: GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUserCurrentOrganizationAndLocationIdList: Array<GqlLocation>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUsersToOrganizationOrganizationIdAndLocationId: GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUsersToOrganizationOrganizationIdAndLocationIdList: Array<GqlLocation>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsConnection: GqlLocationsConnection;
  /** Reads a single `Term` that is related to this `Organization`. */
  mainTerm: Maybe<GqlTerm>;
  mainTermId: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Array<GqlNotification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection: GqlNotificationsConnection;
  /** Reads a single `NoviOrganization` that is related to this `Organization`. */
  noviOrganization: Maybe<GqlNoviOrganization>;
  /**
   * Reads and enables pagination through a set of `NoviOrganization`.
   * @deprecated Please use noviOrganization instead
   */
  noviOrganizationsConnection: GqlNoviOrganizationsConnection;
  order: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListings: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsByAssociationId: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsByAssociationIdConnection: GqlOrganizationListingsConnection;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsConnection: GqlOrganizationListingsConnection;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacks: Array<GqlOrganizationTechstack>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacksConnection: GqlOrganizationTechstacksConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByAssociationToOrganizationAssociationIdAndOrganizationId: GqlOrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByAssociationToOrganizationAssociationIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByAssociationToOrganizationOrganizationIdAndAssociationId: GqlOrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByAssociationToOrganizationOrganizationIdAndAssociationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingAssociationIdAndOrganizationId: GqlOrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingAssociationIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingOrganizationIdAndAssociationId: GqlOrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationListingOrganizationIdAndAssociationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingAssociationIdAndOrganizationId: GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingAssociationIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingOrganizationIdAndAssociationId: GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingOrganizationIdAndAssociationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsByNetworkId: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsByNetworkIdConnection: GqlProductFeatureByTermsConnection;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsByAssociationId: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsByAssociationIdConnection: GqlProductListingsConnection;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
  /** Reads and enables pagination through a set of `ProductToClient`. */
  productToClientsByClientId: Array<GqlProductToClient>;
  /** Reads and enables pagination through a set of `ProductToClient`. */
  productToClientsByClientIdConnection: GqlProductToClientsConnection;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitors: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: GqlProductToCompetitorsConnection;
  /** Reads and enables pagination through a set of `ProductToOrganization`. */
  productToOrganizations: Array<GqlProductToOrganization>;
  /** Reads and enables pagination through a set of `ProductToOrganization`. */
  productToOrganizationsConnection: GqlProductToOrganizationsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByOrganizationTechstackOrganizationIdAndProductId: GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByOrganizationTechstackOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductFeatureByTermNetworkIdAndProductId: GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductFeatureByTermNetworkIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductListingAssociationIdAndProductId: GqlOrganizationProductsByProductListingAssociationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductListingAssociationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductListingOrganizationIdAndProductId: GqlOrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductListingOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToClientClientIdAndProductId: GqlOrganizationProductsByProductToClientClientIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToClientClientIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorOrganizationIdAndCompetitorId: GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorOrganizationIdAndCompetitorIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorOrganizationIdAndProductId: GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToOrganizationOrganizationIdAndProductId: GqlOrganizationProductsByProductToOrganizationOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToOrganizationOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTechstackOrganizationIdAndProductId: GqlOrganizationProductsByTechstackOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTechstackOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUseCaseOrganizationIdAndProductId: GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUseCaseOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUserStoryOrganizationIdAndProductId: GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUserStoryOrganizationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `SimpleService`. */
  simpleServices: Array<GqlSimpleService>;
  /** Reads and enables pagination through a set of `SimpleService`. */
  simpleServicesConnection: GqlSimpleServicesConnection;
  slug: Scalars['String'];
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccounts: Array<GqlStripeAccount>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccountsConnection: GqlStripeAccountsConnection;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomers: Array<GqlStripeCustomer>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersConnection: GqlStripeCustomersConnection;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchases: Array<GqlStripePurchase>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesBySuiteListingOrganizationIdAndStripePurchaseId: GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyConnection;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdList: Array<GqlStripePurchase>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesConnection: GqlStripePurchasesConnection;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeats: Array<GqlStripeSeat>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatsConnection: GqlStripeSeatsConnection;
  subtype: Maybe<OrganizationSubtype>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListings: Array<GqlSuiteListing>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsConnection: GqlSuiteListingsConnection;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacks: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: GqlTechstacksConnection;
  /** Reads and enables pagination through a set of `TermToOrganization`. */
  termToOrganizations: Array<GqlTermToOrganization>;
  /** Reads and enables pagination through a set of `TermToOrganization`. */
  termToOrganizationsConnection: GqlTermToOrganizationsConnection;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStackshares: Array<GqlTermToVendorStackshare>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStacksharesConnection: GqlTermToVendorStacksharesConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByProductFeatureByTermNetworkIdAndTermId: GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByProductFeatureByTermNetworkIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsBySimpleServiceOrganizationIdAndTermId: GqlOrganizationTermsBySimpleServiceOrganizationIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsBySimpleServiceOrganizationIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToOrganizationOrganizationIdAndTermId: GqlOrganizationTermsByTermToOrganizationOrganizationIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToOrganizationOrganizationIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToUserOrganizationIdAndTermId: GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToUserOrganizationIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToVendorStackshareOrganizationIdAndTermId: GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToVendorStackshareOrganizationIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUseCaseOrganizationIdAndPracticeGroup: GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUseCaseOrganizationIdAndPracticeGroupList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUsersToOrganizationOrganizationIdAndJobTitle: GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUsersToOrganizationOrganizationIdAndJobTitleList: Array<GqlTerm>;
  testMode: Scalars['Boolean'];
  type: OrganizationType;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStories: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: GqlUserStoriesConnection;
  /** Reads and enables pagination through a set of `UserToOrgStack`. */
  userToOrgStacks: Array<GqlUserToOrgStack>;
  /** Reads and enables pagination through a set of `UserToOrgStack`. */
  userToOrgStacksConnection: GqlUserToOrgStacksConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByConnectCustomerOrganizationIdAndUserId: GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByConnectCustomerOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByConnectPurchaseOrganizationIdAndOwnerId: GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByConnectPurchaseOrganizationIdAndOwnerIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCurrentOrganization: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByCurrentOrganizationConnection: GqlUsersConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByNotificationOrganizationIdAndUserId: GqlOrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByNotificationOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripeAccountOrganizationIdAndUserId: GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripeAccountOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripeCustomerOrganizationIdAndUserId: GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripeCustomerOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripePurchaseOrganizationIdAndOwnerId: GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripePurchaseOrganizationIdAndOwnerIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripeSeatOrganizationIdAndUserId: GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByStripeSeatOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackOrganizationIdAndAddedBy: GqlOrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackOrganizationIdAndAddedByList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackOrganizationIdAndOwnedBy: GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackOrganizationIdAndOwnedByList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTermToUserOrganizationIdAndUserId: GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTermToUserOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUseCaseOrganizationIdAndAuthor: GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUseCaseOrganizationIdAndAuthorList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserStoryOrganizationIdAndAuthor: GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserStoryOrganizationIdAndAuthorList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserToOrgStackOrganizationIdAndUserId: GqlOrganizationUsersByUserToOrgStackOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserToOrgStackOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToOrganizationOrganizationIdAndUserId: GqlOrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToOrganizationOrganizationIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
  /** Reads and enables pagination through a set of `VendorStackshareLogo`. */
  vendorStackshareLogos: Array<GqlVendorStackshareLogo>;
  /** Reads and enables pagination through a set of `VendorStackshareLogo`. */
  vendorStackshareLogosConnection: GqlVendorStackshareLogosConnection;
};


export type GqlOrganizationAssocHomesArgs = {
  condition: InputMaybe<GqlAssocHomeCondition>;
  filter: InputMaybe<GqlAssocHomeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssocHomesOrderBy>>;
};


export type GqlOrganizationAssocHomesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssocHomeCondition>;
  filter: InputMaybe<GqlAssocHomeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssocHomesOrderBy>>;
};


export type GqlOrganizationAssocSectionsByAssociationIdArgs = {
  condition: InputMaybe<GqlAssocSectionCondition>;
  filter: InputMaybe<GqlAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssocSectionsOrderBy>>;
};


export type GqlOrganizationAssocSectionsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssocSectionCondition>;
  filter: InputMaybe<GqlAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};


export type GqlOrganizationAssociationToOrganizationsArgs = {
  condition: InputMaybe<GqlAssociationToOrganizationCondition>;
  filter: InputMaybe<GqlAssociationToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};


export type GqlOrganizationAssociationToOrganizationsByAssociationIdArgs = {
  condition: InputMaybe<GqlAssociationToOrganizationCondition>;
  filter: InputMaybe<GqlAssociationToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};


export type GqlOrganizationAssociationToOrganizationsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssociationToOrganizationCondition>;
  filter: InputMaybe<GqlAssociationToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};


export type GqlOrganizationAssociationToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssociationToOrganizationCondition>;
  filter: InputMaybe<GqlAssociationToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};


export type GqlOrganizationConnectCustomersArgs = {
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


export type GqlOrganizationConnectCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


export type GqlOrganizationConnectPurchasesArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdListArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdListArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdListArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdListArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationConnectPurchasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlOrganizationDiversityCertificationsArgs = {
  condition: InputMaybe<GqlDiversityCertificationCondition>;
  filter: InputMaybe<GqlDiversityCertificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};


export type GqlOrganizationDiversityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlDiversityCertificationCondition>;
  filter: InputMaybe<GqlDiversityCertificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};


export type GqlOrganizationListingCreatorsArgs = {
  condition: InputMaybe<GqlListingCreatorCondition>;
  filter: InputMaybe<GqlListingCreatorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ListingCreatorsOrderBy>>;
};


export type GqlOrganizationListingCreatorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlListingCreatorCondition>;
  filter: InputMaybe<GqlListingCreatorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ListingCreatorsOrderBy>>;
};


export type GqlOrganizationLocationsArgs = {
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdListArgs = {
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdListArgs = {
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlOrganizationLocationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlOrganizationNotificationsArgs = {
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NotificationsOrderBy>>;
};


export type GqlOrganizationNotificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type GqlOrganizationNoviOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNoviOrganizationCondition>;
  filter: InputMaybe<GqlNoviOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationListingsArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


export type GqlOrganizationOrganizationListingsByAssociationIdArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


export type GqlOrganizationOrganizationListingsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


export type GqlOrganizationOrganizationListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


export type GqlOrganizationOrganizationTechstacksArgs = {
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


export type GqlOrganizationOrganizationTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


export type GqlOrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlOrganizationProductFeatureByTermsByNetworkIdArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


export type GqlOrganizationProductFeatureByTermsByNetworkIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


export type GqlOrganizationProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlOrganizationProductListingsByAssociationIdArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlOrganizationProductListingsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlOrganizationProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlOrganizationProductToClientsByClientIdArgs = {
  condition: InputMaybe<GqlProductToClientCondition>;
  filter: InputMaybe<GqlProductToClientFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToClientsOrderBy>>;
};


export type GqlOrganizationProductToClientsByClientIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToClientCondition>;
  filter: InputMaybe<GqlProductToClientFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};


export type GqlOrganizationProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


export type GqlOrganizationProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


export type GqlOrganizationProductToOrganizationsArgs = {
  condition: InputMaybe<GqlProductToOrganizationCondition>;
  filter: InputMaybe<GqlProductToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};


export type GqlOrganizationProductToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToOrganizationCondition>;
  filter: InputMaybe<GqlProductToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};


export type GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductListingAssociationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductListingAssociationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductListingOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductListingOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToClientClientIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToClientClientIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToOrganizationOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByProductToOrganizationOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByTechstackOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByTechstackOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlOrganizationSimpleServicesArgs = {
  condition: InputMaybe<GqlSimpleServiceCondition>;
  filter: InputMaybe<GqlSimpleServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SimpleServicesOrderBy>>;
};


export type GqlOrganizationSimpleServicesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSimpleServiceCondition>;
  filter: InputMaybe<GqlSimpleServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};


export type GqlOrganizationStripeAccountsArgs = {
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeAccountsOrderBy>>;
};


export type GqlOrganizationStripeAccountsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};


export type GqlOrganizationStripeCustomersArgs = {
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type GqlOrganizationStripeCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type GqlOrganizationStripePurchasesArgs = {
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripePurchasesOrderBy>>;
};


export type GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};


export type GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdListArgs = {
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripePurchasesOrderBy>>;
};


export type GqlOrganizationStripePurchasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};


export type GqlOrganizationStripeSeatsArgs = {
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeSeatsOrderBy>>;
};


export type GqlOrganizationStripeSeatsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};


export type GqlOrganizationSuiteListingsArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlOrganizationSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlOrganizationTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlOrganizationTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlOrganizationTermToOrganizationsArgs = {
  condition: InputMaybe<GqlTermToOrganizationCondition>;
  filter: InputMaybe<GqlTermToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};


export type GqlOrganizationTermToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToOrganizationCondition>;
  filter: InputMaybe<GqlTermToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};


export type GqlOrganizationTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


export type GqlOrganizationTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};


export type GqlOrganizationTermToVendorStacksharesArgs = {
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


export type GqlOrganizationTermToVendorStacksharesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


export type GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsBySimpleServiceOrganizationIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsBySimpleServiceOrganizationIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByTermToOrganizationOrganizationIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByTermToOrganizationOrganizationIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlOrganizationUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlOrganizationUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlOrganizationUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlOrganizationUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlOrganizationUserToOrgStacksArgs = {
  condition: InputMaybe<GqlUserToOrgStackCondition>;
  filter: InputMaybe<GqlUserToOrgStackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};


export type GqlOrganizationUserToOrgStacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserToOrgStackCondition>;
  filter: InputMaybe<GqlUserToOrgStackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};


export type GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByCurrentOrganizationArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByCurrentOrganizationConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByNotificationOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByNotificationOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByTechstackOrganizationIdAndAddedByArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByTechstackOrganizationIdAndAddedByListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUserToOrgStackOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUserToOrgStackOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlOrganizationUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


export type GqlOrganizationUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


export type GqlOrganizationVendorStackshareLogosArgs = {
  condition: InputMaybe<GqlVendorStackshareLogoCondition>;
  filter: InputMaybe<GqlVendorStackshareLogoFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};


export type GqlOrganizationVendorStackshareLogosConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlVendorStackshareLogoCondition>;
  filter: InputMaybe<GqlVendorStackshareLogoFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};

/**
 * A condition to be used against `Organization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlOrganizationCondition = {
  /** Checks for equality with the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `auth0OrgId` field. */
  auth0OrgId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `domain` field. */
  domain?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `excerpt` field. */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `listingStatus` field. */
  listingStatus?: InputMaybe<CompanyListingStatus>;
  /** Checks for equality with the object’s `mainTermId` field. */
  mainTermId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subtype` field. */
  subtype?: InputMaybe<OrganizationSubtype>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<OrganizationType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ConnectPurchase` values, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyConnection = {
  __typename?: 'OrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyConnection';
  /** A list of edges which contains the `ConnectPurchase`, info from the `OrganizationListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyEdge>;
  /** A list of `ConnectPurchase` objects. */
  nodes: Array<Maybe<GqlConnectPurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectPurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectPurchase` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyEdge = {
  __typename?: 'OrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectPurchase` at the end of the edge. */
  node: Maybe<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListings: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsConnection: GqlOrganizationListingsConnection;
};


/** A `ConnectPurchase` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyEdgeOrganizationListingsArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


/** A `ConnectPurchase` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingAssociationIdAndConnectPurchaseIdManyToManyEdgeOrganizationListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** A connection to a list of `ConnectPurchase` values, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyConnection = {
  __typename?: 'OrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyConnection';
  /** A list of edges which contains the `ConnectPurchase`, info from the `OrganizationListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyEdge>;
  /** A list of `ConnectPurchase` objects. */
  nodes: Array<Maybe<GqlConnectPurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectPurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectPurchase` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyEdge = {
  __typename?: 'OrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectPurchase` at the end of the edge. */
  node: Maybe<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListings: Array<GqlOrganizationListing>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsConnection: GqlOrganizationListingsConnection;
};


/** A `ConnectPurchase` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyEdgeOrganizationListingsArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


/** A `ConnectPurchase` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationConnectPurchasesByOrganizationListingOrganizationIdAndConnectPurchaseIdManyToManyEdgeOrganizationListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** A connection to a list of `ConnectPurchase` values, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyConnection = {
  __typename?: 'OrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyConnection';
  /** A list of edges which contains the `ConnectPurchase`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyEdge>;
  /** A list of `ConnectPurchase` objects. */
  nodes: Array<Maybe<GqlConnectPurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectPurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyEdge = {
  __typename?: 'OrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectPurchase` at the end of the edge. */
  node: Maybe<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingAssociationIdAndConnectPurchaseIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A connection to a list of `ConnectPurchase` values, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyConnection = {
  __typename?: 'OrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyConnection';
  /** A list of edges which contains the `ConnectPurchase`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyEdge>;
  /** A list of `ConnectPurchase` objects. */
  nodes: Array<Maybe<GqlConnectPurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectPurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyEdge = {
  __typename?: 'OrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectPurchase` at the end of the edge. */
  node: Maybe<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationConnectPurchasesByProductListingOrganizationIdAndConnectPurchaseIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A filter to be used against `Organization` object types. All fields are combined with a logical ‘and.’ */
export type GqlOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlOrganizationFilter>>;
  /** Filter by the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `auth0OrgId` field. */
  auth0OrgId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `domain` field. */
  domain?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `excerpt` field. */
  excerpt?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `listingStatus` field. */
  listingStatus?: InputMaybe<GqlCompanyListingStatusFilter>;
  /** Filter by the object’s `mainTermId` field. */
  mainTermId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlOrganizationFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `subtype` field. */
  subtype?: InputMaybe<GqlOrganizationSubtypeFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlOrganizationTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `Organization` */
export type GqlOrganizationInput = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  auth0OrgId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  domain?: InputMaybe<Scalars['String']>;
  excerpt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  listingStatus?: InputMaybe<CompanyListingStatus>;
  mainTermId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<OrganizationSubtype>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type: OrganizationType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GqlOrganizationListing = GqlNode & {
  __typename?: 'OrganizationListing';
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  association: Maybe<GqlOrganization>;
  associationId: Scalars['UUID'];
  /** Reads a single `ConnectPurchase` that is related to this `OrganizationListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  connectPurchaseId: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  details: Scalars['JSON'];
  excerpt: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  show: Scalars['Boolean'];
  status: CompanyListingStatus;
  type: Scalars['String'];
};

/**
 * A condition to be used against `OrganizationListing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlOrganizationListingCondition = {
  /** Checks for equality with the object’s `associationId` field. */
  associationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `connectPurchaseId` field. */
  connectPurchaseId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `excerpt` field. */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `show` field. */
  show?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<CompanyListingStatus>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `OrganizationListing` object types. All fields are combined with a logical ‘and.’ */
export type GqlOrganizationListingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlOrganizationListingFilter>>;
  /** Filter by the object’s `associationId` field. */
  associationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `connectPurchaseId` field. */
  connectPurchaseId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `excerpt` field. */
  excerpt?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlOrganizationListingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlOrganizationListingFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `show` field. */
  show?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlCompanyListingStatusFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlStringFilter>;
};

/** An input for mutations affecting `OrganizationListing` */
export type GqlOrganizationListingInput = {
  associationId: Scalars['UUID'];
  connectPurchaseId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  show?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<CompanyListingStatus>;
  type?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `OrganizationListing`. Fields that are set will be updated. */
export type GqlOrganizationListingPatch = {
  associationId?: InputMaybe<Scalars['UUID']>;
  connectPurchaseId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  show?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<CompanyListingStatus>;
  type?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `OrganizationListing` values. */
export type GqlOrganizationListingsConnection = {
  __typename?: 'OrganizationListingsConnection';
  /** A list of edges which contains the `OrganizationListing` and cursor to aid in pagination. */
  edges: Array<GqlOrganizationListingsEdge>;
  /** A list of `OrganizationListing` objects. */
  nodes: Array<Maybe<GqlOrganizationListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `OrganizationListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrganizationListing` edge in the connection. */
export type GqlOrganizationListingsEdge = {
  __typename?: 'OrganizationListingsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `OrganizationListing` at the end of the edge. */
  node: Maybe<GqlOrganizationListing>;
};

/** Methods to use when ordering `OrganizationListing`. */
export enum OrganizationListingsOrderBy {
  AssociationIdAsc = 'ASSOCIATION_ID_ASC',
  AssociationIdDesc = 'ASSOCIATION_ID_DESC',
  ConnectPurchaseIdAsc = 'CONNECT_PURCHASE_ID_ASC',
  ConnectPurchaseIdDesc = 'CONNECT_PURCHASE_ID_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  ExcerptAsc = 'EXCERPT_ASC',
  ExcerptDesc = 'EXCERPT_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShowAsc = 'SHOW_ASC',
  ShowDesc = 'SHOW_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC'
}

/** A connection to a list of `Location` values, with data from `User`. */
export type GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyConnection = {
  __typename?: 'OrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `User`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Maybe<GqlLocation>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Location` edge in the connection, with data from `User`. */
export type GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyEdge = {
  __typename?: 'OrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Location` at the end of the edge. */
  node: Maybe<GqlLocation>;
  /** Reads and enables pagination through a set of `User`. */
  users: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersConnection: GqlUsersConnection;
};


/** A `Location` edge in the connection, with data from `User`. */
export type GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyEdgeUsersArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


/** A `Location` edge in the connection, with data from `User`. */
export type GqlOrganizationLocationsByUserCurrentOrganizationAndLocationIdManyToManyEdgeUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `Location` values, with data from `UsersToOrganization`. */
export type GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyConnection = {
  __typename?: 'OrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Maybe<GqlLocation>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyEdge = {
  __typename?: 'OrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Location` at the end of the edge. */
  node: Maybe<GqlLocation>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationLocationsByUsersToOrganizationOrganizationIdAndLocationIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `AssociationToOrganization`. */
export type GqlOrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'OrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `AssociationToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `AssociationToOrganization`. */
export type GqlOrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'OrganizationOrganizationsByAssociationToOrganizationAssociationIdAndOrganizationIdManyToManyEdge';
  appMetadata: Scalars['JSON'];
  createdAt: Maybe<Scalars['Datetime']>;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  status: Maybe<MemberStatus>;
  updatedAt: Maybe<Scalars['Datetime']>;
};

/** A connection to a list of `Organization` values, with data from `AssociationToOrganization`. */
export type GqlOrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdManyToManyConnection = {
  __typename?: 'OrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `AssociationToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `AssociationToOrganization`. */
export type GqlOrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdManyToManyEdge = {
  __typename?: 'OrganizationOrganizationsByAssociationToOrganizationOrganizationIdAndAssociationIdManyToManyEdge';
  appMetadata: Scalars['JSON'];
  createdAt: Maybe<Scalars['Datetime']>;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  status: Maybe<MemberStatus>;
  updatedAt: Maybe<Scalars['Datetime']>;
};

/** A connection to a list of `Organization` values, with data from `OrganizationListing`. */
export type GqlOrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'OrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `OrganizationListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'OrganizationOrganizationsByOrganizationListingAssociationIdAndOrganizationIdManyToManyEdge';
  connectPurchaseId: Maybe<Scalars['Int']>;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  description: Scalars['String'];
  details: Scalars['JSON'];
  excerpt: Scalars['String'];
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  show: Scalars['Boolean'];
  status: CompanyListingStatus;
  type: Scalars['String'];
};

/** A connection to a list of `Organization` values, with data from `OrganizationListing`. */
export type GqlOrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdManyToManyConnection = {
  __typename?: 'OrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `OrganizationListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `OrganizationListing`. */
export type GqlOrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdManyToManyEdge = {
  __typename?: 'OrganizationOrganizationsByOrganizationListingOrganizationIdAndAssociationIdManyToManyEdge';
  connectPurchaseId: Maybe<Scalars['Int']>;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  description: Scalars['String'];
  details: Scalars['JSON'];
  excerpt: Scalars['String'];
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  show: Scalars['Boolean'];
  status: CompanyListingStatus;
  type: Scalars['String'];
};

/** A connection to a list of `Organization` values, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'OrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'OrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingAssociationIdAndOrganizationIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyConnection = {
  __typename?: 'OrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyEdge = {
  __typename?: 'OrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsByAssociationId: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsByAssociationIdConnection: GqlProductListingsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyEdgeProductListingsByAssociationIdArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationOrganizationsByProductListingOrganizationIdAndAssociationIdManyToManyEdgeProductListingsByAssociationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** Represents an update to a `Organization`. Fields that are set will be updated. */
export type GqlOrganizationPatch = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  auth0OrgId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  domain?: InputMaybe<Scalars['String']>;
  excerpt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  listingStatus?: InputMaybe<CompanyListingStatus>;
  mainTermId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<OrganizationSubtype>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<OrganizationType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Product` values, with data from `OrganizationTechstack`. */
export type GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `OrganizationTechstack`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `OrganizationTechstack`. */
export type GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacks: Array<GqlOrganizationTechstack>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacksConnection: GqlOrganizationTechstacksConnection;
};


/** A `Product` edge in the connection, with data from `OrganizationTechstack`. */
export type GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyEdgeOrganizationTechstacksArgs = {
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


/** A `Product` edge in the connection, with data from `OrganizationTechstack`. */
export type GqlOrganizationProductsByOrganizationTechstackOrganizationIdAndProductIdManyToManyEdgeOrganizationTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductFeatureByTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: GqlProductFeatureByTermsConnection;
};


/** A `Product` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyEdgeProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationProductsByProductFeatureByTermNetworkIdAndProductIdManyToManyEdgeProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductListing`. */
export type GqlOrganizationProductsByProductListingAssociationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductListingAssociationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductListingAssociationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationProductsByProductListingAssociationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductListingAssociationIdAndProductIdManyToManyEdge';
  appMetadata: Scalars['JSON'];
  connectPurchaseId: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  organizationId: Maybe<Scalars['UUID']>;
  show: Scalars['Boolean'];
  state: ProductState;
  theoremPurchaseId: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Product` values, with data from `ProductListing`. */
export type GqlOrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductListing`. */
export type GqlOrganizationProductsByProductListingOrganizationIdAndProductIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductToClient`. */
export type GqlOrganizationProductsByProductToClientClientIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductToClientClientIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToClient`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductToClientClientIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToClient`. */
export type GqlOrganizationProductsByProductToClientClientIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductToClientClientIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `Product` values, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToCompetitor`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsByCompetitorId: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsByCompetitorIdConnection: GqlProductToCompetitorsConnection;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyEdgeProductToCompetitorsByCompetitorIdArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndCompetitorIdManyToManyEdgeProductToCompetitorsByCompetitorIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToCompetitor`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitors: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: GqlProductToCompetitorsConnection;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyEdgeProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlOrganizationProductsByProductToCompetitorOrganizationIdAndProductIdManyToManyEdgeProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductToOrganization`. */
export type GqlOrganizationProductsByProductToOrganizationOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByProductToOrganizationOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByProductToOrganizationOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToOrganization`. */
export type GqlOrganizationProductsByProductToOrganizationOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByProductToOrganizationOrganizationIdAndProductIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `Product` values, with data from `Techstack`. */
export type GqlOrganizationProductsByTechstackOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByTechstackOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByTechstackOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationProductsByTechstackOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByTechstackOrganizationIdAndProductIdManyToManyEdge';
  access: TechstackAccess;
  addedBy: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  id: Scalars['Int'];
  metadata: Scalars['JSON'];
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  ownedBy: Maybe<Scalars['Int']>;
  stage: TechstackStage;
  testFloat: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Product` values, with data from `UseCase`. */
export type GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
};


/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyEdgeUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationProductsByUseCaseOrganizationIdAndProductIdManyToManyEdgeUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `UserStory`. */
export type GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyConnection = {
  __typename?: 'OrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `UserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `UserStory`. */
export type GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyEdge = {
  __typename?: 'OrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStories: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: GqlUserStoriesConnection;
};


/** A `Product` edge in the connection, with data from `UserStory`. */
export type GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyEdgeUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** A `Product` edge in the connection, with data from `UserStory`. */
export type GqlOrganizationProductsByUserStoryOrganizationIdAndProductIdManyToManyEdgeUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** A connection to a list of `StripePurchase` values, with data from `SuiteListing`. */
export type GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyConnection = {
  __typename?: 'OrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyConnection';
  /** A list of edges which contains the `StripePurchase`, info from the `SuiteListing`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyEdge>;
  /** A list of `StripePurchase` objects. */
  nodes: Array<Maybe<GqlStripePurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `StripePurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StripePurchase` edge in the connection, with data from `SuiteListing`. */
export type GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyEdge = {
  __typename?: 'OrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `StripePurchase` at the end of the edge. */
  node: Maybe<GqlStripePurchase>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListings: Array<GqlSuiteListing>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsConnection: GqlSuiteListingsConnection;
};


/** A `StripePurchase` edge in the connection, with data from `SuiteListing`. */
export type GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyEdgeSuiteListingsArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


/** A `StripePurchase` edge in the connection, with data from `SuiteListing`. */
export type GqlOrganizationStripePurchasesBySuiteListingOrganizationIdAndStripePurchaseIdManyToManyEdgeSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

export enum OrganizationSubtype {
  Alsp = 'ALSP',
  Consultant = 'CONSULTANT',
  InHouse = 'IN_HOUSE',
  Lawfirm = 'LAWFIRM',
  Software = 'SOFTWARE'
}

/** A filter to be used against OrganizationSubtype fields. All fields are combined with a logical ‘and.’ */
export type GqlOrganizationSubtypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrganizationSubtype>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrganizationSubtype>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrganizationSubtype>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrganizationSubtype>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrganizationSubtype>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrganizationSubtype>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrganizationSubtype>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrganizationSubtype>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrganizationSubtype>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrganizationSubtype>>;
};

export type GqlOrganizationTechstack = GqlNode & {
  __typename?: 'OrganizationTechstack';
  action: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  locationId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `OrganizationTechstack`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads a single `Product` that is related to this `OrganizationTechstack`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `OrganizationTechstack` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlOrganizationTechstackCondition = {
  /** Checks for equality with the object’s `action` field. */
  action?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `OrganizationTechstack` object types. All fields are combined with a logical ‘and.’ */
export type GqlOrganizationTechstackFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<GqlStringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlOrganizationTechstackFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlOrganizationTechstackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlOrganizationTechstackFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `OrganizationTechstack` */
export type GqlOrganizationTechstackInput = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  locationId?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `OrganizationTechstack`. Fields that are set will be updated. */
export type GqlOrganizationTechstackPatch = {
  action?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  locationId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `OrganizationTechstack` values. */
export type GqlOrganizationTechstacksConnection = {
  __typename?: 'OrganizationTechstacksConnection';
  /** A list of edges which contains the `OrganizationTechstack` and cursor to aid in pagination. */
  edges: Array<GqlOrganizationTechstacksEdge>;
  /** A list of `OrganizationTechstack` objects. */
  nodes: Array<Maybe<GqlOrganizationTechstack>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `OrganizationTechstack` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `OrganizationTechstack` edge in the connection. */
export type GqlOrganizationTechstacksEdge = {
  __typename?: 'OrganizationTechstacksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `OrganizationTechstack` at the end of the edge. */
  node: Maybe<GqlOrganizationTechstack>;
};

/** Methods to use when ordering `OrganizationTechstack`. */
export enum OrganizationTechstacksOrderBy {
  ActionAsc = 'ACTION_ASC',
  ActionDesc = 'ACTION_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `Term` values, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyConnection = {
  __typename?: 'OrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `ProductFeatureByTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyEdge = {
  __typename?: 'OrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: GqlProductFeatureByTermsConnection;
};


/** A `Term` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyEdgeProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** A `Term` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlOrganizationTermsByProductFeatureByTermNetworkIdAndTermIdManyToManyEdgeProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `SimpleService`. */
export type GqlOrganizationTermsBySimpleServiceOrganizationIdAndTermIdManyToManyConnection = {
  __typename?: 'OrganizationTermsBySimpleServiceOrganizationIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `SimpleService`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsBySimpleServiceOrganizationIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `SimpleService`. */
export type GqlOrganizationTermsBySimpleServiceOrganizationIdAndTermIdManyToManyEdge = {
  __typename?: 'OrganizationTermsBySimpleServiceOrganizationIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  order: Scalars['Int'];
};

/** A connection to a list of `Term` values, with data from `TermToOrganization`. */
export type GqlOrganizationTermsByTermToOrganizationOrganizationIdAndTermIdManyToManyConnection = {
  __typename?: 'OrganizationTermsByTermToOrganizationOrganizationIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsByTermToOrganizationOrganizationIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToOrganization`. */
export type GqlOrganizationTermsByTermToOrganizationOrganizationIdAndTermIdManyToManyEdge = {
  __typename?: 'OrganizationTermsByTermToOrganizationOrganizationIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

/** A connection to a list of `Term` values, with data from `TermToUser`. */
export type GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyConnection = {
  __typename?: 'OrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToUser`. */
export type GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyEdge = {
  __typename?: 'OrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
};


/** A `Term` edge in the connection, with data from `TermToUser`. */
export type GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyEdgeTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


/** A `Term` edge in the connection, with data from `TermToUser`. */
export type GqlOrganizationTermsByTermToUserOrganizationIdAndTermIdManyToManyEdgeTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `TermToVendorStackshare`. */
export type GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyConnection = {
  __typename?: 'OrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToVendorStackshare`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToVendorStackshare`. */
export type GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyEdge = {
  __typename?: 'OrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStackshares: Array<GqlTermToVendorStackshare>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStacksharesConnection: GqlTermToVendorStacksharesConnection;
};


/** A `Term` edge in the connection, with data from `TermToVendorStackshare`. */
export type GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyEdgeTermToVendorStacksharesArgs = {
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


/** A `Term` edge in the connection, with data from `TermToVendorStackshare`. */
export type GqlOrganizationTermsByTermToVendorStackshareOrganizationIdAndTermIdManyToManyEdgeTermToVendorStacksharesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `UseCase`. */
export type GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyConnection = {
  __typename?: 'OrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyEdge = {
  __typename?: 'OrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroup: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroupConnection: GqlUseCasesConnection;
};


/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyEdgeUseCasesByPracticeGroupArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationTermsByUseCaseOrganizationIdAndPracticeGroupManyToManyEdgeUseCasesByPracticeGroupConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `UsersToOrganization`. */
export type GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyConnection = {
  __typename?: 'OrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyEdge = {
  __typename?: 'OrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitle: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitleConnection: GqlUsersToOrganizationsConnection;
};


/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyEdgeUsersToOrganizationsByJobTitleArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationTermsByUsersToOrganizationOrganizationIdAndJobTitleManyToManyEdgeUsersToOrganizationsByJobTitleConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

export enum OrganizationType {
  Association = 'ASSOCIATION',
  Company = 'COMPANY',
  Lawfirm = 'LAWFIRM',
  Other = 'OTHER',
  Personal = 'PERSONAL',
  Vendor = 'VENDOR'
}

/** A filter to be used against OrganizationType fields. All fields are combined with a logical ‘and.’ */
export type GqlOrganizationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OrganizationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OrganizationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OrganizationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OrganizationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OrganizationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OrganizationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OrganizationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OrganizationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OrganizationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OrganizationType>>;
};

/** A connection to a list of `User` values, with data from `ConnectCustomer`. */
export type GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `ConnectCustomer`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `ConnectCustomer`. */
export type GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomers: Array<GqlConnectCustomer>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomersConnection: GqlConnectCustomersConnection;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
};


/** A `User` edge in the connection, with data from `ConnectCustomer`. */
export type GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyEdgeConnectCustomersArgs = {
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


/** A `User` edge in the connection, with data from `ConnectCustomer`. */
export type GqlOrganizationUsersByConnectCustomerOrganizationIdAndUserIdManyToManyEdgeConnectCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};

/** A connection to a list of `User` values, with data from `ConnectPurchase`. */
export type GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `ConnectPurchase`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `ConnectPurchase`. */
export type GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOwnerId: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOwnerIdConnection: GqlConnectPurchasesConnection;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
};


/** A `User` edge in the connection, with data from `ConnectPurchase`. */
export type GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyEdgeConnectPurchasesByOwnerIdArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


/** A `User` edge in the connection, with data from `ConnectPurchase`. */
export type GqlOrganizationUsersByConnectPurchaseOrganizationIdAndOwnerIdManyToManyEdgeConnectPurchasesByOwnerIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Notification`. */
export type GqlOrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Notification`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Notification`. */
export type GqlOrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Array<GqlNotification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection: GqlNotificationsConnection;
};


/** A `User` edge in the connection, with data from `Notification`. */
export type GqlOrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyEdgeNotificationsArgs = {
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NotificationsOrderBy>>;
};


/** A `User` edge in the connection, with data from `Notification`. */
export type GqlOrganizationUsersByNotificationOrganizationIdAndUserIdManyToManyEdgeNotificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `StripeAccount`. */
export type GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `StripeAccount`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `StripeAccount`. */
export type GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccounts: Array<GqlStripeAccount>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccountsConnection: GqlStripeAccountsConnection;
};


/** A `User` edge in the connection, with data from `StripeAccount`. */
export type GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyEdgeStripeAccountsArgs = {
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeAccountsOrderBy>>;
};


/** A `User` edge in the connection, with data from `StripeAccount`. */
export type GqlOrganizationUsersByStripeAccountOrganizationIdAndUserIdManyToManyEdgeStripeAccountsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `StripeCustomer`. */
export type GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `StripeCustomer`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `StripeCustomer`. */
export type GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomers: Array<GqlStripeCustomer>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersConnection: GqlStripeCustomersConnection;
};


/** A `User` edge in the connection, with data from `StripeCustomer`. */
export type GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyEdgeStripeCustomersArgs = {
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeCustomersOrderBy>>;
};


/** A `User` edge in the connection, with data from `StripeCustomer`. */
export type GqlOrganizationUsersByStripeCustomerOrganizationIdAndUserIdManyToManyEdgeStripeCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** A connection to a list of `User` values, with data from `StripePurchase`. */
export type GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `StripePurchase`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `StripePurchase`. */
export type GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesByOwnerId: Array<GqlStripePurchase>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesByOwnerIdConnection: GqlStripePurchasesConnection;
};


/** A `User` edge in the connection, with data from `StripePurchase`. */
export type GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyEdgeStripePurchasesByOwnerIdArgs = {
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripePurchasesOrderBy>>;
};


/** A `User` edge in the connection, with data from `StripePurchase`. */
export type GqlOrganizationUsersByStripePurchaseOrganizationIdAndOwnerIdManyToManyEdgeStripePurchasesByOwnerIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `StripeSeat`. */
export type GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `StripeSeat`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `StripeSeat`. */
export type GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeats: Array<GqlStripeSeat>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatsConnection: GqlStripeSeatsConnection;
};


/** A `User` edge in the connection, with data from `StripeSeat`. */
export type GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyEdgeStripeSeatsArgs = {
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeSeatsOrderBy>>;
};


/** A `User` edge in the connection, with data from `StripeSeat`. */
export type GqlOrganizationUsersByStripeSeatOrganizationIdAndUserIdManyToManyEdgeStripeSeatsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyConnection = {
  __typename?: 'OrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyEdge = {
  __typename?: 'OrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedByConnection: GqlTechstacksConnection;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyEdgeTechstacksByAddedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndAddedByManyToManyEdgeTechstacksByAddedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyConnection = {
  __typename?: 'OrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyEdge = {
  __typename?: 'OrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedByConnection: GqlTechstacksConnection;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyEdgeTechstacksByOwnedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlOrganizationUsersByTechstackOrganizationIdAndOwnedByManyToManyEdgeTechstacksByOwnedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `User` values, with data from `TermToUser`. */
export type GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `TermToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `TermToUser`. */
export type GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
};


/** A `User` edge in the connection, with data from `TermToUser`. */
export type GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyEdgeTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


/** A `User` edge in the connection, with data from `TermToUser`. */
export type GqlOrganizationUsersByTermToUserOrganizationIdAndUserIdManyToManyEdgeTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UseCase`. */
export type GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyConnection = {
  __typename?: 'OrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyEdge = {
  __typename?: 'OrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthor: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthorConnection: GqlUseCasesConnection;
};


/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyEdgeUseCasesByAuthorArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlOrganizationUsersByUseCaseOrganizationIdAndAuthorManyToManyEdgeUseCasesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UserStory`. */
export type GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyConnection = {
  __typename?: 'OrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UserStory`. */
export type GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyEdge = {
  __typename?: 'OrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByAuthor: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByAuthorConnection: GqlUserStoriesConnection;
};


/** A `User` edge in the connection, with data from `UserStory`. */
export type GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyEdgeUserStoriesByAuthorArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UserStory`. */
export type GqlOrganizationUsersByUserStoryOrganizationIdAndAuthorManyToManyEdgeUserStoriesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UserToOrgStack`. */
export type GqlOrganizationUsersByUserToOrgStackOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByUserToOrgStackOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserToOrgStack`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByUserToOrgStackOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UserToOrgStack`. */
export type GqlOrganizationUsersByUserToOrgStackOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByUserToOrgStackOrganizationIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
};

/** A connection to a list of `User` values, with data from `UsersToOrganization`. */
export type GqlOrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdManyToManyConnection = {
  __typename?: 'OrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlOrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlOrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdManyToManyEdge = {
  __typename?: 'OrganizationUsersByUsersToOrganizationOrganizationIdAndUserIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  jobTitle: Maybe<Scalars['Int']>;
  locationId: Maybe<Scalars['Int']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  role: UserRole;
  status: MemberStatus;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Organization` values. */
export type GqlOrganizationsConnection = {
  __typename?: 'OrganizationsConnection';
  /** A list of edges which contains the `Organization` and cursor to aid in pagination. */
  edges: Array<GqlOrganizationsEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection. */
export type GqlOrganizationsEdge = {
  __typename?: 'OrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};

/** Methods to use when ordering `Organization`. */
export enum OrganizationsOrderBy {
  AppMetadataAsc = 'APP_METADATA_ASC',
  AppMetadataDesc = 'APP_METADATA_DESC',
  Auth0OrgIdAsc = 'AUTH0_ORG_ID_ASC',
  Auth0OrgIdDesc = 'AUTH0_ORG_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  DomainAsc = 'DOMAIN_ASC',
  DomainDesc = 'DOMAIN_DESC',
  ExcerptAsc = 'EXCERPT_ASC',
  ExcerptDesc = 'EXCERPT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  ListingStatusAsc = 'LISTING_STATUS_ASC',
  ListingStatusDesc = 'LISTING_STATUS_DESC',
  MainTermIdAsc = 'MAIN_TERM_ID_ASC',
  MainTermIdDesc = 'MAIN_TERM_ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  SubtypeAsc = 'SUBTYPE_ASC',
  SubtypeDesc = 'SUBTYPE_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** Information about pagination in a connection. */
export type GqlPageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['Cursor']>;
};

export enum PaymentStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

/** A filter to be used against PaymentStatus fields. All fields are combined with a logical ‘and.’ */
export type GqlPaymentStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PaymentStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PaymentStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PaymentStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PaymentStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PaymentStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PaymentStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PaymentStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PaymentStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PaymentStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PaymentStatus>>;
};

export type GqlPersonalTechstack = GqlNode & {
  __typename?: 'PersonalTechstack';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads a single `Product` that is related to this `PersonalTechstack`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `User` that is related to this `PersonalTechstack`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `PersonalTechstack` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlPersonalTechstackCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `PersonalTechstack` object types. All fields are combined with a logical ‘and.’ */
export type GqlPersonalTechstackFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlPersonalTechstackFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlPersonalTechstackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlPersonalTechstackFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `PersonalTechstack` */
export type GqlPersonalTechstackInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** Represents an update to a `PersonalTechstack`. Fields that are set will be updated. */
export type GqlPersonalTechstackPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `PersonalTechstack` values. */
export type GqlPersonalTechstacksConnection = {
  __typename?: 'PersonalTechstacksConnection';
  /** A list of edges which contains the `PersonalTechstack` and cursor to aid in pagination. */
  edges: Array<GqlPersonalTechstacksEdge>;
  /** A list of `PersonalTechstack` objects. */
  nodes: Array<Maybe<GqlPersonalTechstack>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PersonalTechstack` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PersonalTechstack` edge in the connection. */
export type GqlPersonalTechstacksEdge = {
  __typename?: 'PersonalTechstacksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PersonalTechstack` at the end of the edge. */
  node: Maybe<GqlPersonalTechstack>;
};

/** Methods to use when ordering `PersonalTechstack`. */
export enum PersonalTechstacksOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlPracticeGroup = GqlNode & {
  __typename?: 'PracticeGroup';
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `ProductToPracticeGroup`. */
  productToPracticeGroups: Array<GqlProductToPracticeGroup>;
  /** Reads and enables pagination through a set of `ProductToPracticeGroup`. */
  productToPracticeGroupsConnection: GqlProductToPracticeGroupsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToPracticeGroupPracticeGroupIdAndProductId: GqlPracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToPracticeGroupPracticeGroupIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToPracticeGroupPracticeGroupIdAndUserId: GqlPracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToPracticeGroupPracticeGroupIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToPracticeGroup`. */
  usersToPracticeGroups: Array<GqlUsersToPracticeGroup>;
  /** Reads and enables pagination through a set of `UsersToPracticeGroup`. */
  usersToPracticeGroupsConnection: GqlUsersToPracticeGroupsConnection;
};


export type GqlPracticeGroupProductToPracticeGroupsArgs = {
  condition: InputMaybe<GqlProductToPracticeGroupCondition>;
  filter: InputMaybe<GqlProductToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};


export type GqlPracticeGroupProductToPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToPracticeGroupCondition>;
  filter: InputMaybe<GqlProductToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};


export type GqlPracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlPracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlPracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlPracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlPracticeGroupUsersToPracticeGroupsArgs = {
  condition: InputMaybe<GqlUsersToPracticeGroupCondition>;
  filter: InputMaybe<GqlUsersToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};


export type GqlPracticeGroupUsersToPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToPracticeGroupCondition>;
  filter: InputMaybe<GqlUsersToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};

/**
 * A condition to be used against `PracticeGroup` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlPracticeGroupCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `PracticeGroup` object types. All fields are combined with a logical ‘and.’ */
export type GqlPracticeGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlPracticeGroupFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlPracticeGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlPracticeGroupFilter>>;
};

/** An input for mutations affecting `PracticeGroup` */
export type GqlPracticeGroupInput = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `PracticeGroup`. Fields that are set will be updated. */
export type GqlPracticeGroupPatch = {
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Product` values, with data from `ProductToPracticeGroup`. */
export type GqlPracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdManyToManyConnection = {
  __typename?: 'PracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToPracticeGroup`, and the cursor to aid in pagination. */
  edges: Array<GqlPracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToPracticeGroup`. */
export type GqlPracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdManyToManyEdge = {
  __typename?: 'PracticeGroupProductsByProductToPracticeGroupPracticeGroupIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `User` values, with data from `UsersToPracticeGroup`. */
export type GqlPracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdManyToManyConnection = {
  __typename?: 'PracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UsersToPracticeGroup`, and the cursor to aid in pagination. */
  edges: Array<GqlPracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UsersToPracticeGroup`. */
export type GqlPracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdManyToManyEdge = {
  __typename?: 'PracticeGroupUsersByUsersToPracticeGroupPracticeGroupIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
};

/** A connection to a list of `PracticeGroup` values. */
export type GqlPracticeGroupsConnection = {
  __typename?: 'PracticeGroupsConnection';
  /** A list of edges which contains the `PracticeGroup` and cursor to aid in pagination. */
  edges: Array<GqlPracticeGroupsEdge>;
  /** A list of `PracticeGroup` objects. */
  nodes: Array<Maybe<GqlPracticeGroup>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PracticeGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PracticeGroup` edge in the connection. */
export type GqlPracticeGroupsEdge = {
  __typename?: 'PracticeGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PracticeGroup` at the end of the edge. */
  node: Maybe<GqlPracticeGroup>;
};

/** Methods to use when ordering `PracticeGroup`. */
export enum PracticeGroupsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GqlPremiumInfoToTerm = GqlNode & {
  __typename?: 'PremiumInfoToTerm';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  peerFirmUsersBySize: Maybe<Scalars['Int']>;
  /** Reads a single `PremiumProductInfo` that is related to this `PremiumInfoToTerm`. */
  premiumInfo: Maybe<GqlPremiumProductInfo>;
  premiumInfoId: Scalars['Int'];
  /** Reads a single `Term` that is related to this `PremiumInfoToTerm`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `PremiumInfoToTerm` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlPremiumInfoToTermCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `peerFirmUsersBySize` field. */
  peerFirmUsersBySize?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `premiumInfoId` field. */
  premiumInfoId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `PremiumInfoToTerm` object types. All fields are combined with a logical ‘and.’ */
export type GqlPremiumInfoToTermFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlPremiumInfoToTermFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlPremiumInfoToTermFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlPremiumInfoToTermFilter>>;
  /** Filter by the object’s `peerFirmUsersBySize` field. */
  peerFirmUsersBySize?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `premiumInfoId` field. */
  premiumInfoId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `PremiumInfoToTerm` */
export type GqlPremiumInfoToTermInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  peerFirmUsersBySize?: InputMaybe<Scalars['Int']>;
  premiumInfoId: Scalars['Int'];
  termId: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `PremiumInfoToTerm`. Fields that are set will be updated. */
export type GqlPremiumInfoToTermPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  peerFirmUsersBySize?: InputMaybe<Scalars['Int']>;
  premiumInfoId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PremiumInfoToTerm` values. */
export type GqlPremiumInfoToTermsConnection = {
  __typename?: 'PremiumInfoToTermsConnection';
  /** A list of edges which contains the `PremiumInfoToTerm` and cursor to aid in pagination. */
  edges: Array<GqlPremiumInfoToTermsEdge>;
  /** A list of `PremiumInfoToTerm` objects. */
  nodes: Array<Maybe<GqlPremiumInfoToTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PremiumInfoToTerm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PremiumInfoToTerm` edge in the connection. */
export type GqlPremiumInfoToTermsEdge = {
  __typename?: 'PremiumInfoToTermsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PremiumInfoToTerm` at the end of the edge. */
  node: Maybe<GqlPremiumInfoToTerm>;
};

/** Methods to use when ordering `PremiumInfoToTerm`. */
export enum PremiumInfoToTermsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  PeerFirmUsersBySizeAsc = 'PEER_FIRM_USERS_BY_SIZE_ASC',
  PeerFirmUsersBySizeDesc = 'PEER_FIRM_USERS_BY_SIZE_DESC',
  PremiumInfoIdAsc = 'PREMIUM_INFO_ID_ASC',
  PremiumInfoIdDesc = 'PREMIUM_INFO_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlPremiumProductInfo = GqlNode & {
  __typename?: 'PremiumProductInfo';
  averagePeerPrice: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  easeOfSetup: Maybe<Scalars['Float']>;
  easeOfUse: Maybe<Scalars['Float']>;
  estimatedTimeToDeploy: Maybe<Scalars['String']>;
  fundingAndStabilityRank: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  idealNumberUsers: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  overallRating: Maybe<Scalars['Float']>;
  peerRating: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `PremiumInfoToTerm`. */
  premiumInfoToTermsByPremiumInfoId: Array<GqlPremiumInfoToTerm>;
  /** Reads and enables pagination through a set of `PremiumInfoToTerm`. */
  premiumInfoToTermsByPremiumInfoIdConnection: GqlPremiumInfoToTermsConnection;
  /** Reads a single `Product` that is related to this `PremiumProductInfo`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  qualityOfSupport: Maybe<Scalars['Float']>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByPremiumInfoToTermPremiumInfoIdAndTermId: GqlPremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByPremiumInfoToTermPremiumInfoIdAndTermIdList: Array<GqlTerm>;
  totalFirms: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
  valueForMoney: Maybe<Scalars['Float']>;
};


export type GqlPremiumProductInfoPremiumInfoToTermsByPremiumInfoIdArgs = {
  condition: InputMaybe<GqlPremiumInfoToTermCondition>;
  filter: InputMaybe<GqlPremiumInfoToTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};


export type GqlPremiumProductInfoPremiumInfoToTermsByPremiumInfoIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPremiumInfoToTermCondition>;
  filter: InputMaybe<GqlPremiumInfoToTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};


export type GqlPremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlPremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};

/**
 * A condition to be used against `PremiumProductInfo` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlPremiumProductInfoCondition = {
  /** Checks for equality with the object’s `averagePeerPrice` field. */
  averagePeerPrice?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `easeOfSetup` field. */
  easeOfSetup?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `easeOfUse` field. */
  easeOfUse?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `estimatedTimeToDeploy` field. */
  estimatedTimeToDeploy?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fundingAndStabilityRank` field. */
  fundingAndStabilityRank?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `idealNumberUsers` field. */
  idealNumberUsers?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `overallRating` field. */
  overallRating?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `peerRating` field. */
  peerRating?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `qualityOfSupport` field. */
  qualityOfSupport?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `totalFirms` field. */
  totalFirms?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `valueForMoney` field. */
  valueForMoney?: InputMaybe<Scalars['Float']>;
};

/** A filter to be used against `PremiumProductInfo` object types. All fields are combined with a logical ‘and.’ */
export type GqlPremiumProductInfoFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlPremiumProductInfoFilter>>;
  /** Filter by the object’s `averagePeerPrice` field. */
  averagePeerPrice?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `easeOfSetup` field. */
  easeOfSetup?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `easeOfUse` field. */
  easeOfUse?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `estimatedTimeToDeploy` field. */
  estimatedTimeToDeploy?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `fundingAndStabilityRank` field. */
  fundingAndStabilityRank?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `idealNumberUsers` field. */
  idealNumberUsers?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlPremiumProductInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlPremiumProductInfoFilter>>;
  /** Filter by the object’s `overallRating` field. */
  overallRating?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `peerRating` field. */
  peerRating?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `qualityOfSupport` field. */
  qualityOfSupport?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `totalFirms` field. */
  totalFirms?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `valueForMoney` field. */
  valueForMoney?: InputMaybe<GqlFloatFilter>;
};

/** An input for mutations affecting `PremiumProductInfo` */
export type GqlPremiumProductInfoInput = {
  averagePeerPrice?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  easeOfSetup?: InputMaybe<Scalars['Float']>;
  easeOfUse?: InputMaybe<Scalars['Float']>;
  estimatedTimeToDeploy?: InputMaybe<Scalars['String']>;
  fundingAndStabilityRank?: InputMaybe<Scalars['Float']>;
  id: Scalars['Int'];
  idealNumberUsers?: InputMaybe<Scalars['String']>;
  overallRating?: InputMaybe<Scalars['Float']>;
  peerRating?: InputMaybe<Scalars['Float']>;
  productId: Scalars['Int'];
  qualityOfSupport?: InputMaybe<Scalars['Float']>;
  totalFirms?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  valueForMoney?: InputMaybe<Scalars['Float']>;
};

/** Represents an update to a `PremiumProductInfo`. Fields that are set will be updated. */
export type GqlPremiumProductInfoPatch = {
  averagePeerPrice?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  easeOfSetup?: InputMaybe<Scalars['Float']>;
  easeOfUse?: InputMaybe<Scalars['Float']>;
  estimatedTimeToDeploy?: InputMaybe<Scalars['String']>;
  fundingAndStabilityRank?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['Int']>;
  idealNumberUsers?: InputMaybe<Scalars['String']>;
  overallRating?: InputMaybe<Scalars['Float']>;
  peerRating?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['Int']>;
  qualityOfSupport?: InputMaybe<Scalars['Float']>;
  totalFirms?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  valueForMoney?: InputMaybe<Scalars['Float']>;
};

/** A connection to a list of `Term` values, with data from `PremiumInfoToTerm`. */
export type GqlPremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdManyToManyConnection = {
  __typename?: 'PremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `PremiumInfoToTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlPremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `PremiumInfoToTerm`. */
export type GqlPremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdManyToManyEdge = {
  __typename?: 'PremiumProductInfoTermsByPremiumInfoToTermPremiumInfoIdAndTermIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  peerFirmUsersBySize: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `PremiumProductInfo` values. */
export type GqlPremiumProductInfosConnection = {
  __typename?: 'PremiumProductInfosConnection';
  /** A list of edges which contains the `PremiumProductInfo` and cursor to aid in pagination. */
  edges: Array<GqlPremiumProductInfosEdge>;
  /** A list of `PremiumProductInfo` objects. */
  nodes: Array<Maybe<GqlPremiumProductInfo>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PremiumProductInfo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PremiumProductInfo` edge in the connection. */
export type GqlPremiumProductInfosEdge = {
  __typename?: 'PremiumProductInfosEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PremiumProductInfo` at the end of the edge. */
  node: Maybe<GqlPremiumProductInfo>;
};

/** Methods to use when ordering `PremiumProductInfo`. */
export enum PremiumProductInfosOrderBy {
  AveragePeerPriceAsc = 'AVERAGE_PEER_PRICE_ASC',
  AveragePeerPriceDesc = 'AVERAGE_PEER_PRICE_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EaseOfSetupAsc = 'EASE_OF_SETUP_ASC',
  EaseOfSetupDesc = 'EASE_OF_SETUP_DESC',
  EaseOfUseAsc = 'EASE_OF_USE_ASC',
  EaseOfUseDesc = 'EASE_OF_USE_DESC',
  EstimatedTimeToDeployAsc = 'ESTIMATED_TIME_TO_DEPLOY_ASC',
  EstimatedTimeToDeployDesc = 'ESTIMATED_TIME_TO_DEPLOY_DESC',
  FundingAndStabilityRankAsc = 'FUNDING_AND_STABILITY_RANK_ASC',
  FundingAndStabilityRankDesc = 'FUNDING_AND_STABILITY_RANK_DESC',
  IdealNumberUsersAsc = 'IDEAL_NUMBER_USERS_ASC',
  IdealNumberUsersDesc = 'IDEAL_NUMBER_USERS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OverallRatingAsc = 'OVERALL_RATING_ASC',
  OverallRatingDesc = 'OVERALL_RATING_DESC',
  PeerRatingAsc = 'PEER_RATING_ASC',
  PeerRatingDesc = 'PEER_RATING_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  QualityOfSupportAsc = 'QUALITY_OF_SUPPORT_ASC',
  QualityOfSupportDesc = 'QUALITY_OF_SUPPORT_DESC',
  TotalFirmsAsc = 'TOTAL_FIRMS_ASC',
  TotalFirmsDesc = 'TOTAL_FIRMS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  ValueForMoneyAsc = 'VALUE_FOR_MONEY_ASC',
  ValueForMoneyDesc = 'VALUE_FOR_MONEY_DESC'
}

export type GqlProduct = GqlNode & {
  __typename?: 'Product';
  /** Reads and enables pagination through a set of `AssocSection`. */
  assocSectionsByProductToAssocSectionProductIdAndAssocSectionId: GqlProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AssocSection`. */
  assocSectionsByProductToAssocSectionProductIdAndAssocSectionIdList: Array<GqlAssocSection>;
  /** Reads and enables pagination through a set of `AwardBadge`. */
  awardBadgesByProductToAwardBadgeProductIdAndAwardBadgeId: GqlProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdManyToManyConnection;
  /** Reads and enables pagination through a set of `AwardBadge`. */
  awardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdList: Array<GqlAwardBadge>;
  /** Reads and enables pagination through a set of `BestForToProduct`. */
  bestForToProducts: Array<GqlBestForToProduct>;
  /** Reads and enables pagination through a set of `BestForToProduct`. */
  bestForToProductsConnection: GqlBestForToProductsConnection;
  /** Reads and enables pagination through a set of `BestFor`. */
  bestForsByBestForToProductProductIdAndBestForId: GqlProductBestForsByBestForToProductProductIdAndBestForIdManyToManyConnection;
  /** Reads and enables pagination through a set of `BestFor`. */
  bestForsByBestForToProductProductIdAndBestForIdList: Array<GqlBestFor>;
  /** Reads and enables pagination through a set of `Category`. */
  categoriesByCategoryToProductProductIdAndCategoryId: GqlProductCategoriesByCategoryToProductProductIdAndCategoryIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Category`. */
  categoriesByCategoryToProductProductIdAndCategoryIdList: Array<GqlCategory>;
  /** Reads and enables pagination through a set of `CategoryToProduct`. */
  categoryToProducts: Array<GqlCategoryToProduct>;
  /** Reads and enables pagination through a set of `CategoryToProduct`. */
  categoryToProductsConnection: GqlCategoryToProductsConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByProductListingProductIdAndConnectPurchaseId: GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByProductListingProductIdAndConnectPurchaseIdList: Array<GqlConnectPurchase>;
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  details: Scalars['JSON'];
  excerpt: Scalars['String'];
  /** Reads and enables pagination through a set of `FeatureToProduct`. */
  featureToProducts: Array<GqlFeatureToProduct>;
  /** Reads and enables pagination through a set of `FeatureToProduct`. */
  featureToProductsConnection: GqlFeatureToProductsConnection;
  featured: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Feature`. */
  featuresByFeatureToProductProductIdAndFeatureId: GqlProductFeaturesByFeatureToProductProductIdAndFeatureIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Feature`. */
  featuresByFeatureToProductProductIdAndFeatureIdList: Array<GqlFeature>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacks: Array<GqlOrganizationTechstack>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacksConnection: GqlOrganizationTechstacksConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationTechstackProductIdAndOrganizationId: GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByOrganizationTechstackProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductFeatureByTermProductIdAndNetworkId: GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductFeatureByTermProductIdAndNetworkIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingProductIdAndAssociationId: GqlProductOrganizationsByProductListingProductIdAndAssociationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingProductIdAndAssociationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingProductIdAndOrganizationId: GqlProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductListingProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToClientProductIdAndClientId: GqlProductOrganizationsByProductToClientProductIdAndClientIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToClientProductIdAndClientIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToCompetitorCompetitorIdAndOrganizationId: GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToCompetitorCompetitorIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToCompetitorProductIdAndOrganizationId: GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToCompetitorProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToOrganizationProductIdAndOrganizationId: GqlProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductToOrganizationProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTechstackProductIdAndOrganizationId: GqlProductOrganizationsByTechstackProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTechstackProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUseCaseProductIdAndOrganizationId: GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUseCaseProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserStoryProductIdAndOrganizationId: GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserStoryProductIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `PersonalTechstack`. */
  personalTechstacks: Array<GqlPersonalTechstack>;
  /** Reads and enables pagination through a set of `PersonalTechstack`. */
  personalTechstacksConnection: GqlPersonalTechstacksConnection;
  /** Reads and enables pagination through a set of `PracticeGroup`. */
  practiceGroupsByProductToPracticeGroupProductIdAndPracticeGroupId: GqlProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `PracticeGroup`. */
  practiceGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdList: Array<GqlPracticeGroup>;
  /** Reads and enables pagination through a set of `PremiumProductInfo`. */
  premiumProductInfos: Array<GqlPremiumProductInfo>;
  /** Reads and enables pagination through a set of `PremiumProductInfo`. */
  premiumProductInfosConnection: GqlPremiumProductInfosConnection;
  /** Reads and enables pagination through a set of `ProductAwardDetail`. */
  productAwardDetails: Array<GqlProductAwardDetail>;
  /** Reads and enables pagination through a set of `ProductAwardDetail`. */
  productAwardDetailsConnection: GqlProductAwardDetailsConnection;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: GqlProductFeatureByTermsConnection;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
  /** Reads and enables pagination through a set of `ProductToAssocSection`. */
  productToAssocSections: Array<GqlProductToAssocSection>;
  /** Reads and enables pagination through a set of `ProductToAssocSection`. */
  productToAssocSectionsConnection: GqlProductToAssocSectionsConnection;
  /** Reads and enables pagination through a set of `ProductToAwardBadge`. */
  productToAwardBadges: Array<GqlProductToAwardBadge>;
  /** Reads and enables pagination through a set of `ProductToAwardBadge`. */
  productToAwardBadgesConnection: GqlProductToAwardBadgesConnection;
  /** Reads and enables pagination through a set of `ProductToClient`. */
  productToClients: Array<GqlProductToClient>;
  /** Reads and enables pagination through a set of `ProductToClient`. */
  productToClientsConnection: GqlProductToClientsConnection;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitors: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsByCompetitorId: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsByCompetitorIdConnection: GqlProductToCompetitorsConnection;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: GqlProductToCompetitorsConnection;
  /** Reads and enables pagination through a set of `ProductToIntegration`. */
  productToIntegrations: Array<GqlProductToIntegration>;
  /** Reads and enables pagination through a set of `ProductToIntegration`. */
  productToIntegrationsByIntegrationId: Array<GqlProductToIntegration>;
  /** Reads and enables pagination through a set of `ProductToIntegration`. */
  productToIntegrationsByIntegrationIdConnection: GqlProductToIntegrationsConnection;
  /** Reads and enables pagination through a set of `ProductToIntegration`. */
  productToIntegrationsConnection: GqlProductToIntegrationsConnection;
  /** Reads and enables pagination through a set of `ProductToOrganization`. */
  productToOrganizations: Array<GqlProductToOrganization>;
  /** Reads and enables pagination through a set of `ProductToOrganization`. */
  productToOrganizationsConnection: GqlProductToOrganizationsConnection;
  /** Reads and enables pagination through a set of `ProductToPracticeGroup`. */
  productToPracticeGroups: Array<GqlProductToPracticeGroup>;
  /** Reads and enables pagination through a set of `ProductToPracticeGroup`. */
  productToPracticeGroupsConnection: GqlProductToPracticeGroupsConnection;
  /** Reads and enables pagination through a set of `ProductToSuiteListing`. */
  productToSuiteListings: Array<GqlProductToSuiteListing>;
  /** Reads and enables pagination through a set of `ProductToSuiteListing`. */
  productToSuiteListingsConnection: GqlProductToSuiteListingsConnection;
  /** Reads and enables pagination through a set of `ProductToUser`. */
  productToUsers: Array<GqlProductToUser>;
  /** Reads and enables pagination through a set of `ProductToUser`. */
  productToUsersConnection: GqlProductToUsersConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorCompetitorIdAndProductId: GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorCompetitorIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorProductIdAndCompetitorId: GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToCompetitorProductIdAndCompetitorIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToIntegrationIntegrationIdAndProductId: GqlProductProductsByProductToIntegrationIntegrationIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToIntegrationIntegrationIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToIntegrationProductIdAndIntegrationId: GqlProductProductsByProductToIntegrationProductIdAndIntegrationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToIntegrationProductIdAndIntegrationIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `RfpToProduct`. */
  rfpToProducts: Array<GqlRfpToProduct>;
  /** Reads and enables pagination through a set of `RfpToProduct`. */
  rfpToProductsConnection: GqlRfpToProductsConnection;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfpsByRfpToProductProductIdAndRfpId: GqlProductRfpsByRfpToProductProductIdAndRfpIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfpsByRfpToProductProductIdAndRfpIdList: Array<GqlRfp>;
  show: Scalars['Boolean'];
  slug: Scalars['String'];
  state: ProductState;
  status: ProductStatus;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsByProductToSuiteListingProductIdAndSuiteListingId: GqlProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdManyToManyConnection;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsByProductToSuiteListingProductIdAndSuiteListingIdList: Array<GqlSuiteListing>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacks: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: GqlTechstacksConnection;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProducts: Array<GqlTermToProduct>;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProductsConnection: GqlTermToProductsConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByProductFeatureByTermProductIdAndTermId: GqlProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByProductFeatureByTermProductIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToProductProductIdAndTermId: GqlProductTermsByTermToProductProductIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToProductProductIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTestDriveProductIdAndTermId: GqlProductTermsByTestDriveProductIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTestDriveProductIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUseCaseProductIdAndPracticeGroup: GqlProductTermsByUseCaseProductIdAndPracticeGroupManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUseCaseProductIdAndPracticeGroupList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Termscout`. */
  termscouts: Array<GqlTermscout>;
  /** Reads and enables pagination through a set of `Termscout`. */
  termscoutsConnection: GqlTermscoutsConnection;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrives: Array<GqlTestDrive>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesConnection: GqlTestDrivesConnection;
  testMode: Scalars['Boolean'];
  type: ProductType;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStories: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: GqlUserStoriesConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByPersonalTechstackProductIdAndUserId: GqlProductUsersByPersonalTechstackProductIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByPersonalTechstackProductIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByProductToUserProductIdAndUserId: GqlProductUsersByProductToUserProductIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByProductToUserProductIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackProductIdAndAddedBy: GqlProductUsersByTechstackProductIdAndAddedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackProductIdAndAddedByList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackProductIdAndOwnedBy: GqlProductUsersByTechstackProductIdAndOwnedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackProductIdAndOwnedByList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUseCaseProductIdAndAuthor: GqlProductUsersByUseCaseProductIdAndAuthorManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUseCaseProductIdAndAuthorList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserStoryProductIdAndAuthor: GqlProductUsersByUserStoryProductIdAndAuthorManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUserStoryProductIdAndAuthorList: Array<GqlUser>;
};


export type GqlProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssocSectionCondition>;
  filter: InputMaybe<GqlAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};


export type GqlProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdListArgs = {
  condition: InputMaybe<GqlAssocSectionCondition>;
  filter: InputMaybe<GqlAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssocSectionsOrderBy>>;
};


export type GqlProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAwardBadgeCondition>;
  filter: InputMaybe<GqlAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AwardBadgesOrderBy>>;
};


export type GqlProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdListArgs = {
  condition: InputMaybe<GqlAwardBadgeCondition>;
  filter: InputMaybe<GqlAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AwardBadgesOrderBy>>;
};


export type GqlProductBestForToProductsArgs = {
  condition: InputMaybe<GqlBestForToProductCondition>;
  filter: InputMaybe<GqlBestForToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<BestForToProductsOrderBy>>;
};


export type GqlProductBestForToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlBestForToProductCondition>;
  filter: InputMaybe<GqlBestForToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};


export type GqlProductBestForsByBestForToProductProductIdAndBestForIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlBestForCondition>;
  filter: InputMaybe<GqlBestForFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BestForsOrderBy>>;
};


export type GqlProductBestForsByBestForToProductProductIdAndBestForIdListArgs = {
  condition: InputMaybe<GqlBestForCondition>;
  filter: InputMaybe<GqlBestForFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<BestForsOrderBy>>;
};


export type GqlProductCategoriesByCategoryToProductProductIdAndCategoryIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlCategoryCondition>;
  filter: InputMaybe<GqlCategoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};


export type GqlProductCategoriesByCategoryToProductProductIdAndCategoryIdListArgs = {
  condition: InputMaybe<GqlCategoryCondition>;
  filter: InputMaybe<GqlCategoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<CategoriesOrderBy>>;
};


export type GqlProductCategoryToProductsArgs = {
  condition: InputMaybe<GqlCategoryToProductCondition>;
  filter: InputMaybe<GqlCategoryToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<CategoryToProductsOrderBy>>;
};


export type GqlProductCategoryToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlCategoryToProductCondition>;
  filter: InputMaybe<GqlCategoryToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};


export type GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdListArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlProductFeatureToProductsArgs = {
  condition: InputMaybe<GqlFeatureToProductCondition>;
  filter: InputMaybe<GqlFeatureToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<FeatureToProductsOrderBy>>;
};


export type GqlProductFeatureToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlFeatureToProductCondition>;
  filter: InputMaybe<GqlFeatureToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};


export type GqlProductFeaturesByFeatureToProductProductIdAndFeatureIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlFeatureCondition>;
  filter: InputMaybe<GqlFeatureFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};


export type GqlProductFeaturesByFeatureToProductProductIdAndFeatureIdListArgs = {
  condition: InputMaybe<GqlFeatureCondition>;
  filter: InputMaybe<GqlFeatureFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<FeaturesOrderBy>>;
};


export type GqlProductOrganizationTechstacksArgs = {
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


export type GqlProductOrganizationTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


export type GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductListingProductIdAndAssociationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductListingProductIdAndAssociationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductListingProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductListingProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToClientProductIdAndClientIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToClientProductIdAndClientIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByTechstackProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByTechstackProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlProductPersonalTechstacksArgs = {
  condition: InputMaybe<GqlPersonalTechstackCondition>;
  filter: InputMaybe<GqlPersonalTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};


export type GqlProductPersonalTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPersonalTechstackCondition>;
  filter: InputMaybe<GqlPersonalTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};


export type GqlProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPracticeGroupCondition>;
  filter: InputMaybe<GqlPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};


export type GqlProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdListArgs = {
  condition: InputMaybe<GqlPracticeGroupCondition>;
  filter: InputMaybe<GqlPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PracticeGroupsOrderBy>>;
};


export type GqlProductPremiumProductInfosArgs = {
  condition: InputMaybe<GqlPremiumProductInfoCondition>;
  filter: InputMaybe<GqlPremiumProductInfoFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};


export type GqlProductPremiumProductInfosConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPremiumProductInfoCondition>;
  filter: InputMaybe<GqlPremiumProductInfoFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};


export type GqlProductProductAwardDetailsArgs = {
  condition: InputMaybe<GqlProductAwardDetailCondition>;
  filter: InputMaybe<GqlProductAwardDetailFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};


export type GqlProductProductAwardDetailsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductAwardDetailCondition>;
  filter: InputMaybe<GqlProductAwardDetailFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};


export type GqlProductProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


export type GqlProductProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


export type GqlProductProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlProductProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};


export type GqlProductProductToAssocSectionsArgs = {
  condition: InputMaybe<GqlProductToAssocSectionCondition>;
  filter: InputMaybe<GqlProductToAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};


export type GqlProductProductToAssocSectionsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToAssocSectionCondition>;
  filter: InputMaybe<GqlProductToAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};


export type GqlProductProductToAwardBadgesArgs = {
  condition: InputMaybe<GqlProductToAwardBadgeCondition>;
  filter: InputMaybe<GqlProductToAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};


export type GqlProductProductToAwardBadgesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToAwardBadgeCondition>;
  filter: InputMaybe<GqlProductToAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};


export type GqlProductProductToClientsArgs = {
  condition: InputMaybe<GqlProductToClientCondition>;
  filter: InputMaybe<GqlProductToClientFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToClientsOrderBy>>;
};


export type GqlProductProductToClientsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToClientCondition>;
  filter: InputMaybe<GqlProductToClientFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};


export type GqlProductProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


export type GqlProductProductToCompetitorsByCompetitorIdArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


export type GqlProductProductToCompetitorsByCompetitorIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


export type GqlProductProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


export type GqlProductProductToIntegrationsArgs = {
  condition: InputMaybe<GqlProductToIntegrationCondition>;
  filter: InputMaybe<GqlProductToIntegrationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};


export type GqlProductProductToIntegrationsByIntegrationIdArgs = {
  condition: InputMaybe<GqlProductToIntegrationCondition>;
  filter: InputMaybe<GqlProductToIntegrationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};


export type GqlProductProductToIntegrationsByIntegrationIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToIntegrationCondition>;
  filter: InputMaybe<GqlProductToIntegrationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};


export type GqlProductProductToIntegrationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToIntegrationCondition>;
  filter: InputMaybe<GqlProductToIntegrationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};


export type GqlProductProductToOrganizationsArgs = {
  condition: InputMaybe<GqlProductToOrganizationCondition>;
  filter: InputMaybe<GqlProductToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};


export type GqlProductProductToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToOrganizationCondition>;
  filter: InputMaybe<GqlProductToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};


export type GqlProductProductToPracticeGroupsArgs = {
  condition: InputMaybe<GqlProductToPracticeGroupCondition>;
  filter: InputMaybe<GqlProductToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};


export type GqlProductProductToPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToPracticeGroupCondition>;
  filter: InputMaybe<GqlProductToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};


export type GqlProductProductToSuiteListingsArgs = {
  condition: InputMaybe<GqlProductToSuiteListingCondition>;
  filter: InputMaybe<GqlProductToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};


export type GqlProductProductToSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToSuiteListingCondition>;
  filter: InputMaybe<GqlProductToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};


export type GqlProductProductToUsersArgs = {
  condition: InputMaybe<GqlProductToUserCondition>;
  filter: InputMaybe<GqlProductToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToUsersOrderBy>>;
};


export type GqlProductProductToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToUserCondition>;
  filter: InputMaybe<GqlProductToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};


export type GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToIntegrationIntegrationIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToIntegrationIntegrationIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToIntegrationProductIdAndIntegrationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductProductsByProductToIntegrationProductIdAndIntegrationIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlProductRfpToProductsArgs = {
  condition: InputMaybe<GqlRfpToProductCondition>;
  filter: InputMaybe<GqlRfpToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpToProductsOrderBy>>;
};


export type GqlProductRfpToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpToProductCondition>;
  filter: InputMaybe<GqlRfpToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};


export type GqlProductRfpsByRfpToProductProductIdAndRfpIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};


export type GqlProductRfpsByRfpToProductProductIdAndRfpIdListArgs = {
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpsOrderBy>>;
};


export type GqlProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdListArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlProductTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlProductTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlProductTermToProductsArgs = {
  condition: InputMaybe<GqlTermToProductCondition>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToProductsOrderBy>>;
};


export type GqlProductTermToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToProductCondition>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};


export type GqlProductTermsByProductFeatureByTermProductIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByProductFeatureByTermProductIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByTermToProductProductIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByTermToProductProductIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByTestDriveProductIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByTestDriveProductIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByUseCaseProductIdAndPracticeGroupArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermsByUseCaseProductIdAndPracticeGroupListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlProductTermscoutsArgs = {
  condition: InputMaybe<GqlTermscoutCondition>;
  filter: InputMaybe<GqlTermscoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermscoutsOrderBy>>;
};


export type GqlProductTermscoutsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermscoutCondition>;
  filter: InputMaybe<GqlTermscoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermscoutsOrderBy>>;
};


export type GqlProductTestDrivesArgs = {
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TestDrivesOrderBy>>;
};


export type GqlProductTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};


export type GqlProductUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlProductUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlProductUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlProductUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlProductUsersByPersonalTechstackProductIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByPersonalTechstackProductIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByProductToUserProductIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByProductToUserProductIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByTechstackProductIdAndAddedByArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByTechstackProductIdAndAddedByListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByTechstackProductIdAndOwnedByArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByTechstackProductIdAndOwnedByListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByUseCaseProductIdAndAuthorArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByUseCaseProductIdAndAuthorListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByUserStoryProductIdAndAuthorArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlProductUsersByUserStoryProductIdAndAuthorListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};

/** A connection to a list of `AssocSection` values, with data from `ProductToAssocSection`. */
export type GqlProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdManyToManyConnection = {
  __typename?: 'ProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdManyToManyConnection';
  /** A list of edges which contains the `AssocSection`, info from the `ProductToAssocSection`, and the cursor to aid in pagination. */
  edges: Array<GqlProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdManyToManyEdge>;
  /** A list of `AssocSection` objects. */
  nodes: Array<Maybe<GqlAssocSection>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `AssocSection` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AssocSection` edge in the connection, with data from `ProductToAssocSection`. */
export type GqlProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdManyToManyEdge = {
  __typename?: 'ProductAssocSectionsByProductToAssocSectionProductIdAndAssocSectionIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AssocSection` at the end of the edge. */
  node: Maybe<GqlAssocSection>;
  order: Maybe<Scalars['Int']>;
};

/** A connection to a list of `AwardBadge` values, with data from `ProductToAwardBadge`. */
export type GqlProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdManyToManyConnection = {
  __typename?: 'ProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdManyToManyConnection';
  /** A list of edges which contains the `AwardBadge`, info from the `ProductToAwardBadge`, and the cursor to aid in pagination. */
  edges: Array<GqlProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdManyToManyEdge>;
  /** A list of `AwardBadge` objects. */
  nodes: Array<Maybe<GqlAwardBadge>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `AwardBadge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AwardBadge` edge in the connection, with data from `ProductToAwardBadge`. */
export type GqlProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdManyToManyEdge = {
  __typename?: 'ProductAwardBadgesByProductToAwardBadgeProductIdAndAwardBadgeIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AwardBadge` at the end of the edge. */
  node: Maybe<GqlAwardBadge>;
};

export type GqlProductAwardDetail = GqlNode & {
  __typename?: 'ProductAwardDetail';
  link: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `ProductAwardDetail`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  titleGroup: Scalars['String'];
  titleOfAward: Scalars['String'];
  year: Scalars['Int'];
};

/**
 * A condition to be used against `ProductAwardDetail` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlProductAwardDetailCondition = {
  /** Checks for equality with the object’s `link` field. */
  link?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `titleGroup` field. */
  titleGroup?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `titleOfAward` field. */
  titleOfAward?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `year` field. */
  year?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductAwardDetail` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductAwardDetailFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductAwardDetailFilter>>;
  /** Filter by the object’s `link` field. */
  link?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductAwardDetailFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductAwardDetailFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `titleGroup` field. */
  titleGroup?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `titleOfAward` field. */
  titleOfAward?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `year` field. */
  year?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductAwardDetail` */
export type GqlProductAwardDetailInput = {
  link?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  titleGroup?: InputMaybe<Scalars['String']>;
  titleOfAward?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `ProductAwardDetail`. Fields that are set will be updated. */
export type GqlProductAwardDetailPatch = {
  link?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  titleGroup?: InputMaybe<Scalars['String']>;
  titleOfAward?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductAwardDetail` values. */
export type GqlProductAwardDetailsConnection = {
  __typename?: 'ProductAwardDetailsConnection';
  /** A list of edges which contains the `ProductAwardDetail` and cursor to aid in pagination. */
  edges: Array<GqlProductAwardDetailsEdge>;
  /** A list of `ProductAwardDetail` objects. */
  nodes: Array<Maybe<GqlProductAwardDetail>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductAwardDetail` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductAwardDetail` edge in the connection. */
export type GqlProductAwardDetailsEdge = {
  __typename?: 'ProductAwardDetailsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductAwardDetail` at the end of the edge. */
  node: Maybe<GqlProductAwardDetail>;
};

/** Methods to use when ordering `ProductAwardDetail`. */
export enum ProductAwardDetailsOrderBy {
  LinkAsc = 'LINK_ASC',
  LinkDesc = 'LINK_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  TitleGroupAsc = 'TITLE_GROUP_ASC',
  TitleGroupDesc = 'TITLE_GROUP_DESC',
  TitleOfAwardAsc = 'TITLE_OF_AWARD_ASC',
  TitleOfAwardDesc = 'TITLE_OF_AWARD_DESC',
  YearAsc = 'YEAR_ASC',
  YearDesc = 'YEAR_DESC'
}

/** A connection to a list of `BestFor` values, with data from `BestForToProduct`. */
export type GqlProductBestForsByBestForToProductProductIdAndBestForIdManyToManyConnection = {
  __typename?: 'ProductBestForsByBestForToProductProductIdAndBestForIdManyToManyConnection';
  /** A list of edges which contains the `BestFor`, info from the `BestForToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlProductBestForsByBestForToProductProductIdAndBestForIdManyToManyEdge>;
  /** A list of `BestFor` objects. */
  nodes: Array<Maybe<GqlBestFor>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `BestFor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `BestFor` edge in the connection, with data from `BestForToProduct`. */
export type GqlProductBestForsByBestForToProductProductIdAndBestForIdManyToManyEdge = {
  __typename?: 'ProductBestForsByBestForToProductProductIdAndBestForIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `BestFor` at the end of the edge. */
  node: Maybe<GqlBestFor>;
};

/** A connection to a list of `Category` values, with data from `CategoryToProduct`. */
export type GqlProductCategoriesByCategoryToProductProductIdAndCategoryIdManyToManyConnection = {
  __typename?: 'ProductCategoriesByCategoryToProductProductIdAndCategoryIdManyToManyConnection';
  /** A list of edges which contains the `Category`, info from the `CategoryToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlProductCategoriesByCategoryToProductProductIdAndCategoryIdManyToManyEdge>;
  /** A list of `Category` objects. */
  nodes: Array<Maybe<GqlCategory>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Category` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Category` edge in the connection, with data from `CategoryToProduct`. */
export type GqlProductCategoriesByCategoryToProductProductIdAndCategoryIdManyToManyEdge = {
  __typename?: 'ProductCategoriesByCategoryToProductProductIdAndCategoryIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Category` at the end of the edge. */
  node: Maybe<GqlCategory>;
};

/** A condition to be used against `Product` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlProductCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `excerpt` field. */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `featured` field. */
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `show` field. */
  show?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ProductState>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ProductStatus>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ProductType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ConnectPurchase` values, with data from `ProductListing`. */
export type GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyConnection = {
  __typename?: 'ProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyConnection';
  /** A list of edges which contains the `ConnectPurchase`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyEdge>;
  /** A list of `ConnectPurchase` objects. */
  nodes: Array<Maybe<GqlConnectPurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ConnectPurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyEdge = {
  __typename?: 'ProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ConnectPurchase` at the end of the edge. */
  node: Maybe<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `ConnectPurchase` edge in the connection, with data from `ProductListing`. */
export type GqlProductConnectPurchasesByProductListingProductIdAndConnectPurchaseIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

export type GqlProductFeatureByTerm = GqlNode & {
  __typename?: 'ProductFeatureByTerm';
  /** Reads a single `Organization` that is related to this `ProductFeatureByTerm`. */
  network: Maybe<GqlOrganization>;
  networkId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `ProductFeatureByTerm`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `Term` that is related to this `ProductFeatureByTerm`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductFeatureByTerm` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductFeatureByTermCondition = {
  /** Checks for equality with the object’s `networkId` field. */
  networkId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductFeatureByTerm` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductFeatureByTermFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductFeatureByTermFilter>>;
  /** Filter by the object’s `networkId` field. */
  networkId?: InputMaybe<GqlUuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductFeatureByTermFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductFeatureByTermFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductFeatureByTerm` */
export type GqlProductFeatureByTermInput = {
  networkId: Scalars['UUID'];
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** Represents an update to a `ProductFeatureByTerm`. Fields that are set will be updated. */
export type GqlProductFeatureByTermPatch = {
  networkId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductFeatureByTerm` values. */
export type GqlProductFeatureByTermsConnection = {
  __typename?: 'ProductFeatureByTermsConnection';
  /** A list of edges which contains the `ProductFeatureByTerm` and cursor to aid in pagination. */
  edges: Array<GqlProductFeatureByTermsEdge>;
  /** A list of `ProductFeatureByTerm` objects. */
  nodes: Array<Maybe<GqlProductFeatureByTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductFeatureByTerm` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductFeatureByTerm` edge in the connection. */
export type GqlProductFeatureByTermsEdge = {
  __typename?: 'ProductFeatureByTermsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductFeatureByTerm` at the end of the edge. */
  node: Maybe<GqlProductFeatureByTerm>;
};

/** Methods to use when ordering `ProductFeatureByTerm`. */
export enum ProductFeatureByTermsOrderBy {
  Natural = 'NATURAL',
  NetworkIdAsc = 'NETWORK_ID_ASC',
  NetworkIdDesc = 'NETWORK_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

/** A connection to a list of `Feature` values, with data from `FeatureToProduct`. */
export type GqlProductFeaturesByFeatureToProductProductIdAndFeatureIdManyToManyConnection = {
  __typename?: 'ProductFeaturesByFeatureToProductProductIdAndFeatureIdManyToManyConnection';
  /** A list of edges which contains the `Feature`, info from the `FeatureToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlProductFeaturesByFeatureToProductProductIdAndFeatureIdManyToManyEdge>;
  /** A list of `Feature` objects. */
  nodes: Array<Maybe<GqlFeature>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Feature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Feature` edge in the connection, with data from `FeatureToProduct`. */
export type GqlProductFeaturesByFeatureToProductProductIdAndFeatureIdManyToManyEdge = {
  __typename?: 'ProductFeaturesByFeatureToProductProductIdAndFeatureIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Feature` at the end of the edge. */
  node: Maybe<GqlFeature>;
};

/** A filter to be used against `Product` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `excerpt` field. */
  excerpt?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `featured` field. */
  featured?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductFilter>>;
  /** Filter by the object’s `show` field. */
  show?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GqlProductStateFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlProductStatusFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlProductTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `Product` */
export type GqlProductInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  show?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ProductState>;
  status?: InputMaybe<ProductStatus>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ProductType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GqlProductListing = GqlNode & {
  __typename?: 'ProductListing';
  appMetadata: Scalars['JSON'];
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  association: Maybe<GqlOrganization>;
  associationId: Scalars['UUID'];
  /** Reads a single `ConnectPurchase` that is related to this `ProductListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  connectPurchaseId: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads a single `Product` that is related to this `ProductListing`. */
  product: Maybe<GqlProduct>;
  productId: Maybe<Scalars['Int']>;
  show: Scalars['Boolean'];
  state: ProductState;
  theoremPurchaseId: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `ProductListing` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlProductListingCondition = {
  /** Checks for equality with the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `associationId` field. */
  associationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `connectPurchaseId` field. */
  connectPurchaseId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `show` field. */
  show?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ProductState>;
  /** Checks for equality with the object’s `theoremPurchaseId` field. */
  theoremPurchaseId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `ProductListing` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductListingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductListingFilter>>;
  /** Filter by the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `associationId` field. */
  associationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `connectPurchaseId` field. */
  connectPurchaseId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductListingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductListingFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `show` field. */
  show?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GqlProductStateFilter>;
  /** Filter by the object’s `theoremPurchaseId` field. */
  theoremPurchaseId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `ProductListing` */
export type GqlProductListingInput = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  associationId: Scalars['UUID'];
  connectPurchaseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  show?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<ProductState>;
  theoremPurchaseId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `ProductListing`. Fields that are set will be updated. */
export type GqlProductListingPatch = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  associationId?: InputMaybe<Scalars['UUID']>;
  connectPurchaseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  show?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<ProductState>;
  theoremPurchaseId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `ProductListing` values. */
export type GqlProductListingsConnection = {
  __typename?: 'ProductListingsConnection';
  /** A list of edges which contains the `ProductListing` and cursor to aid in pagination. */
  edges: Array<GqlProductListingsEdge>;
  /** A list of `ProductListing` objects. */
  nodes: Array<Maybe<GqlProductListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductListing` edge in the connection. */
export type GqlProductListingsEdge = {
  __typename?: 'ProductListingsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductListing` at the end of the edge. */
  node: Maybe<GqlProductListing>;
};

/** Methods to use when ordering `ProductListing`. */
export enum ProductListingsOrderBy {
  AppMetadataAsc = 'APP_METADATA_ASC',
  AppMetadataDesc = 'APP_METADATA_DESC',
  AssociationIdAsc = 'ASSOCIATION_ID_ASC',
  AssociationIdDesc = 'ASSOCIATION_ID_DESC',
  ConnectPurchaseIdAsc = 'CONNECT_PURCHASE_ID_ASC',
  ConnectPurchaseIdDesc = 'CONNECT_PURCHASE_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  ShowAsc = 'SHOW_ASC',
  ShowDesc = 'SHOW_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  TheoremPurchaseIdAsc = 'THEOREM_PURCHASE_ID_ASC',
  TheoremPurchaseIdDesc = 'THEOREM_PURCHASE_ID_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Organization` values, with data from `OrganizationTechstack`. */
export type GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `OrganizationTechstack`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `OrganizationTechstack`. */
export type GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacks: Array<GqlOrganizationTechstack>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacksConnection: GqlOrganizationTechstacksConnection;
};


/** A `Organization` edge in the connection, with data from `OrganizationTechstack`. */
export type GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyEdgeOrganizationTechstacksArgs = {
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `OrganizationTechstack`. */
export type GqlProductOrganizationsByOrganizationTechstackProductIdAndOrganizationIdManyToManyEdgeOrganizationTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductFeatureByTerm`. */
export type GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductFeatureByTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsByNetworkId: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsByNetworkIdConnection: GqlProductFeatureByTermsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyEdgeProductFeatureByTermsByNetworkIdArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlProductOrganizationsByProductFeatureByTermProductIdAndNetworkIdManyToManyEdgeProductFeatureByTermsByNetworkIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductListing`. */
export type GqlProductOrganizationsByProductListingProductIdAndAssociationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductListingProductIdAndAssociationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductListingProductIdAndAssociationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlProductOrganizationsByProductListingProductIdAndAssociationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductListingProductIdAndAssociationIdManyToManyEdge';
  appMetadata: Scalars['JSON'];
  connectPurchaseId: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  show: Scalars['Boolean'];
  state: ProductState;
  theoremPurchaseId: Maybe<Scalars['Int']>;
  type: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Organization` values, with data from `ProductListing`. */
export type GqlProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductListing`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListings: Array<GqlProductListing>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: GqlProductListingsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyEdgeProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductListing`. */
export type GqlProductOrganizationsByProductListingProductIdAndOrganizationIdManyToManyEdgeProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductToClient`. */
export type GqlProductOrganizationsByProductToClientProductIdAndClientIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductToClientProductIdAndClientIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductToClient`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductToClientProductIdAndClientIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductToClient`. */
export type GqlProductOrganizationsByProductToClientProductIdAndClientIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductToClientProductIdAndClientIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};

/** A connection to a list of `Organization` values, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductToCompetitor`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitors: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: GqlProductToCompetitorsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyEdgeProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorCompetitorIdAndOrganizationIdManyToManyEdgeProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductToCompetitor`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitors: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: GqlProductToCompetitorsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyEdgeProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductOrganizationsByProductToCompetitorProductIdAndOrganizationIdManyToManyEdgeProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductToOrganization`. */
export type GqlProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductToOrganization`. */
export type GqlProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByProductToOrganizationProductIdAndOrganizationIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};

/** A connection to a list of `Organization` values, with data from `Techstack`. */
export type GqlProductOrganizationsByTechstackProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByTechstackProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByTechstackProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlProductOrganizationsByTechstackProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByTechstackProductIdAndOrganizationIdManyToManyEdge';
  access: TechstackAccess;
  addedBy: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  id: Scalars['Int'];
  metadata: Scalars['JSON'];
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  ownedBy: Maybe<Scalars['Int']>;
  stage: TechstackStage;
  testFloat: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Organization` values, with data from `UseCase`. */
export type GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
};


/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyEdgeUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlProductOrganizationsByUseCaseProductIdAndOrganizationIdManyToManyEdgeUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UserStory`. */
export type GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'ProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UserStory`. */
export type GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'ProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStories: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: GqlUserStoriesConnection;
};


/** A `Organization` edge in the connection, with data from `UserStory`. */
export type GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyEdgeUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UserStory`. */
export type GqlProductOrganizationsByUserStoryProductIdAndOrganizationIdManyToManyEdgeUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** Represents an update to a `Product`. Fields that are set will be updated. */
export type GqlProductPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  show?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ProductState>;
  status?: InputMaybe<ProductStatus>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ProductType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PracticeGroup` values, with data from `ProductToPracticeGroup`. */
export type GqlProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdManyToManyConnection = {
  __typename?: 'ProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdManyToManyConnection';
  /** A list of edges which contains the `PracticeGroup`, info from the `ProductToPracticeGroup`, and the cursor to aid in pagination. */
  edges: Array<GqlProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdManyToManyEdge>;
  /** A list of `PracticeGroup` objects. */
  nodes: Array<Maybe<GqlPracticeGroup>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PracticeGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PracticeGroup` edge in the connection, with data from `ProductToPracticeGroup`. */
export type GqlProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdManyToManyEdge = {
  __typename?: 'ProductPracticeGroupsByProductToPracticeGroupProductIdAndPracticeGroupIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PracticeGroup` at the end of the edge. */
  node: Maybe<GqlPracticeGroup>;
};

/** A connection to a list of `Product` values, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyConnection = {
  __typename?: 'ProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToCompetitor`, and the cursor to aid in pagination. */
  edges: Array<GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyEdge = {
  __typename?: 'ProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitors: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: GqlProductToCompetitorsConnection;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyEdgeProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorCompetitorIdAndProductIdManyToManyEdgeProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyConnection = {
  __typename?: 'ProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToCompetitor`, and the cursor to aid in pagination. */
  edges: Array<GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyEdge = {
  __typename?: 'ProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsByCompetitorId: Array<GqlProductToCompetitor>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsByCompetitorIdConnection: GqlProductToCompetitorsConnection;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyEdgeProductToCompetitorsByCompetitorIdArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductToCompetitor`. */
export type GqlProductProductsByProductToCompetitorProductIdAndCompetitorIdManyToManyEdgeProductToCompetitorsByCompetitorIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `ProductToIntegration`. */
export type GqlProductProductsByProductToIntegrationIntegrationIdAndProductIdManyToManyConnection = {
  __typename?: 'ProductProductsByProductToIntegrationIntegrationIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToIntegration`, and the cursor to aid in pagination. */
  edges: Array<GqlProductProductsByProductToIntegrationIntegrationIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToIntegration`. */
export type GqlProductProductsByProductToIntegrationIntegrationIdAndProductIdManyToManyEdge = {
  __typename?: 'ProductProductsByProductToIntegrationIntegrationIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  organizationId: Maybe<Scalars['UUID']>;
  vendorId: Maybe<Scalars['Int']>;
};

/** A connection to a list of `Product` values, with data from `ProductToIntegration`. */
export type GqlProductProductsByProductToIntegrationProductIdAndIntegrationIdManyToManyConnection = {
  __typename?: 'ProductProductsByProductToIntegrationProductIdAndIntegrationIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToIntegration`, and the cursor to aid in pagination. */
  edges: Array<GqlProductProductsByProductToIntegrationProductIdAndIntegrationIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToIntegration`. */
export type GqlProductProductsByProductToIntegrationProductIdAndIntegrationIdManyToManyEdge = {
  __typename?: 'ProductProductsByProductToIntegrationProductIdAndIntegrationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  organizationId: Maybe<Scalars['UUID']>;
  vendorId: Maybe<Scalars['Int']>;
};

/** A connection to a list of `Rfp` values, with data from `RfpToProduct`. */
export type GqlProductRfpsByRfpToProductProductIdAndRfpIdManyToManyConnection = {
  __typename?: 'ProductRfpsByRfpToProductProductIdAndRfpIdManyToManyConnection';
  /** A list of edges which contains the `Rfp`, info from the `RfpToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlProductRfpsByRfpToProductProductIdAndRfpIdManyToManyEdge>;
  /** A list of `Rfp` objects. */
  nodes: Array<Maybe<GqlRfp>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Rfp` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Rfp` edge in the connection, with data from `RfpToProduct`. */
export type GqlProductRfpsByRfpToProductProductIdAndRfpIdManyToManyEdge = {
  __typename?: 'ProductRfpsByRfpToProductProductIdAndRfpIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Rfp` at the end of the edge. */
  node: Maybe<GqlRfp>;
};

export type GqlProductSection = GqlNode & {
  __typename?: 'ProductSection';
  id: Scalars['Int'];
  label: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  products: Array<Maybe<Scalars['Int']>>;
};

/**
 * A condition to be used against `ProductSection` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlProductSectionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `products` field. */
  products?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** A filter to be used against `ProductSection` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductSectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductSectionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductSectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductSectionFilter>>;
  /** Filter by the object’s `products` field. */
  products?: InputMaybe<GqlIntListFilter>;
};

/** An input for mutations affecting `ProductSection` */
export type GqlProductSectionInput = {
  id?: InputMaybe<Scalars['Int']>;
  label: Scalars['String'];
  products?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** Represents an update to a `ProductSection`. Fields that are set will be updated. */
export type GqlProductSectionPatch = {
  id?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

/** A connection to a list of `ProductSection` values. */
export type GqlProductSectionsConnection = {
  __typename?: 'ProductSectionsConnection';
  /** A list of edges which contains the `ProductSection` and cursor to aid in pagination. */
  edges: Array<GqlProductSectionsEdge>;
  /** A list of `ProductSection` objects. */
  nodes: Array<Maybe<GqlProductSection>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductSection` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductSection` edge in the connection. */
export type GqlProductSectionsEdge = {
  __typename?: 'ProductSectionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductSection` at the end of the edge. */
  node: Maybe<GqlProductSection>;
};

/** Methods to use when ordering `ProductSection`. */
export enum ProductSectionsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LabelAsc = 'LABEL_ASC',
  LabelDesc = 'LABEL_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductsAsc = 'PRODUCTS_ASC',
  ProductsDesc = 'PRODUCTS_DESC'
}

export enum ProductState {
  Active = 'ACTIVE',
  Claimed = 'CLAIMED',
  Complete = 'COMPLETE',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Review = 'REVIEW',
  Unclaimed = 'UNCLAIMED'
}

/** A filter to be used against ProductState fields. All fields are combined with a logical ‘and.’ */
export type GqlProductStateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProductState>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProductState>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProductState>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProductState>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProductState>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProductState>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProductState>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProductState>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProductState>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProductState>>;
};

export enum ProductStatus {
  Active = 'ACTIVE',
  Claimed = 'CLAIMED',
  Draft = 'DRAFT',
  Review = 'REVIEW',
  Unclaimed = 'UNCLAIMED'
}

/** A filter to be used against ProductStatus fields. All fields are combined with a logical ‘and.’ */
export type GqlProductStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProductStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProductStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProductStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProductStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProductStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProductStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProductStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProductStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProductStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProductStatus>>;
};

/** A connection to a list of `SuiteListing` values, with data from `ProductToSuiteListing`. */
export type GqlProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdManyToManyConnection = {
  __typename?: 'ProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdManyToManyConnection';
  /** A list of edges which contains the `SuiteListing`, info from the `ProductToSuiteListing`, and the cursor to aid in pagination. */
  edges: Array<GqlProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdManyToManyEdge>;
  /** A list of `SuiteListing` objects. */
  nodes: Array<Maybe<GqlSuiteListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `SuiteListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuiteListing` edge in the connection, with data from `ProductToSuiteListing`. */
export type GqlProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdManyToManyEdge = {
  __typename?: 'ProductSuiteListingsByProductToSuiteListingProductIdAndSuiteListingIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SuiteListing` at the end of the edge. */
  node: Maybe<GqlSuiteListing>;
};

/** A connection to a list of `Term` values, with data from `ProductFeatureByTerm`. */
export type GqlProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyConnection = {
  __typename?: 'ProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `ProductFeatureByTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyEdge = {
  __typename?: 'ProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: GqlProductFeatureByTermsConnection;
};


/** A `Term` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyEdgeProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** A `Term` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlProductTermsByProductFeatureByTermProductIdAndTermIdManyToManyEdgeProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `TermToProduct`. */
export type GqlProductTermsByTermToProductProductIdAndTermIdManyToManyConnection = {
  __typename?: 'ProductTermsByTermToProductProductIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlProductTermsByTermToProductProductIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToProduct`. */
export type GqlProductTermsByTermToProductProductIdAndTermIdManyToManyEdge = {
  __typename?: 'ProductTermsByTermToProductProductIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

/** A connection to a list of `Term` values, with data from `TestDrive`. */
export type GqlProductTermsByTestDriveProductIdAndTermIdManyToManyConnection = {
  __typename?: 'ProductTermsByTestDriveProductIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TestDrive`, and the cursor to aid in pagination. */
  edges: Array<GqlProductTermsByTestDriveProductIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TestDrive`. */
export type GqlProductTermsByTestDriveProductIdAndTermIdManyToManyEdge = {
  __typename?: 'ProductTermsByTestDriveProductIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrives: Array<GqlTestDrive>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesConnection: GqlTestDrivesConnection;
};


/** A `Term` edge in the connection, with data from `TestDrive`. */
export type GqlProductTermsByTestDriveProductIdAndTermIdManyToManyEdgeTestDrivesArgs = {
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TestDrivesOrderBy>>;
};


/** A `Term` edge in the connection, with data from `TestDrive`. */
export type GqlProductTermsByTestDriveProductIdAndTermIdManyToManyEdgeTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `UseCase`. */
export type GqlProductTermsByUseCaseProductIdAndPracticeGroupManyToManyConnection = {
  __typename?: 'ProductTermsByUseCaseProductIdAndPracticeGroupManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlProductTermsByUseCaseProductIdAndPracticeGroupManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlProductTermsByUseCaseProductIdAndPracticeGroupManyToManyEdge = {
  __typename?: 'ProductTermsByUseCaseProductIdAndPracticeGroupManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroup: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroupConnection: GqlUseCasesConnection;
};


/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlProductTermsByUseCaseProductIdAndPracticeGroupManyToManyEdgeUseCasesByPracticeGroupArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlProductTermsByUseCaseProductIdAndPracticeGroupManyToManyEdgeUseCasesByPracticeGroupConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

export type GqlProductToAssocSection = GqlNode & {
  __typename?: 'ProductToAssocSection';
  /** Reads a single `AssocSection` that is related to this `ProductToAssocSection`. */
  assocSection: Maybe<GqlAssocSection>;
  assocSectionId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  /** Reads a single `Product` that is related to this `ProductToAssocSection`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToAssocSection` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToAssocSectionCondition = {
  /** Checks for equality with the object’s `assocSectionId` field. */
  assocSectionId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToAssocSection` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToAssocSectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToAssocSectionFilter>>;
  /** Filter by the object’s `assocSectionId` field. */
  assocSectionId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToAssocSectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToAssocSectionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToAssocSection` */
export type GqlProductToAssocSectionInput = {
  assocSectionId: Scalars['Int'];
  order?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
};

/** Represents an update to a `ProductToAssocSection`. Fields that are set will be updated. */
export type GqlProductToAssocSectionPatch = {
  assocSectionId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToAssocSection` values. */
export type GqlProductToAssocSectionsConnection = {
  __typename?: 'ProductToAssocSectionsConnection';
  /** A list of edges which contains the `ProductToAssocSection` and cursor to aid in pagination. */
  edges: Array<GqlProductToAssocSectionsEdge>;
  /** A list of `ProductToAssocSection` objects. */
  nodes: Array<Maybe<GqlProductToAssocSection>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToAssocSection` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToAssocSection` edge in the connection. */
export type GqlProductToAssocSectionsEdge = {
  __typename?: 'ProductToAssocSectionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToAssocSection` at the end of the edge. */
  node: Maybe<GqlProductToAssocSection>;
};

/** Methods to use when ordering `ProductToAssocSection`. */
export enum ProductToAssocSectionsOrderBy {
  AssocSectionIdAsc = 'ASSOC_SECTION_ID_ASC',
  AssocSectionIdDesc = 'ASSOC_SECTION_ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export type GqlProductToAwardBadge = GqlNode & {
  __typename?: 'ProductToAwardBadge';
  /** Reads a single `AwardBadge` that is related to this `ProductToAwardBadge`. */
  awardBadge: Maybe<GqlAwardBadge>;
  awardBadgeId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `ProductToAwardBadge`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToAwardBadge` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToAwardBadgeCondition = {
  /** Checks for equality with the object’s `awardBadgeId` field. */
  awardBadgeId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToAwardBadge` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToAwardBadgeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToAwardBadgeFilter>>;
  /** Filter by the object’s `awardBadgeId` field. */
  awardBadgeId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToAwardBadgeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToAwardBadgeFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToAwardBadge` */
export type GqlProductToAwardBadgeInput = {
  awardBadgeId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** Represents an update to a `ProductToAwardBadge`. Fields that are set will be updated. */
export type GqlProductToAwardBadgePatch = {
  awardBadgeId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToAwardBadge` values. */
export type GqlProductToAwardBadgesConnection = {
  __typename?: 'ProductToAwardBadgesConnection';
  /** A list of edges which contains the `ProductToAwardBadge` and cursor to aid in pagination. */
  edges: Array<GqlProductToAwardBadgesEdge>;
  /** A list of `ProductToAwardBadge` objects. */
  nodes: Array<Maybe<GqlProductToAwardBadge>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToAwardBadge` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToAwardBadge` edge in the connection. */
export type GqlProductToAwardBadgesEdge = {
  __typename?: 'ProductToAwardBadgesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToAwardBadge` at the end of the edge. */
  node: Maybe<GqlProductToAwardBadge>;
};

/** Methods to use when ordering `ProductToAwardBadge`. */
export enum ProductToAwardBadgesOrderBy {
  AwardBadgeIdAsc = 'AWARD_BADGE_ID_ASC',
  AwardBadgeIdDesc = 'AWARD_BADGE_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export type GqlProductToClient = GqlNode & {
  __typename?: 'ProductToClient';
  /** Reads a single `Organization` that is related to this `ProductToClient`. */
  client: Maybe<GqlOrganization>;
  clientId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `ProductToClient`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToClient` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToClientCondition = {
  /** Checks for equality with the object’s `clientId` field. */
  clientId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToClient` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToClientFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToClientFilter>>;
  /** Filter by the object’s `clientId` field. */
  clientId?: InputMaybe<GqlUuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToClientFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToClientFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToClient` */
export type GqlProductToClientInput = {
  clientId: Scalars['UUID'];
  productId: Scalars['Int'];
};

/** Represents an update to a `ProductToClient`. Fields that are set will be updated. */
export type GqlProductToClientPatch = {
  clientId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToClient` values. */
export type GqlProductToClientsConnection = {
  __typename?: 'ProductToClientsConnection';
  /** A list of edges which contains the `ProductToClient` and cursor to aid in pagination. */
  edges: Array<GqlProductToClientsEdge>;
  /** A list of `ProductToClient` objects. */
  nodes: Array<Maybe<GqlProductToClient>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToClient` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToClient` edge in the connection. */
export type GqlProductToClientsEdge = {
  __typename?: 'ProductToClientsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToClient` at the end of the edge. */
  node: Maybe<GqlProductToClient>;
};

/** Methods to use when ordering `ProductToClient`. */
export enum ProductToClientsOrderBy {
  ClientIdAsc = 'CLIENT_ID_ASC',
  ClientIdDesc = 'CLIENT_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export type GqlProductToCompetitor = GqlNode & {
  __typename?: 'ProductToCompetitor';
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  competitor: Maybe<GqlProduct>;
  competitorId: Scalars['Int'];
  locked: Scalars['Boolean'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `ProductToCompetitor`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToCompetitor` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToCompetitorCondition = {
  /** Checks for equality with the object’s `competitorId` field. */
  competitorId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `locked` field. */
  locked?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToCompetitor` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToCompetitorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToCompetitorFilter>>;
  /** Filter by the object’s `competitorId` field. */
  competitorId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `locked` field. */
  locked?: InputMaybe<GqlBooleanFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToCompetitorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToCompetitorFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToCompetitor` */
export type GqlProductToCompetitorInput = {
  competitorId: Scalars['Int'];
  locked?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId: Scalars['Int'];
};

/** Represents an update to a `ProductToCompetitor`. Fields that are set will be updated. */
export type GqlProductToCompetitorPatch = {
  competitorId?: InputMaybe<Scalars['Int']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToCompetitor` values. */
export type GqlProductToCompetitorsConnection = {
  __typename?: 'ProductToCompetitorsConnection';
  /** A list of edges which contains the `ProductToCompetitor` and cursor to aid in pagination. */
  edges: Array<GqlProductToCompetitorsEdge>;
  /** A list of `ProductToCompetitor` objects. */
  nodes: Array<Maybe<GqlProductToCompetitor>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToCompetitor` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToCompetitor` edge in the connection. */
export type GqlProductToCompetitorsEdge = {
  __typename?: 'ProductToCompetitorsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToCompetitor` at the end of the edge. */
  node: Maybe<GqlProductToCompetitor>;
};

/** Methods to use when ordering `ProductToCompetitor`. */
export enum ProductToCompetitorsOrderBy {
  CompetitorIdAsc = 'COMPETITOR_ID_ASC',
  CompetitorIdDesc = 'COMPETITOR_ID_DESC',
  LockedAsc = 'LOCKED_ASC',
  LockedDesc = 'LOCKED_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export type GqlProductToIntegration = GqlNode & {
  __typename?: 'ProductToIntegration';
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  integration: Maybe<GqlProduct>;
  integrationId: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  vendorId: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `ProductToIntegration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToIntegrationCondition = {
  /** Checks for equality with the object’s `integrationId` field. */
  integrationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `vendorId` field. */
  vendorId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToIntegration` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToIntegrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToIntegrationFilter>>;
  /** Filter by the object’s `integrationId` field. */
  integrationId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToIntegrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToIntegrationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `vendorId` field. */
  vendorId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToIntegration` */
export type GqlProductToIntegrationInput = {
  integrationId: Scalars['Int'];
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId: Scalars['Int'];
  vendorId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `ProductToIntegration`. Fields that are set will be updated. */
export type GqlProductToIntegrationPatch = {
  integrationId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToIntegration` values. */
export type GqlProductToIntegrationsConnection = {
  __typename?: 'ProductToIntegrationsConnection';
  /** A list of edges which contains the `ProductToIntegration` and cursor to aid in pagination. */
  edges: Array<GqlProductToIntegrationsEdge>;
  /** A list of `ProductToIntegration` objects. */
  nodes: Array<Maybe<GqlProductToIntegration>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToIntegration` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToIntegration` edge in the connection. */
export type GqlProductToIntegrationsEdge = {
  __typename?: 'ProductToIntegrationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToIntegration` at the end of the edge. */
  node: Maybe<GqlProductToIntegration>;
};

/** Methods to use when ordering `ProductToIntegration`. */
export enum ProductToIntegrationsOrderBy {
  IntegrationIdAsc = 'INTEGRATION_ID_ASC',
  IntegrationIdDesc = 'INTEGRATION_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  VendorIdAsc = 'VENDOR_ID_ASC',
  VendorIdDesc = 'VENDOR_ID_DESC'
}

export type GqlProductToOrganization = GqlNode & {
  __typename?: 'ProductToOrganization';
  createdAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `ProductToOrganization`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads a single `Product` that is related to this `ProductToOrganization`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToOrganization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToOrganizationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToOrganization` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToOrganizationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToOrganization` */
export type GqlProductToOrganizationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
};

/** Represents an update to a `ProductToOrganization`. Fields that are set will be updated. */
export type GqlProductToOrganizationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToOrganization` values. */
export type GqlProductToOrganizationsConnection = {
  __typename?: 'ProductToOrganizationsConnection';
  /** A list of edges which contains the `ProductToOrganization` and cursor to aid in pagination. */
  edges: Array<GqlProductToOrganizationsEdge>;
  /** A list of `ProductToOrganization` objects. */
  nodes: Array<Maybe<GqlProductToOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToOrganization` edge in the connection. */
export type GqlProductToOrganizationsEdge = {
  __typename?: 'ProductToOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToOrganization` at the end of the edge. */
  node: Maybe<GqlProductToOrganization>;
};

/** Methods to use when ordering `ProductToOrganization`. */
export enum ProductToOrganizationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export type GqlProductToPracticeGroup = GqlNode & {
  __typename?: 'ProductToPracticeGroup';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PracticeGroup` that is related to this `ProductToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  practiceGroupId: Scalars['Int'];
  /** Reads a single `Product` that is related to this `ProductToPracticeGroup`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToPracticeGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToPracticeGroupCondition = {
  /** Checks for equality with the object’s `practiceGroupId` field. */
  practiceGroupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToPracticeGroup` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToPracticeGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToPracticeGroupFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToPracticeGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToPracticeGroupFilter>>;
  /** Filter by the object’s `practiceGroupId` field. */
  practiceGroupId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToPracticeGroup` */
export type GqlProductToPracticeGroupInput = {
  practiceGroupId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** Represents an update to a `ProductToPracticeGroup`. Fields that are set will be updated. */
export type GqlProductToPracticeGroupPatch = {
  practiceGroupId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToPracticeGroup` values. */
export type GqlProductToPracticeGroupsConnection = {
  __typename?: 'ProductToPracticeGroupsConnection';
  /** A list of edges which contains the `ProductToPracticeGroup` and cursor to aid in pagination. */
  edges: Array<GqlProductToPracticeGroupsEdge>;
  /** A list of `ProductToPracticeGroup` objects. */
  nodes: Array<Maybe<GqlProductToPracticeGroup>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToPracticeGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToPracticeGroup` edge in the connection. */
export type GqlProductToPracticeGroupsEdge = {
  __typename?: 'ProductToPracticeGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToPracticeGroup` at the end of the edge. */
  node: Maybe<GqlProductToPracticeGroup>;
};

/** Methods to use when ordering `ProductToPracticeGroup`. */
export enum ProductToPracticeGroupsOrderBy {
  Natural = 'NATURAL',
  PracticeGroupIdAsc = 'PRACTICE_GROUP_ID_ASC',
  PracticeGroupIdDesc = 'PRACTICE_GROUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

export type GqlProductToSuiteListing = GqlNode & {
  __typename?: 'ProductToSuiteListing';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `ProductToSuiteListing`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `SuiteListing` that is related to this `ProductToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
  suiteListingId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToSuiteListing` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToSuiteListingCondition = {
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `suiteListingId` field. */
  suiteListingId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToSuiteListing` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToSuiteListingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToSuiteListingFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToSuiteListingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToSuiteListingFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `suiteListingId` field. */
  suiteListingId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToSuiteListing` */
export type GqlProductToSuiteListingInput = {
  productId: Scalars['Int'];
  suiteListingId: Scalars['Int'];
};

/** Represents an update to a `ProductToSuiteListing`. Fields that are set will be updated. */
export type GqlProductToSuiteListingPatch = {
  productId?: InputMaybe<Scalars['Int']>;
  suiteListingId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToSuiteListing` values. */
export type GqlProductToSuiteListingsConnection = {
  __typename?: 'ProductToSuiteListingsConnection';
  /** A list of edges which contains the `ProductToSuiteListing` and cursor to aid in pagination. */
  edges: Array<GqlProductToSuiteListingsEdge>;
  /** A list of `ProductToSuiteListing` objects. */
  nodes: Array<Maybe<GqlProductToSuiteListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToSuiteListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToSuiteListing` edge in the connection. */
export type GqlProductToSuiteListingsEdge = {
  __typename?: 'ProductToSuiteListingsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToSuiteListing` at the end of the edge. */
  node: Maybe<GqlProductToSuiteListing>;
};

/** Methods to use when ordering `ProductToSuiteListing`. */
export enum ProductToSuiteListingsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  SuiteListingIdAsc = 'SUITE_LISTING_ID_ASC',
  SuiteListingIdDesc = 'SUITE_LISTING_ID_DESC'
}

export type GqlProductToUser = GqlNode & {
  __typename?: 'ProductToUser';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `ProductToUser`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `User` that is related to this `ProductToUser`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `ProductToUser` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlProductToUserCondition = {
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `ProductToUser` object types. All fields are combined with a logical ‘and.’ */
export type GqlProductToUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlProductToUserFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlProductToUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlProductToUserFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `ProductToUser` */
export type GqlProductToUserInput = {
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** Represents an update to a `ProductToUser`. Fields that are set will be updated. */
export type GqlProductToUserPatch = {
  productId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `ProductToUser` values. */
export type GqlProductToUsersConnection = {
  __typename?: 'ProductToUsersConnection';
  /** A list of edges which contains the `ProductToUser` and cursor to aid in pagination. */
  edges: Array<GqlProductToUsersEdge>;
  /** A list of `ProductToUser` objects. */
  nodes: Array<Maybe<GqlProductToUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `ProductToUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `ProductToUser` edge in the connection. */
export type GqlProductToUsersEdge = {
  __typename?: 'ProductToUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `ProductToUser` at the end of the edge. */
  node: Maybe<GqlProductToUser>;
};

/** Methods to use when ordering `ProductToUser`. */
export enum ProductToUsersOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export enum ProductType {
  Service = 'SERVICE',
  Software = 'SOFTWARE'
}

/** A filter to be used against ProductType fields. All fields are combined with a logical ‘and.’ */
export type GqlProductTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProductType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProductType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProductType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProductType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProductType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProductType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProductType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProductType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProductType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProductType>>;
};

/** A connection to a list of `User` values, with data from `PersonalTechstack`. */
export type GqlProductUsersByPersonalTechstackProductIdAndUserIdManyToManyConnection = {
  __typename?: 'ProductUsersByPersonalTechstackProductIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `PersonalTechstack`, and the cursor to aid in pagination. */
  edges: Array<GqlProductUsersByPersonalTechstackProductIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `PersonalTechstack`. */
export type GqlProductUsersByPersonalTechstackProductIdAndUserIdManyToManyEdge = {
  __typename?: 'ProductUsersByPersonalTechstackProductIdAndUserIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  organizationId: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `User` values, with data from `ProductToUser`. */
export type GqlProductUsersByProductToUserProductIdAndUserIdManyToManyConnection = {
  __typename?: 'ProductUsersByProductToUserProductIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `ProductToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlProductUsersByProductToUserProductIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `ProductToUser`. */
export type GqlProductUsersByProductToUserProductIdAndUserIdManyToManyEdge = {
  __typename?: 'ProductUsersByProductToUserProductIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
};

/** A connection to a list of `User` values, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndAddedByManyToManyConnection = {
  __typename?: 'ProductUsersByTechstackProductIdAndAddedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlProductUsersByTechstackProductIdAndAddedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndAddedByManyToManyEdge = {
  __typename?: 'ProductUsersByTechstackProductIdAndAddedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedByConnection: GqlTechstacksConnection;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndAddedByManyToManyEdgeTechstacksByAddedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndAddedByManyToManyEdgeTechstacksByAddedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndOwnedByManyToManyConnection = {
  __typename?: 'ProductUsersByTechstackProductIdAndOwnedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlProductUsersByTechstackProductIdAndOwnedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndOwnedByManyToManyEdge = {
  __typename?: 'ProductUsersByTechstackProductIdAndOwnedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedByConnection: GqlTechstacksConnection;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndOwnedByManyToManyEdgeTechstacksByOwnedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlProductUsersByTechstackProductIdAndOwnedByManyToManyEdgeTechstacksByOwnedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UseCase`. */
export type GqlProductUsersByUseCaseProductIdAndAuthorManyToManyConnection = {
  __typename?: 'ProductUsersByUseCaseProductIdAndAuthorManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlProductUsersByUseCaseProductIdAndAuthorManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlProductUsersByUseCaseProductIdAndAuthorManyToManyEdge = {
  __typename?: 'ProductUsersByUseCaseProductIdAndAuthorManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthor: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthorConnection: GqlUseCasesConnection;
};


/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlProductUsersByUseCaseProductIdAndAuthorManyToManyEdgeUseCasesByAuthorArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlProductUsersByUseCaseProductIdAndAuthorManyToManyEdgeUseCasesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UserStory`. */
export type GqlProductUsersByUserStoryProductIdAndAuthorManyToManyConnection = {
  __typename?: 'ProductUsersByUserStoryProductIdAndAuthorManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlProductUsersByUserStoryProductIdAndAuthorManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UserStory`. */
export type GqlProductUsersByUserStoryProductIdAndAuthorManyToManyEdge = {
  __typename?: 'ProductUsersByUserStoryProductIdAndAuthorManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByAuthor: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByAuthorConnection: GqlUserStoriesConnection;
};


/** A `User` edge in the connection, with data from `UserStory`. */
export type GqlProductUsersByUserStoryProductIdAndAuthorManyToManyEdgeUserStoriesByAuthorArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UserStory`. */
export type GqlProductUsersByUserStoryProductIdAndAuthorManyToManyEdgeUserStoriesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** A connection to a list of `Product` values. */
export type GqlProductsConnection = {
  __typename?: 'ProductsConnection';
  /** A list of edges which contains the `Product` and cursor to aid in pagination. */
  edges: Array<GqlProductsEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection. */
export type GqlProductsEdge = {
  __typename?: 'ProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** Methods to use when ordering `Product`. */
export enum ProductsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  ExcerptAsc = 'EXCERPT_ASC',
  ExcerptDesc = 'EXCERPT_DESC',
  FeaturedAsc = 'FEATURED_ASC',
  FeaturedDesc = 'FEATURED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShowAsc = 'SHOW_ASC',
  ShowDesc = 'SHOW_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum PurchaseType {
  TestDrive = 'TEST_DRIVE',
  Theorem = 'THEOREM'
}

/** A filter to be used against PurchaseType fields. All fields are combined with a logical ‘and.’ */
export type GqlPurchaseTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PurchaseType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PurchaseType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PurchaseType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PurchaseType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PurchaseType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PurchaseType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PurchaseType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PurchaseType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PurchaseType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PurchaseType>>;
};

/** The root query type which gives access points into the data universe. */
export type GqlQuery = GqlNode & {
  __typename?: 'Query';
  assocHomeById: Maybe<GqlAssocHome>;
  /** Reads a set of `AssocHome`. */
  assocHomes: Maybe<Array<GqlAssocHome>>;
  /** Reads and enables pagination through a set of `AssocHome`. */
  assocHomesConnection: Maybe<GqlAssocHomesConnection>;
  assocSection: Maybe<GqlAssocSection>;
  /** Reads a single `AssocSection` using its globally unique `ID`. */
  assocSectionByNodeId: Maybe<GqlAssocSection>;
  /** Reads a set of `AssocSection`. */
  assocSections: Maybe<Array<GqlAssocSection>>;
  /** Reads and enables pagination through a set of `AssocSection`. */
  assocSectionsConnection: Maybe<GqlAssocSectionsConnection>;
  associationToOrganization: Maybe<GqlAssociationToOrganization>;
  /** Reads a single `AssociationToOrganization` using its globally unique `ID`. */
  associationToOrganizationByNodeId: Maybe<GqlAssociationToOrganization>;
  /** Reads a set of `AssociationToOrganization`. */
  associationToOrganizations: Maybe<Array<GqlAssociationToOrganization>>;
  /** Reads and enables pagination through a set of `AssociationToOrganization`. */
  associationToOrganizationsConnection: Maybe<GqlAssociationToOrganizationsConnection>;
  awardBadgeById: Maybe<GqlAwardBadge>;
  awardBadgeBySlug: Maybe<GqlAwardBadge>;
  /** Reads a set of `AwardBadge`. */
  awardBadges: Maybe<Array<GqlAwardBadge>>;
  /** Reads and enables pagination through a set of `AwardBadge`. */
  awardBadgesConnection: Maybe<GqlAwardBadgesConnection>;
  bestFor: Maybe<GqlBestFor>;
  /** Reads a single `BestFor` using its globally unique `ID`. */
  bestForByNodeId: Maybe<GqlBestFor>;
  bestForToProduct: Maybe<GqlBestForToProduct>;
  /** Reads a single `BestForToProduct` using its globally unique `ID`. */
  bestForToProductByNodeId: Maybe<GqlBestForToProduct>;
  /** Reads a set of `BestForToProduct`. */
  bestForToProducts: Maybe<Array<GqlBestForToProduct>>;
  /** Reads and enables pagination through a set of `BestForToProduct`. */
  bestForToProductsConnection: Maybe<GqlBestForToProductsConnection>;
  /** Reads a set of `BestFor`. */
  bestFors: Maybe<Array<GqlBestFor>>;
  /** Reads and enables pagination through a set of `BestFor`. */
  bestForsConnection: Maybe<GqlBestForsConnection>;
  /** Reads a set of `Category`. */
  categories: Maybe<Array<GqlCategory>>;
  /** Reads and enables pagination through a set of `Category`. */
  categoriesConnection: Maybe<GqlCategoriesConnection>;
  category: Maybe<GqlCategory>;
  /** Reads a single `Category` using its globally unique `ID`. */
  categoryByNodeId: Maybe<GqlCategory>;
  categoryToProduct: Maybe<GqlCategoryToProduct>;
  /** Reads a single `CategoryToProduct` using its globally unique `ID`. */
  categoryToProductByNodeId: Maybe<GqlCategoryToProduct>;
  /** Reads a set of `CategoryToProduct`. */
  categoryToProducts: Maybe<Array<GqlCategoryToProduct>>;
  /** Reads and enables pagination through a set of `CategoryToProduct`. */
  categoryToProductsConnection: Maybe<GqlCategoryToProductsConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  competitorsByIds: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  competitorsByIdsConnection: Maybe<GqlProductsConnection>;
  connectCustomer: Maybe<GqlConnectCustomer>;
  /** Reads a single `ConnectCustomer` using its globally unique `ID`. */
  connectCustomerByNodeId: Maybe<GqlConnectCustomer>;
  connectCustomerByUserIdAndAccountIdAndOrganizationId: Maybe<GqlConnectCustomer>;
  /** Reads a set of `ConnectCustomer`. */
  connectCustomers: Maybe<Array<GqlConnectCustomer>>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomersConnection: Maybe<GqlConnectCustomersConnection>;
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `ConnectPurchase` using its globally unique `ID`. */
  connectPurchaseByNodeId: Maybe<GqlConnectPurchase>;
  /** Reads a set of `ConnectPurchase`. */
  connectPurchases: Maybe<Array<GqlConnectPurchase>>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesConnection: Maybe<GqlConnectPurchasesConnection>;
  currentUserId: Maybe<Scalars['Int']>;
  diversityCertification: Maybe<GqlDiversityCertification>;
  /** Reads a single `DiversityCertification` using its globally unique `ID`. */
  diversityCertificationByNodeId: Maybe<GqlDiversityCertification>;
  /** Reads a set of `DiversityCertification`. */
  diversityCertifications: Maybe<Array<GqlDiversityCertification>>;
  /** Reads and enables pagination through a set of `DiversityCertification`. */
  diversityCertificationsConnection: Maybe<GqlDiversityCertificationsConnection>;
  feature: Maybe<GqlFeature>;
  /** Reads a single `Feature` using its globally unique `ID`. */
  featureByNodeId: Maybe<GqlFeature>;
  featureToProduct: Maybe<GqlFeatureToProduct>;
  /** Reads a single `FeatureToProduct` using its globally unique `ID`. */
  featureToProductByNodeId: Maybe<GqlFeatureToProduct>;
  /** Reads a set of `FeatureToProduct`. */
  featureToProducts: Maybe<Array<GqlFeatureToProduct>>;
  /** Reads and enables pagination through a set of `FeatureToProduct`. */
  featureToProductsConnection: Maybe<GqlFeatureToProductsConnection>;
  /** Reads a set of `Feature`. */
  features: Maybe<Array<GqlFeature>>;
  /** Reads and enables pagination through a set of `Feature`. */
  featuresConnection: Maybe<GqlFeaturesConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  getFeatureProductsByTermNames: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  getFeatureProductsByTermNamesConnection: Maybe<GqlProductsConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  getProductsByTermName: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  getProductsByTermNameConnection: Maybe<GqlProductsConnection>;
  lawfirmService: Maybe<GqlLawfirmService>;
  /** Reads a single `LawfirmService` using its globally unique `ID`. */
  lawfirmServiceByNodeId: Maybe<GqlLawfirmService>;
  /** Reads a set of `LawfirmService`. */
  lawfirmServices: Maybe<Array<GqlLawfirmService>>;
  /** Reads and enables pagination through a set of `LawfirmService`. */
  lawfirmServicesConnection: Maybe<GqlLawfirmServicesConnection>;
  listingCreatorById: Maybe<GqlListingCreator>;
  /** Reads a set of `ListingCreator`. */
  listingCreators: Maybe<Array<GqlListingCreator>>;
  /** Reads and enables pagination through a set of `ListingCreator`. */
  listingCreatorsConnection: Maybe<GqlListingCreatorsConnection>;
  location: Maybe<GqlLocation>;
  /** Reads a single `Location` using its globally unique `ID`. */
  locationByNodeId: Maybe<GqlLocation>;
  /** Reads a set of `Location`. */
  locations: Maybe<Array<GqlLocation>>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsConnection: Maybe<GqlLocationsConnection>;
  /** Fetches an object given its globally unique `ID`. */
  node: Maybe<GqlNode>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  notification: Maybe<GqlNotification>;
  /** Reads a single `Notification` using its globally unique `ID`. */
  notificationByNodeId: Maybe<GqlNotification>;
  /** Reads a set of `Notification`. */
  notifications: Maybe<Array<GqlNotification>>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection: Maybe<GqlNotificationsConnection>;
  noviMember: Maybe<GqlNoviMember>;
  /** Reads a single `NoviMember` using its globally unique `ID`. */
  noviMemberByNodeId: Maybe<GqlNoviMember>;
  /** Reads a set of `NoviMember`. */
  noviMembers: Maybe<Array<GqlNoviMember>>;
  /** Reads and enables pagination through a set of `NoviMember`. */
  noviMembersConnection: Maybe<GqlNoviMembersConnection>;
  noviOrganization: Maybe<GqlNoviOrganization>;
  /** Reads a single `NoviOrganization` using its globally unique `ID`. */
  noviOrganizationByNodeId: Maybe<GqlNoviOrganization>;
  /** Reads a set of `NoviOrganization`. */
  noviOrganizations: Maybe<Array<GqlNoviOrganization>>;
  /** Reads and enables pagination through a set of `NoviOrganization`. */
  noviOrganizationsConnection: Maybe<GqlNoviOrganizationsConnection>;
  organization: Maybe<GqlOrganization>;
  organizationByAuth0OrgId: Maybe<GqlOrganization>;
  /** Reads a single `Organization` using its globally unique `ID`. */
  organizationByNodeId: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationIds: Maybe<Array<Maybe<GqlOrganization>>>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationIdsConnection: Maybe<GqlOrganizationsConnection>;
  organizationListing: Maybe<GqlOrganizationListing>;
  /** Reads a single `OrganizationListing` using its globally unique `ID`. */
  organizationListingByNodeId: Maybe<GqlOrganizationListing>;
  /** Reads a set of `OrganizationListing`. */
  organizationListings: Maybe<Array<GqlOrganizationListing>>;
  /** Reads and enables pagination through a set of `OrganizationListing`. */
  organizationListingsConnection: Maybe<GqlOrganizationListingsConnection>;
  organizationTechstack: Maybe<GqlOrganizationTechstack>;
  /** Reads a single `OrganizationTechstack` using its globally unique `ID`. */
  organizationTechstackByNodeId: Maybe<GqlOrganizationTechstack>;
  /** Reads and enables pagination through a set of `Product`. */
  organizationTechstackFilter: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  organizationTechstackFilterConnection: Maybe<GqlProductsConnection>;
  /** Reads a set of `OrganizationTechstack`. */
  organizationTechstacks: Maybe<Array<GqlOrganizationTechstack>>;
  /** Reads and enables pagination through a set of `OrganizationTechstack`. */
  organizationTechstacksConnection: Maybe<GqlOrganizationTechstacksConnection>;
  /** Reads a set of `Organization`. */
  organizations: Maybe<Array<GqlOrganization>>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsConnection: Maybe<GqlOrganizationsConnection>;
  personalTechstack: Maybe<GqlPersonalTechstack>;
  /** Reads a single `PersonalTechstack` using its globally unique `ID`. */
  personalTechstackByNodeId: Maybe<GqlPersonalTechstack>;
  /** Reads a set of `PersonalTechstack`. */
  personalTechstacks: Maybe<Array<GqlPersonalTechstack>>;
  /** Reads and enables pagination through a set of `PersonalTechstack`. */
  personalTechstacksConnection: Maybe<GqlPersonalTechstacksConnection>;
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Reads a single `PracticeGroup` using its globally unique `ID`. */
  practiceGroupByNodeId: Maybe<GqlPracticeGroup>;
  /** Reads a set of `PracticeGroup`. */
  practiceGroups: Maybe<Array<GqlPracticeGroup>>;
  /** Reads and enables pagination through a set of `PracticeGroup`. */
  practiceGroupsConnection: Maybe<GqlPracticeGroupsConnection>;
  premiumInfoToTerm: Maybe<GqlPremiumInfoToTerm>;
  /** Reads a single `PremiumInfoToTerm` using its globally unique `ID`. */
  premiumInfoToTermByNodeId: Maybe<GqlPremiumInfoToTerm>;
  /** Reads a set of `PremiumInfoToTerm`. */
  premiumInfoToTerms: Maybe<Array<GqlPremiumInfoToTerm>>;
  /** Reads and enables pagination through a set of `PremiumInfoToTerm`. */
  premiumInfoToTermsConnection: Maybe<GqlPremiumInfoToTermsConnection>;
  premiumProductInfo: Maybe<GqlPremiumProductInfo>;
  premiumProductInfoByIdAndProductId: Maybe<GqlPremiumProductInfo>;
  /** Reads a single `PremiumProductInfo` using its globally unique `ID`. */
  premiumProductInfoByNodeId: Maybe<GqlPremiumProductInfo>;
  /** Reads a set of `PremiumProductInfo`. */
  premiumProductInfos: Maybe<Array<GqlPremiumProductInfo>>;
  /** Reads and enables pagination through a set of `PremiumProductInfo`. */
  premiumProductInfosConnection: Maybe<GqlPremiumProductInfosConnection>;
  product: Maybe<GqlProduct>;
  productAwardDetail: Maybe<GqlProductAwardDetail>;
  /** Reads a single `ProductAwardDetail` using its globally unique `ID`. */
  productAwardDetailByNodeId: Maybe<GqlProductAwardDetail>;
  /** Reads a set of `ProductAwardDetail`. */
  productAwardDetails: Maybe<Array<GqlProductAwardDetail>>;
  /** Reads and enables pagination through a set of `ProductAwardDetail`. */
  productAwardDetailsConnection: Maybe<GqlProductAwardDetailsConnection>;
  /** Reads a single `Product` using its globally unique `ID`. */
  productByNodeId: Maybe<GqlProduct>;
  productFeatureByTerm: Maybe<GqlProductFeatureByTerm>;
  /** Reads a single `ProductFeatureByTerm` using its globally unique `ID`. */
  productFeatureByTermByNodeId: Maybe<GqlProductFeatureByTerm>;
  /** Reads a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Maybe<Array<GqlProductFeatureByTerm>>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: Maybe<GqlProductFeatureByTermsConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  productIds: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  productIdsConnection: Maybe<GqlProductsConnection>;
  productListing: Maybe<GqlProductListing>;
  /** Reads a single `ProductListing` using its globally unique `ID`. */
  productListingByNodeId: Maybe<GqlProductListing>;
  productListingByProductIdAndAssociationId: Maybe<GqlProductListing>;
  /** Reads a set of `ProductListing`. */
  productListings: Maybe<Array<GqlProductListing>>;
  /** Reads and enables pagination through a set of `ProductListing`. */
  productListingsConnection: Maybe<GqlProductListingsConnection>;
  productSection: Maybe<GqlProductSection>;
  /** Reads a single `ProductSection` using its globally unique `ID`. */
  productSectionByNodeId: Maybe<GqlProductSection>;
  /** Reads a set of `ProductSection`. */
  productSections: Maybe<Array<GqlProductSection>>;
  /** Reads and enables pagination through a set of `ProductSection`. */
  productSectionsConnection: Maybe<GqlProductSectionsConnection>;
  productToAssocSection: Maybe<GqlProductToAssocSection>;
  /** Reads a single `ProductToAssocSection` using its globally unique `ID`. */
  productToAssocSectionByNodeId: Maybe<GqlProductToAssocSection>;
  /** Reads a set of `ProductToAssocSection`. */
  productToAssocSections: Maybe<Array<GqlProductToAssocSection>>;
  /** Reads and enables pagination through a set of `ProductToAssocSection`. */
  productToAssocSectionsConnection: Maybe<GqlProductToAssocSectionsConnection>;
  productToAwardBadge: Maybe<GqlProductToAwardBadge>;
  /** Reads a single `ProductToAwardBadge` using its globally unique `ID`. */
  productToAwardBadgeByNodeId: Maybe<GqlProductToAwardBadge>;
  /** Reads a set of `ProductToAwardBadge`. */
  productToAwardBadges: Maybe<Array<GqlProductToAwardBadge>>;
  /** Reads and enables pagination through a set of `ProductToAwardBadge`. */
  productToAwardBadgesConnection: Maybe<GqlProductToAwardBadgesConnection>;
  productToClient: Maybe<GqlProductToClient>;
  /** Reads a single `ProductToClient` using its globally unique `ID`. */
  productToClientByNodeId: Maybe<GqlProductToClient>;
  /** Reads a set of `ProductToClient`. */
  productToClients: Maybe<Array<GqlProductToClient>>;
  /** Reads and enables pagination through a set of `ProductToClient`. */
  productToClientsConnection: Maybe<GqlProductToClientsConnection>;
  productToCompetitor: Maybe<GqlProductToCompetitor>;
  /** Reads a single `ProductToCompetitor` using its globally unique `ID`. */
  productToCompetitorByNodeId: Maybe<GqlProductToCompetitor>;
  /** Reads a set of `ProductToCompetitor`. */
  productToCompetitors: Maybe<Array<GqlProductToCompetitor>>;
  /** Reads and enables pagination through a set of `ProductToCompetitor`. */
  productToCompetitorsConnection: Maybe<GqlProductToCompetitorsConnection>;
  productToIntegration: Maybe<GqlProductToIntegration>;
  /** Reads a single `ProductToIntegration` using its globally unique `ID`. */
  productToIntegrationByNodeId: Maybe<GqlProductToIntegration>;
  /** Reads a set of `ProductToIntegration`. */
  productToIntegrations: Maybe<Array<GqlProductToIntegration>>;
  /** Reads and enables pagination through a set of `ProductToIntegration`. */
  productToIntegrationsConnection: Maybe<GqlProductToIntegrationsConnection>;
  productToOrganization: Maybe<GqlProductToOrganization>;
  /** Reads a single `ProductToOrganization` using its globally unique `ID`. */
  productToOrganizationByNodeId: Maybe<GqlProductToOrganization>;
  /** Reads a set of `ProductToOrganization`. */
  productToOrganizations: Maybe<Array<GqlProductToOrganization>>;
  /** Reads and enables pagination through a set of `ProductToOrganization`. */
  productToOrganizationsConnection: Maybe<GqlProductToOrganizationsConnection>;
  productToPracticeGroup: Maybe<GqlProductToPracticeGroup>;
  /** Reads a single `ProductToPracticeGroup` using its globally unique `ID`. */
  productToPracticeGroupByNodeId: Maybe<GqlProductToPracticeGroup>;
  /** Reads a set of `ProductToPracticeGroup`. */
  productToPracticeGroups: Maybe<Array<GqlProductToPracticeGroup>>;
  /** Reads and enables pagination through a set of `ProductToPracticeGroup`. */
  productToPracticeGroupsConnection: Maybe<GqlProductToPracticeGroupsConnection>;
  productToSuiteListing: Maybe<GqlProductToSuiteListing>;
  /** Reads a single `ProductToSuiteListing` using its globally unique `ID`. */
  productToSuiteListingByNodeId: Maybe<GqlProductToSuiteListing>;
  /** Reads a set of `ProductToSuiteListing`. */
  productToSuiteListings: Maybe<Array<GqlProductToSuiteListing>>;
  /** Reads and enables pagination through a set of `ProductToSuiteListing`. */
  productToSuiteListingsConnection: Maybe<GqlProductToSuiteListingsConnection>;
  productToUser: Maybe<GqlProductToUser>;
  /** Reads a single `ProductToUser` using its globally unique `ID`. */
  productToUserByNodeId: Maybe<GqlProductToUser>;
  /** Reads a set of `ProductToUser`. */
  productToUsers: Maybe<Array<GqlProductToUser>>;
  /** Reads and enables pagination through a set of `ProductToUser`. */
  productToUsersConnection: Maybe<GqlProductToUsersConnection>;
  /** Reads a set of `Product`. */
  products: Maybe<Array<GqlProduct>>;
  /** Reads and enables pagination through a set of `Product`. */
  productsConnection: Maybe<GqlProductsConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  productsFilter: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  productsFilterConnection: Maybe<GqlProductsConnection>;
  /** Reads and enables pagination through a set of `Product`. */
  productsToLawfirm: Maybe<Array<Maybe<GqlProduct>>>;
  /** Reads and enables pagination through a set of `Product`. */
  productsToLawfirmConnection: Maybe<GqlProductsConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: GqlQuery;
  rfp: Maybe<GqlRfp>;
  /** Reads a single `Rfp` using its globally unique `ID`. */
  rfpByNodeId: Maybe<GqlRfp>;
  rfpToProduct: Maybe<GqlRfpToProduct>;
  /** Reads a single `RfpToProduct` using its globally unique `ID`. */
  rfpToProductByNodeId: Maybe<GqlRfpToProduct>;
  /** Reads a set of `RfpToProduct`. */
  rfpToProducts: Maybe<Array<GqlRfpToProduct>>;
  /** Reads and enables pagination through a set of `RfpToProduct`. */
  rfpToProductsConnection: Maybe<GqlRfpToProductsConnection>;
  /** Reads a set of `Rfp`. */
  rfps: Maybe<Array<GqlRfp>>;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfpsConnection: Maybe<GqlRfpsConnection>;
  scheduler: Maybe<GqlScheduler>;
  /** Reads a single `Scheduler` using its globally unique `ID`. */
  schedulerByNodeId: Maybe<GqlScheduler>;
  /** Reads a set of `Scheduler`. */
  schedulers: Maybe<Array<GqlScheduler>>;
  /** Reads and enables pagination through a set of `Scheduler`. */
  schedulersConnection: Maybe<GqlSchedulersConnection>;
  /** Reads and enables pagination through a set of `Organization`. */
  searchLawfirms: Maybe<Array<Maybe<GqlOrganization>>>;
  /** Reads and enables pagination through a set of `Organization`. */
  searchLawfirmsConnection: Maybe<GqlOrganizationsConnection>;
  sectionLayout: Maybe<GqlSectionLayout>;
  /** Reads a single `SectionLayout` using its globally unique `ID`. */
  sectionLayoutByNodeId: Maybe<GqlSectionLayout>;
  /** Reads a set of `SectionLayout`. */
  sectionLayouts: Maybe<Array<GqlSectionLayout>>;
  /** Reads and enables pagination through a set of `SectionLayout`. */
  sectionLayoutsConnection: Maybe<GqlSectionLayoutsConnection>;
  simpleService: Maybe<GqlSimpleService>;
  /** Reads a single `SimpleService` using its globally unique `ID`. */
  simpleServiceByNodeId: Maybe<GqlSimpleService>;
  simpleServiceByOrganizationIdAndTermId: Maybe<GqlSimpleService>;
  /** Reads a set of `SimpleService`. */
  simpleServices: Maybe<Array<GqlSimpleService>>;
  /** Reads and enables pagination through a set of `SimpleService`. */
  simpleServicesConnection: Maybe<GqlSimpleServicesConnection>;
  slugify: Maybe<Scalars['String']>;
  stackshareOption: Maybe<GqlStackshareOption>;
  /** Reads a single `StackshareOption` using its globally unique `ID`. */
  stackshareOptionByNodeId: Maybe<GqlStackshareOption>;
  /** Reads a set of `StackshareOption`. */
  stackshareOptions: Maybe<Array<GqlStackshareOption>>;
  /** Reads and enables pagination through a set of `StackshareOption`. */
  stackshareOptionsConnection: Maybe<GqlStackshareOptionsConnection>;
  stripeAccount: Maybe<GqlStripeAccount>;
  /** Reads a single `StripeAccount` using its globally unique `ID`. */
  stripeAccountByNodeId: Maybe<GqlStripeAccount>;
  /** Reads a set of `StripeAccount`. */
  stripeAccounts: Maybe<Array<GqlStripeAccount>>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccountsConnection: Maybe<GqlStripeAccountsConnection>;
  stripeCustomer: Maybe<GqlStripeCustomer>;
  /** Reads a single `StripeCustomer` using its globally unique `ID`. */
  stripeCustomerByNodeId: Maybe<GqlStripeCustomer>;
  /** Reads a set of `StripeCustomer`. */
  stripeCustomers: Maybe<Array<GqlStripeCustomer>>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersConnection: Maybe<GqlStripeCustomersConnection>;
  stripePurchase: Maybe<GqlStripePurchase>;
  /** Reads a single `StripePurchase` using its globally unique `ID`. */
  stripePurchaseByNodeId: Maybe<GqlStripePurchase>;
  /** Reads a set of `StripePurchase`. */
  stripePurchases: Maybe<Array<GqlStripePurchase>>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesConnection: Maybe<GqlStripePurchasesConnection>;
  stripeSeat: Maybe<GqlStripeSeat>;
  /** Reads a single `StripeSeat` using its globally unique `ID`. */
  stripeSeatByNodeId: Maybe<GqlStripeSeat>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatIds: Maybe<Array<Maybe<GqlStripeSeat>>>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatIdsConnection: Maybe<GqlStripeSeatsConnection>;
  /** Reads a set of `StripeSeat`. */
  stripeSeats: Maybe<Array<GqlStripeSeat>>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatsConnection: Maybe<GqlStripeSeatsConnection>;
  suiteListing: Maybe<GqlSuiteListing>;
  /** Reads a single `SuiteListing` using its globally unique `ID`. */
  suiteListingByNodeId: Maybe<GqlSuiteListing>;
  /** Reads a set of `SuiteListing`. */
  suiteListings: Maybe<Array<GqlSuiteListing>>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsConnection: Maybe<GqlSuiteListingsConnection>;
  /** Reads a set of `Taxonomy`. */
  taxonomies: Maybe<Array<GqlTaxonomy>>;
  /** Reads and enables pagination through a set of `Taxonomy`. */
  taxonomiesConnection: Maybe<GqlTaxonomiesConnection>;
  taxonomy: Maybe<GqlTaxonomy>;
  /** Reads a single `Taxonomy` using its globally unique `ID`. */
  taxonomyByNodeId: Maybe<GqlTaxonomy>;
  techstack: Maybe<GqlTechstack>;
  /** Reads a single `Techstack` using its globally unique `ID`. */
  techstackByNodeId: Maybe<GqlTechstack>;
  techstackByOrganizationIdAndProductId: Maybe<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstackFilter: Maybe<Array<Maybe<GqlTechstack>>>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstackFilterConnection: Maybe<GqlTechstacksConnection>;
  /** Reads a set of `Techstack`. */
  techstacks: Maybe<Array<GqlTechstack>>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: Maybe<GqlTechstacksConnection>;
  /** Reads a set of `TempDatum`. */
  tempData: Maybe<Array<GqlTempDatum>>;
  /** Reads and enables pagination through a set of `TempDatum`. */
  tempDataConnection: Maybe<GqlTempDataConnection>;
  tempDatumById: Maybe<GqlTempDatum>;
  term: Maybe<GqlTerm>;
  /** Reads a single `Term` using its globally unique `ID`. */
  termByNodeId: Maybe<GqlTerm>;
  termToOrganization: Maybe<GqlTermToOrganization>;
  /** Reads a single `TermToOrganization` using its globally unique `ID`. */
  termToOrganizationByNodeId: Maybe<GqlTermToOrganization>;
  /** Reads a set of `TermToOrganization`. */
  termToOrganizations: Maybe<Array<GqlTermToOrganization>>;
  /** Reads and enables pagination through a set of `TermToOrganization`. */
  termToOrganizationsConnection: Maybe<GqlTermToOrganizationsConnection>;
  termToProduct: Maybe<GqlTermToProduct>;
  /** Reads a single `TermToProduct` using its globally unique `ID`. */
  termToProductByNodeId: Maybe<GqlTermToProduct>;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProductByTermIds: Maybe<Array<Maybe<GqlTermToProduct>>>;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProductByTermIdsConnection: Maybe<GqlTermToProductsConnection>;
  /** Reads a set of `TermToProduct`. */
  termToProducts: Maybe<Array<GqlTermToProduct>>;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProductsConnection: Maybe<GqlTermToProductsConnection>;
  termToRfp: Maybe<GqlTermToRfp>;
  /** Reads a single `TermToRfp` using its globally unique `ID`. */
  termToRfpByNodeId: Maybe<GqlTermToRfp>;
  /** Reads a set of `TermToRfp`. */
  termToRfps: Maybe<Array<GqlTermToRfp>>;
  /** Reads and enables pagination through a set of `TermToRfp`. */
  termToRfpsConnection: Maybe<GqlTermToRfpsConnection>;
  termToSuiteListing: Maybe<GqlTermToSuiteListing>;
  /** Reads a single `TermToSuiteListing` using its globally unique `ID`. */
  termToSuiteListingByNodeId: Maybe<GqlTermToSuiteListing>;
  /** Reads a set of `TermToSuiteListing`. */
  termToSuiteListings: Maybe<Array<GqlTermToSuiteListing>>;
  /** Reads and enables pagination through a set of `TermToSuiteListing`. */
  termToSuiteListingsConnection: Maybe<GqlTermToSuiteListingsConnection>;
  termToTestDrive: Maybe<GqlTermToTestDrive>;
  /** Reads a single `TermToTestDrive` using its globally unique `ID`. */
  termToTestDriveByNodeId: Maybe<GqlTermToTestDrive>;
  /** Reads a set of `TermToTestDrive`. */
  termToTestDrives: Maybe<Array<GqlTermToTestDrive>>;
  /** Reads and enables pagination through a set of `TermToTestDrive`. */
  termToTestDrivesConnection: Maybe<GqlTermToTestDrivesConnection>;
  termToUser: Maybe<GqlTermToUser>;
  /** Reads a single `TermToUser` using its globally unique `ID`. */
  termToUserByNodeId: Maybe<GqlTermToUser>;
  /** Reads a set of `TermToUserStory`. */
  termToUserStories: Maybe<Array<GqlTermToUserStory>>;
  /** Reads and enables pagination through a set of `TermToUserStory`. */
  termToUserStoriesConnection: Maybe<GqlTermToUserStoriesConnection>;
  termToUserStory: Maybe<GqlTermToUserStory>;
  /** Reads a single `TermToUserStory` using its globally unique `ID`. */
  termToUserStoryByNodeId: Maybe<GqlTermToUserStory>;
  /** Reads a set of `TermToUser`. */
  termToUsers: Maybe<Array<GqlTermToUser>>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: Maybe<GqlTermToUsersConnection>;
  termToVendorStackshare: Maybe<GqlTermToVendorStackshare>;
  /** Reads a single `TermToVendorStackshare` using its globally unique `ID`. */
  termToVendorStackshareByNodeId: Maybe<GqlTermToVendorStackshare>;
  /** Reads a set of `TermToVendorStackshare`. */
  termToVendorStackshares: Maybe<Array<GqlTermToVendorStackshare>>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStacksharesConnection: Maybe<GqlTermToVendorStacksharesConnection>;
  /** Reads a set of `Term`. */
  terms: Maybe<Array<GqlTerm>>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTaxonomyIds: Maybe<Array<Maybe<GqlTerm>>>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTaxonomyIdsConnection: Maybe<GqlTermsConnection>;
  /** Reads and enables pagination through a set of `Term`. */
  termsConnection: Maybe<GqlTermsConnection>;
  termscout: Maybe<GqlTermscout>;
  /** Reads a single `Termscout` using its globally unique `ID`. */
  termscoutByNodeId: Maybe<GqlTermscout>;
  /** Reads and enables pagination through a set of `Termscout`. */
  termscoutIds: Maybe<Array<Maybe<GqlTermscout>>>;
  /** Reads and enables pagination through a set of `Termscout`. */
  termscoutIdsConnection: Maybe<GqlTermscoutsConnection>;
  /** Reads a set of `Termscout`. */
  termscouts: Maybe<Array<GqlTermscout>>;
  /** Reads and enables pagination through a set of `Termscout`. */
  termscoutsConnection: Maybe<GqlTermscoutsConnection>;
  testDrive: Maybe<GqlTestDrive>;
  /** Reads a single `TestDrive` using its globally unique `ID`. */
  testDriveByNodeId: Maybe<GqlTestDrive>;
  /** Reads a set of `TestDrive`. */
  testDrives: Maybe<Array<GqlTestDrive>>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesConnection: Maybe<GqlTestDrivesConnection>;
  theoremProduct: Maybe<GqlTheoremProduct>;
  /** Reads a single `TheoremProduct` using its globally unique `ID`. */
  theoremProductByNodeId: Maybe<GqlTheoremProduct>;
  theoremProductByStripeProductId: Maybe<GqlTheoremProduct>;
  theoremProductByTestStripeProductId: Maybe<GqlTheoremProduct>;
  /** Reads and enables pagination through a set of `TheoremProduct`. */
  theoremProductIds: Maybe<Array<Maybe<GqlTheoremProduct>>>;
  /** Reads and enables pagination through a set of `TheoremProduct`. */
  theoremProductIdsConnection: Maybe<GqlTheoremProductsConnection>;
  /** Reads a set of `TheoremProduct`. */
  theoremProducts: Maybe<Array<GqlTheoremProduct>>;
  /** Reads and enables pagination through a set of `TheoremProduct`. */
  theoremProductsConnection: Maybe<GqlTheoremProductsConnection>;
  useCase: Maybe<GqlUseCase>;
  /** Reads a single `UseCase` using its globally unique `ID`. */
  useCaseByNodeId: Maybe<GqlUseCase>;
  /** Reads a set of `UseCase`. */
  useCases: Maybe<Array<GqlUseCase>>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: Maybe<GqlUseCasesConnection>;
  user: Maybe<GqlUser>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId: Maybe<GqlUser>;
  /** Reads a set of `UserStory`. */
  userStories: Maybe<Array<GqlUserStory>>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: Maybe<GqlUserStoriesConnection>;
  userStory: Maybe<GqlUserStory>;
  /** Reads a single `UserStory` using its globally unique `ID`. */
  userStoryByNodeId: Maybe<GqlUserStory>;
  userToOrgStack: Maybe<GqlUserToOrgStack>;
  /** Reads a single `UserToOrgStack` using its globally unique `ID`. */
  userToOrgStackByNodeId: Maybe<GqlUserToOrgStack>;
  /** Reads a set of `UserToOrgStack`. */
  userToOrgStacks: Maybe<Array<GqlUserToOrgStack>>;
  /** Reads and enables pagination through a set of `UserToOrgStack`. */
  userToOrgStacksConnection: Maybe<GqlUserToOrgStacksConnection>;
  userWithinOrg: Maybe<Array<Maybe<Scalars['Int']>>>;
  userWithinOrgConnection: Maybe<GqlUserWithinOrgConnection>;
  /** Reads a set of `User`. */
  users: Maybe<Array<GqlUser>>;
  /** Reads and enables pagination through a set of `User`. */
  usersConnection: Maybe<GqlUsersConnection>;
  /** Reads and enables pagination through a set of `User`. */
  usersIds: Maybe<Array<Maybe<GqlUser>>>;
  /** Reads and enables pagination through a set of `User`. */
  usersIdsConnection: Maybe<GqlUsersConnection>;
  usersInOrg: Maybe<GqlUser>;
  usersToOrganization: Maybe<GqlUsersToOrganization>;
  /** Reads a single `UsersToOrganization` using its globally unique `ID`. */
  usersToOrganizationByNodeId: Maybe<GqlUsersToOrganization>;
  /** Reads a set of `UsersToOrganization`. */
  usersToOrganizations: Maybe<Array<GqlUsersToOrganization>>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: Maybe<GqlUsersToOrganizationsConnection>;
  usersToPracticeGroup: Maybe<GqlUsersToPracticeGroup>;
  /** Reads a single `UsersToPracticeGroup` using its globally unique `ID`. */
  usersToPracticeGroupByNodeId: Maybe<GqlUsersToPracticeGroup>;
  /** Reads a set of `UsersToPracticeGroup`. */
  usersToPracticeGroups: Maybe<Array<GqlUsersToPracticeGroup>>;
  /** Reads and enables pagination through a set of `UsersToPracticeGroup`. */
  usersToPracticeGroupsConnection: Maybe<GqlUsersToPracticeGroupsConnection>;
  usersToTechstack: Maybe<GqlUsersToTechstack>;
  /** Reads a single `UsersToTechstack` using its globally unique `ID`. */
  usersToTechstackByNodeId: Maybe<GqlUsersToTechstack>;
  /** Reads a set of `UsersToTechstack`. */
  usersToTechstacks: Maybe<Array<GqlUsersToTechstack>>;
  /** Reads and enables pagination through a set of `UsersToTechstack`. */
  usersToTechstacksConnection: Maybe<GqlUsersToTechstacksConnection>;
  vendorStackshareLogo: Maybe<GqlVendorStackshareLogo>;
  /** Reads a single `VendorStackshareLogo` using its globally unique `ID`. */
  vendorStackshareLogoByNodeId: Maybe<GqlVendorStackshareLogo>;
  /** Reads a set of `VendorStackshareLogo`. */
  vendorStackshareLogos: Maybe<Array<GqlVendorStackshareLogo>>;
  /** Reads and enables pagination through a set of `VendorStackshareLogo`. */
  vendorStackshareLogosConnection: Maybe<GqlVendorStackshareLogosConnection>;
  viewer: Maybe<GqlUser>;
  viewersCurrentOrganization: Maybe<GqlOrganization>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocHomeByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocHomesArgs = {
  condition: InputMaybe<GqlAssocHomeCondition>;
  filter: InputMaybe<GqlAssocHomeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssocHomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocHomesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssocHomeCondition>;
  filter: InputMaybe<GqlAssocHomeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssocHomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocSectionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocSectionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocSectionsArgs = {
  condition: InputMaybe<GqlAssocSectionCondition>;
  filter: InputMaybe<GqlAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssocSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssocSectionsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssocSectionCondition>;
  filter: InputMaybe<GqlAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssociationToOrganizationArgs = {
  associationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssociationToOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssociationToOrganizationsArgs = {
  condition: InputMaybe<GqlAssociationToOrganizationCondition>;
  filter: InputMaybe<GqlAssociationToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAssociationToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAssociationToOrganizationCondition>;
  filter: InputMaybe<GqlAssociationToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAwardBadgeByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAwardBadgeBySlugArgs = {
  slug: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAwardBadgesArgs = {
  condition: InputMaybe<GqlAwardBadgeCondition>;
  filter: InputMaybe<GqlAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<AwardBadgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryAwardBadgesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlAwardBadgeCondition>;
  filter: InputMaybe<GqlAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AwardBadgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForToProductArgs = {
  bestForId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForToProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForToProductsArgs = {
  condition: InputMaybe<GqlBestForToProductCondition>;
  filter: InputMaybe<GqlBestForToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<BestForToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlBestForToProductCondition>;
  filter: InputMaybe<GqlBestForToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForsArgs = {
  condition: InputMaybe<GqlBestForCondition>;
  filter: InputMaybe<GqlBestForFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<BestForsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryBestForsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlBestForCondition>;
  filter: InputMaybe<GqlBestForFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<BestForsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoriesArgs = {
  condition: InputMaybe<GqlCategoryCondition>;
  filter: InputMaybe<GqlCategoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<CategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlCategoryCondition>;
  filter: InputMaybe<GqlCategoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoryArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoryToProductArgs = {
  categoryId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoryToProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoryToProductsArgs = {
  condition: InputMaybe<GqlCategoryToProductCondition>;
  filter: InputMaybe<GqlCategoryToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<CategoryToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCategoryToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlCategoryToProductCondition>;
  filter: InputMaybe<GqlCategoryToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCompetitorsByIdsArgs = {
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryCompetitorsByIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectCustomerArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectCustomerByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectCustomerByUserIdAndAccountIdAndOrganizationIdArgs = {
  accountId: Scalars['String'];
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectCustomersArgs = {
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectPurchaseArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectPurchaseByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectPurchasesArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryConnectPurchasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryDiversityCertificationArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryDiversityCertificationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryDiversityCertificationsArgs = {
  condition: InputMaybe<GqlDiversityCertificationCondition>;
  filter: InputMaybe<GqlDiversityCertificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryDiversityCertificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlDiversityCertificationCondition>;
  filter: InputMaybe<GqlDiversityCertificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeatureArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeatureByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeatureToProductArgs = {
  featureId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeatureToProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeatureToProductsArgs = {
  condition: InputMaybe<GqlFeatureToProductCondition>;
  filter: InputMaybe<GqlFeatureToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<FeatureToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeatureToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlFeatureToProductCondition>;
  filter: InputMaybe<GqlFeatureToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeaturesArgs = {
  condition: InputMaybe<GqlFeatureCondition>;
  filter: InputMaybe<GqlFeatureFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<FeaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryFeaturesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlFeatureCondition>;
  filter: InputMaybe<GqlFeatureFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryGetFeatureProductsByTermNamesArgs = {
  assocId: InputMaybe<Scalars['UUID']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  termNames: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryGetFeatureProductsByTermNamesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  assocId: InputMaybe<Scalars['UUID']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  termNames: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryGetProductsByTermNameArgs = {
  assocId: InputMaybe<Scalars['UUID']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  termNames: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryGetProductsByTermNameConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  assocId: InputMaybe<Scalars['UUID']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  termNames: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLawfirmServiceArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLawfirmServiceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLawfirmServicesArgs = {
  condition: InputMaybe<GqlLawfirmServiceCondition>;
  filter: InputMaybe<GqlLawfirmServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LawfirmServicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLawfirmServicesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLawfirmServiceCondition>;
  filter: InputMaybe<GqlLawfirmServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LawfirmServicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryListingCreatorByIdArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryListingCreatorsArgs = {
  condition: InputMaybe<GqlListingCreatorCondition>;
  filter: InputMaybe<GqlListingCreatorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ListingCreatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryListingCreatorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlListingCreatorCondition>;
  filter: InputMaybe<GqlListingCreatorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ListingCreatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLocationArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLocationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLocationsArgs = {
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryLocationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNotificationArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNotificationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNotificationsArgs = {
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNotificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviMemberArgs = {
  noviMemberId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviMemberByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviMembersArgs = {
  condition: InputMaybe<GqlNoviMemberCondition>;
  filter: InputMaybe<GqlNoviMemberFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NoviMembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviMembersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNoviMemberCondition>;
  filter: InputMaybe<GqlNoviMemberFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoviMembersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviOrganizationArgs = {
  organizationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviOrganizationsArgs = {
  condition: InputMaybe<GqlNoviOrganizationCondition>;
  filter: InputMaybe<GqlNoviOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryNoviOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNoviOrganizationCondition>;
  filter: InputMaybe<GqlNoviOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationByAuth0OrgIdArgs = {
  auth0OrgId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationIdsArgs = {
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationListingArgs = {
  associationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationListingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationListingsArgs = {
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationListingCondition>;
  filter: InputMaybe<GqlOrganizationListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationTechstackArgs = {
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationTechstackByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationTechstackFilterArgs = {
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  selectedOrganizationId: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationTechstackFilterConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  selectedOrganizationId: InputMaybe<Scalars['UUID']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationTechstacksArgs = {
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationTechstackCondition>;
  filter: InputMaybe<GqlOrganizationTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationsArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPersonalTechstackArgs = {
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPersonalTechstackByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPersonalTechstacksArgs = {
  condition: InputMaybe<GqlPersonalTechstackCondition>;
  filter: InputMaybe<GqlPersonalTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPersonalTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPersonalTechstackCondition>;
  filter: InputMaybe<GqlPersonalTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPracticeGroupArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPracticeGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPracticeGroupsArgs = {
  condition: InputMaybe<GqlPracticeGroupCondition>;
  filter: InputMaybe<GqlPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PracticeGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPracticeGroupCondition>;
  filter: InputMaybe<GqlPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumInfoToTermArgs = {
  premiumInfoId: Scalars['Int'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumInfoToTermByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumInfoToTermsArgs = {
  condition: InputMaybe<GqlPremiumInfoToTermCondition>;
  filter: InputMaybe<GqlPremiumInfoToTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumInfoToTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPremiumInfoToTermCondition>;
  filter: InputMaybe<GqlPremiumInfoToTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumProductInfoArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumProductInfoByIdAndProductIdArgs = {
  id: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumProductInfoByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumProductInfosArgs = {
  condition: InputMaybe<GqlPremiumProductInfoCondition>;
  filter: InputMaybe<GqlPremiumProductInfoFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryPremiumProductInfosConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPremiumProductInfoCondition>;
  filter: InputMaybe<GqlPremiumProductInfoFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductAwardDetailArgs = {
  productId: Scalars['Int'];
  year: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductAwardDetailByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductAwardDetailsArgs = {
  condition: InputMaybe<GqlProductAwardDetailCondition>;
  filter: InputMaybe<GqlProductAwardDetailFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductAwardDetailsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductAwardDetailCondition>;
  filter: InputMaybe<GqlProductAwardDetailFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductFeatureByTermArgs = {
  networkId: Scalars['UUID'];
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductFeatureByTermByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductIdsArgs = {
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductListingArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductListingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductListingByProductIdAndAssociationIdArgs = {
  associationId: Scalars['UUID'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductListingsArgs = {
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductListingCondition>;
  filter: InputMaybe<GqlProductListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductSectionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductSectionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductSectionsArgs = {
  condition: InputMaybe<GqlProductSectionCondition>;
  filter: InputMaybe<GqlProductSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductSectionsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductSectionCondition>;
  filter: InputMaybe<GqlProductSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAssocSectionArgs = {
  assocSectionId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAssocSectionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAssocSectionsArgs = {
  condition: InputMaybe<GqlProductToAssocSectionCondition>;
  filter: InputMaybe<GqlProductToAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAssocSectionsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToAssocSectionCondition>;
  filter: InputMaybe<GqlProductToAssocSectionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAwardBadgeArgs = {
  awardBadgeId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAwardBadgeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAwardBadgesArgs = {
  condition: InputMaybe<GqlProductToAwardBadgeCondition>;
  filter: InputMaybe<GqlProductToAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToAwardBadgesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToAwardBadgeCondition>;
  filter: InputMaybe<GqlProductToAwardBadgeFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToClientArgs = {
  clientId: Scalars['UUID'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToClientByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToClientsArgs = {
  condition: InputMaybe<GqlProductToClientCondition>;
  filter: InputMaybe<GqlProductToClientFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToClientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToClientsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToClientCondition>;
  filter: InputMaybe<GqlProductToClientFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToCompetitorArgs = {
  competitorId: Scalars['Int'];
  locked: Scalars['Boolean'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToCompetitorByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToCompetitorsArgs = {
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToCompetitorsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToCompetitorCondition>;
  filter: InputMaybe<GqlProductToCompetitorFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToIntegrationArgs = {
  integrationId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToIntegrationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToIntegrationsArgs = {
  condition: InputMaybe<GqlProductToIntegrationCondition>;
  filter: InputMaybe<GqlProductToIntegrationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToIntegrationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToIntegrationCondition>;
  filter: InputMaybe<GqlProductToIntegrationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToOrganizationArgs = {
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToOrganizationsArgs = {
  condition: InputMaybe<GqlProductToOrganizationCondition>;
  filter: InputMaybe<GqlProductToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToOrganizationCondition>;
  filter: InputMaybe<GqlProductToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToPracticeGroupArgs = {
  practiceGroupId: Scalars['Int'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToPracticeGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToPracticeGroupsArgs = {
  condition: InputMaybe<GqlProductToPracticeGroupCondition>;
  filter: InputMaybe<GqlProductToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToPracticeGroupCondition>;
  filter: InputMaybe<GqlProductToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToSuiteListingArgs = {
  productId: Scalars['Int'];
  suiteListingId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToSuiteListingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToSuiteListingsArgs = {
  condition: InputMaybe<GqlProductToSuiteListingCondition>;
  filter: InputMaybe<GqlProductToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToSuiteListingCondition>;
  filter: InputMaybe<GqlProductToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToUserArgs = {
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToUsersArgs = {
  condition: InputMaybe<GqlProductToUserCondition>;
  filter: InputMaybe<GqlProductToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToUserCondition>;
  filter: InputMaybe<GqlProductToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductsArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductsFilterArgs = {
  bestForIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  integrationIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isFreeTrial: InputMaybe<Scalars['Boolean']>;
  isFreeVersion: InputMaybe<Scalars['Boolean']>;
  isPerUser: InputMaybe<Scalars['Boolean']>;
  offset: InputMaybe<Scalars['Int']>;
  practiceGroupIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  subcategoryIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  termIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductsFilterConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  bestForIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  categoryIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  integrationIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  isFreeTrial: InputMaybe<Scalars['Boolean']>;
  isFreeVersion: InputMaybe<Scalars['Boolean']>;
  isPerUser: InputMaybe<Scalars['Boolean']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  practiceGroupIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  subcategoryIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  termIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductsToLawfirmArgs = {
  companyid: InputMaybe<Scalars['Int']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryProductsToLawfirmConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  companyid: InputMaybe<Scalars['Int']>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpToProductArgs = {
  productId: Scalars['Int'];
  rfpId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpToProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpToProductsArgs = {
  condition: InputMaybe<GqlRfpToProductCondition>;
  filter: InputMaybe<GqlRfpToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpToProductCondition>;
  filter: InputMaybe<GqlRfpToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpsArgs = {
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryRfpsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySchedulerArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySchedulerByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySchedulersArgs = {
  condition: InputMaybe<GqlSchedulerCondition>;
  filter: InputMaybe<GqlSchedulerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SchedulersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySchedulersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSchedulerCondition>;
  filter: InputMaybe<GqlSchedulerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SchedulersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySearchLawfirmsArgs = {
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  search: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySearchLawfirmsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  search: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySectionLayoutArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySectionLayoutByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySectionLayoutsArgs = {
  condition: InputMaybe<GqlSectionLayoutCondition>;
  filter: InputMaybe<GqlSectionLayoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SectionLayoutsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySectionLayoutsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSectionLayoutCondition>;
  filter: InputMaybe<GqlSectionLayoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SectionLayoutsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySimpleServiceArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySimpleServiceByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySimpleServiceByOrganizationIdAndTermIdArgs = {
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySimpleServicesArgs = {
  condition: InputMaybe<GqlSimpleServiceCondition>;
  filter: InputMaybe<GqlSimpleServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SimpleServicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySimpleServicesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSimpleServiceCondition>;
  filter: InputMaybe<GqlSimpleServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySlugifyArgs = {
  value: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStackshareOptionArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStackshareOptionByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStackshareOptionsArgs = {
  condition: InputMaybe<GqlStackshareOptionCondition>;
  filter: InputMaybe<GqlStackshareOptionFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StackshareOptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStackshareOptionsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStackshareOptionCondition>;
  filter: InputMaybe<GqlStackshareOptionFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StackshareOptionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeAccountArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeAccountByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeAccountsArgs = {
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeAccountsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeCustomerArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeCustomerByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeCustomersArgs = {
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripePurchaseArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripePurchaseByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripePurchasesArgs = {
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripePurchasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripePurchasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeSeatArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeSeatByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeSeatIdsArgs = {
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeSeatIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeSeatsArgs = {
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeSeatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryStripeSeatsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySuiteListingArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySuiteListingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySuiteListingsArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQuerySuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTaxonomiesArgs = {
  condition: InputMaybe<GqlTaxonomyCondition>;
  filter: InputMaybe<GqlTaxonomyFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TaxonomiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTaxonomiesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTaxonomyCondition>;
  filter: InputMaybe<GqlTaxonomyFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaxonomiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTaxonomyArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTaxonomyByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstackArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstackByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstackByOrganizationIdAndProductIdArgs = {
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstackFilterArgs = {
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orgId: InputMaybe<Scalars['UUID']>;
  userIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstackFilterConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orgId: InputMaybe<Scalars['UUID']>;
  userIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTempDataArgs = {
  condition: InputMaybe<GqlTempDatumCondition>;
  filter: InputMaybe<GqlTempDatumFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TempDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTempDataConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTempDatumCondition>;
  filter: InputMaybe<GqlTempDatumFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TempDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTempDatumByIdArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToOrganizationArgs = {
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToOrganizationsArgs = {
  condition: InputMaybe<GqlTermToOrganizationCondition>;
  filter: InputMaybe<GqlTermToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToOrganizationCondition>;
  filter: InputMaybe<GqlTermToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToProductArgs = {
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToProductByTermIdsArgs = {
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  termIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToProductByTermIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  termIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToProductsArgs = {
  condition: InputMaybe<GqlTermToProductCondition>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToProductCondition>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToRfpArgs = {
  rfpId: Scalars['Int'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToRfpByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToRfpsArgs = {
  condition: InputMaybe<GqlTermToRfpCondition>;
  filter: InputMaybe<GqlTermToRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToRfpsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToRfpsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToRfpCondition>;
  filter: InputMaybe<GqlTermToRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToSuiteListingArgs = {
  suiteListingId: Scalars['Int'];
  termId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToSuiteListingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToSuiteListingsArgs = {
  condition: InputMaybe<GqlTermToSuiteListingCondition>;
  filter: InputMaybe<GqlTermToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToSuiteListingCondition>;
  filter: InputMaybe<GqlTermToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToTestDriveArgs = {
  termId: Scalars['Int'];
  testDriveId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToTestDriveByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToTestDrivesArgs = {
  condition: InputMaybe<GqlTermToTestDriveCondition>;
  filter: InputMaybe<GqlTermToTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToTestDriveCondition>;
  filter: InputMaybe<GqlTermToTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUserArgs = {
  termId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUserStoriesArgs = {
  condition: InputMaybe<GqlTermToUserStoryCondition>;
  filter: InputMaybe<GqlTermToUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserStoryCondition>;
  filter: InputMaybe<GqlTermToUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUserStoryArgs = {
  termId: Scalars['Int'];
  userStoryId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUserStoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToVendorStackshareArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToVendorStackshareByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToVendorStacksharesArgs = {
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermToVendorStacksharesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermsArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermsByTaxonomyIdsArgs = {
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  taxonomyIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermsByTaxonomyIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  taxonomyIds: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermscoutArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermscoutByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermscoutIdsArgs = {
  filter: InputMaybe<GqlTermscoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermscoutIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlTermscoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermscoutsArgs = {
  condition: InputMaybe<GqlTermscoutCondition>;
  filter: InputMaybe<GqlTermscoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermscoutsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTermscoutsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermscoutCondition>;
  filter: InputMaybe<GqlTermscoutFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermscoutsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTestDriveArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTestDriveByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTestDrivesArgs = {
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TestDrivesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductByStripeProductIdArgs = {
  stripeProductId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductByTestStripeProductIdArgs = {
  testStripeProductId: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductIdsArgs = {
  filter: InputMaybe<GqlTheoremProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlTheoremProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductsArgs = {
  condition: InputMaybe<GqlTheoremProductCondition>;
  filter: InputMaybe<GqlTheoremProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TheoremProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryTheoremProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTheoremProductCondition>;
  filter: InputMaybe<GqlTheoremProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TheoremProductsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUseCaseArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUseCaseByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserStoryArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserStoryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserToOrgStackArgs = {
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserToOrgStackByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserToOrgStacksArgs = {
  condition: InputMaybe<GqlUserToOrgStackCondition>;
  filter: InputMaybe<GqlUserToOrgStackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserToOrgStacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserToOrgStackCondition>;
  filter: InputMaybe<GqlUserToOrgStackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserWithinOrgArgs = {
  filter: InputMaybe<GqlIntFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUserWithinOrgConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlIntFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersIdsArgs = {
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersIdsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  ids: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToOrganizationArgs = {
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToOrganizationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToPracticeGroupArgs = {
  practiceGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToPracticeGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToPracticeGroupsArgs = {
  condition: InputMaybe<GqlUsersToPracticeGroupCondition>;
  filter: InputMaybe<GqlUsersToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToPracticeGroupCondition>;
  filter: InputMaybe<GqlUsersToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToTechstackArgs = {
  techstackId: Scalars['Int'];
  userId: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToTechstackByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToTechstacksArgs = {
  condition: InputMaybe<GqlUsersToTechstackCondition>;
  filter: InputMaybe<GqlUsersToTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryUsersToTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToTechstackCondition>;
  filter: InputMaybe<GqlUsersToTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryVendorStackshareLogoArgs = {
  id: Scalars['Int'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryVendorStackshareLogoByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryVendorStackshareLogosArgs = {
  condition: InputMaybe<GqlVendorStackshareLogoCondition>;
  filter: InputMaybe<GqlVendorStackshareLogoFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type GqlQueryVendorStackshareLogosConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlVendorStackshareLogoCondition>;
  filter: InputMaybe<GqlVendorStackshareLogoFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};

/** All input for the `replaceTermToUserStory` mutation. */
export type GqlReplaceTermToUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  story?: InputMaybe<Scalars['Int']>;
};

/** The output of our `replaceTermToUserStory` mutation. */
export type GqlReplaceTermToUserStoryPayload = {
  __typename?: 'ReplaceTermToUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  termToProducts: Maybe<Array<Maybe<GqlTermToProduct>>>;
};

export type GqlRfp = GqlNode & {
  __typename?: 'Rfp';
  createdAt: Maybe<Scalars['Datetime']>;
  details: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Product`. */
  productsByRfpToProductRfpIdAndProductId: GqlRfpProductsByRfpToProductRfpIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByRfpToProductRfpIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `RfpToProduct`. */
  rfpToProducts: Array<GqlRfpToProduct>;
  /** Reads and enables pagination through a set of `RfpToProduct`. */
  rfpToProductsConnection: GqlRfpToProductsConnection;
  /** Reads and enables pagination through a set of `TermToRfp`. */
  termToRfps: Array<GqlTermToRfp>;
  /** Reads and enables pagination through a set of `TermToRfp`. */
  termToRfpsConnection: GqlTermToRfpsConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToRfpRfpIdAndTermId: GqlRfpTermsByTermToRfpRfpIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToRfpRfpIdAndTermIdList: Array<GqlTerm>;
  updatedAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `Rfp`. */
  user: Maybe<GqlUser>;
  userId: Maybe<Scalars['Int']>;
};


export type GqlRfpProductsByRfpToProductRfpIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlRfpProductsByRfpToProductRfpIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlRfpRfpToProductsArgs = {
  condition: InputMaybe<GqlRfpToProductCondition>;
  filter: InputMaybe<GqlRfpToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpToProductsOrderBy>>;
};


export type GqlRfpRfpToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpToProductCondition>;
  filter: InputMaybe<GqlRfpToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};


export type GqlRfpTermToRfpsArgs = {
  condition: InputMaybe<GqlTermToRfpCondition>;
  filter: InputMaybe<GqlTermToRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToRfpsOrderBy>>;
};


export type GqlRfpTermToRfpsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToRfpCondition>;
  filter: InputMaybe<GqlTermToRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};


export type GqlRfpTermsByTermToRfpRfpIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlRfpTermsByTermToRfpRfpIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};

/** A condition to be used against `Rfp` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlRfpCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Rfp` object types. All fields are combined with a logical ‘and.’ */
export type GqlRfpFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlRfpFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlRfpFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlRfpFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `Rfp` */
export type GqlRfpInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Rfp`. Fields that are set will be updated. */
export type GqlRfpPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `Product` values, with data from `RfpToProduct`. */
export type GqlRfpProductsByRfpToProductRfpIdAndProductIdManyToManyConnection = {
  __typename?: 'RfpProductsByRfpToProductRfpIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `RfpToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlRfpProductsByRfpToProductRfpIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `RfpToProduct`. */
export type GqlRfpProductsByRfpToProductRfpIdAndProductIdManyToManyEdge = {
  __typename?: 'RfpProductsByRfpToProductRfpIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `Term` values, with data from `TermToRfp`. */
export type GqlRfpTermsByTermToRfpRfpIdAndTermIdManyToManyConnection = {
  __typename?: 'RfpTermsByTermToRfpRfpIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToRfp`, and the cursor to aid in pagination. */
  edges: Array<GqlRfpTermsByTermToRfpRfpIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToRfp`. */
export type GqlRfpTermsByTermToRfpRfpIdAndTermIdManyToManyEdge = {
  __typename?: 'RfpTermsByTermToRfpRfpIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

export type GqlRfpToProduct = GqlNode & {
  __typename?: 'RfpToProduct';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `RfpToProduct`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `Rfp` that is related to this `RfpToProduct`. */
  rfp: Maybe<GqlRfp>;
  rfpId: Scalars['Int'];
};

/**
 * A condition to be used against `RfpToProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlRfpToProductCondition = {
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `rfpId` field. */
  rfpId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `RfpToProduct` object types. All fields are combined with a logical ‘and.’ */
export type GqlRfpToProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlRfpToProductFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlRfpToProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlRfpToProductFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `rfpId` field. */
  rfpId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `RfpToProduct` */
export type GqlRfpToProductInput = {
  productId: Scalars['Int'];
  rfpId: Scalars['Int'];
};

/** Represents an update to a `RfpToProduct`. Fields that are set will be updated. */
export type GqlRfpToProductPatch = {
  productId?: InputMaybe<Scalars['Int']>;
  rfpId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `RfpToProduct` values. */
export type GqlRfpToProductsConnection = {
  __typename?: 'RfpToProductsConnection';
  /** A list of edges which contains the `RfpToProduct` and cursor to aid in pagination. */
  edges: Array<GqlRfpToProductsEdge>;
  /** A list of `RfpToProduct` objects. */
  nodes: Array<Maybe<GqlRfpToProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `RfpToProduct` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RfpToProduct` edge in the connection. */
export type GqlRfpToProductsEdge = {
  __typename?: 'RfpToProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `RfpToProduct` at the end of the edge. */
  node: Maybe<GqlRfpToProduct>;
};

/** Methods to use when ordering `RfpToProduct`. */
export enum RfpToProductsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  RfpIdAsc = 'RFP_ID_ASC',
  RfpIdDesc = 'RFP_ID_DESC'
}

/** A connection to a list of `Rfp` values. */
export type GqlRfpsConnection = {
  __typename?: 'RfpsConnection';
  /** A list of edges which contains the `Rfp` and cursor to aid in pagination. */
  edges: Array<GqlRfpsEdge>;
  /** A list of `Rfp` objects. */
  nodes: Array<Maybe<GqlRfp>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Rfp` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Rfp` edge in the connection. */
export type GqlRfpsEdge = {
  __typename?: 'RfpsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Rfp` at the end of the edge. */
  node: Maybe<GqlRfp>;
};

/** Methods to use when ordering `Rfp`. */
export enum RfpsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlScheduler = GqlNode & {
  __typename?: 'Scheduler';
  createdAt: Maybe<Scalars['Datetime']>;
  days: Maybe<Scalars['Int']>;
  details: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  scheduledDate: Maybe<Scalars['Datetime']>;
  type: SchedulerType;
  updatedAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `Scheduler`. */
  user: Maybe<GqlUser>;
  userId: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `Scheduler` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlSchedulerCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `days` field. */
  days?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scheduledDate` field. */
  scheduledDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SchedulerType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `Scheduler` object types. All fields are combined with a logical ‘and.’ */
export type GqlSchedulerFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlSchedulerFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `days` field. */
  days?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlSchedulerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlSchedulerFilter>>;
  /** Filter by the object’s `scheduledDate` field. */
  scheduledDate?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlSchedulerTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `Scheduler` */
export type GqlSchedulerInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  days?: InputMaybe<Scalars['Int']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  scheduledDate?: InputMaybe<Scalars['Datetime']>;
  type: SchedulerType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `Scheduler`. Fields that are set will be updated. */
export type GqlSchedulerPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  days?: InputMaybe<Scalars['Int']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  scheduledDate?: InputMaybe<Scalars['Datetime']>;
  type?: InputMaybe<SchedulerType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export enum SchedulerType {
  VStripeAccount = 'V_STRIPE_ACCOUNT',
  VUpgradePayment = 'V_UPGRADE_PAYMENT'
}

/** A filter to be used against SchedulerType fields. All fields are combined with a logical ‘and.’ */
export type GqlSchedulerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SchedulerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SchedulerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SchedulerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SchedulerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SchedulerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SchedulerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SchedulerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SchedulerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SchedulerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SchedulerType>>;
};

/** A connection to a list of `Scheduler` values. */
export type GqlSchedulersConnection = {
  __typename?: 'SchedulersConnection';
  /** A list of edges which contains the `Scheduler` and cursor to aid in pagination. */
  edges: Array<GqlSchedulersEdge>;
  /** A list of `Scheduler` objects. */
  nodes: Array<Maybe<GqlScheduler>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Scheduler` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Scheduler` edge in the connection. */
export type GqlSchedulersEdge = {
  __typename?: 'SchedulersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Scheduler` at the end of the edge. */
  node: Maybe<GqlScheduler>;
};

/** Methods to use when ordering `Scheduler`. */
export enum SchedulersOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DaysAsc = 'DAYS_ASC',
  DaysDesc = 'DAYS_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ScheduledDateAsc = 'SCHEDULED_DATE_ASC',
  ScheduledDateDesc = 'SCHEDULED_DATE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlSectionLayout = GqlNode & {
  __typename?: 'SectionLayout';
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  type: SectionLayoutType;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `SectionLayout` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlSectionLayoutCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SectionLayoutType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SectionLayout` object types. All fields are combined with a logical ‘and.’ */
export type GqlSectionLayoutFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlSectionLayoutFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlSectionLayoutFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlSectionLayoutFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlSectionLayoutTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `SectionLayout` */
export type GqlSectionLayoutInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  type: SectionLayoutType;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `SectionLayout`. Fields that are set will be updated. */
export type GqlSectionLayoutPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<SectionLayoutType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum SectionLayoutType {
  Basic = 'BASIC',
  CategoryList = 'CATEGORY_LIST',
  LargeProduct = 'LARGE_PRODUCT',
  ProductsGrid = 'PRODUCTS_GRID',
  ProductsSlider = 'PRODUCTS_SLIDER',
  ProductType = 'PRODUCT_TYPE',
  TheoremFeatures = 'THEOREM_FEATURES'
}

/** A filter to be used against SectionLayoutType fields. All fields are combined with a logical ‘and.’ */
export type GqlSectionLayoutTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SectionLayoutType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SectionLayoutType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SectionLayoutType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SectionLayoutType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SectionLayoutType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SectionLayoutType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SectionLayoutType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SectionLayoutType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SectionLayoutType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SectionLayoutType>>;
};

/** A connection to a list of `SectionLayout` values. */
export type GqlSectionLayoutsConnection = {
  __typename?: 'SectionLayoutsConnection';
  /** A list of edges which contains the `SectionLayout` and cursor to aid in pagination. */
  edges: Array<GqlSectionLayoutsEdge>;
  /** A list of `SectionLayout` objects. */
  nodes: Array<Maybe<GqlSectionLayout>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `SectionLayout` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SectionLayout` edge in the connection. */
export type GqlSectionLayoutsEdge = {
  __typename?: 'SectionLayoutsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SectionLayout` at the end of the edge. */
  node: Maybe<GqlSectionLayout>;
};

/** Methods to use when ordering `SectionLayout`. */
export enum SectionLayoutsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlSimpleService = GqlNode & {
  __typename?: 'SimpleService';
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  /** Reads a single `Organization` that is related to this `SimpleService`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads a single `Term` that is related to this `SimpleService`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `SimpleService` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlSimpleServiceCondition = {
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `SimpleService` object types. All fields are combined with a logical ‘and.’ */
export type GqlSimpleServiceFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlSimpleServiceFilter>>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlSimpleServiceFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlSimpleServiceFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `SimpleService` */
export type GqlSimpleServiceInput = {
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};

/** Represents an update to a `SimpleService`. Fields that are set will be updated. */
export type GqlSimpleServicePatch = {
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `SimpleService` values. */
export type GqlSimpleServicesConnection = {
  __typename?: 'SimpleServicesConnection';
  /** A list of edges which contains the `SimpleService` and cursor to aid in pagination. */
  edges: Array<GqlSimpleServicesEdge>;
  /** A list of `SimpleService` objects. */
  nodes: Array<Maybe<GqlSimpleService>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `SimpleService` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SimpleService` edge in the connection. */
export type GqlSimpleServicesEdge = {
  __typename?: 'SimpleServicesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SimpleService` at the end of the edge. */
  node: Maybe<GqlSimpleService>;
};

/** Methods to use when ordering `SimpleService`. */
export enum SimpleServicesOrderBy {
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

export type GqlStackshareOption = GqlNode & {
  __typename?: 'StackshareOption';
  id: Scalars['Int'];
  networkId: Maybe<Scalars['UUID']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  productId: Scalars['Int'];
};

/**
 * A condition to be used against `StackshareOption` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlStackshareOptionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `networkId` field. */
  networkId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `StackshareOption` object types. All fields are combined with a logical ‘and.’ */
export type GqlStackshareOptionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlStackshareOptionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `networkId` field. */
  networkId?: InputMaybe<GqlUuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlStackshareOptionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlStackshareOptionFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `StackshareOption` */
export type GqlStackshareOptionInput = {
  id?: InputMaybe<Scalars['Int']>;
  networkId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
};

/** Represents an update to a `StackshareOption`. Fields that are set will be updated. */
export type GqlStackshareOptionPatch = {
  id?: InputMaybe<Scalars['Int']>;
  networkId?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `StackshareOption` values. */
export type GqlStackshareOptionsConnection = {
  __typename?: 'StackshareOptionsConnection';
  /** A list of edges which contains the `StackshareOption` and cursor to aid in pagination. */
  edges: Array<GqlStackshareOptionsEdge>;
  /** A list of `StackshareOption` objects. */
  nodes: Array<Maybe<GqlStackshareOption>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `StackshareOption` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StackshareOption` edge in the connection. */
export type GqlStackshareOptionsEdge = {
  __typename?: 'StackshareOptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `StackshareOption` at the end of the edge. */
  node: Maybe<GqlStackshareOption>;
};

/** Methods to use when ordering `StackshareOption`. */
export enum StackshareOptionsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  NetworkIdAsc = 'NETWORK_ID_ASC',
  NetworkIdDesc = 'NETWORK_ID_DESC',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC'
}

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type GqlStringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

export type GqlStripeAccount = GqlNode & {
  __typename?: 'StripeAccount';
  accountId: Maybe<Scalars['String']>;
  createdAt: Maybe<Scalars['Datetime']>;
  detailsSubmitted: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `StripeAccount`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  refreshToken: Maybe<Scalars['String']>;
  testMode: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `StripeAccount`. */
  user: Maybe<GqlUser>;
  userId: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `StripeAccount` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlStripeAccountCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `detailsSubmitted` field. */
  detailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `refreshToken` field. */
  refreshToken?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `StripeAccount` object types. All fields are combined with a logical ‘and.’ */
export type GqlStripeAccountFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<GqlStringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlStripeAccountFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `detailsSubmitted` field. */
  detailsSubmitted?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlStripeAccountFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlStripeAccountFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `refreshToken` field. */
  refreshToken?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `StripeAccount` */
export type GqlStripeAccountInput = {
  accountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  detailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `StripeAccount`. Fields that are set will be updated. */
export type GqlStripeAccountPatch = {
  accountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  detailsSubmitted?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `StripeAccount` values. */
export type GqlStripeAccountsConnection = {
  __typename?: 'StripeAccountsConnection';
  /** A list of edges which contains the `StripeAccount` and cursor to aid in pagination. */
  edges: Array<GqlStripeAccountsEdge>;
  /** A list of `StripeAccount` objects. */
  nodes: Array<Maybe<GqlStripeAccount>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `StripeAccount` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StripeAccount` edge in the connection. */
export type GqlStripeAccountsEdge = {
  __typename?: 'StripeAccountsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `StripeAccount` at the end of the edge. */
  node: Maybe<GqlStripeAccount>;
};

/** Methods to use when ordering `StripeAccount`. */
export enum StripeAccountsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsSubmittedAsc = 'DETAILS_SUBMITTED_ASC',
  DetailsSubmittedDesc = 'DETAILS_SUBMITTED_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RefreshTokenAsc = 'REFRESH_TOKEN_ASC',
  RefreshTokenDesc = 'REFRESH_TOKEN_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlStripeCustomer = GqlNode & {
  __typename?: 'StripeCustomer';
  accountId: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  customerId: Scalars['String'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `StripeCustomer`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  testMode: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `StripeCustomer`. */
  user: Maybe<GqlUser>;
  userId: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `StripeCustomer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlStripeCustomerCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerId` field. */
  customerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `StripeCustomer` object types. All fields are combined with a logical ‘and.’ */
export type GqlStripeCustomerFilter = {
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<GqlStringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlStripeCustomerFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `customerId` field. */
  customerId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlStripeCustomerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlStripeCustomerFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `StripeCustomer` */
export type GqlStripeCustomerInput = {
  accountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `StripeCustomer`. Fields that are set will be updated. */
export type GqlStripeCustomerPatch = {
  accountId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `StripeCustomer` values. */
export type GqlStripeCustomersConnection = {
  __typename?: 'StripeCustomersConnection';
  /** A list of edges which contains the `StripeCustomer` and cursor to aid in pagination. */
  edges: Array<GqlStripeCustomersEdge>;
  /** A list of `StripeCustomer` objects. */
  nodes: Array<Maybe<GqlStripeCustomer>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `StripeCustomer` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StripeCustomer` edge in the connection. */
export type GqlStripeCustomersEdge = {
  __typename?: 'StripeCustomersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `StripeCustomer` at the end of the edge. */
  node: Maybe<GqlStripeCustomer>;
};

/** Methods to use when ordering `StripeCustomer`. */
export enum StripeCustomersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlStripePurchase = GqlNode & {
  __typename?: 'StripePurchase';
  createdAt: Maybe<Scalars['Datetime']>;
  customerId: Maybe<Scalars['String']>;
  expiresAt: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `StripePurchase`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsBySuiteListingStripePurchaseIdAndOrganizationId: GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsBySuiteListingStripePurchaseIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads a single `User` that is related to this `StripePurchase`. */
  owner: Maybe<GqlUser>;
  ownerId: Maybe<Scalars['Int']>;
  priceId: Maybe<Scalars['String']>;
  stripeProductId: Maybe<Scalars['String']>;
  subscriptionId: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListings: Array<GqlSuiteListing>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsConnection: GqlSuiteListingsConnection;
  testMode: Scalars['Boolean'];
  type: PurchaseType;
  updatedAt: Maybe<Scalars['Datetime']>;
};


export type GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlStripePurchaseSuiteListingsArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlStripePurchaseSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

/**
 * A condition to be used against `StripePurchase` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlStripePurchaseCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `customerId` field. */
  customerId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ownerId` field. */
  ownerId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `priceId` field. */
  priceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `stripeProductId` field. */
  stripeProductId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<PurchaseType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `StripePurchase` object types. All fields are combined with a logical ‘and.’ */
export type GqlStripePurchaseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlStripePurchaseFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `customerId` field. */
  customerId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlStripePurchaseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlStripePurchaseFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `ownerId` field. */
  ownerId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `priceId` field. */
  priceId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `stripeProductId` field. */
  stripeProductId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlPurchaseTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `StripePurchase` */
export type GqlStripePurchaseInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  priceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PurchaseType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Organization` values, with data from `SuiteListing`. */
export type GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'StripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `SuiteListing`, and the cursor to aid in pagination. */
  edges: Array<GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `SuiteListing`. */
export type GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'StripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListings: Array<GqlSuiteListing>;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsConnection: GqlSuiteListingsConnection;
};


/** A `Organization` edge in the connection, with data from `SuiteListing`. */
export type GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyEdgeSuiteListingsArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `SuiteListing`. */
export type GqlStripePurchaseOrganizationsBySuiteListingStripePurchaseIdAndOrganizationIdManyToManyEdgeSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

/** Represents an update to a `StripePurchase`. Fields that are set will be updated. */
export type GqlStripePurchasePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  customerId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerId?: InputMaybe<Scalars['Int']>;
  priceId?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PurchaseType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `StripePurchase` values. */
export type GqlStripePurchasesConnection = {
  __typename?: 'StripePurchasesConnection';
  /** A list of edges which contains the `StripePurchase` and cursor to aid in pagination. */
  edges: Array<GqlStripePurchasesEdge>;
  /** A list of `StripePurchase` objects. */
  nodes: Array<Maybe<GqlStripePurchase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `StripePurchase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StripePurchase` edge in the connection. */
export type GqlStripePurchasesEdge = {
  __typename?: 'StripePurchasesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `StripePurchase` at the end of the edge. */
  node: Maybe<GqlStripePurchase>;
};

/** Methods to use when ordering `StripePurchase`. */
export enum StripePurchasesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CustomerIdAsc = 'CUSTOMER_ID_ASC',
  CustomerIdDesc = 'CUSTOMER_ID_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OwnerIdAsc = 'OWNER_ID_ASC',
  OwnerIdDesc = 'OWNER_ID_DESC',
  PriceIdAsc = 'PRICE_ID_ASC',
  PriceIdDesc = 'PRICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StripeProductIdAsc = 'STRIPE_PRODUCT_ID_ASC',
  StripeProductIdDesc = 'STRIPE_PRODUCT_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlStripeSeat = GqlNode & {
  __typename?: 'StripeSeat';
  createdAt: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `StripeSeat`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  stripeProductId: Maybe<Scalars['String']>;
  subscriptionId: Maybe<Scalars['String']>;
  testMode: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `StripeSeat`. */
  user: Maybe<GqlUser>;
  userId: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `StripeSeat` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlStripeSeatCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stripeProductId` field. */
  stripeProductId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `StripeSeat` object types. All fields are combined with a logical ‘and.’ */
export type GqlStripeSeatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlStripeSeatFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlStripeSeatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlStripeSeatFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `stripeProductId` field. */
  stripeProductId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `subscriptionId` field. */
  subscriptionId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `StripeSeat` */
export type GqlStripeSeatInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Represents an update to a `StripeSeat`. Fields that are set will be updated. */
export type GqlStripeSeatPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `StripeSeat` values. */
export type GqlStripeSeatsConnection = {
  __typename?: 'StripeSeatsConnection';
  /** A list of edges which contains the `StripeSeat` and cursor to aid in pagination. */
  edges: Array<GqlStripeSeatsEdge>;
  /** A list of `StripeSeat` objects. */
  nodes: Array<Maybe<GqlStripeSeat>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `StripeSeat` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `StripeSeat` edge in the connection. */
export type GqlStripeSeatsEdge = {
  __typename?: 'StripeSeatsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `StripeSeat` at the end of the edge. */
  node: Maybe<GqlStripeSeat>;
};

/** Methods to use when ordering `StripeSeat`. */
export enum StripeSeatsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StripeProductIdAsc = 'STRIPE_PRODUCT_ID_ASC',
  StripeProductIdDesc = 'STRIPE_PRODUCT_ID_DESC',
  SubscriptionIdAsc = 'SUBSCRIPTION_ID_ASC',
  SubscriptionIdDesc = 'SUBSCRIPTION_ID_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlSuiteListing = GqlNode & {
  __typename?: 'SuiteListing';
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  details: Scalars['JSON'];
  excerpt: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `SuiteListing`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `ProductToSuiteListing`. */
  productToSuiteListings: Array<GqlProductToSuiteListing>;
  /** Reads and enables pagination through a set of `ProductToSuiteListing`. */
  productToSuiteListingsConnection: GqlProductToSuiteListingsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToSuiteListingSuiteListingIdAndProductId: GqlSuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToSuiteListingSuiteListingIdAndProductIdList: Array<GqlProduct>;
  show: Scalars['Boolean'];
  slug: Scalars['String'];
  state: ProductState;
  /** Reads a single `StripePurchase` that is related to this `SuiteListing`. */
  stripePurchase: Maybe<GqlStripePurchase>;
  stripePurchaseId: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `TermToSuiteListing`. */
  termToSuiteListings: Array<GqlTermToSuiteListing>;
  /** Reads and enables pagination through a set of `TermToSuiteListing`. */
  termToSuiteListingsConnection: GqlTermToSuiteListingsConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToSuiteListingSuiteListingIdAndTermId: GqlSuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToSuiteListingSuiteListingIdAndTermIdList: Array<GqlTerm>;
  testMode: Scalars['Boolean'];
  type: ProductType;
  updatedAt: Scalars['Datetime'];
};


export type GqlSuiteListingProductToSuiteListingsArgs = {
  condition: InputMaybe<GqlProductToSuiteListingCondition>;
  filter: InputMaybe<GqlProductToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};


export type GqlSuiteListingProductToSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToSuiteListingCondition>;
  filter: InputMaybe<GqlProductToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};


export type GqlSuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlSuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlSuiteListingTermToSuiteListingsArgs = {
  condition: InputMaybe<GqlTermToSuiteListingCondition>;
  filter: InputMaybe<GqlTermToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};


export type GqlSuiteListingTermToSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToSuiteListingCondition>;
  filter: InputMaybe<GqlTermToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};


export type GqlSuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlSuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};

/**
 * A condition to be used against `SuiteListing` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlSuiteListingCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `excerpt` field. */
  excerpt?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `show` field. */
  show?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<ProductState>;
  /** Checks for equality with the object’s `stripePurchaseId` field. */
  stripePurchaseId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ProductType>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `SuiteListing` object types. All fields are combined with a logical ‘and.’ */
export type GqlSuiteListingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlSuiteListingFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `excerpt` field. */
  excerpt?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlSuiteListingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlSuiteListingFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `show` field. */
  show?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `state` field. */
  state?: InputMaybe<GqlProductStateFilter>;
  /** Filter by the object’s `stripePurchaseId` field. */
  stripePurchaseId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<GqlProductTypeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `SuiteListing` */
export type GqlSuiteListingInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  show?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ProductState>;
  stripePurchaseId?: InputMaybe<Scalars['Int']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ProductType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `SuiteListing`. Fields that are set will be updated. */
export type GqlSuiteListingPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  details?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  show?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<ProductState>;
  stripePurchaseId?: InputMaybe<Scalars['Int']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ProductType>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Product` values, with data from `ProductToSuiteListing`. */
export type GqlSuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdManyToManyConnection = {
  __typename?: 'SuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToSuiteListing`, and the cursor to aid in pagination. */
  edges: Array<GqlSuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToSuiteListing`. */
export type GqlSuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdManyToManyEdge = {
  __typename?: 'SuiteListingProductsByProductToSuiteListingSuiteListingIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `Term` values, with data from `TermToSuiteListing`. */
export type GqlSuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdManyToManyConnection = {
  __typename?: 'SuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToSuiteListing`, and the cursor to aid in pagination. */
  edges: Array<GqlSuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToSuiteListing`. */
export type GqlSuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdManyToManyEdge = {
  __typename?: 'SuiteListingTermsByTermToSuiteListingSuiteListingIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

/** A connection to a list of `SuiteListing` values. */
export type GqlSuiteListingsConnection = {
  __typename?: 'SuiteListingsConnection';
  /** A list of edges which contains the `SuiteListing` and cursor to aid in pagination. */
  edges: Array<GqlSuiteListingsEdge>;
  /** A list of `SuiteListing` objects. */
  nodes: Array<Maybe<GqlSuiteListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `SuiteListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuiteListing` edge in the connection. */
export type GqlSuiteListingsEdge = {
  __typename?: 'SuiteListingsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SuiteListing` at the end of the edge. */
  node: Maybe<GqlSuiteListing>;
};

/** Methods to use when ordering `SuiteListing`. */
export enum SuiteListingsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  ExcerptAsc = 'EXCERPT_ASC',
  ExcerptDesc = 'EXCERPT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ShowAsc = 'SHOW_ASC',
  ShowDesc = 'SHOW_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  StripePurchaseIdAsc = 'STRIPE_PURCHASE_ID_ASC',
  StripePurchaseIdDesc = 'STRIPE_PURCHASE_ID_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `Taxonomy` values. */
export type GqlTaxonomiesConnection = {
  __typename?: 'TaxonomiesConnection';
  /** A list of edges which contains the `Taxonomy` and cursor to aid in pagination. */
  edges: Array<GqlTaxonomiesEdge>;
  /** A list of `Taxonomy` objects. */
  nodes: Array<Maybe<GqlTaxonomy>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Taxonomy` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Taxonomy` edge in the connection. */
export type GqlTaxonomiesEdge = {
  __typename?: 'TaxonomiesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Taxonomy` at the end of the edge. */
  node: Maybe<GqlTaxonomy>;
};

/** Methods to use when ordering `Taxonomy`. */
export enum TaxonomiesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  ParentIdAsc = 'PARENT_ID_ASC',
  ParentIdDesc = 'PARENT_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlTaxonomy = GqlNode & {
  __typename?: 'Taxonomy';
  /** Reads and enables pagination through a set of `Taxonomy`. */
  childTaxonomies: Array<GqlTaxonomy>;
  /** Reads and enables pagination through a set of `Taxonomy`. */
  childTaxonomiesConnection: GqlTaxonomiesConnection;
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Taxonomy` that is related to this `Taxonomy`. */
  parent: Maybe<GqlTaxonomy>;
  parentId: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  /** Reads and enables pagination through a set of `Term`. */
  terms: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsConnection: GqlTermsConnection;
  updatedAt: Scalars['Datetime'];
};


export type GqlTaxonomyChildTaxonomiesArgs = {
  condition: InputMaybe<GqlTaxonomyCondition>;
  filter: InputMaybe<GqlTaxonomyFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TaxonomiesOrderBy>>;
};


export type GqlTaxonomyChildTaxonomiesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTaxonomyCondition>;
  filter: InputMaybe<GqlTaxonomyFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TaxonomiesOrderBy>>;
};


export type GqlTaxonomyTermsArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlTaxonomyTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};

/**
 * A condition to be used against `Taxonomy` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTaxonomyCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `parentId` field. */
  parentId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Taxonomy` object types. All fields are combined with a logical ‘and.’ */
export type GqlTaxonomyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTaxonomyFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTaxonomyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTaxonomyFilter>>;
  /** Filter by the object’s `parentId` field. */
  parentId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `Taxonomy` */
export type GqlTaxonomyInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Taxonomy`. Fields that are set will be updated. */
export type GqlTaxonomyPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GqlTechstack = GqlNode & {
  __typename?: 'Techstack';
  access: TechstackAccess;
  addedBy: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  id: Scalars['Int'];
  metadata: Scalars['JSON'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `Techstack`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  ownedBy: Maybe<Scalars['Int']>;
  /** Reads a single `Product` that is related to this `Techstack`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  stage: TechstackStage;
  testFloat: Maybe<Scalars['Float']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Techstack`. */
  userByAddedBy: Maybe<GqlUser>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByOwnedBy: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToTechstackTechstackIdAndUserId: GqlTechstackUsersByUsersToTechstackTechstackIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToTechstackTechstackIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToTechstack`. */
  usersToTechstacks: Array<GqlUsersToTechstack>;
  /** Reads and enables pagination through a set of `UsersToTechstack`. */
  usersToTechstacksConnection: GqlUsersToTechstacksConnection;
};


export type GqlTechstackUsersByUsersToTechstackTechstackIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTechstackUsersByUsersToTechstackTechstackIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTechstackUsersToTechstacksArgs = {
  condition: InputMaybe<GqlUsersToTechstackCondition>;
  filter: InputMaybe<GqlUsersToTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};


export type GqlTechstackUsersToTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToTechstackCondition>;
  filter: InputMaybe<GqlUsersToTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};

export enum TechstackAccess {
  Authorized = 'AUTHORIZED',
  Hide = 'HIDE',
  Organization = 'ORGANIZATION',
  Review = 'REVIEW',
  User = 'USER'
}

/** A filter to be used against TechstackAccess fields. All fields are combined with a logical ‘and.’ */
export type GqlTechstackAccessFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TechstackAccess>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TechstackAccess>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TechstackAccess>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TechstackAccess>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TechstackAccess>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TechstackAccess>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TechstackAccess>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TechstackAccess>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TechstackAccess>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TechstackAccess>>;
};

/**
 * A condition to be used against `Techstack` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTechstackCondition = {
  /** Checks for equality with the object’s `access` field. */
  access?: InputMaybe<TechstackAccess>;
  /** Checks for equality with the object’s `addedBy` field. */
  addedBy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `metadata` field. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ownedBy` field. */
  ownedBy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `stage` field. */
  stage?: InputMaybe<TechstackStage>;
  /** Checks for equality with the object’s `testFloat` field. */
  testFloat?: InputMaybe<Scalars['Float']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Techstack` object types. All fields are combined with a logical ‘and.’ */
export type GqlTechstackFilter = {
  /** Filter by the object’s `access` field. */
  access?: InputMaybe<GqlTechstackAccessFilter>;
  /** Filter by the object’s `addedBy` field. */
  addedBy?: InputMaybe<GqlIntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTechstackFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `metadata` field. */
  metadata?: InputMaybe<GqlJsonFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTechstackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTechstackFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `ownedBy` field. */
  ownedBy?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `stage` field. */
  stage?: InputMaybe<GqlTechstackStageFilter>;
  /** Filter by the object’s `testFloat` field. */
  testFloat?: InputMaybe<GqlFloatFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `Techstack` */
export type GqlTechstackInput = {
  access?: InputMaybe<TechstackAccess>;
  addedBy?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  organizationId: Scalars['UUID'];
  ownedBy?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
  stage?: InputMaybe<TechstackStage>;
  testFloat?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Techstack`. Fields that are set will be updated. */
export type GqlTechstackPatch = {
  access?: InputMaybe<TechstackAccess>;
  addedBy?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownedBy?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<TechstackStage>;
  testFloat?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export enum TechstackStage {
  Active = 'ACTIVE',
  ContractReview = 'CONTRACT_REVIEW',
  Investigation = 'INVESTIGATION',
  Pilot = 'PILOT',
  PracticeRollout = 'PRACTICE_ROLLOUT',
  RegionRollout = 'REGION_ROLLOUT',
  UnderReview = 'UNDER_REVIEW'
}

/** A filter to be used against TechstackStage fields. All fields are combined with a logical ‘and.’ */
export type GqlTechstackStageFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<TechstackStage>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<TechstackStage>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<TechstackStage>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<TechstackStage>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<TechstackStage>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<TechstackStage>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<TechstackStage>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<TechstackStage>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<TechstackStage>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<TechstackStage>>;
};

/** A connection to a list of `User` values, with data from `UsersToTechstack`. */
export type GqlTechstackUsersByUsersToTechstackTechstackIdAndUserIdManyToManyConnection = {
  __typename?: 'TechstackUsersByUsersToTechstackTechstackIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UsersToTechstack`, and the cursor to aid in pagination. */
  edges: Array<GqlTechstackUsersByUsersToTechstackTechstackIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UsersToTechstack`. */
export type GqlTechstackUsersByUsersToTechstackTechstackIdAndUserIdManyToManyEdge = {
  __typename?: 'TechstackUsersByUsersToTechstackTechstackIdAndUserIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  logins: Scalars['Int'];
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Techstack` values. */
export type GqlTechstacksConnection = {
  __typename?: 'TechstacksConnection';
  /** A list of edges which contains the `Techstack` and cursor to aid in pagination. */
  edges: Array<GqlTechstacksEdge>;
  /** A list of `Techstack` objects. */
  nodes: Array<Maybe<GqlTechstack>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Techstack` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Techstack` edge in the connection. */
export type GqlTechstacksEdge = {
  __typename?: 'TechstacksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Techstack` at the end of the edge. */
  node: Maybe<GqlTechstack>;
};

/** Methods to use when ordering `Techstack`. */
export enum TechstacksOrderBy {
  AccessAsc = 'ACCESS_ASC',
  AccessDesc = 'ACCESS_DESC',
  AddedByAsc = 'ADDED_BY_ASC',
  AddedByDesc = 'ADDED_BY_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MetadataAsc = 'METADATA_ASC',
  MetadataDesc = 'METADATA_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OwnedByAsc = 'OWNED_BY_ASC',
  OwnedByDesc = 'OWNED_BY_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  StageAsc = 'STAGE_ASC',
  StageDesc = 'STAGE_DESC',
  TestFloatAsc = 'TEST_FLOAT_ASC',
  TestFloatDesc = 'TEST_FLOAT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A connection to a list of `TempDatum` values. */
export type GqlTempDataConnection = {
  __typename?: 'TempDataConnection';
  /** A list of edges which contains the `TempDatum` and cursor to aid in pagination. */
  edges: Array<GqlTempDataEdge>;
  /** A list of `TempDatum` objects. */
  nodes: Array<Maybe<GqlTempDatum>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TempDatum` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TempDatum` edge in the connection. */
export type GqlTempDataEdge = {
  __typename?: 'TempDataEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TempDatum` at the end of the edge. */
  node: Maybe<GqlTempDatum>;
};

/** Methods to use when ordering `TempDatum`. */
export enum TempDataOrderBy {
  DataAsc = 'DATA_ASC',
  DataDesc = 'DATA_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL'
}

export type GqlTempDatum = {
  __typename?: 'TempDatum';
  data: Scalars['JSON'];
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `TempDatum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTempDatumCondition = {
  /** Checks for equality with the object’s `data` field. */
  data?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `TempDatum` object types. All fields are combined with a logical ‘and.’ */
export type GqlTempDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTempDatumFilter>>;
  /** Filter by the object’s `data` field. */
  data?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlUuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTempDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTempDatumFilter>>;
};

/** An input for mutations affecting `TempDatum` */
export type GqlTempDatumInput = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `TempDatum`. Fields that are set will be updated. */
export type GqlTempDatumPatch = {
  data?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['UUID']>;
};

export type GqlTerm = GqlNode & {
  __typename?: 'Term';
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUsersToOrganizationJobTitleAndLocationId: GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUsersToOrganizationJobTitleAndLocationIdList: Array<GqlLocation>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByMainTermId: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByMainTermIdConnection: GqlOrganizationsConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductFeatureByTermTermIdAndNetworkId: GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByProductFeatureByTermTermIdAndNetworkIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsBySimpleServiceTermIdAndOrganizationId: GqlTermOrganizationsBySimpleServiceTermIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsBySimpleServiceTermIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToOrganizationTermIdAndOrganizationId: GqlTermOrganizationsByTermToOrganizationTermIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToOrganizationTermIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToUserTermIdAndOrganizationId: GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToUserTermIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToVendorStackshareTermIdAndOrganizationId: GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToVendorStackshareTermIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUseCasePracticeGroupAndOrganizationId: GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUseCasePracticeGroupAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUsersToOrganizationJobTitleAndOrganizationId: GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUsersToOrganizationJobTitleAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `PremiumInfoToTerm`. */
  premiumInfoToTerms: Array<GqlPremiumInfoToTerm>;
  /** Reads and enables pagination through a set of `PremiumInfoToTerm`. */
  premiumInfoToTermsConnection: GqlPremiumInfoToTermsConnection;
  /** Reads and enables pagination through a set of `PremiumProductInfo`. */
  premiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoId: GqlTermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdManyToManyConnection;
  /** Reads and enables pagination through a set of `PremiumProductInfo`. */
  premiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdList: Array<GqlPremiumProductInfo>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: GqlProductFeatureByTermsConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductFeatureByTermTermIdAndProductId: GqlTermProductsByProductFeatureByTermTermIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductFeatureByTermTermIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTermToProductTermIdAndProductId: GqlTermProductsByTermToProductTermIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTermToProductTermIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTestDriveTermIdAndProductId: GqlTermProductsByTestDriveTermIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTestDriveTermIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUseCasePracticeGroupAndProductId: GqlTermProductsByUseCasePracticeGroupAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUseCasePracticeGroupAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfpsByTermToRfpTermIdAndRfpId: GqlTermRfpsByTermToRfpTermIdAndRfpIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfpsByTermToRfpTermIdAndRfpIdList: Array<GqlRfp>;
  /** Reads and enables pagination through a set of `SimpleService`. */
  simpleServices: Array<GqlSimpleService>;
  /** Reads and enables pagination through a set of `SimpleService`. */
  simpleServicesConnection: GqlSimpleServicesConnection;
  slug: Scalars['String'];
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsByTermToSuiteListingTermIdAndSuiteListingId: GqlTermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdManyToManyConnection;
  /** Reads and enables pagination through a set of `SuiteListing`. */
  suiteListingsByTermToSuiteListingTermIdAndSuiteListingIdList: Array<GqlSuiteListing>;
  /** Reads a single `Taxonomy` that is related to this `Term`. */
  taxonomy: Maybe<GqlTaxonomy>;
  taxonomyId: Scalars['Int'];
  /** Reads and enables pagination through a set of `TermToOrganization`. */
  termToOrganizations: Array<GqlTermToOrganization>;
  /** Reads and enables pagination through a set of `TermToOrganization`. */
  termToOrganizationsConnection: GqlTermToOrganizationsConnection;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProducts: Array<GqlTermToProduct>;
  /** Reads and enables pagination through a set of `TermToProduct`. */
  termToProductsConnection: GqlTermToProductsConnection;
  /** Reads and enables pagination through a set of `TermToRfp`. */
  termToRfps: Array<GqlTermToRfp>;
  /** Reads and enables pagination through a set of `TermToRfp`. */
  termToRfpsConnection: GqlTermToRfpsConnection;
  /** Reads and enables pagination through a set of `TermToSuiteListing`. */
  termToSuiteListings: Array<GqlTermToSuiteListing>;
  /** Reads and enables pagination through a set of `TermToSuiteListing`. */
  termToSuiteListingsConnection: GqlTermToSuiteListingsConnection;
  /** Reads and enables pagination through a set of `TermToTestDrive`. */
  termToTestDrives: Array<GqlTermToTestDrive>;
  /** Reads and enables pagination through a set of `TermToTestDrive`. */
  termToTestDrivesConnection: GqlTermToTestDrivesConnection;
  /** Reads and enables pagination through a set of `TermToUserStory`. */
  termToUserStories: Array<GqlTermToUserStory>;
  /** Reads and enables pagination through a set of `TermToUserStory`. */
  termToUserStoriesConnection: GqlTermToUserStoriesConnection;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStackshares: Array<GqlTermToVendorStackshare>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStacksharesConnection: GqlTermToVendorStacksharesConnection;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrives: Array<GqlTestDrive>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesByTermToTestDriveTermIdAndTestDriveId: GqlTermTestDrivesByTermToTestDriveTermIdAndTestDriveIdManyToManyConnection;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesByTermToTestDriveTermIdAndTestDriveIdList: Array<GqlTestDrive>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesConnection: GqlTestDrivesConnection;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroup: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroupConnection: GqlUseCasesConnection;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByTermToUserStoryTermIdAndUserStoryId: GqlTermUserStoriesByTermToUserStoryTermIdAndUserStoryIdManyToManyConnection;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByTermToUserStoryTermIdAndUserStoryIdList: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTermToUserTermIdAndUserId: GqlTermUsersByTermToUserTermIdAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTermToUserTermIdAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUseCasePracticeGroupAndAuthor: GqlTermUsersByUseCasePracticeGroupAndAuthorManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUseCasePracticeGroupAndAuthorList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToOrganizationJobTitleAndUserId: GqlTermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByUsersToOrganizationJobTitleAndUserIdList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitle: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitleConnection: GqlUsersToOrganizationsConnection;
};


export type GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdListArgs = {
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlTermOrganizationsByMainTermIdArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByMainTermIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsBySimpleServiceTermIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsBySimpleServiceTermIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByTermToOrganizationTermIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByTermToOrganizationTermIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlTermPremiumInfoToTermsArgs = {
  condition: InputMaybe<GqlPremiumInfoToTermCondition>;
  filter: InputMaybe<GqlPremiumInfoToTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};


export type GqlTermPremiumInfoToTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPremiumInfoToTermCondition>;
  filter: InputMaybe<GqlPremiumInfoToTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};


export type GqlTermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPremiumProductInfoCondition>;
  filter: InputMaybe<GqlPremiumProductInfoFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};


export type GqlTermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdListArgs = {
  condition: InputMaybe<GqlPremiumProductInfoCondition>;
  filter: InputMaybe<GqlPremiumProductInfoFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};


export type GqlTermProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


export type GqlTermProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


export type GqlTermProductsByProductFeatureByTermTermIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByProductFeatureByTermTermIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByTermToProductTermIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByTermToProductTermIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByTestDriveTermIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByTestDriveTermIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByUseCasePracticeGroupAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermProductsByUseCasePracticeGroupAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlTermRfpsByTermToRfpTermIdAndRfpIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};


export type GqlTermRfpsByTermToRfpTermIdAndRfpIdListArgs = {
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpsOrderBy>>;
};


export type GqlTermSimpleServicesArgs = {
  condition: InputMaybe<GqlSimpleServiceCondition>;
  filter: InputMaybe<GqlSimpleServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SimpleServicesOrderBy>>;
};


export type GqlTermSimpleServicesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSimpleServiceCondition>;
  filter: InputMaybe<GqlSimpleServiceFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};


export type GqlTermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlTermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdListArgs = {
  condition: InputMaybe<GqlSuiteListingCondition>;
  filter: InputMaybe<GqlSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SuiteListingsOrderBy>>;
};


export type GqlTermTermToOrganizationsArgs = {
  condition: InputMaybe<GqlTermToOrganizationCondition>;
  filter: InputMaybe<GqlTermToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};


export type GqlTermTermToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToOrganizationCondition>;
  filter: InputMaybe<GqlTermToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};


export type GqlTermTermToProductsArgs = {
  condition: InputMaybe<GqlTermToProductCondition>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToProductsOrderBy>>;
};


export type GqlTermTermToProductsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToProductCondition>;
  filter: InputMaybe<GqlTermToProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};


export type GqlTermTermToRfpsArgs = {
  condition: InputMaybe<GqlTermToRfpCondition>;
  filter: InputMaybe<GqlTermToRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToRfpsOrderBy>>;
};


export type GqlTermTermToRfpsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToRfpCondition>;
  filter: InputMaybe<GqlTermToRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};


export type GqlTermTermToSuiteListingsArgs = {
  condition: InputMaybe<GqlTermToSuiteListingCondition>;
  filter: InputMaybe<GqlTermToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};


export type GqlTermTermToSuiteListingsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToSuiteListingCondition>;
  filter: InputMaybe<GqlTermToSuiteListingFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};


export type GqlTermTermToTestDrivesArgs = {
  condition: InputMaybe<GqlTermToTestDriveCondition>;
  filter: InputMaybe<GqlTermToTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};


export type GqlTermTermToTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToTestDriveCondition>;
  filter: InputMaybe<GqlTermToTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};


export type GqlTermTermToUserStoriesArgs = {
  condition: InputMaybe<GqlTermToUserStoryCondition>;
  filter: InputMaybe<GqlTermToUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};


export type GqlTermTermToUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserStoryCondition>;
  filter: InputMaybe<GqlTermToUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};


export type GqlTermTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


export type GqlTermTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};


export type GqlTermTermToVendorStacksharesArgs = {
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


export type GqlTermTermToVendorStacksharesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


export type GqlTermTestDrivesArgs = {
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TestDrivesOrderBy>>;
};


export type GqlTermTestDrivesByTermToTestDriveTermIdAndTestDriveIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};


export type GqlTermTestDrivesByTermToTestDriveTermIdAndTestDriveIdListArgs = {
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TestDrivesOrderBy>>;
};


export type GqlTermTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};


export type GqlTermUseCasesByPracticeGroupArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlTermUseCasesByPracticeGroupConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlTermUserStoriesByTermToUserStoryTermIdAndUserStoryIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlTermUserStoriesByTermToUserStoryTermIdAndUserStoryIdListArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlTermUsersByTermToUserTermIdAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTermUsersByTermToUserTermIdAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTermUsersByUseCasePracticeGroupAndAuthorArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTermUsersByUseCasePracticeGroupAndAuthorListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTermUsersByUsersToOrganizationJobTitleAndUserIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTermUsersByUsersToOrganizationJobTitleAndUserIdListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlTermUsersToOrganizationsByJobTitleArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


export type GqlTermUsersToOrganizationsByJobTitleConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A condition to be used against `Term` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlTermCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `description` field. */
  description?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `slug` field. */
  slug?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `taxonomyId` field. */
  taxonomyId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Term` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `description` field. */
  description?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `slug` field. */
  slug?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `taxonomyId` field. */
  taxonomyId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `Term` */
export type GqlTermInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  taxonomyId: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Location` values, with data from `UsersToOrganization`. */
export type GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyConnection = {
  __typename?: 'TermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Maybe<GqlLocation>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyEdge = {
  __typename?: 'TermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Location` at the end of the edge. */
  node: Maybe<GqlLocation>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermLocationsByUsersToOrganizationJobTitleAndLocationIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ProductFeatureByTerm`. */
export type GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyConnection = {
  __typename?: 'TermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ProductFeatureByTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyEdge = {
  __typename?: 'TermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsByNetworkId: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsByNetworkIdConnection: GqlProductFeatureByTermsConnection;
};


/** A `Organization` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyEdgeProductFeatureByTermsByNetworkIdArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlTermOrganizationsByProductFeatureByTermTermIdAndNetworkIdManyToManyEdgeProductFeatureByTermsByNetworkIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `SimpleService`. */
export type GqlTermOrganizationsBySimpleServiceTermIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'TermOrganizationsBySimpleServiceTermIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `SimpleService`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsBySimpleServiceTermIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `SimpleService`. */
export type GqlTermOrganizationsBySimpleServiceTermIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'TermOrganizationsBySimpleServiceTermIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  order: Scalars['Int'];
};

/** A connection to a list of `Organization` values, with data from `TermToOrganization`. */
export type GqlTermOrganizationsByTermToOrganizationTermIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'TermOrganizationsByTermToOrganizationTermIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `TermToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsByTermToOrganizationTermIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `TermToOrganization`. */
export type GqlTermOrganizationsByTermToOrganizationTermIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'TermOrganizationsByTermToOrganizationTermIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};

/** A connection to a list of `Organization` values, with data from `TermToUser`. */
export type GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'TermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `TermToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `TermToUser`. */
export type GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'TermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
};


/** A `Organization` edge in the connection, with data from `TermToUser`. */
export type GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyEdgeTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `TermToUser`. */
export type GqlTermOrganizationsByTermToUserTermIdAndOrganizationIdManyToManyEdgeTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `TermToVendorStackshare`. */
export type GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'TermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `TermToVendorStackshare`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `TermToVendorStackshare`. */
export type GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'TermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStackshares: Array<GqlTermToVendorStackshare>;
  /** Reads and enables pagination through a set of `TermToVendorStackshare`. */
  termToVendorStacksharesConnection: GqlTermToVendorStacksharesConnection;
};


/** A `Organization` edge in the connection, with data from `TermToVendorStackshare`. */
export type GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyEdgeTermToVendorStacksharesArgs = {
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `TermToVendorStackshare`. */
export type GqlTermOrganizationsByTermToVendorStackshareTermIdAndOrganizationIdManyToManyEdgeTermToVendorStacksharesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToVendorStackshareCondition>;
  filter: InputMaybe<GqlTermToVendorStackshareFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UseCase`. */
export type GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyConnection = {
  __typename?: 'TermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyEdge = {
  __typename?: 'TermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
};


/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyEdgeUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlTermOrganizationsByUseCasePracticeGroupAndOrganizationIdManyToManyEdgeUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UsersToOrganization`. */
export type GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyConnection = {
  __typename?: 'TermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyEdge = {
  __typename?: 'TermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermOrganizationsByUsersToOrganizationJobTitleAndOrganizationIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** Represents an update to a `Term`. Fields that are set will be updated. */
export type GqlTermPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  taxonomyId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PremiumProductInfo` values, with data from `PremiumInfoToTerm`. */
export type GqlTermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdManyToManyConnection = {
  __typename?: 'TermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdManyToManyConnection';
  /** A list of edges which contains the `PremiumProductInfo`, info from the `PremiumInfoToTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlTermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdManyToManyEdge>;
  /** A list of `PremiumProductInfo` objects. */
  nodes: Array<Maybe<GqlPremiumProductInfo>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PremiumProductInfo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PremiumProductInfo` edge in the connection, with data from `PremiumInfoToTerm`. */
export type GqlTermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdManyToManyEdge = {
  __typename?: 'TermPremiumProductInfosByPremiumInfoToTermTermIdAndPremiumInfoIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PremiumProductInfo` at the end of the edge. */
  node: Maybe<GqlPremiumProductInfo>;
  peerFirmUsersBySize: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Product` values, with data from `ProductFeatureByTerm`. */
export type GqlTermProductsByProductFeatureByTermTermIdAndProductIdManyToManyConnection = {
  __typename?: 'TermProductsByProductFeatureByTermTermIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductFeatureByTerm`, and the cursor to aid in pagination. */
  edges: Array<GqlTermProductsByProductFeatureByTermTermIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlTermProductsByProductFeatureByTermTermIdAndProductIdManyToManyEdge = {
  __typename?: 'TermProductsByProductFeatureByTermTermIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTerms: Array<GqlProductFeatureByTerm>;
  /** Reads and enables pagination through a set of `ProductFeatureByTerm`. */
  productFeatureByTermsConnection: GqlProductFeatureByTermsConnection;
};


/** A `Product` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlTermProductsByProductFeatureByTermTermIdAndProductIdManyToManyEdgeProductFeatureByTermsArgs = {
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};


/** A `Product` edge in the connection, with data from `ProductFeatureByTerm`. */
export type GqlTermProductsByProductFeatureByTermTermIdAndProductIdManyToManyEdgeProductFeatureByTermsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductFeatureByTermCondition>;
  filter: InputMaybe<GqlProductFeatureByTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `TermToProduct`. */
export type GqlTermProductsByTermToProductTermIdAndProductIdManyToManyConnection = {
  __typename?: 'TermProductsByTermToProductTermIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `TermToProduct`, and the cursor to aid in pagination. */
  edges: Array<GqlTermProductsByTermToProductTermIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `TermToProduct`. */
export type GqlTermProductsByTermToProductTermIdAndProductIdManyToManyEdge = {
  __typename?: 'TermProductsByTermToProductTermIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `Product` values, with data from `TestDrive`. */
export type GqlTermProductsByTestDriveTermIdAndProductIdManyToManyConnection = {
  __typename?: 'TermProductsByTestDriveTermIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `TestDrive`, and the cursor to aid in pagination. */
  edges: Array<GqlTermProductsByTestDriveTermIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `TestDrive`. */
export type GqlTermProductsByTestDriveTermIdAndProductIdManyToManyEdge = {
  __typename?: 'TermProductsByTestDriveTermIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrives: Array<GqlTestDrive>;
  /** Reads and enables pagination through a set of `TestDrive`. */
  testDrivesConnection: GqlTestDrivesConnection;
};


/** A `Product` edge in the connection, with data from `TestDrive`. */
export type GqlTermProductsByTestDriveTermIdAndProductIdManyToManyEdgeTestDrivesArgs = {
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TestDrivesOrderBy>>;
};


/** A `Product` edge in the connection, with data from `TestDrive`. */
export type GqlTermProductsByTestDriveTermIdAndProductIdManyToManyEdgeTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTestDriveCondition>;
  filter: InputMaybe<GqlTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `UseCase`. */
export type GqlTermProductsByUseCasePracticeGroupAndProductIdManyToManyConnection = {
  __typename?: 'TermProductsByUseCasePracticeGroupAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlTermProductsByUseCasePracticeGroupAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlTermProductsByUseCasePracticeGroupAndProductIdManyToManyEdge = {
  __typename?: 'TermProductsByUseCasePracticeGroupAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
};


/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlTermProductsByUseCasePracticeGroupAndProductIdManyToManyEdgeUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlTermProductsByUseCasePracticeGroupAndProductIdManyToManyEdgeUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Rfp` values, with data from `TermToRfp`. */
export type GqlTermRfpsByTermToRfpTermIdAndRfpIdManyToManyConnection = {
  __typename?: 'TermRfpsByTermToRfpTermIdAndRfpIdManyToManyConnection';
  /** A list of edges which contains the `Rfp`, info from the `TermToRfp`, and the cursor to aid in pagination. */
  edges: Array<GqlTermRfpsByTermToRfpTermIdAndRfpIdManyToManyEdge>;
  /** A list of `Rfp` objects. */
  nodes: Array<Maybe<GqlRfp>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Rfp` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Rfp` edge in the connection, with data from `TermToRfp`. */
export type GqlTermRfpsByTermToRfpTermIdAndRfpIdManyToManyEdge = {
  __typename?: 'TermRfpsByTermToRfpTermIdAndRfpIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Rfp` at the end of the edge. */
  node: Maybe<GqlRfp>;
};

/** A connection to a list of `SuiteListing` values, with data from `TermToSuiteListing`. */
export type GqlTermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdManyToManyConnection = {
  __typename?: 'TermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdManyToManyConnection';
  /** A list of edges which contains the `SuiteListing`, info from the `TermToSuiteListing`, and the cursor to aid in pagination. */
  edges: Array<GqlTermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdManyToManyEdge>;
  /** A list of `SuiteListing` objects. */
  nodes: Array<Maybe<GqlSuiteListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `SuiteListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SuiteListing` edge in the connection, with data from `TermToSuiteListing`. */
export type GqlTermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdManyToManyEdge = {
  __typename?: 'TermSuiteListingsByTermToSuiteListingTermIdAndSuiteListingIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SuiteListing` at the end of the edge. */
  node: Maybe<GqlSuiteListing>;
};

/** A connection to a list of `TestDrive` values, with data from `TermToTestDrive`. */
export type GqlTermTestDrivesByTermToTestDriveTermIdAndTestDriveIdManyToManyConnection = {
  __typename?: 'TermTestDrivesByTermToTestDriveTermIdAndTestDriveIdManyToManyConnection';
  /** A list of edges which contains the `TestDrive`, info from the `TermToTestDrive`, and the cursor to aid in pagination. */
  edges: Array<GqlTermTestDrivesByTermToTestDriveTermIdAndTestDriveIdManyToManyEdge>;
  /** A list of `TestDrive` objects. */
  nodes: Array<Maybe<GqlTestDrive>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TestDrive` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TestDrive` edge in the connection, with data from `TermToTestDrive`. */
export type GqlTermTestDrivesByTermToTestDriveTermIdAndTestDriveIdManyToManyEdge = {
  __typename?: 'TermTestDrivesByTermToTestDriveTermIdAndTestDriveIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TestDrive` at the end of the edge. */
  node: Maybe<GqlTestDrive>;
};

export type GqlTermToOrganization = GqlNode & {
  __typename?: 'TermToOrganization';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `TermToOrganization`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads a single `Term` that is related to this `TermToOrganization`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToOrganization` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlTermToOrganizationCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToOrganization` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToOrganizationFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToOrganization` */
export type GqlTermToOrganizationInput = {
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};

/** Represents an update to a `TermToOrganization`. Fields that are set will be updated. */
export type GqlTermToOrganizationPatch = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToOrganization` values. */
export type GqlTermToOrganizationsConnection = {
  __typename?: 'TermToOrganizationsConnection';
  /** A list of edges which contains the `TermToOrganization` and cursor to aid in pagination. */
  edges: Array<GqlTermToOrganizationsEdge>;
  /** A list of `TermToOrganization` objects. */
  nodes: Array<Maybe<GqlTermToOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToOrganization` edge in the connection. */
export type GqlTermToOrganizationsEdge = {
  __typename?: 'TermToOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToOrganization` at the end of the edge. */
  node: Maybe<GqlTermToOrganization>;
};

/** Methods to use when ordering `TermToOrganization`. */
export enum TermToOrganizationsOrderBy {
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

export type GqlTermToProduct = GqlNode & {
  __typename?: 'TermToProduct';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `TermToProduct`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `Term` that is related to this `TermToProduct`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlTermToProductCondition = {
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToProduct` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToProductFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToProductFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToProduct` */
export type GqlTermToProductInput = {
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** Represents an update to a `TermToProduct`. Fields that are set will be updated. */
export type GqlTermToProductPatch = {
  productId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToProduct` values. */
export type GqlTermToProductsConnection = {
  __typename?: 'TermToProductsConnection';
  /** A list of edges which contains the `TermToProduct` and cursor to aid in pagination. */
  edges: Array<GqlTermToProductsEdge>;
  /** A list of `TermToProduct` objects. */
  nodes: Array<Maybe<GqlTermToProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToProduct` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToProduct` edge in the connection. */
export type GqlTermToProductsEdge = {
  __typename?: 'TermToProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToProduct` at the end of the edge. */
  node: Maybe<GqlTermToProduct>;
};

/** Methods to use when ordering `TermToProduct`. */
export enum TermToProductsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

export type GqlTermToRfp = GqlNode & {
  __typename?: 'TermToRfp';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Rfp` that is related to this `TermToRfp`. */
  rfp: Maybe<GqlRfp>;
  rfpId: Scalars['Int'];
  /** Reads a single `Term` that is related to this `TermToRfp`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToRfp` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTermToRfpCondition = {
  /** Checks for equality with the object’s `rfpId` field. */
  rfpId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToRfp` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToRfpFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToRfpFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToRfpFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToRfpFilter>>;
  /** Filter by the object’s `rfpId` field. */
  rfpId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToRfp` */
export type GqlTermToRfpInput = {
  rfpId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** Represents an update to a `TermToRfp`. Fields that are set will be updated. */
export type GqlTermToRfpPatch = {
  rfpId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToRfp` values. */
export type GqlTermToRfpsConnection = {
  __typename?: 'TermToRfpsConnection';
  /** A list of edges which contains the `TermToRfp` and cursor to aid in pagination. */
  edges: Array<GqlTermToRfpsEdge>;
  /** A list of `TermToRfp` objects. */
  nodes: Array<Maybe<GqlTermToRfp>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToRfp` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToRfp` edge in the connection. */
export type GqlTermToRfpsEdge = {
  __typename?: 'TermToRfpsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToRfp` at the end of the edge. */
  node: Maybe<GqlTermToRfp>;
};

/** Methods to use when ordering `TermToRfp`. */
export enum TermToRfpsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RfpIdAsc = 'RFP_ID_ASC',
  RfpIdDesc = 'RFP_ID_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

export type GqlTermToSuiteListing = GqlNode & {
  __typename?: 'TermToSuiteListing';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `SuiteListing` that is related to this `TermToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
  suiteListingId: Scalars['Int'];
  /** Reads a single `Term` that is related to this `TermToSuiteListing`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToSuiteListing` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlTermToSuiteListingCondition = {
  /** Checks for equality with the object’s `suiteListingId` field. */
  suiteListingId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToSuiteListing` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToSuiteListingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToSuiteListingFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToSuiteListingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToSuiteListingFilter>>;
  /** Filter by the object’s `suiteListingId` field. */
  suiteListingId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToSuiteListing` */
export type GqlTermToSuiteListingInput = {
  suiteListingId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** Represents an update to a `TermToSuiteListing`. Fields that are set will be updated. */
export type GqlTermToSuiteListingPatch = {
  suiteListingId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToSuiteListing` values. */
export type GqlTermToSuiteListingsConnection = {
  __typename?: 'TermToSuiteListingsConnection';
  /** A list of edges which contains the `TermToSuiteListing` and cursor to aid in pagination. */
  edges: Array<GqlTermToSuiteListingsEdge>;
  /** A list of `TermToSuiteListing` objects. */
  nodes: Array<Maybe<GqlTermToSuiteListing>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToSuiteListing` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToSuiteListing` edge in the connection. */
export type GqlTermToSuiteListingsEdge = {
  __typename?: 'TermToSuiteListingsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToSuiteListing` at the end of the edge. */
  node: Maybe<GqlTermToSuiteListing>;
};

/** Methods to use when ordering `TermToSuiteListing`. */
export enum TermToSuiteListingsOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SuiteListingIdAsc = 'SUITE_LISTING_ID_ASC',
  SuiteListingIdDesc = 'SUITE_LISTING_ID_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

export type GqlTermToTestDrive = GqlNode & {
  __typename?: 'TermToTestDrive';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Term` that is related to this `TermToTestDrive`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
  /** Reads a single `TestDrive` that is related to this `TermToTestDrive`. */
  testDrive: Maybe<GqlTestDrive>;
  testDriveId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToTestDrive` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlTermToTestDriveCondition = {
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testDriveId` field. */
  testDriveId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToTestDrive` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToTestDriveFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToTestDriveFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToTestDriveFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToTestDriveFilter>>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `testDriveId` field. */
  testDriveId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToTestDrive` */
export type GqlTermToTestDriveInput = {
  termId: Scalars['Int'];
  testDriveId: Scalars['Int'];
};

/** Represents an update to a `TermToTestDrive`. Fields that are set will be updated. */
export type GqlTermToTestDrivePatch = {
  termId?: InputMaybe<Scalars['Int']>;
  testDriveId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToTestDrive` values. */
export type GqlTermToTestDrivesConnection = {
  __typename?: 'TermToTestDrivesConnection';
  /** A list of edges which contains the `TermToTestDrive` and cursor to aid in pagination. */
  edges: Array<GqlTermToTestDrivesEdge>;
  /** A list of `TermToTestDrive` objects. */
  nodes: Array<Maybe<GqlTermToTestDrive>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToTestDrive` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToTestDrive` edge in the connection. */
export type GqlTermToTestDrivesEdge = {
  __typename?: 'TermToTestDrivesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToTestDrive` at the end of the edge. */
  node: Maybe<GqlTermToTestDrive>;
};

/** Methods to use when ordering `TermToTestDrive`. */
export enum TermToTestDrivesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC',
  TestDriveIdAsc = 'TEST_DRIVE_ID_ASC',
  TestDriveIdDesc = 'TEST_DRIVE_ID_DESC'
}

export type GqlTermToUser = GqlNode & {
  __typename?: 'TermToUser';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `TermToUser`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads a single `Term` that is related to this `TermToUser`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
  /** Reads a single `User` that is related to this `TermToUser`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToUser` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTermToUserCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToUser` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToUserFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToUserFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToUser` */
export type GqlTermToUserInput = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** Represents an update to a `TermToUser`. Fields that are set will be updated. */
export type GqlTermToUserPatch = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToUserStory` values. */
export type GqlTermToUserStoriesConnection = {
  __typename?: 'TermToUserStoriesConnection';
  /** A list of edges which contains the `TermToUserStory` and cursor to aid in pagination. */
  edges: Array<GqlTermToUserStoriesEdge>;
  /** A list of `TermToUserStory` objects. */
  nodes: Array<Maybe<GqlTermToUserStory>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToUserStory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToUserStory` edge in the connection. */
export type GqlTermToUserStoriesEdge = {
  __typename?: 'TermToUserStoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToUserStory` at the end of the edge. */
  node: Maybe<GqlTermToUserStory>;
};

/** Methods to use when ordering `TermToUserStory`. */
export enum TermToUserStoriesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC',
  UserStoryIdAsc = 'USER_STORY_ID_ASC',
  UserStoryIdDesc = 'USER_STORY_ID_DESC'
}

export type GqlTermToUserStory = GqlNode & {
  __typename?: 'TermToUserStory';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Term` that is related to this `TermToUserStory`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
  /** Reads a single `UserStory` that is related to this `TermToUserStory`. */
  userStory: Maybe<GqlUserStory>;
  userStoryId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToUserStory` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlTermToUserStoryCondition = {
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userStoryId` field. */
  userStoryId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToUserStory` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToUserStoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToUserStoryFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToUserStoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToUserStoryFilter>>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `userStoryId` field. */
  userStoryId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToUserStory` */
export type GqlTermToUserStoryInput = {
  termId: Scalars['Int'];
  userStoryId: Scalars['Int'];
};

/** Represents an update to a `TermToUserStory`. Fields that are set will be updated. */
export type GqlTermToUserStoryPatch = {
  termId?: InputMaybe<Scalars['Int']>;
  userStoryId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToUser` values. */
export type GqlTermToUsersConnection = {
  __typename?: 'TermToUsersConnection';
  /** A list of edges which contains the `TermToUser` and cursor to aid in pagination. */
  edges: Array<GqlTermToUsersEdge>;
  /** A list of `TermToUser` objects. */
  nodes: Array<Maybe<GqlTermToUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToUser` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToUser` edge in the connection. */
export type GqlTermToUsersEdge = {
  __typename?: 'TermToUsersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToUser` at the end of the edge. */
  node: Maybe<GqlTermToUser>;
};

/** Methods to use when ordering `TermToUser`. */
export enum TermToUsersOrderBy {
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlTermToVendorStackshare = GqlNode & {
  __typename?: 'TermToVendorStackshare';
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  /** Reads a single `Organization` that is related to this `TermToVendorStackshare`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads a single `Term` that is related to this `TermToVendorStackshare`. */
  term: Maybe<GqlTerm>;
  termId: Scalars['Int'];
};

/**
 * A condition to be used against `TermToVendorStackshare` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlTermToVendorStackshareCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `TermToVendorStackshare` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermToVendorStackshareFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermToVendorStackshareFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermToVendorStackshareFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermToVendorStackshareFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `TermToVendorStackshare` */
export type GqlTermToVendorStackshareInput = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
  termId: Scalars['Int'];
};

/** Represents an update to a `TermToVendorStackshare`. Fields that are set will be updated. */
export type GqlTermToVendorStacksharePatch = {
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `TermToVendorStackshare` values. */
export type GqlTermToVendorStacksharesConnection = {
  __typename?: 'TermToVendorStacksharesConnection';
  /** A list of edges which contains the `TermToVendorStackshare` and cursor to aid in pagination. */
  edges: Array<GqlTermToVendorStacksharesEdge>;
  /** A list of `TermToVendorStackshare` objects. */
  nodes: Array<Maybe<GqlTermToVendorStackshare>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TermToVendorStackshare` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TermToVendorStackshare` edge in the connection. */
export type GqlTermToVendorStacksharesEdge = {
  __typename?: 'TermToVendorStacksharesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TermToVendorStackshare` at the end of the edge. */
  node: Maybe<GqlTermToVendorStackshare>;
};

/** Methods to use when ordering `TermToVendorStackshare`. */
export enum TermToVendorStacksharesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC'
}

/** A connection to a list of `UserStory` values, with data from `TermToUserStory`. */
export type GqlTermUserStoriesByTermToUserStoryTermIdAndUserStoryIdManyToManyConnection = {
  __typename?: 'TermUserStoriesByTermToUserStoryTermIdAndUserStoryIdManyToManyConnection';
  /** A list of edges which contains the `UserStory`, info from the `TermToUserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlTermUserStoriesByTermToUserStoryTermIdAndUserStoryIdManyToManyEdge>;
  /** A list of `UserStory` objects. */
  nodes: Array<Maybe<GqlUserStory>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UserStory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserStory` edge in the connection, with data from `TermToUserStory`. */
export type GqlTermUserStoriesByTermToUserStoryTermIdAndUserStoryIdManyToManyEdge = {
  __typename?: 'TermUserStoriesByTermToUserStoryTermIdAndUserStoryIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UserStory` at the end of the edge. */
  node: Maybe<GqlUserStory>;
};

/** A connection to a list of `User` values, with data from `TermToUser`. */
export type GqlTermUsersByTermToUserTermIdAndUserIdManyToManyConnection = {
  __typename?: 'TermUsersByTermToUserTermIdAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `TermToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlTermUsersByTermToUserTermIdAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `TermToUser`. */
export type GqlTermUsersByTermToUserTermIdAndUserIdManyToManyEdge = {
  __typename?: 'TermUsersByTermToUserTermIdAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  organizationId: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `User` values, with data from `UseCase`. */
export type GqlTermUsersByUseCasePracticeGroupAndAuthorManyToManyConnection = {
  __typename?: 'TermUsersByUseCasePracticeGroupAndAuthorManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlTermUsersByUseCasePracticeGroupAndAuthorManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlTermUsersByUseCasePracticeGroupAndAuthorManyToManyEdge = {
  __typename?: 'TermUsersByUseCasePracticeGroupAndAuthorManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthor: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthorConnection: GqlUseCasesConnection;
};


/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlTermUsersByUseCasePracticeGroupAndAuthorManyToManyEdgeUseCasesByAuthorArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `User` edge in the connection, with data from `UseCase`. */
export type GqlTermUsersByUseCasePracticeGroupAndAuthorManyToManyEdgeUseCasesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `User` values, with data from `UsersToOrganization`. */
export type GqlTermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyConnection = {
  __typename?: 'TermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlTermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyEdge = {
  __typename?: 'TermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `User` edge in the connection, with data from `UsersToOrganization`. */
export type GqlTermUsersByUsersToOrganizationJobTitleAndUserIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A connection to a list of `Term` values. */
export type GqlTermsConnection = {
  __typename?: 'TermsConnection';
  /** A list of edges which contains the `Term` and cursor to aid in pagination. */
  edges: Array<GqlTermsEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection. */
export type GqlTermsEdge = {
  __typename?: 'TermsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

/** Methods to use when ordering `Term`. */
export enum TermsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DescriptionAsc = 'DESCRIPTION_ASC',
  DescriptionDesc = 'DESCRIPTION_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SlugAsc = 'SLUG_ASC',
  SlugDesc = 'SLUG_DESC',
  TaxonomyIdAsc = 'TAXONOMY_ID_ASC',
  TaxonomyIdDesc = 'TAXONOMY_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlTermscout = GqlNode & {
  __typename?: 'Termscout';
  createdAt: Maybe<Scalars['Datetime']>;
  id: Scalars['Int'];
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Product` that is related to this `Termscout`. */
  product: Maybe<GqlProduct>;
  productId: Maybe<Scalars['Int']>;
  productSuiteId: Scalars['Int'];
  updatedAt: Maybe<Scalars['Datetime']>;
};

/**
 * A condition to be used against `Termscout` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTermscoutCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productSuiteId` field. */
  productSuiteId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `Termscout` object types. All fields are combined with a logical ‘and.’ */
export type GqlTermscoutFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTermscoutFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTermscoutFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTermscoutFilter>>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `productSuiteId` field. */
  productSuiteId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `Termscout` */
export type GqlTermscoutInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  productSuiteId: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Termscout`. Fields that are set will be updated. */
export type GqlTermscoutPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['Int']>;
  productSuiteId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Termscout` values. */
export type GqlTermscoutsConnection = {
  __typename?: 'TermscoutsConnection';
  /** A list of edges which contains the `Termscout` and cursor to aid in pagination. */
  edges: Array<GqlTermscoutsEdge>;
  /** A list of `Termscout` objects. */
  nodes: Array<Maybe<GqlTermscout>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Termscout` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Termscout` edge in the connection. */
export type GqlTermscoutsEdge = {
  __typename?: 'TermscoutsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Termscout` at the end of the edge. */
  node: Maybe<GqlTermscout>;
};

/** Methods to use when ordering `Termscout`. */
export enum TermscoutsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  ProductSuiteIdAsc = 'PRODUCT_SUITE_ID_ASC',
  ProductSuiteIdDesc = 'PRODUCT_SUITE_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlTestDrive = GqlNode & {
  __typename?: 'TestDrive';
  createdAt: Maybe<Scalars['Datetime']>;
  details: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Maybe<Scalars['Int']>;
  organizationId: Maybe<Scalars['UUID']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  termId: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `TermToTestDrive`. */
  termToTestDrives: Array<GqlTermToTestDrive>;
  /** Reads and enables pagination through a set of `TermToTestDrive`. */
  termToTestDrivesConnection: GqlTermToTestDrivesConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToTestDriveTestDriveIdAndTermId: GqlTestDriveTermsByTermToTestDriveTestDriveIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToTestDriveTestDriveIdAndTermIdList: Array<GqlTerm>;
  testMode: Maybe<Scalars['Boolean']>;
  updatedAt: Maybe<Scalars['Datetime']>;
};


export type GqlTestDriveTermToTestDrivesArgs = {
  condition: InputMaybe<GqlTermToTestDriveCondition>;
  filter: InputMaybe<GqlTermToTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};


export type GqlTestDriveTermToTestDrivesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToTestDriveCondition>;
  filter: InputMaybe<GqlTermToTestDriveFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};


export type GqlTestDriveTermsByTermToTestDriveTestDriveIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlTestDriveTermsByTermToTestDriveTestDriveIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};

/**
 * A condition to be used against `TestDrive` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlTestDriveCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `termId` field. */
  termId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `TestDrive` object types. All fields are combined with a logical ‘and.’ */
export type GqlTestDriveFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTestDriveFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTestDriveFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTestDriveFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `termId` field. */
  termId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `TestDrive` */
export type GqlTestDriveInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId: Scalars['Int'];
  termId?: InputMaybe<Scalars['Int']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `TestDrive`. Fields that are set will be updated. */
export type GqlTestDrivePatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Term` values, with data from `TermToTestDrive`. */
export type GqlTestDriveTermsByTermToTestDriveTestDriveIdAndTermIdManyToManyConnection = {
  __typename?: 'TestDriveTermsByTermToTestDriveTestDriveIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToTestDrive`, and the cursor to aid in pagination. */
  edges: Array<GqlTestDriveTermsByTermToTestDriveTestDriveIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToTestDrive`. */
export type GqlTestDriveTermsByTermToTestDriveTestDriveIdAndTermIdManyToManyEdge = {
  __typename?: 'TestDriveTermsByTermToTestDriveTestDriveIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

/** A connection to a list of `TestDrive` values. */
export type GqlTestDrivesConnection = {
  __typename?: 'TestDrivesConnection';
  /** A list of edges which contains the `TestDrive` and cursor to aid in pagination. */
  edges: Array<GqlTestDrivesEdge>;
  /** A list of `TestDrive` objects. */
  nodes: Array<Maybe<GqlTestDrive>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TestDrive` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TestDrive` edge in the connection. */
export type GqlTestDrivesEdge = {
  __typename?: 'TestDrivesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TestDrive` at the end of the edge. */
  node: Maybe<GqlTestDrive>;
};

/** Methods to use when ordering `TestDrive`. */
export enum TestDrivesOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  TermIdAsc = 'TERM_ID_ASC',
  TermIdDesc = 'TERM_ID_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlTheoremProduct = GqlNode & {
  __typename?: 'TheoremProduct';
  createdAt: Scalars['Datetime'];
  details: Maybe<Scalars['JSON']>;
  id: Scalars['Int'];
  key: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  priceId: Maybe<Scalars['String']>;
  priceId2: Maybe<Scalars['String']>;
  stripeProductId: Maybe<Scalars['String']>;
  testPriceId: Maybe<Scalars['String']>;
  testPriceId2: Maybe<Scalars['String']>;
  testStripeProductId: Maybe<Scalars['String']>;
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `TheoremProduct` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlTheoremProductCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `key` field. */
  key?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priceId` field. */
  priceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `priceId2` field. */
  priceId2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `stripeProductId` field. */
  stripeProductId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testPriceId` field. */
  testPriceId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testPriceId2` field. */
  testPriceId2?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `testStripeProductId` field. */
  testStripeProductId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `TheoremProduct` object types. All fields are combined with a logical ‘and.’ */
export type GqlTheoremProductFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlTheoremProductFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `key` field. */
  key?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlTheoremProductFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlTheoremProductFilter>>;
  /** Filter by the object’s `priceId` field. */
  priceId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `priceId2` field. */
  priceId2?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `stripeProductId` field. */
  stripeProductId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testPriceId` field. */
  testPriceId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testPriceId2` field. */
  testPriceId2?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `testStripeProductId` field. */
  testStripeProductId?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `TheoremProduct` */
export type GqlTheoremProductInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  priceId2?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  testPriceId?: InputMaybe<Scalars['String']>;
  testPriceId2?: InputMaybe<Scalars['String']>;
  testStripeProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `TheoremProduct`. Fields that are set will be updated. */
export type GqlTheoremProductPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceId?: InputMaybe<Scalars['String']>;
  priceId2?: InputMaybe<Scalars['String']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  testPriceId?: InputMaybe<Scalars['String']>;
  testPriceId2?: InputMaybe<Scalars['String']>;
  testStripeProductId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `TheoremProduct` values. */
export type GqlTheoremProductsConnection = {
  __typename?: 'TheoremProductsConnection';
  /** A list of edges which contains the `TheoremProduct` and cursor to aid in pagination. */
  edges: Array<GqlTheoremProductsEdge>;
  /** A list of `TheoremProduct` objects. */
  nodes: Array<Maybe<GqlTheoremProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `TheoremProduct` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `TheoremProduct` edge in the connection. */
export type GqlTheoremProductsEdge = {
  __typename?: 'TheoremProductsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `TheoremProduct` at the end of the edge. */
  node: Maybe<GqlTheoremProduct>;
};

/** Methods to use when ordering `TheoremProduct`. */
export enum TheoremProductsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  KeyAsc = 'KEY_ASC',
  KeyDesc = 'KEY_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PriceId_2Asc = 'PRICE_ID_2_ASC',
  PriceId_2Desc = 'PRICE_ID_2_DESC',
  PriceIdAsc = 'PRICE_ID_ASC',
  PriceIdDesc = 'PRICE_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StripeProductIdAsc = 'STRIPE_PRODUCT_ID_ASC',
  StripeProductIdDesc = 'STRIPE_PRODUCT_ID_DESC',
  TestPriceId_2Asc = 'TEST_PRICE_ID_2_ASC',
  TestPriceId_2Desc = 'TEST_PRICE_ID_2_DESC',
  TestPriceIdAsc = 'TEST_PRICE_ID_ASC',
  TestPriceIdDesc = 'TEST_PRICE_ID_DESC',
  TestStripeProductIdAsc = 'TEST_STRIPE_PRODUCT_ID_ASC',
  TestStripeProductIdDesc = 'TEST_STRIPE_PRODUCT_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type GqlUuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** All input for the `updateAssocHomeById` mutation. */
export type GqlUpdateAssocHomeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `AssocHome` being updated. */
  patch: GqlAssocHomePatch;
};

/** The output of our update `AssocHome` mutation. */
export type GqlUpdateAssocHomePayload = {
  __typename?: 'UpdateAssocHomePayload';
  /** The `AssocHome` that was updated by this mutation. */
  assocHome: Maybe<GqlAssocHome>;
  /** An edge for our `AssocHome`. May be used by Relay 1. */
  assocHomeEdge: Maybe<GqlAssocHomesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `AssocHome`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `AssocHome` mutation. */
export type GqlUpdateAssocHomePayloadAssocHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocHomesOrderBy>>;
};

/** All input for the `updateAssocSectionByNodeId` mutation. */
export type GqlUpdateAssocSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AssocSection` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AssocSection` being updated. */
  patch: GqlAssocSectionPatch;
};

/** All input for the `updateAssocSection` mutation. */
export type GqlUpdateAssocSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `AssocSection` being updated. */
  patch: GqlAssocSectionPatch;
};

/** The output of our update `AssocSection` mutation. */
export type GqlUpdateAssocSectionPayload = {
  __typename?: 'UpdateAssocSectionPayload';
  /** The `AssocSection` that was updated by this mutation. */
  assocSection: Maybe<GqlAssocSection>;
  /** An edge for our `AssocSection`. May be used by Relay 1. */
  assocSectionEdge: Maybe<GqlAssocSectionsEdge>;
  /** Reads a single `Organization` that is related to this `AssocSection`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `AssocSection` mutation. */
export type GqlUpdateAssocSectionPayloadAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};

/** All input for the `updateAssociationToOrganizationByNodeId` mutation. */
export type GqlUpdateAssociationToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `AssociationToOrganization` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `AssociationToOrganization` being updated. */
  patch: GqlAssociationToOrganizationPatch;
};

/** All input for the `updateAssociationToOrganization` mutation. */
export type GqlUpdateAssociationToOrganizationInput = {
  associationId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `AssociationToOrganization` being updated. */
  patch: GqlAssociationToOrganizationPatch;
};

/** The output of our update `AssociationToOrganization` mutation. */
export type GqlUpdateAssociationToOrganizationPayload = {
  __typename?: 'UpdateAssociationToOrganizationPayload';
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  association: Maybe<GqlOrganization>;
  /** The `AssociationToOrganization` that was updated by this mutation. */
  associationToOrganization: Maybe<GqlAssociationToOrganization>;
  /** An edge for our `AssociationToOrganization`. May be used by Relay 1. */
  associationToOrganizationEdge: Maybe<GqlAssociationToOrganizationsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `AssociationToOrganization` mutation. */
export type GqlUpdateAssociationToOrganizationPayloadAssociationToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};

/** All input for the `updateAwardBadgeById` mutation. */
export type GqlUpdateAwardBadgeByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `AwardBadge` being updated. */
  patch: GqlAwardBadgePatch;
};

/** All input for the `updateAwardBadgeBySlug` mutation. */
export type GqlUpdateAwardBadgeBySlugInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `AwardBadge` being updated. */
  patch: GqlAwardBadgePatch;
  slug: Scalars['String'];
};

/** The output of our update `AwardBadge` mutation. */
export type GqlUpdateAwardBadgePayload = {
  __typename?: 'UpdateAwardBadgePayload';
  /** The `AwardBadge` that was updated by this mutation. */
  awardBadge: Maybe<GqlAwardBadge>;
  /** An edge for our `AwardBadge`. May be used by Relay 1. */
  awardBadgeEdge: Maybe<GqlAwardBadgesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `AwardBadge` mutation. */
export type GqlUpdateAwardBadgePayloadAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<AwardBadgesOrderBy>>;
};

/** All input for the `updateBestForByNodeId` mutation. */
export type GqlUpdateBestForByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BestFor` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BestFor` being updated. */
  patch: GqlBestForPatch;
};

/** All input for the `updateBestFor` mutation. */
export type GqlUpdateBestForInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `BestFor` being updated. */
  patch: GqlBestForPatch;
};

/** The output of our update `BestFor` mutation. */
export type GqlUpdateBestForPayload = {
  __typename?: 'UpdateBestForPayload';
  /** The `BestFor` that was updated by this mutation. */
  bestFor: Maybe<GqlBestFor>;
  /** An edge for our `BestFor`. May be used by Relay 1. */
  bestForEdge: Maybe<GqlBestForsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `BestFor` mutation. */
export type GqlUpdateBestForPayloadBestForEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForsOrderBy>>;
};

/** All input for the `updateBestForToProductByNodeId` mutation. */
export type GqlUpdateBestForToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `BestForToProduct` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `BestForToProduct` being updated. */
  patch: GqlBestForToProductPatch;
};

/** All input for the `updateBestForToProduct` mutation. */
export type GqlUpdateBestForToProductInput = {
  bestForId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `BestForToProduct` being updated. */
  patch: GqlBestForToProductPatch;
  productId: Scalars['Int'];
};

/** The output of our update `BestForToProduct` mutation. */
export type GqlUpdateBestForToProductPayload = {
  __typename?: 'UpdateBestForToProductPayload';
  /** Reads a single `BestFor` that is related to this `BestForToProduct`. */
  bestFor: Maybe<GqlBestFor>;
  /** The `BestForToProduct` that was updated by this mutation. */
  bestForToProduct: Maybe<GqlBestForToProduct>;
  /** An edge for our `BestForToProduct`. May be used by Relay 1. */
  bestForToProductEdge: Maybe<GqlBestForToProductsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `BestForToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `BestForToProduct` mutation. */
export type GqlUpdateBestForToProductPayloadBestForToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};

/** All input for the `updateCategoryByNodeId` mutation. */
export type GqlUpdateCategoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Category` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Category` being updated. */
  patch: GqlCategoryPatch;
};

/** All input for the `updateCategory` mutation. */
export type GqlUpdateCategoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Category` being updated. */
  patch: GqlCategoryPatch;
};

/** The output of our update `Category` mutation. */
export type GqlUpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  /** The `Category` that was updated by this mutation. */
  category: Maybe<GqlCategory>;
  /** An edge for our `Category`. May be used by Relay 1. */
  categoryEdge: Maybe<GqlCategoriesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `Category` mutation. */
export type GqlUpdateCategoryPayloadCategoryEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};

/** All input for the `updateCategoryToProductByNodeId` mutation. */
export type GqlUpdateCategoryToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `CategoryToProduct` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `CategoryToProduct` being updated. */
  patch: GqlCategoryToProductPatch;
};

/** All input for the `updateCategoryToProduct` mutation. */
export type GqlUpdateCategoryToProductInput = {
  categoryId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `CategoryToProduct` being updated. */
  patch: GqlCategoryToProductPatch;
  productId: Scalars['Int'];
};

/** The output of our update `CategoryToProduct` mutation. */
export type GqlUpdateCategoryToProductPayload = {
  __typename?: 'UpdateCategoryToProductPayload';
  /** Reads a single `Category` that is related to this `CategoryToProduct`. */
  category: Maybe<GqlCategory>;
  /** The `CategoryToProduct` that was updated by this mutation. */
  categoryToProduct: Maybe<GqlCategoryToProduct>;
  /** An edge for our `CategoryToProduct`. May be used by Relay 1. */
  categoryToProductEdge: Maybe<GqlCategoryToProductsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `CategoryToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `CategoryToProduct` mutation. */
export type GqlUpdateCategoryToProductPayloadCategoryToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};

/** All input for the `updateConnectCustomerByNodeId` mutation. */
export type GqlUpdateConnectCustomerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ConnectCustomer` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ConnectCustomer` being updated. */
  patch: GqlConnectCustomerPatch;
};

/** All input for the `updateConnectCustomerByUserIdAndAccountIdAndOrganizationId` mutation. */
export type GqlUpdateConnectCustomerByUserIdAndAccountIdAndOrganizationIdInput = {
  accountId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ConnectCustomer` being updated. */
  patch: GqlConnectCustomerPatch;
  userId: Scalars['Int'];
};

/** All input for the `updateConnectCustomer` mutation. */
export type GqlUpdateConnectCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ConnectCustomer` being updated. */
  patch: GqlConnectCustomerPatch;
};

/** The output of our update `ConnectCustomer` mutation. */
export type GqlUpdateConnectCustomerPayload = {
  __typename?: 'UpdateConnectCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectCustomer` that was updated by this mutation. */
  connectCustomer: Maybe<GqlConnectCustomer>;
  /** An edge for our `ConnectCustomer`. May be used by Relay 1. */
  connectCustomerEdge: Maybe<GqlConnectCustomersEdge>;
  /** Reads a single `Organization` that is related to this `ConnectCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ConnectCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `ConnectCustomer` mutation. */
export type GqlUpdateConnectCustomerPayloadConnectCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};

/** All input for the `updateConnectPurchaseByNodeId` mutation. */
export type GqlUpdateConnectPurchaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ConnectPurchase` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ConnectPurchase` being updated. */
  patch: GqlConnectPurchasePatch;
};

/** All input for the `updateConnectPurchase` mutation. */
export type GqlUpdateConnectPurchaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ConnectPurchase` being updated. */
  patch: GqlConnectPurchasePatch;
};

/** The output of our update `ConnectPurchase` mutation. */
export type GqlUpdateConnectPurchasePayload = {
  __typename?: 'UpdateConnectPurchasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectPurchase` that was updated by this mutation. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** An edge for our `ConnectPurchase`. May be used by Relay 1. */
  connectPurchaseEdge: Maybe<GqlConnectPurchasesEdge>;
  /** Reads a single `Organization` that is related to this `ConnectPurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `ConnectPurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ConnectPurchase` mutation. */
export type GqlUpdateConnectPurchasePayloadConnectPurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};

/** All input for the `updateDiversityCertificationByNodeId` mutation. */
export type GqlUpdateDiversityCertificationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `DiversityCertification` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `DiversityCertification` being updated. */
  patch: GqlDiversityCertificationPatch;
};

/** All input for the `updateDiversityCertification` mutation. */
export type GqlUpdateDiversityCertificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `DiversityCertification` being updated. */
  patch: GqlDiversityCertificationPatch;
};

/** The output of our update `DiversityCertification` mutation. */
export type GqlUpdateDiversityCertificationPayload = {
  __typename?: 'UpdateDiversityCertificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DiversityCertification` that was updated by this mutation. */
  diversityCertification: Maybe<GqlDiversityCertification>;
  /** An edge for our `DiversityCertification`. May be used by Relay 1. */
  diversityCertificationEdge: Maybe<GqlDiversityCertificationsEdge>;
  /** Reads a single `Organization` that is related to this `DiversityCertification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `DiversityCertification` mutation. */
export type GqlUpdateDiversityCertificationPayloadDiversityCertificationEdgeArgs = {
  orderBy?: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};

/** All input for the `updateFeatureByNodeId` mutation. */
export type GqlUpdateFeatureByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Feature` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Feature` being updated. */
  patch: GqlFeaturePatch;
};

/** All input for the `updateFeature` mutation. */
export type GqlUpdateFeatureInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Feature` being updated. */
  patch: GqlFeaturePatch;
};

/** The output of our update `Feature` mutation. */
export type GqlUpdateFeaturePayload = {
  __typename?: 'UpdateFeaturePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Feature` that was updated by this mutation. */
  feature: Maybe<GqlFeature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge: Maybe<GqlFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `Feature` mutation. */
export type GqlUpdateFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the `updateFeatureToProductByNodeId` mutation. */
export type GqlUpdateFeatureToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FeatureToProduct` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FeatureToProduct` being updated. */
  patch: GqlFeatureToProductPatch;
};

/** All input for the `updateFeatureToProduct` mutation. */
export type GqlUpdateFeatureToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  featureId: Scalars['Int'];
  /** An object where the defined keys will be set on the `FeatureToProduct` being updated. */
  patch: GqlFeatureToProductPatch;
  productId: Scalars['Int'];
};

/** The output of our update `FeatureToProduct` mutation. */
export type GqlUpdateFeatureToProductPayload = {
  __typename?: 'UpdateFeatureToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Feature` that is related to this `FeatureToProduct`. */
  feature: Maybe<GqlFeature>;
  /** The `FeatureToProduct` that was updated by this mutation. */
  featureToProduct: Maybe<GqlFeatureToProduct>;
  /** An edge for our `FeatureToProduct`. May be used by Relay 1. */
  featureToProductEdge: Maybe<GqlFeatureToProductsEdge>;
  /** Reads a single `Product` that is related to this `FeatureToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `FeatureToProduct` mutation. */
export type GqlUpdateFeatureToProductPayloadFeatureToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};

/** All input for the `updateLawfirmServiceByNodeId` mutation. */
export type GqlUpdateLawfirmServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LawfirmService` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `LawfirmService` being updated. */
  patch: GqlLawfirmServicePatch;
};

/** All input for the `updateLawfirmService` mutation. */
export type GqlUpdateLawfirmServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `LawfirmService` being updated. */
  patch: GqlLawfirmServicePatch;
};

/** The output of our update `LawfirmService` mutation. */
export type GqlUpdateLawfirmServicePayload = {
  __typename?: 'UpdateLawfirmServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `LawfirmService` that was updated by this mutation. */
  lawfirmService: Maybe<GqlLawfirmService>;
  /** An edge for our `LawfirmService`. May be used by Relay 1. */
  lawfirmServiceEdge: Maybe<GqlLawfirmServicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `LawfirmService` mutation. */
export type GqlUpdateLawfirmServicePayloadLawfirmServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<LawfirmServicesOrderBy>>;
};

/** All input for the `updateLawfirmType` mutation. */
export type GqlUpdateLawfirmTypeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  orgid: Scalars['UUID'];
  termid: Scalars['Int'];
};

/** The output of our `updateLawfirmType` mutation. */
export type GqlUpdateLawfirmTypePayload = {
  __typename?: 'UpdateLawfirmTypePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  integer: Maybe<Scalars['Int']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};

/** All input for the `updateListingCreatorById` mutation. */
export type GqlUpdateListingCreatorByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ListingCreator` being updated. */
  patch: GqlListingCreatorPatch;
};

/** The output of our update `ListingCreator` mutation. */
export type GqlUpdateListingCreatorPayload = {
  __typename?: 'UpdateListingCreatorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ListingCreator` that was updated by this mutation. */
  listingCreator: Maybe<GqlListingCreator>;
  /** An edge for our `ListingCreator`. May be used by Relay 1. */
  listingCreatorEdge: Maybe<GqlListingCreatorsEdge>;
  /** Reads a single `Organization` that is related to this `ListingCreator`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ListingCreator` mutation. */
export type GqlUpdateListingCreatorPayloadListingCreatorEdgeArgs = {
  orderBy?: InputMaybe<Array<ListingCreatorsOrderBy>>;
};

/** All input for the `updateLocationByNodeId` mutation. */
export type GqlUpdateLocationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Location` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Location` being updated. */
  patch: GqlLocationPatch;
};

/** All input for the `updateLocation` mutation. */
export type GqlUpdateLocationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Location` being updated. */
  patch: GqlLocationPatch;
};

/** The output of our update `Location` mutation. */
export type GqlUpdateLocationPayload = {
  __typename?: 'UpdateLocationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Location` that was updated by this mutation. */
  location: Maybe<GqlLocation>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge: Maybe<GqlLocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `Location` mutation. */
export type GqlUpdateLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** All input for the `updateNotificationByNodeId` mutation. */
export type GqlUpdateNotificationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Notification` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Notification` being updated. */
  patch: GqlNotificationPatch;
};

/** All input for the `updateNotification` mutation. */
export type GqlUpdateNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Notification` being updated. */
  patch: GqlNotificationPatch;
};

/** The output of our update `Notification` mutation. */
export type GqlUpdateNotificationPayload = {
  __typename?: 'UpdateNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Notification` that was updated by this mutation. */
  notification: Maybe<GqlNotification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<GqlNotificationsEdge>;
  /** Reads a single `Organization` that is related to this `Notification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `Notification`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `Notification` mutation. */
export type GqlUpdateNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** All input for the `updateNoviMemberByNodeId` mutation. */
export type GqlUpdateNoviMemberByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `NoviMember` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `NoviMember` being updated. */
  patch: GqlNoviMemberPatch;
};

/** All input for the `updateNoviMember` mutation. */
export type GqlUpdateNoviMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  noviMemberId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NoviMember` being updated. */
  patch: GqlNoviMemberPatch;
  userId: Scalars['Int'];
};

/** The output of our update `NoviMember` mutation. */
export type GqlUpdateNoviMemberPayload = {
  __typename?: 'UpdateNoviMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `NoviMember` that was updated by this mutation. */
  noviMember: Maybe<GqlNoviMember>;
  /** An edge for our `NoviMember`. May be used by Relay 1. */
  noviMemberEdge: Maybe<GqlNoviMembersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `NoviMember`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `NoviMember` mutation. */
export type GqlUpdateNoviMemberPayloadNoviMemberEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviMembersOrderBy>>;
};

/** All input for the `updateNoviOrganizationByNodeId` mutation. */
export type GqlUpdateNoviOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `NoviOrganization` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `NoviOrganization` being updated. */
  patch: GqlNoviOrganizationPatch;
};

/** All input for the `updateNoviOrganization` mutation. */
export type GqlUpdateNoviOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `NoviOrganization` being updated. */
  patch: GqlNoviOrganizationPatch;
};

/** The output of our update `NoviOrganization` mutation. */
export type GqlUpdateNoviOrganizationPayload = {
  __typename?: 'UpdateNoviOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `NoviOrganization` that was updated by this mutation. */
  noviOrganization: Maybe<GqlNoviOrganization>;
  /** An edge for our `NoviOrganization`. May be used by Relay 1. */
  noviOrganizationEdge: Maybe<GqlNoviOrganizationsEdge>;
  /** Reads a single `Organization` that is related to this `NoviOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `NoviOrganization` mutation. */
export type GqlUpdateNoviOrganizationPayloadNoviOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};

/** All input for the `updateOrganizationByAuth0OrgId` mutation. */
export type GqlUpdateOrganizationByAuth0OrgIdInput = {
  auth0OrgId: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Organization` being updated. */
  patch: GqlOrganizationPatch;
};

/** All input for the `updateOrganizationByNodeId` mutation. */
export type GqlUpdateOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Organization` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Organization` being updated. */
  patch: GqlOrganizationPatch;
};

/** All input for the `updateOrganization` mutation. */
export type GqlUpdateOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Organization` being updated. */
  patch: GqlOrganizationPatch;
};

/** All input for the `updateOrganizationListingByNodeId` mutation. */
export type GqlUpdateOrganizationListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrganizationListing` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrganizationListing` being updated. */
  patch: GqlOrganizationListingPatch;
};

/** All input for the `updateOrganizationListing` mutation. */
export type GqlUpdateOrganizationListingInput = {
  associationId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrganizationListing` being updated. */
  patch: GqlOrganizationListingPatch;
};

/** The output of our update `OrganizationListing` mutation. */
export type GqlUpdateOrganizationListingPayload = {
  __typename?: 'UpdateOrganizationListingPayload';
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `OrganizationListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationListing` that was updated by this mutation. */
  organizationListing: Maybe<GqlOrganizationListing>;
  /** An edge for our `OrganizationListing`. May be used by Relay 1. */
  organizationListingEdge: Maybe<GqlOrganizationListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `OrganizationListing` mutation. */
export type GqlUpdateOrganizationListingPayloadOrganizationListingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** The output of our update `Organization` mutation. */
export type GqlUpdateOrganizationPayload = {
  __typename?: 'UpdateOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Term` that is related to this `Organization`. */
  mainTerm: Maybe<GqlTerm>;
  /** The `Organization` that was updated by this mutation. */
  organization: Maybe<GqlOrganization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge: Maybe<GqlOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `Organization` mutation. */
export type GqlUpdateOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the `updateOrganizationTechstackByNodeId` mutation. */
export type GqlUpdateOrganizationTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `OrganizationTechstack` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `OrganizationTechstack` being updated. */
  patch: GqlOrganizationTechstackPatch;
};

/** All input for the `updateOrganizationTechstack` mutation. */
export type GqlUpdateOrganizationTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `OrganizationTechstack` being updated. */
  patch: GqlOrganizationTechstackPatch;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our update `OrganizationTechstack` mutation. */
export type GqlUpdateOrganizationTechstackPayload = {
  __typename?: 'UpdateOrganizationTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `OrganizationTechstack`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationTechstack` that was updated by this mutation. */
  organizationTechstack: Maybe<GqlOrganizationTechstack>;
  /** An edge for our `OrganizationTechstack`. May be used by Relay 1. */
  organizationTechstackEdge: Maybe<GqlOrganizationTechstacksEdge>;
  /** Reads a single `Product` that is related to this `OrganizationTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `OrganizationTechstack` mutation. */
export type GqlUpdateOrganizationTechstackPayloadOrganizationTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};

/** All input for the `updatePersonalTechstackByNodeId` mutation. */
export type GqlUpdatePersonalTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PersonalTechstack` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PersonalTechstack` being updated. */
  patch: GqlPersonalTechstackPatch;
};

/** All input for the `updatePersonalTechstack` mutation. */
export type GqlUpdatePersonalTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PersonalTechstack` being updated. */
  patch: GqlPersonalTechstackPatch;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our update `PersonalTechstack` mutation. */
export type GqlUpdatePersonalTechstackPayload = {
  __typename?: 'UpdatePersonalTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PersonalTechstack` that was updated by this mutation. */
  personalTechstack: Maybe<GqlPersonalTechstack>;
  /** An edge for our `PersonalTechstack`. May be used by Relay 1. */
  personalTechstackEdge: Maybe<GqlPersonalTechstacksEdge>;
  /** Reads a single `Product` that is related to this `PersonalTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `PersonalTechstack`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `PersonalTechstack` mutation. */
export type GqlUpdatePersonalTechstackPayloadPersonalTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};

/** All input for the `updatePracticeGroupByNodeId` mutation. */
export type GqlUpdatePracticeGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PracticeGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PracticeGroup` being updated. */
  patch: GqlPracticeGroupPatch;
};

/** All input for the `updatePracticeGroup` mutation. */
export type GqlUpdatePracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `PracticeGroup` being updated. */
  patch: GqlPracticeGroupPatch;
};

/** The output of our update `PracticeGroup` mutation. */
export type GqlUpdatePracticeGroupPayload = {
  __typename?: 'UpdatePracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PracticeGroup` that was updated by this mutation. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** An edge for our `PracticeGroup`. May be used by Relay 1. */
  practiceGroupEdge: Maybe<GqlPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `PracticeGroup` mutation. */
export type GqlUpdatePracticeGroupPayloadPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};

/** All input for the `updatePremiumInfoToTermByNodeId` mutation. */
export type GqlUpdatePremiumInfoToTermByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PremiumInfoToTerm` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PremiumInfoToTerm` being updated. */
  patch: GqlPremiumInfoToTermPatch;
};

/** All input for the `updatePremiumInfoToTerm` mutation. */
export type GqlUpdatePremiumInfoToTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PremiumInfoToTerm` being updated. */
  patch: GqlPremiumInfoToTermPatch;
  premiumInfoId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our update `PremiumInfoToTerm` mutation. */
export type GqlUpdatePremiumInfoToTermPayload = {
  __typename?: 'UpdatePremiumInfoToTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PremiumProductInfo` that is related to this `PremiumInfoToTerm`. */
  premiumInfo: Maybe<GqlPremiumProductInfo>;
  /** The `PremiumInfoToTerm` that was updated by this mutation. */
  premiumInfoToTerm: Maybe<GqlPremiumInfoToTerm>;
  /** An edge for our `PremiumInfoToTerm`. May be used by Relay 1. */
  premiumInfoToTermEdge: Maybe<GqlPremiumInfoToTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `PremiumInfoToTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our update `PremiumInfoToTerm` mutation. */
export type GqlUpdatePremiumInfoToTermPayloadPremiumInfoToTermEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};

/** All input for the `updatePremiumProductInfoByIdAndProductId` mutation. */
export type GqlUpdatePremiumProductInfoByIdAndProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `PremiumProductInfo` being updated. */
  patch: GqlPremiumProductInfoPatch;
  productId: Scalars['Int'];
};

/** All input for the `updatePremiumProductInfoByNodeId` mutation. */
export type GqlUpdatePremiumProductInfoByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PremiumProductInfo` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PremiumProductInfo` being updated. */
  patch: GqlPremiumProductInfoPatch;
};

/** All input for the `updatePremiumProductInfo` mutation. */
export type GqlUpdatePremiumProductInfoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `PremiumProductInfo` being updated. */
  patch: GqlPremiumProductInfoPatch;
};

/** The output of our update `PremiumProductInfo` mutation. */
export type GqlUpdatePremiumProductInfoPayload = {
  __typename?: 'UpdatePremiumProductInfoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PremiumProductInfo` that was updated by this mutation. */
  premiumProductInfo: Maybe<GqlPremiumProductInfo>;
  /** An edge for our `PremiumProductInfo`. May be used by Relay 1. */
  premiumProductInfoEdge: Maybe<GqlPremiumProductInfosEdge>;
  /** Reads a single `Product` that is related to this `PremiumProductInfo`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `PremiumProductInfo` mutation. */
export type GqlUpdatePremiumProductInfoPayloadPremiumProductInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};

/** All input for the `updateProductAwardDetailByNodeId` mutation. */
export type GqlUpdateProductAwardDetailByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductAwardDetail` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductAwardDetail` being updated. */
  patch: GqlProductAwardDetailPatch;
};

/** All input for the `updateProductAwardDetail` mutation. */
export type GqlUpdateProductAwardDetailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductAwardDetail` being updated. */
  patch: GqlProductAwardDetailPatch;
  productId: Scalars['Int'];
  year: Scalars['Int'];
};

/** The output of our update `ProductAwardDetail` mutation. */
export type GqlUpdateProductAwardDetailPayload = {
  __typename?: 'UpdateProductAwardDetailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductAwardDetail`. */
  product: Maybe<GqlProduct>;
  /** The `ProductAwardDetail` that was updated by this mutation. */
  productAwardDetail: Maybe<GqlProductAwardDetail>;
  /** An edge for our `ProductAwardDetail`. May be used by Relay 1. */
  productAwardDetailEdge: Maybe<GqlProductAwardDetailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductAwardDetail` mutation. */
export type GqlUpdateProductAwardDetailPayloadProductAwardDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};

/** All input for the `updateProductByNodeId` mutation. */
export type GqlUpdateProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Product` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: GqlProductPatch;
};

/** All input for the `updateProductFeatureByTermByNodeId` mutation. */
export type GqlUpdateProductFeatureByTermByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductFeatureByTerm` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductFeatureByTerm` being updated. */
  patch: GqlProductFeatureByTermPatch;
};

/** All input for the `updateProductFeatureByTerm` mutation. */
export type GqlUpdateProductFeatureByTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  networkId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProductFeatureByTerm` being updated. */
  patch: GqlProductFeatureByTermPatch;
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our update `ProductFeatureByTerm` mutation. */
export type GqlUpdateProductFeatureByTermPayload = {
  __typename?: 'UpdateProductFeatureByTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `ProductFeatureByTerm`. */
  network: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductFeatureByTerm`. */
  product: Maybe<GqlProduct>;
  /** The `ProductFeatureByTerm` that was updated by this mutation. */
  productFeatureByTerm: Maybe<GqlProductFeatureByTerm>;
  /** An edge for our `ProductFeatureByTerm`. May be used by Relay 1. */
  productFeatureByTermEdge: Maybe<GqlProductFeatureByTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `ProductFeatureByTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our update `ProductFeatureByTerm` mutation. */
export type GqlUpdateProductFeatureByTermPayloadProductFeatureByTermEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** All input for the `updateProduct` mutation. */
export type GqlUpdateProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Product` being updated. */
  patch: GqlProductPatch;
};

/** All input for the `updateProductListingByNodeId` mutation. */
export type GqlUpdateProductListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductListing` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductListing` being updated. */
  patch: GqlProductListingPatch;
};

/** All input for the `updateProductListingByProductIdAndAssociationId` mutation. */
export type GqlUpdateProductListingByProductIdAndAssociationIdInput = {
  associationId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductListing` being updated. */
  patch: GqlProductListingPatch;
  productId: Scalars['Int'];
};

/** All input for the `updateProductListing` mutation. */
export type GqlUpdateProductListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProductListing` being updated. */
  patch: GqlProductListingPatch;
};

/** The output of our update `ProductListing` mutation. */
export type GqlUpdateProductListingPayload = {
  __typename?: 'UpdateProductListingPayload';
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  association: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `ProductListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductListing` that was updated by this mutation. */
  productListing: Maybe<GqlProductListing>;
  /** An edge for our `ProductListing`. May be used by Relay 1. */
  productListingEdge: Maybe<GqlProductListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductListing` mutation. */
export type GqlUpdateProductListingPayloadProductListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** The output of our update `Product` mutation. */
export type GqlUpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Product` that was updated by this mutation. */
  product: Maybe<GqlProduct>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge: Maybe<GqlProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `Product` mutation. */
export type GqlUpdateProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the `updateProductSectionByNodeId` mutation. */
export type GqlUpdateProductSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductSection` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductSection` being updated. */
  patch: GqlProductSectionPatch;
};

/** All input for the `updateProductSection` mutation. */
export type GqlUpdateProductSectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProductSection` being updated. */
  patch: GqlProductSectionPatch;
};

/** The output of our update `ProductSection` mutation. */
export type GqlUpdateProductSectionPayload = {
  __typename?: 'UpdateProductSectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProductSection` that was updated by this mutation. */
  productSection: Maybe<GqlProductSection>;
  /** An edge for our `ProductSection`. May be used by Relay 1. */
  productSectionEdge: Maybe<GqlProductSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductSection` mutation. */
export type GqlUpdateProductSectionPayloadProductSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductSectionsOrderBy>>;
};

/** All input for the `updateProductToAssocSectionByNodeId` mutation. */
export type GqlUpdateProductToAssocSectionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToAssocSection` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToAssocSection` being updated. */
  patch: GqlProductToAssocSectionPatch;
};

/** All input for the `updateProductToAssocSection` mutation. */
export type GqlUpdateProductToAssocSectionInput = {
  assocSectionId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductToAssocSection` being updated. */
  patch: GqlProductToAssocSectionPatch;
  productId: Scalars['Int'];
};

/** The output of our update `ProductToAssocSection` mutation. */
export type GqlUpdateProductToAssocSectionPayload = {
  __typename?: 'UpdateProductToAssocSectionPayload';
  /** Reads a single `AssocSection` that is related to this `ProductToAssocSection`. */
  assocSection: Maybe<GqlAssocSection>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToAssocSection`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAssocSection` that was updated by this mutation. */
  productToAssocSection: Maybe<GqlProductToAssocSection>;
  /** An edge for our `ProductToAssocSection`. May be used by Relay 1. */
  productToAssocSectionEdge: Maybe<GqlProductToAssocSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToAssocSection` mutation. */
export type GqlUpdateProductToAssocSectionPayloadProductToAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};

/** All input for the `updateProductToAwardBadgeByNodeId` mutation. */
export type GqlUpdateProductToAwardBadgeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToAwardBadge` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToAwardBadge` being updated. */
  patch: GqlProductToAwardBadgePatch;
};

/** All input for the `updateProductToAwardBadge` mutation. */
export type GqlUpdateProductToAwardBadgeInput = {
  awardBadgeId: Scalars['Int'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductToAwardBadge` being updated. */
  patch: GqlProductToAwardBadgePatch;
  productId: Scalars['Int'];
};

/** The output of our update `ProductToAwardBadge` mutation. */
export type GqlUpdateProductToAwardBadgePayload = {
  __typename?: 'UpdateProductToAwardBadgePayload';
  /** Reads a single `AwardBadge` that is related to this `ProductToAwardBadge`. */
  awardBadge: Maybe<GqlAwardBadge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToAwardBadge`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAwardBadge` that was updated by this mutation. */
  productToAwardBadge: Maybe<GqlProductToAwardBadge>;
  /** An edge for our `ProductToAwardBadge`. May be used by Relay 1. */
  productToAwardBadgeEdge: Maybe<GqlProductToAwardBadgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToAwardBadge` mutation. */
export type GqlUpdateProductToAwardBadgePayloadProductToAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};

/** All input for the `updateProductToClientByNodeId` mutation. */
export type GqlUpdateProductToClientByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToClient` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToClient` being updated. */
  patch: GqlProductToClientPatch;
};

/** All input for the `updateProductToClient` mutation. */
export type GqlUpdateProductToClientInput = {
  clientId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductToClient` being updated. */
  patch: GqlProductToClientPatch;
  productId: Scalars['Int'];
};

/** The output of our update `ProductToClient` mutation. */
export type GqlUpdateProductToClientPayload = {
  __typename?: 'UpdateProductToClientPayload';
  /** Reads a single `Organization` that is related to this `ProductToClient`. */
  client: Maybe<GqlOrganization>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToClient`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToClient` that was updated by this mutation. */
  productToClient: Maybe<GqlProductToClient>;
  /** An edge for our `ProductToClient`. May be used by Relay 1. */
  productToClientEdge: Maybe<GqlProductToClientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToClient` mutation. */
export type GqlUpdateProductToClientPayloadProductToClientEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};

/** All input for the `updateProductToCompetitorByNodeId` mutation. */
export type GqlUpdateProductToCompetitorByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToCompetitor` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToCompetitor` being updated. */
  patch: GqlProductToCompetitorPatch;
};

/** All input for the `updateProductToCompetitor` mutation. */
export type GqlUpdateProductToCompetitorInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  competitorId: Scalars['Int'];
  locked: Scalars['Boolean'];
  /** An object where the defined keys will be set on the `ProductToCompetitor` being updated. */
  patch: GqlProductToCompetitorPatch;
  productId: Scalars['Int'];
};

/** The output of our update `ProductToCompetitor` mutation. */
export type GqlUpdateProductToCompetitorPayload = {
  __typename?: 'UpdateProductToCompetitorPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  competitor: Maybe<GqlProduct>;
  /** Reads a single `Organization` that is related to this `ProductToCompetitor`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToCompetitor` that was updated by this mutation. */
  productToCompetitor: Maybe<GqlProductToCompetitor>;
  /** An edge for our `ProductToCompetitor`. May be used by Relay 1. */
  productToCompetitorEdge: Maybe<GqlProductToCompetitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToCompetitor` mutation. */
export type GqlUpdateProductToCompetitorPayloadProductToCompetitorEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** All input for the `updateProductToIntegrationByNodeId` mutation. */
export type GqlUpdateProductToIntegrationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToIntegration` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToIntegration` being updated. */
  patch: GqlProductToIntegrationPatch;
};

/** All input for the `updateProductToIntegration` mutation. */
export type GqlUpdateProductToIntegrationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  integrationId: Scalars['Int'];
  /** An object where the defined keys will be set on the `ProductToIntegration` being updated. */
  patch: GqlProductToIntegrationPatch;
  productId: Scalars['Int'];
};

/** The output of our update `ProductToIntegration` mutation. */
export type GqlUpdateProductToIntegrationPayload = {
  __typename?: 'UpdateProductToIntegrationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  integration: Maybe<GqlProduct>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToIntegration` that was updated by this mutation. */
  productToIntegration: Maybe<GqlProductToIntegration>;
  /** An edge for our `ProductToIntegration`. May be used by Relay 1. */
  productToIntegrationEdge: Maybe<GqlProductToIntegrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToIntegration` mutation. */
export type GqlUpdateProductToIntegrationPayloadProductToIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};

/** All input for the `updateProductToOrganizationByNodeId` mutation. */
export type GqlUpdateProductToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToOrganization` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToOrganization` being updated. */
  patch: GqlProductToOrganizationPatch;
};

/** All input for the `updateProductToOrganization` mutation. */
export type GqlUpdateProductToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `ProductToOrganization` being updated. */
  patch: GqlProductToOrganizationPatch;
  productId: Scalars['Int'];
};

/** The output of our update `ProductToOrganization` mutation. */
export type GqlUpdateProductToOrganizationPayload = {
  __typename?: 'UpdateProductToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `ProductToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToOrganization`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToOrganization` that was updated by this mutation. */
  productToOrganization: Maybe<GqlProductToOrganization>;
  /** An edge for our `ProductToOrganization`. May be used by Relay 1. */
  productToOrganizationEdge: Maybe<GqlProductToOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToOrganization` mutation. */
export type GqlUpdateProductToOrganizationPayloadProductToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};

/** All input for the `updateProductToPracticeGroupByNodeId` mutation. */
export type GqlUpdateProductToPracticeGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToPracticeGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToPracticeGroup` being updated. */
  patch: GqlProductToPracticeGroupPatch;
};

/** All input for the `updateProductToPracticeGroup` mutation. */
export type GqlUpdateProductToPracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductToPracticeGroup` being updated. */
  patch: GqlProductToPracticeGroupPatch;
  practiceGroupId: Scalars['Int'];
  productId: Scalars['Int'];
};

/** The output of our update `ProductToPracticeGroup` mutation. */
export type GqlUpdateProductToPracticeGroupPayload = {
  __typename?: 'UpdateProductToPracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PracticeGroup` that is related to this `ProductToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Reads a single `Product` that is related to this `ProductToPracticeGroup`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToPracticeGroup` that was updated by this mutation. */
  productToPracticeGroup: Maybe<GqlProductToPracticeGroup>;
  /** An edge for our `ProductToPracticeGroup`. May be used by Relay 1. */
  productToPracticeGroupEdge: Maybe<GqlProductToPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our update `ProductToPracticeGroup` mutation. */
export type GqlUpdateProductToPracticeGroupPayloadProductToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};

/** All input for the `updateProductToSuiteListingByNodeId` mutation. */
export type GqlUpdateProductToSuiteListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToSuiteListing` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToSuiteListing` being updated. */
  patch: GqlProductToSuiteListingPatch;
};

/** All input for the `updateProductToSuiteListing` mutation. */
export type GqlUpdateProductToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductToSuiteListing` being updated. */
  patch: GqlProductToSuiteListingPatch;
  productId: Scalars['Int'];
  suiteListingId: Scalars['Int'];
};

/** The output of our update `ProductToSuiteListing` mutation. */
export type GqlUpdateProductToSuiteListingPayload = {
  __typename?: 'UpdateProductToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToSuiteListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToSuiteListing` that was updated by this mutation. */
  productToSuiteListing: Maybe<GqlProductToSuiteListing>;
  /** An edge for our `ProductToSuiteListing`. May be used by Relay 1. */
  productToSuiteListingEdge: Maybe<GqlProductToSuiteListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `ProductToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
};


/** The output of our update `ProductToSuiteListing` mutation. */
export type GqlUpdateProductToSuiteListingPayloadProductToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};

/** All input for the `updateProductToUserByNodeId` mutation. */
export type GqlUpdateProductToUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `ProductToUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `ProductToUser` being updated. */
  patch: GqlProductToUserPatch;
};

/** All input for the `updateProductToUser` mutation. */
export type GqlUpdateProductToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `ProductToUser` being updated. */
  patch: GqlProductToUserPatch;
  productId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our update `ProductToUser` mutation. */
export type GqlUpdateProductToUserPayload = {
  __typename?: 'UpdateProductToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToUser`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToUser` that was updated by this mutation. */
  productToUser: Maybe<GqlProductToUser>;
  /** An edge for our `ProductToUser`. May be used by Relay 1. */
  productToUserEdge: Maybe<GqlProductToUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ProductToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `ProductToUser` mutation. */
export type GqlUpdateProductToUserPayloadProductToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};

/** All input for the `updateRfpByNodeId` mutation. */
export type GqlUpdateRfpByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Rfp` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Rfp` being updated. */
  patch: GqlRfpPatch;
};

/** All input for the `updateRfp` mutation. */
export type GqlUpdateRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Rfp` being updated. */
  patch: GqlRfpPatch;
};

/** The output of our update `Rfp` mutation. */
export type GqlUpdateRfpPayload = {
  __typename?: 'UpdateRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Rfp` that was updated by this mutation. */
  rfp: Maybe<GqlRfp>;
  /** An edge for our `Rfp`. May be used by Relay 1. */
  rfpEdge: Maybe<GqlRfpsEdge>;
  /** Reads a single `User` that is related to this `Rfp`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `Rfp` mutation. */
export type GqlUpdateRfpPayloadRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};

/** All input for the `updateRfpToProductByNodeId` mutation. */
export type GqlUpdateRfpToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RfpToProduct` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RfpToProduct` being updated. */
  patch: GqlRfpToProductPatch;
};

/** All input for the `updateRfpToProduct` mutation. */
export type GqlUpdateRfpToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `RfpToProduct` being updated. */
  patch: GqlRfpToProductPatch;
  productId: Scalars['Int'];
  rfpId: Scalars['Int'];
};

/** The output of our update `RfpToProduct` mutation. */
export type GqlUpdateRfpToProductPayload = {
  __typename?: 'UpdateRfpToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `RfpToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `RfpToProduct`. */
  rfp: Maybe<GqlRfp>;
  /** The `RfpToProduct` that was updated by this mutation. */
  rfpToProduct: Maybe<GqlRfpToProduct>;
  /** An edge for our `RfpToProduct`. May be used by Relay 1. */
  rfpToProductEdge: Maybe<GqlRfpToProductsEdge>;
};


/** The output of our update `RfpToProduct` mutation. */
export type GqlUpdateRfpToProductPayloadRfpToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};

/** All input for the `updateSchedulerByNodeId` mutation. */
export type GqlUpdateSchedulerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Scheduler` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Scheduler` being updated. */
  patch: GqlSchedulerPatch;
};

/** All input for the `updateScheduler` mutation. */
export type GqlUpdateSchedulerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Scheduler` being updated. */
  patch: GqlSchedulerPatch;
};

/** The output of our update `Scheduler` mutation. */
export type GqlUpdateSchedulerPayload = {
  __typename?: 'UpdateSchedulerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Scheduler` that was updated by this mutation. */
  scheduler: Maybe<GqlScheduler>;
  /** An edge for our `Scheduler`. May be used by Relay 1. */
  schedulerEdge: Maybe<GqlSchedulersEdge>;
  /** Reads a single `User` that is related to this `Scheduler`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `Scheduler` mutation. */
export type GqlUpdateSchedulerPayloadSchedulerEdgeArgs = {
  orderBy?: InputMaybe<Array<SchedulersOrderBy>>;
};

/** All input for the `updateSectionLayoutByNodeId` mutation. */
export type GqlUpdateSectionLayoutByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SectionLayout` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SectionLayout` being updated. */
  patch: GqlSectionLayoutPatch;
};

/** All input for the `updateSectionLayout` mutation. */
export type GqlUpdateSectionLayoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SectionLayout` being updated. */
  patch: GqlSectionLayoutPatch;
};

/** The output of our update `SectionLayout` mutation. */
export type GqlUpdateSectionLayoutPayload = {
  __typename?: 'UpdateSectionLayoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SectionLayout` that was updated by this mutation. */
  sectionLayout: Maybe<GqlSectionLayout>;
  /** An edge for our `SectionLayout`. May be used by Relay 1. */
  sectionLayoutEdge: Maybe<GqlSectionLayoutsEdge>;
};


/** The output of our update `SectionLayout` mutation. */
export type GqlUpdateSectionLayoutPayloadSectionLayoutEdgeArgs = {
  orderBy?: InputMaybe<Array<SectionLayoutsOrderBy>>;
};

/** All input for the `updateSimpleServiceByNodeId` mutation. */
export type GqlUpdateSimpleServiceByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SimpleService` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SimpleService` being updated. */
  patch: GqlSimpleServicePatch;
};

/** All input for the `updateSimpleServiceByOrganizationIdAndTermId` mutation. */
export type GqlUpdateSimpleServiceByOrganizationIdAndTermIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `SimpleService` being updated. */
  patch: GqlSimpleServicePatch;
  termId: Scalars['Int'];
};

/** All input for the `updateSimpleService` mutation. */
export type GqlUpdateSimpleServiceInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SimpleService` being updated. */
  patch: GqlSimpleServicePatch;
};

/** The output of our update `SimpleService` mutation. */
export type GqlUpdateSimpleServicePayload = {
  __typename?: 'UpdateSimpleServicePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `SimpleService`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SimpleService` that was updated by this mutation. */
  simpleService: Maybe<GqlSimpleService>;
  /** An edge for our `SimpleService`. May be used by Relay 1. */
  simpleServiceEdge: Maybe<GqlSimpleServicesEdge>;
  /** Reads a single `Term` that is related to this `SimpleService`. */
  term: Maybe<GqlTerm>;
};


/** The output of our update `SimpleService` mutation. */
export type GqlUpdateSimpleServicePayloadSimpleServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};

/** All input for the `updateStackshareOptionByNodeId` mutation. */
export type GqlUpdateStackshareOptionByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StackshareOption` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `StackshareOption` being updated. */
  patch: GqlStackshareOptionPatch;
};

/** All input for the `updateStackshareOption` mutation. */
export type GqlUpdateStackshareOptionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `StackshareOption` being updated. */
  patch: GqlStackshareOptionPatch;
};

/** The output of our update `StackshareOption` mutation. */
export type GqlUpdateStackshareOptionPayload = {
  __typename?: 'UpdateStackshareOptionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StackshareOption` that was updated by this mutation. */
  stackshareOption: Maybe<GqlStackshareOption>;
  /** An edge for our `StackshareOption`. May be used by Relay 1. */
  stackshareOptionEdge: Maybe<GqlStackshareOptionsEdge>;
};


/** The output of our update `StackshareOption` mutation. */
export type GqlUpdateStackshareOptionPayloadStackshareOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<StackshareOptionsOrderBy>>;
};

/** All input for the `updateStripeAccountByNodeId` mutation. */
export type GqlUpdateStripeAccountByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripeAccount` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `StripeAccount` being updated. */
  patch: GqlStripeAccountPatch;
};

/** All input for the `updateStripeAccount` mutation. */
export type GqlUpdateStripeAccountInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `StripeAccount` being updated. */
  patch: GqlStripeAccountPatch;
};

/** The output of our update `StripeAccount` mutation. */
export type GqlUpdateStripeAccountPayload = {
  __typename?: 'UpdateStripeAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeAccount`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeAccount` that was updated by this mutation. */
  stripeAccount: Maybe<GqlStripeAccount>;
  /** An edge for our `StripeAccount`. May be used by Relay 1. */
  stripeAccountEdge: Maybe<GqlStripeAccountsEdge>;
  /** Reads a single `User` that is related to this `StripeAccount`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `StripeAccount` mutation. */
export type GqlUpdateStripeAccountPayloadStripeAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};

/** All input for the `updateStripeCustomerByNodeId` mutation. */
export type GqlUpdateStripeCustomerByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripeCustomer` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `StripeCustomer` being updated. */
  patch: GqlStripeCustomerPatch;
};

/** All input for the `updateStripeCustomer` mutation. */
export type GqlUpdateStripeCustomerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `StripeCustomer` being updated. */
  patch: GqlStripeCustomerPatch;
};

/** The output of our update `StripeCustomer` mutation. */
export type GqlUpdateStripeCustomerPayload = {
  __typename?: 'UpdateStripeCustomerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeCustomer` that was updated by this mutation. */
  stripeCustomer: Maybe<GqlStripeCustomer>;
  /** An edge for our `StripeCustomer`. May be used by Relay 1. */
  stripeCustomerEdge: Maybe<GqlStripeCustomersEdge>;
  /** Reads a single `User` that is related to this `StripeCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `StripeCustomer` mutation. */
export type GqlUpdateStripeCustomerPayloadStripeCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** All input for the `updateStripePurchaseByNodeId` mutation. */
export type GqlUpdateStripePurchaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripePurchase` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `StripePurchase` being updated. */
  patch: GqlStripePurchasePatch;
};

/** All input for the `updateStripePurchase` mutation. */
export type GqlUpdateStripePurchaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `StripePurchase` being updated. */
  patch: GqlStripePurchasePatch;
};

/** The output of our update `StripePurchase` mutation. */
export type GqlUpdateStripePurchasePayload = {
  __typename?: 'UpdateStripePurchasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripePurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `StripePurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripePurchase` that was updated by this mutation. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** An edge for our `StripePurchase`. May be used by Relay 1. */
  stripePurchaseEdge: Maybe<GqlStripePurchasesEdge>;
};


/** The output of our update `StripePurchase` mutation. */
export type GqlUpdateStripePurchasePayloadStripePurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};

/** All input for the `updateStripeSeatByNodeId` mutation. */
export type GqlUpdateStripeSeatByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `StripeSeat` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `StripeSeat` being updated. */
  patch: GqlStripeSeatPatch;
};

/** All input for the `updateStripeSeat` mutation. */
export type GqlUpdateStripeSeatInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `StripeSeat` being updated. */
  patch: GqlStripeSeatPatch;
};

/** The output of our update `StripeSeat` mutation. */
export type GqlUpdateStripeSeatPayload = {
  __typename?: 'UpdateStripeSeatPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeSeat`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeSeat` that was updated by this mutation. */
  stripeSeat: Maybe<GqlStripeSeat>;
  /** An edge for our `StripeSeat`. May be used by Relay 1. */
  stripeSeatEdge: Maybe<GqlStripeSeatsEdge>;
  /** Reads a single `User` that is related to this `StripeSeat`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `StripeSeat` mutation. */
export type GqlUpdateStripeSeatPayloadStripeSeatEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** All input for the `updateSuiteListingByNodeId` mutation. */
export type GqlUpdateSuiteListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `SuiteListing` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `SuiteListing` being updated. */
  patch: GqlSuiteListingPatch;
};

/** All input for the `updateSuiteListing` mutation. */
export type GqlUpdateSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `SuiteListing` being updated. */
  patch: GqlSuiteListingPatch;
};

/** The output of our update `SuiteListing` mutation. */
export type GqlUpdateSuiteListingPayload = {
  __typename?: 'UpdateSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `SuiteListing`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `StripePurchase` that is related to this `SuiteListing`. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** The `SuiteListing` that was updated by this mutation. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** An edge for our `SuiteListing`. May be used by Relay 1. */
  suiteListingEdge: Maybe<GqlSuiteListingsEdge>;
};


/** The output of our update `SuiteListing` mutation. */
export type GqlUpdateSuiteListingPayloadSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

/** All input for the `updateTaxonomyByNodeId` mutation. */
export type GqlUpdateTaxonomyByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Taxonomy` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Taxonomy` being updated. */
  patch: GqlTaxonomyPatch;
};

/** All input for the `updateTaxonomy` mutation. */
export type GqlUpdateTaxonomyInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Taxonomy` being updated. */
  patch: GqlTaxonomyPatch;
};

/** The output of our update `Taxonomy` mutation. */
export type GqlUpdateTaxonomyPayload = {
  __typename?: 'UpdateTaxonomyPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Taxonomy` that is related to this `Taxonomy`. */
  parent: Maybe<GqlTaxonomy>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Taxonomy` that was updated by this mutation. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** An edge for our `Taxonomy`. May be used by Relay 1. */
  taxonomyEdge: Maybe<GqlTaxonomiesEdge>;
};


/** The output of our update `Taxonomy` mutation. */
export type GqlUpdateTaxonomyPayloadTaxonomyEdgeArgs = {
  orderBy?: InputMaybe<Array<TaxonomiesOrderBy>>;
};

/** All input for the `updateTechstackByNodeId` mutation. */
export type GqlUpdateTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Techstack` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Techstack` being updated. */
  patch: GqlTechstackPatch;
};

/** All input for the `updateTechstackByOrganizationIdAndProductId` mutation. */
export type GqlUpdateTechstackByOrganizationIdAndProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Techstack` being updated. */
  patch: GqlTechstackPatch;
  productId: Scalars['Int'];
};

/** All input for the `updateTechstack` mutation. */
export type GqlUpdateTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Techstack` being updated. */
  patch: GqlTechstackPatch;
};

/** The output of our update `Techstack` mutation. */
export type GqlUpdateTechstackPayload = {
  __typename?: 'UpdateTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `Techstack`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `Techstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Techstack` that was updated by this mutation. */
  techstack: Maybe<GqlTechstack>;
  /** An edge for our `Techstack`. May be used by Relay 1. */
  techstackEdge: Maybe<GqlTechstacksEdge>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByAddedBy: Maybe<GqlUser>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByOwnedBy: Maybe<GqlUser>;
};


/** The output of our update `Techstack` mutation. */
export type GqlUpdateTechstackPayloadTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** All input for the `updateTempDatumById` mutation. */
export type GqlUpdateTempDatumByIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TempDatum` being updated. */
  patch: GqlTempDatumPatch;
};

/** The output of our update `TempDatum` mutation. */
export type GqlUpdateTempDatumPayload = {
  __typename?: 'UpdateTempDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TempDatum` that was updated by this mutation. */
  tempDatum: Maybe<GqlTempDatum>;
  /** An edge for our `TempDatum`. May be used by Relay 1. */
  tempDatumEdge: Maybe<GqlTempDataEdge>;
};


/** The output of our update `TempDatum` mutation. */
export type GqlUpdateTempDatumPayloadTempDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<TempDataOrderBy>>;
};

/** All input for the `updateTermByNodeId` mutation. */
export type GqlUpdateTermByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Term` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Term` being updated. */
  patch: GqlTermPatch;
};

/** All input for the `updateTerm` mutation. */
export type GqlUpdateTermInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Term` being updated. */
  patch: GqlTermPatch;
};

/** The output of our update `Term` mutation. */
export type GqlUpdateTermPayload = {
  __typename?: 'UpdateTermPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Taxonomy` that is related to this `Term`. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** The `Term` that was updated by this mutation. */
  term: Maybe<GqlTerm>;
  /** An edge for our `Term`. May be used by Relay 1. */
  termEdge: Maybe<GqlTermsEdge>;
};


/** The output of our update `Term` mutation. */
export type GqlUpdateTermPayloadTermEdgeArgs = {
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};

/** All input for the `updateTermToOrganizationByNodeId` mutation. */
export type GqlUpdateTermToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToOrganization` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToOrganization` being updated. */
  patch: GqlTermToOrganizationPatch;
};

/** All input for the `updateTermToOrganization` mutation. */
export type GqlUpdateTermToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `TermToOrganization` being updated. */
  patch: GqlTermToOrganizationPatch;
  termId: Scalars['Int'];
};

/** The output of our update `TermToOrganization` mutation. */
export type GqlUpdateTermToOrganizationPayload = {
  __typename?: 'UpdateTermToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToOrganization`. */
  term: Maybe<GqlTerm>;
  /** The `TermToOrganization` that was updated by this mutation. */
  termToOrganization: Maybe<GqlTermToOrganization>;
  /** An edge for our `TermToOrganization`. May be used by Relay 1. */
  termToOrganizationEdge: Maybe<GqlTermToOrganizationsEdge>;
};


/** The output of our update `TermToOrganization` mutation. */
export type GqlUpdateTermToOrganizationPayloadTermToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};

/** All input for the `updateTermToProductByNodeId` mutation. */
export type GqlUpdateTermToProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToProduct` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToProduct` being updated. */
  patch: GqlTermToProductPatch;
};

/** All input for the `updateTermToProduct` mutation. */
export type GqlUpdateTermToProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TermToProduct` being updated. */
  patch: GqlTermToProductPatch;
  productId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our update `TermToProduct` mutation. */
export type GqlUpdateTermToProductPayload = {
  __typename?: 'UpdateTermToProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TermToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToProduct`. */
  term: Maybe<GqlTerm>;
  /** The `TermToProduct` that was updated by this mutation. */
  termToProduct: Maybe<GqlTermToProduct>;
  /** An edge for our `TermToProduct`. May be used by Relay 1. */
  termToProductEdge: Maybe<GqlTermToProductsEdge>;
};


/** The output of our update `TermToProduct` mutation. */
export type GqlUpdateTermToProductPayloadTermToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};

/** All input for the `updateTermToRfpByNodeId` mutation. */
export type GqlUpdateTermToRfpByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToRfp` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToRfp` being updated. */
  patch: GqlTermToRfpPatch;
};

/** All input for the `updateTermToRfp` mutation. */
export type GqlUpdateTermToRfpInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TermToRfp` being updated. */
  patch: GqlTermToRfpPatch;
  rfpId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our update `TermToRfp` mutation. */
export type GqlUpdateTermToRfpPayload = {
  __typename?: 'UpdateTermToRfpPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `TermToRfp`. */
  rfp: Maybe<GqlRfp>;
  /** Reads a single `Term` that is related to this `TermToRfp`. */
  term: Maybe<GqlTerm>;
  /** The `TermToRfp` that was updated by this mutation. */
  termToRfp: Maybe<GqlTermToRfp>;
  /** An edge for our `TermToRfp`. May be used by Relay 1. */
  termToRfpEdge: Maybe<GqlTermToRfpsEdge>;
};


/** The output of our update `TermToRfp` mutation. */
export type GqlUpdateTermToRfpPayloadTermToRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};

/** All input for the `updateTermToSuiteListingByNodeId` mutation. */
export type GqlUpdateTermToSuiteListingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToSuiteListing` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToSuiteListing` being updated. */
  patch: GqlTermToSuiteListingPatch;
};

/** All input for the `updateTermToSuiteListing` mutation. */
export type GqlUpdateTermToSuiteListingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TermToSuiteListing` being updated. */
  patch: GqlTermToSuiteListingPatch;
  suiteListingId: Scalars['Int'];
  termId: Scalars['Int'];
};

/** The output of our update `TermToSuiteListing` mutation. */
export type GqlUpdateTermToSuiteListingPayload = {
  __typename?: 'UpdateTermToSuiteListingPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `TermToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** Reads a single `Term` that is related to this `TermToSuiteListing`. */
  term: Maybe<GqlTerm>;
  /** The `TermToSuiteListing` that was updated by this mutation. */
  termToSuiteListing: Maybe<GqlTermToSuiteListing>;
  /** An edge for our `TermToSuiteListing`. May be used by Relay 1. */
  termToSuiteListingEdge: Maybe<GqlTermToSuiteListingsEdge>;
};


/** The output of our update `TermToSuiteListing` mutation. */
export type GqlUpdateTermToSuiteListingPayloadTermToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};

/** All input for the `updateTermToTestDriveByNodeId` mutation. */
export type GqlUpdateTermToTestDriveByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToTestDrive` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToTestDrive` being updated. */
  patch: GqlTermToTestDrivePatch;
};

/** All input for the `updateTermToTestDrive` mutation. */
export type GqlUpdateTermToTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TermToTestDrive` being updated. */
  patch: GqlTermToTestDrivePatch;
  termId: Scalars['Int'];
  testDriveId: Scalars['Int'];
};

/** The output of our update `TermToTestDrive` mutation. */
export type GqlUpdateTermToTestDrivePayload = {
  __typename?: 'UpdateTermToTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToTestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TermToTestDrive` that was updated by this mutation. */
  termToTestDrive: Maybe<GqlTermToTestDrive>;
  /** An edge for our `TermToTestDrive`. May be used by Relay 1. */
  termToTestDriveEdge: Maybe<GqlTermToTestDrivesEdge>;
  /** Reads a single `TestDrive` that is related to this `TermToTestDrive`. */
  testDrive: Maybe<GqlTestDrive>;
};


/** The output of our update `TermToTestDrive` mutation. */
export type GqlUpdateTermToTestDrivePayloadTermToTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};

/** All input for the `updateTermToUserByNodeId` mutation. */
export type GqlUpdateTermToUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToUser` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToUser` being updated. */
  patch: GqlTermToUserPatch;
};

/** All input for the `updateTermToUser` mutation. */
export type GqlUpdateTermToUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TermToUser` being updated. */
  patch: GqlTermToUserPatch;
  termId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our update `TermToUser` mutation. */
export type GqlUpdateTermToUserPayload = {
  __typename?: 'UpdateTermToUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToUser`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUser`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUser` that was updated by this mutation. */
  termToUser: Maybe<GqlTermToUser>;
  /** An edge for our `TermToUser`. May be used by Relay 1. */
  termToUserEdge: Maybe<GqlTermToUsersEdge>;
  /** Reads a single `User` that is related to this `TermToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our update `TermToUser` mutation. */
export type GqlUpdateTermToUserPayloadTermToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** All input for the `updateTermToUserStoryByNodeId` mutation. */
export type GqlUpdateTermToUserStoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToUserStory` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToUserStory` being updated. */
  patch: GqlTermToUserStoryPatch;
};

/** All input for the `updateTermToUserStory` mutation. */
export type GqlUpdateTermToUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TermToUserStory` being updated. */
  patch: GqlTermToUserStoryPatch;
  termId: Scalars['Int'];
  userStoryId: Scalars['Int'];
};

/** The output of our update `TermToUserStory` mutation. */
export type GqlUpdateTermToUserStoryPayload = {
  __typename?: 'UpdateTermToUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUserStory`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUserStory` that was updated by this mutation. */
  termToUserStory: Maybe<GqlTermToUserStory>;
  /** An edge for our `TermToUserStory`. May be used by Relay 1. */
  termToUserStoryEdge: Maybe<GqlTermToUserStoriesEdge>;
  /** Reads a single `UserStory` that is related to this `TermToUserStory`. */
  userStory: Maybe<GqlUserStory>;
};


/** The output of our update `TermToUserStory` mutation. */
export type GqlUpdateTermToUserStoryPayloadTermToUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};

/** All input for the `updateTermToVendorStackshareByNodeId` mutation. */
export type GqlUpdateTermToVendorStackshareByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TermToVendorStackshare` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TermToVendorStackshare` being updated. */
  patch: GqlTermToVendorStacksharePatch;
};

/** All input for the `updateTermToVendorStackshare` mutation. */
export type GqlUpdateTermToVendorStackshareInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `TermToVendorStackshare` being updated. */
  patch: GqlTermToVendorStacksharePatch;
};

/** The output of our update `TermToVendorStackshare` mutation. */
export type GqlUpdateTermToVendorStacksharePayload = {
  __typename?: 'UpdateTermToVendorStacksharePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToVendorStackshare`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToVendorStackshare`. */
  term: Maybe<GqlTerm>;
  /** The `TermToVendorStackshare` that was updated by this mutation. */
  termToVendorStackshare: Maybe<GqlTermToVendorStackshare>;
  /** An edge for our `TermToVendorStackshare`. May be used by Relay 1. */
  termToVendorStackshareEdge: Maybe<GqlTermToVendorStacksharesEdge>;
};


/** The output of our update `TermToVendorStackshare` mutation. */
export type GqlUpdateTermToVendorStacksharePayloadTermToVendorStackshareEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};

/** All input for the `updateTermscoutByNodeId` mutation. */
export type GqlUpdateTermscoutByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Termscout` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Termscout` being updated. */
  patch: GqlTermscoutPatch;
};

/** All input for the `updateTermscout` mutation. */
export type GqlUpdateTermscoutInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `Termscout` being updated. */
  patch: GqlTermscoutPatch;
};

/** The output of our update `Termscout` mutation. */
export type GqlUpdateTermscoutPayload = {
  __typename?: 'UpdateTermscoutPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `Termscout`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Termscout` that was updated by this mutation. */
  termscout: Maybe<GqlTermscout>;
  /** An edge for our `Termscout`. May be used by Relay 1. */
  termscoutEdge: Maybe<GqlTermscoutsEdge>;
};


/** The output of our update `Termscout` mutation. */
export type GqlUpdateTermscoutPayloadTermscoutEdgeArgs = {
  orderBy?: InputMaybe<Array<TermscoutsOrderBy>>;
};

/** All input for the `updateTestDriveByNodeId` mutation. */
export type GqlUpdateTestDriveByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TestDrive` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TestDrive` being updated. */
  patch: GqlTestDrivePatch;
};

/** All input for the `updateTestDrive` mutation. */
export type GqlUpdateTestDriveInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `TestDrive` being updated. */
  patch: GqlTestDrivePatch;
};

/** The output of our update `TestDrive` mutation. */
export type GqlUpdateTestDrivePayload = {
  __typename?: 'UpdateTestDrivePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TestDrive` that was updated by this mutation. */
  testDrive: Maybe<GqlTestDrive>;
  /** An edge for our `TestDrive`. May be used by Relay 1. */
  testDriveEdge: Maybe<GqlTestDrivesEdge>;
};


/** The output of our update `TestDrive` mutation. */
export type GqlUpdateTestDrivePayloadTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** All input for the `updateTheoremProductByNodeId` mutation. */
export type GqlUpdateTheoremProductByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `TheoremProduct` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `TheoremProduct` being updated. */
  patch: GqlTheoremProductPatch;
};

/** All input for the `updateTheoremProductByStripeProductId` mutation. */
export type GqlUpdateTheoremProductByStripeProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TheoremProduct` being updated. */
  patch: GqlTheoremProductPatch;
  stripeProductId: Scalars['String'];
};

/** All input for the `updateTheoremProductByTestStripeProductId` mutation. */
export type GqlUpdateTheoremProductByTestStripeProductIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `TheoremProduct` being updated. */
  patch: GqlTheoremProductPatch;
  testStripeProductId: Scalars['String'];
};

/** All input for the `updateTheoremProduct` mutation. */
export type GqlUpdateTheoremProductInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `TheoremProduct` being updated. */
  patch: GqlTheoremProductPatch;
};

/** The output of our update `TheoremProduct` mutation. */
export type GqlUpdateTheoremProductPayload = {
  __typename?: 'UpdateTheoremProductPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TheoremProduct` that was updated by this mutation. */
  theoremProduct: Maybe<GqlTheoremProduct>;
  /** An edge for our `TheoremProduct`. May be used by Relay 1. */
  theoremProductEdge: Maybe<GqlTheoremProductsEdge>;
};


/** The output of our update `TheoremProduct` mutation. */
export type GqlUpdateTheoremProductPayloadTheoremProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TheoremProductsOrderBy>>;
};

/** All input for the `updateUseCaseByNodeId` mutation. */
export type GqlUpdateUseCaseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UseCase` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UseCase` being updated. */
  patch: GqlUseCasePatch;
};

/** All input for the `updateUseCase` mutation. */
export type GqlUpdateUseCaseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UseCase` being updated. */
  patch: GqlUseCasePatch;
};

/** The output of our update `UseCase` mutation. */
export type GqlUpdateUseCasePayload = {
  __typename?: 'UpdateUseCasePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UseCase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UseCase`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UseCase`. */
  termByPracticeGroup: Maybe<GqlTerm>;
  /** The `UseCase` that was updated by this mutation. */
  useCase: Maybe<GqlUseCase>;
  /** An edge for our `UseCase`. May be used by Relay 1. */
  useCaseEdge: Maybe<GqlUseCasesEdge>;
  /** Reads a single `User` that is related to this `UseCase`. */
  userByAuthor: Maybe<GqlUser>;
};


/** The output of our update `UseCase` mutation. */
export type GqlUpdateUseCasePayloadUseCaseEdgeArgs = {
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** All input for the `updateUserByNodeId` mutation. */
export type GqlUpdateUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: GqlUserPatch;
};

/** All input for the `updateUser` mutation. */
export type GqlUpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: GqlUserPatch;
};

/** The output of our update `User` mutation. */
export type GqlUpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `User`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByCurrentOrganization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `User` that was updated by this mutation. */
  user: Maybe<GqlUser>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge: Maybe<GqlUsersEdge>;
};


/** The output of our update `User` mutation. */
export type GqlUpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the `updateUserStoryByNodeId` mutation. */
export type GqlUpdateUserStoryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserStory` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserStory` being updated. */
  patch: GqlUserStoryPatch;
};

/** All input for the `updateUserStory` mutation. */
export type GqlUpdateUserStoryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `UserStory` being updated. */
  patch: GqlUserStoryPatch;
};

/** The output of our update `UserStory` mutation. */
export type GqlUpdateUserStoryPayload = {
  __typename?: 'UpdateUserStoryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UserStory`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UserStory`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserStory`. */
  userByAuthor: Maybe<GqlUser>;
  /** The `UserStory` that was updated by this mutation. */
  userStory: Maybe<GqlUserStory>;
  /** An edge for our `UserStory`. May be used by Relay 1. */
  userStoryEdge: Maybe<GqlUserStoriesEdge>;
};


/** The output of our update `UserStory` mutation. */
export type GqlUpdateUserStoryPayloadUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** All input for the `updateUserToOrgStackByNodeId` mutation. */
export type GqlUpdateUserToOrgStackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserToOrgStack` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserToOrgStack` being updated. */
  patch: GqlUserToOrgStackPatch;
};

/** All input for the `updateUserToOrgStack` mutation. */
export type GqlUpdateUserToOrgStackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserToOrgStack` being updated. */
  patch: GqlUserToOrgStackPatch;
  userId: Scalars['Int'];
};

/** The output of our update `UserToOrgStack` mutation. */
export type GqlUpdateUserToOrgStackPayload = {
  __typename?: 'UpdateUserToOrgStackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UserToOrgStack`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserToOrgStack`. */
  user: Maybe<GqlUser>;
  /** The `UserToOrgStack` that was updated by this mutation. */
  userToOrgStack: Maybe<GqlUserToOrgStack>;
  /** An edge for our `UserToOrgStack`. May be used by Relay 1. */
  userToOrgStackEdge: Maybe<GqlUserToOrgStacksEdge>;
};


/** The output of our update `UserToOrgStack` mutation. */
export type GqlUpdateUserToOrgStackPayloadUserToOrgStackEdgeArgs = {
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};

/** All input for the `updateUsersToOrganizationByNodeId` mutation. */
export type GqlUpdateUsersToOrganizationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UsersToOrganization` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UsersToOrganization` being updated. */
  patch: GqlUsersToOrganizationPatch;
};

/** All input for the `updateUsersToOrganization` mutation. */
export type GqlUpdateUsersToOrganizationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UsersToOrganization` being updated. */
  patch: GqlUsersToOrganizationPatch;
  userId: Scalars['Int'];
};

/** The output of our update `UsersToOrganization` mutation. */
export type GqlUpdateUsersToOrganizationPayload = {
  __typename?: 'UpdateUsersToOrganizationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `UsersToOrganization`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `UsersToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UsersToOrganization`. */
  termByJobTitle: Maybe<GqlTerm>;
  /** Reads a single `User` that is related to this `UsersToOrganization`. */
  user: Maybe<GqlUser>;
  /** The `UsersToOrganization` that was updated by this mutation. */
  usersToOrganization: Maybe<GqlUsersToOrganization>;
  /** An edge for our `UsersToOrganization`. May be used by Relay 1. */
  usersToOrganizationEdge: Maybe<GqlUsersToOrganizationsEdge>;
};


/** The output of our update `UsersToOrganization` mutation. */
export type GqlUpdateUsersToOrganizationPayloadUsersToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** All input for the `updateUsersToPracticeGroupByNodeId` mutation. */
export type GqlUpdateUsersToPracticeGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UsersToPracticeGroup` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UsersToPracticeGroup` being updated. */
  patch: GqlUsersToPracticeGroupPatch;
};

/** All input for the `updateUsersToPracticeGroup` mutation. */
export type GqlUpdateUsersToPracticeGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UsersToPracticeGroup` being updated. */
  patch: GqlUsersToPracticeGroupPatch;
  practiceGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our update `UsersToPracticeGroup` mutation. */
export type GqlUpdateUsersToPracticeGroupPayload = {
  __typename?: 'UpdateUsersToPracticeGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PracticeGroup` that is related to this `UsersToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UsersToPracticeGroup`. */
  user: Maybe<GqlUser>;
  /** The `UsersToPracticeGroup` that was updated by this mutation. */
  usersToPracticeGroup: Maybe<GqlUsersToPracticeGroup>;
  /** An edge for our `UsersToPracticeGroup`. May be used by Relay 1. */
  usersToPracticeGroupEdge: Maybe<GqlUsersToPracticeGroupsEdge>;
};


/** The output of our update `UsersToPracticeGroup` mutation. */
export type GqlUpdateUsersToPracticeGroupPayloadUsersToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};

/** All input for the `updateUsersToTechstackByNodeId` mutation. */
export type GqlUpdateUsersToTechstackByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UsersToTechstack` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UsersToTechstack` being updated. */
  patch: GqlUsersToTechstackPatch;
};

/** All input for the `updateUsersToTechstack` mutation. */
export type GqlUpdateUsersToTechstackInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `UsersToTechstack` being updated. */
  patch: GqlUsersToTechstackPatch;
  techstackId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** The output of our update `UsersToTechstack` mutation. */
export type GqlUpdateUsersToTechstackPayload = {
  __typename?: 'UpdateUsersToTechstackPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Techstack` that is related to this `UsersToTechstack`. */
  techstack: Maybe<GqlTechstack>;
  /** Reads a single `User` that is related to this `UsersToTechstack`. */
  user: Maybe<GqlUser>;
  /** The `UsersToTechstack` that was updated by this mutation. */
  usersToTechstack: Maybe<GqlUsersToTechstack>;
  /** An edge for our `UsersToTechstack`. May be used by Relay 1. */
  usersToTechstackEdge: Maybe<GqlUsersToTechstacksEdge>;
};


/** The output of our update `UsersToTechstack` mutation. */
export type GqlUpdateUsersToTechstackPayloadUsersToTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};

/** All input for the `updateVendorStackshareLogoByNodeId` mutation. */
export type GqlUpdateVendorStackshareLogoByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `VendorStackshareLogo` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `VendorStackshareLogo` being updated. */
  patch: GqlVendorStackshareLogoPatch;
};

/** All input for the `updateVendorStackshareLogo` mutation. */
export type GqlUpdateVendorStackshareLogoInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  /** An object where the defined keys will be set on the `VendorStackshareLogo` being updated. */
  patch: GqlVendorStackshareLogoPatch;
};

/** The output of our update `VendorStackshareLogo` mutation. */
export type GqlUpdateVendorStackshareLogoPayload = {
  __typename?: 'UpdateVendorStackshareLogoPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `VendorStackshareLogo`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `VendorStackshareLogo` that was updated by this mutation. */
  vendorStackshareLogo: Maybe<GqlVendorStackshareLogo>;
  /** An edge for our `VendorStackshareLogo`. May be used by Relay 1. */
  vendorStackshareLogoEdge: Maybe<GqlVendorStackshareLogosEdge>;
};


/** The output of our update `VendorStackshareLogo` mutation. */
export type GqlUpdateVendorStackshareLogoPayloadVendorStackshareLogoEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};

/** All input for the upsert `AssocHome` mutation. */
export type GqlUpsertAssocHomeInput = {
  /** The `AssocHome` to be upserted by this mutation. */
  assocHome: GqlAssocHomeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AssocHome` mutation. */
export type GqlUpsertAssocHomePayload = {
  __typename?: 'UpsertAssocHomePayload';
  /** The `AssocHome` that was upserted by this mutation. */
  assocHome: Maybe<GqlAssocHome>;
  /** An edge for our `AssocHome`. May be used by Relay 1. */
  assocHomeEdge: Maybe<GqlAssocHomesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `AssocHome`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `AssocHome` mutation. */
export type GqlUpsertAssocHomePayloadAssocHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocHomesOrderBy>>;
};

/** Where conditions for the upsert `AssocHome` mutation. */
export type GqlUpsertAssocHomeWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `AssocSection` mutation. */
export type GqlUpsertAssocSectionInput = {
  /** The `AssocSection` to be upserted by this mutation. */
  assocSection: GqlAssocSectionInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AssocSection` mutation. */
export type GqlUpsertAssocSectionPayload = {
  __typename?: 'UpsertAssocSectionPayload';
  /** The `AssocSection` that was upserted by this mutation. */
  assocSection: Maybe<GqlAssocSection>;
  /** An edge for our `AssocSection`. May be used by Relay 1. */
  assocSectionEdge: Maybe<GqlAssocSectionsEdge>;
  /** Reads a single `Organization` that is related to this `AssocSection`. */
  association: Maybe<GqlOrganization>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `AssocSection` mutation. */
export type GqlUpsertAssocSectionPayloadAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<AssocSectionsOrderBy>>;
};

/** Where conditions for the upsert `AssocSection` mutation. */
export type GqlUpsertAssocSectionWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `AssociationToOrganization` mutation. */
export type GqlUpsertAssociationToOrganizationInput = {
  /** The `AssociationToOrganization` to be upserted by this mutation. */
  associationToOrganization: GqlAssociationToOrganizationInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AssociationToOrganization` mutation. */
export type GqlUpsertAssociationToOrganizationPayload = {
  __typename?: 'UpsertAssociationToOrganizationPayload';
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  association: Maybe<GqlOrganization>;
  /** The `AssociationToOrganization` that was upserted by this mutation. */
  associationToOrganization: Maybe<GqlAssociationToOrganization>;
  /** An edge for our `AssociationToOrganization`. May be used by Relay 1. */
  associationToOrganizationEdge: Maybe<GqlAssociationToOrganizationsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `AssociationToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `AssociationToOrganization` mutation. */
export type GqlUpsertAssociationToOrganizationPayloadAssociationToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<AssociationToOrganizationsOrderBy>>;
};

/** Where conditions for the upsert `AssociationToOrganization` mutation. */
export type GqlUpsertAssociationToOrganizationWhere = {
  associationId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `AwardBadge` mutation. */
export type GqlUpsertAwardBadgeInput = {
  /** The `AwardBadge` to be upserted by this mutation. */
  awardBadge: GqlAwardBadgeInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `AwardBadge` mutation. */
export type GqlUpsertAwardBadgePayload = {
  __typename?: 'UpsertAwardBadgePayload';
  /** The `AwardBadge` that was upserted by this mutation. */
  awardBadge: Maybe<GqlAwardBadge>;
  /** An edge for our `AwardBadge`. May be used by Relay 1. */
  awardBadgeEdge: Maybe<GqlAwardBadgesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `AwardBadge` mutation. */
export type GqlUpsertAwardBadgePayloadAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<AwardBadgesOrderBy>>;
};

/** Where conditions for the upsert `AwardBadge` mutation. */
export type GqlUpsertAwardBadgeWhere = {
  id?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `BestFor` mutation. */
export type GqlUpsertBestForInput = {
  /** The `BestFor` to be upserted by this mutation. */
  bestFor: GqlBestForInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BestFor` mutation. */
export type GqlUpsertBestForPayload = {
  __typename?: 'UpsertBestForPayload';
  /** The `BestFor` that was upserted by this mutation. */
  bestFor: Maybe<GqlBestFor>;
  /** An edge for our `BestFor`. May be used by Relay 1. */
  bestForEdge: Maybe<GqlBestForsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `BestFor` mutation. */
export type GqlUpsertBestForPayloadBestForEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForsOrderBy>>;
};

/** All input for the upsert `BestForToProduct` mutation. */
export type GqlUpsertBestForToProductInput = {
  /** The `BestForToProduct` to be upserted by this mutation. */
  bestForToProduct: GqlBestForToProductInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `BestForToProduct` mutation. */
export type GqlUpsertBestForToProductPayload = {
  __typename?: 'UpsertBestForToProductPayload';
  /** Reads a single `BestFor` that is related to this `BestForToProduct`. */
  bestFor: Maybe<GqlBestFor>;
  /** The `BestForToProduct` that was upserted by this mutation. */
  bestForToProduct: Maybe<GqlBestForToProduct>;
  /** An edge for our `BestForToProduct`. May be used by Relay 1. */
  bestForToProductEdge: Maybe<GqlBestForToProductsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `BestForToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `BestForToProduct` mutation. */
export type GqlUpsertBestForToProductPayloadBestForToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<BestForToProductsOrderBy>>;
};

/** Where conditions for the upsert `BestForToProduct` mutation. */
export type GqlUpsertBestForToProductWhere = {
  bestForId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `BestFor` mutation. */
export type GqlUpsertBestForWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Category` mutation. */
export type GqlUpsertCategoryInput = {
  /** The `Category` to be upserted by this mutation. */
  category: GqlCategoryInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `Category` mutation. */
export type GqlUpsertCategoryPayload = {
  __typename?: 'UpsertCategoryPayload';
  /** The `Category` that was upserted by this mutation. */
  category: Maybe<GqlCategory>;
  /** An edge for our `Category`. May be used by Relay 1. */
  categoryEdge: Maybe<GqlCategoriesEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `Category` mutation. */
export type GqlUpsertCategoryPayloadCategoryEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
};

/** All input for the upsert `CategoryToProduct` mutation. */
export type GqlUpsertCategoryToProductInput = {
  /** The `CategoryToProduct` to be upserted by this mutation. */
  categoryToProduct: GqlCategoryToProductInput;
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our upsert `CategoryToProduct` mutation. */
export type GqlUpsertCategoryToProductPayload = {
  __typename?: 'UpsertCategoryToProductPayload';
  /** Reads a single `Category` that is related to this `CategoryToProduct`. */
  category: Maybe<GqlCategory>;
  /** The `CategoryToProduct` that was upserted by this mutation. */
  categoryToProduct: Maybe<GqlCategoryToProduct>;
  /** An edge for our `CategoryToProduct`. May be used by Relay 1. */
  categoryToProductEdge: Maybe<GqlCategoryToProductsEdge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `CategoryToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `CategoryToProduct` mutation. */
export type GqlUpsertCategoryToProductPayloadCategoryToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<CategoryToProductsOrderBy>>;
};

/** Where conditions for the upsert `CategoryToProduct` mutation. */
export type GqlUpsertCategoryToProductWhere = {
  categoryId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Category` mutation. */
export type GqlUpsertCategoryWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ConnectCustomer` mutation. */
export type GqlUpsertConnectCustomerInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ConnectCustomer` to be upserted by this mutation. */
  connectCustomer: GqlConnectCustomerInput;
};

/** The output of our upsert `ConnectCustomer` mutation. */
export type GqlUpsertConnectCustomerPayload = {
  __typename?: 'UpsertConnectCustomerPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectCustomer` that was upserted by this mutation. */
  connectCustomer: Maybe<GqlConnectCustomer>;
  /** An edge for our `ConnectCustomer`. May be used by Relay 1. */
  connectCustomerEdge: Maybe<GqlConnectCustomersEdge>;
  /** Reads a single `Organization` that is related to this `ConnectCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ConnectCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `ConnectCustomer` mutation. */
export type GqlUpsertConnectCustomerPayloadConnectCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};

/** Where conditions for the upsert `ConnectCustomer` mutation. */
export type GqlUpsertConnectCustomerWhere = {
  accountId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ConnectPurchase` mutation. */
export type GqlUpsertConnectPurchaseInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ConnectPurchase` to be upserted by this mutation. */
  connectPurchase: GqlConnectPurchaseInput;
};

/** The output of our upsert `ConnectPurchase` mutation. */
export type GqlUpsertConnectPurchasePayload = {
  __typename?: 'UpsertConnectPurchasePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ConnectPurchase` that was upserted by this mutation. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** An edge for our `ConnectPurchase`. May be used by Relay 1. */
  connectPurchaseEdge: Maybe<GqlConnectPurchasesEdge>;
  /** Reads a single `Organization` that is related to this `ConnectPurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `ConnectPurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ConnectPurchase` mutation. */
export type GqlUpsertConnectPurchasePayloadConnectPurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};

/** Where conditions for the upsert `ConnectPurchase` mutation. */
export type GqlUpsertConnectPurchaseWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `DiversityCertification` mutation. */
export type GqlUpsertDiversityCertificationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `DiversityCertification` to be upserted by this mutation. */
  diversityCertification: GqlDiversityCertificationInput;
};

/** The output of our upsert `DiversityCertification` mutation. */
export type GqlUpsertDiversityCertificationPayload = {
  __typename?: 'UpsertDiversityCertificationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `DiversityCertification` that was upserted by this mutation. */
  diversityCertification: Maybe<GqlDiversityCertification>;
  /** An edge for our `DiversityCertification`. May be used by Relay 1. */
  diversityCertificationEdge: Maybe<GqlDiversityCertificationsEdge>;
  /** Reads a single `Organization` that is related to this `DiversityCertification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `DiversityCertification` mutation. */
export type GqlUpsertDiversityCertificationPayloadDiversityCertificationEdgeArgs = {
  orderBy?: InputMaybe<Array<DiversityCertificationsOrderBy>>;
};

/** Where conditions for the upsert `DiversityCertification` mutation. */
export type GqlUpsertDiversityCertificationWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Feature` mutation. */
export type GqlUpsertFeatureInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Feature` to be upserted by this mutation. */
  feature: GqlFeatureInput;
};

/** The output of our upsert `Feature` mutation. */
export type GqlUpsertFeaturePayload = {
  __typename?: 'UpsertFeaturePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Feature` that was upserted by this mutation. */
  feature: Maybe<GqlFeature>;
  /** An edge for our `Feature`. May be used by Relay 1. */
  featureEdge: Maybe<GqlFeaturesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `Feature` mutation. */
export type GqlUpsertFeaturePayloadFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** All input for the upsert `FeatureToProduct` mutation. */
export type GqlUpsertFeatureToProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FeatureToProduct` to be upserted by this mutation. */
  featureToProduct: GqlFeatureToProductInput;
};

/** The output of our upsert `FeatureToProduct` mutation. */
export type GqlUpsertFeatureToProductPayload = {
  __typename?: 'UpsertFeatureToProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Feature` that is related to this `FeatureToProduct`. */
  feature: Maybe<GqlFeature>;
  /** The `FeatureToProduct` that was upserted by this mutation. */
  featureToProduct: Maybe<GqlFeatureToProduct>;
  /** An edge for our `FeatureToProduct`. May be used by Relay 1. */
  featureToProductEdge: Maybe<GqlFeatureToProductsEdge>;
  /** Reads a single `Product` that is related to this `FeatureToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `FeatureToProduct` mutation. */
export type GqlUpsertFeatureToProductPayloadFeatureToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<FeatureToProductsOrderBy>>;
};

/** Where conditions for the upsert `FeatureToProduct` mutation. */
export type GqlUpsertFeatureToProductWhere = {
  featureId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Feature` mutation. */
export type GqlUpsertFeatureWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `LawfirmService` mutation. */
export type GqlUpsertLawfirmServiceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LawfirmService` to be upserted by this mutation. */
  lawfirmService: GqlLawfirmServiceInput;
};

/** The output of our upsert `LawfirmService` mutation. */
export type GqlUpsertLawfirmServicePayload = {
  __typename?: 'UpsertLawfirmServicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `LawfirmService` that was upserted by this mutation. */
  lawfirmService: Maybe<GqlLawfirmService>;
  /** An edge for our `LawfirmService`. May be used by Relay 1. */
  lawfirmServiceEdge: Maybe<GqlLawfirmServicesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `LawfirmService` mutation. */
export type GqlUpsertLawfirmServicePayloadLawfirmServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<LawfirmServicesOrderBy>>;
};

/** Where conditions for the upsert `LawfirmService` mutation. */
export type GqlUpsertLawfirmServiceWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ListingCreator` mutation. */
export type GqlUpsertListingCreatorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ListingCreator` to be upserted by this mutation. */
  listingCreator: GqlListingCreatorInput;
};

/** The output of our upsert `ListingCreator` mutation. */
export type GqlUpsertListingCreatorPayload = {
  __typename?: 'UpsertListingCreatorPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ListingCreator` that was upserted by this mutation. */
  listingCreator: Maybe<GqlListingCreator>;
  /** An edge for our `ListingCreator`. May be used by Relay 1. */
  listingCreatorEdge: Maybe<GqlListingCreatorsEdge>;
  /** Reads a single `Organization` that is related to this `ListingCreator`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ListingCreator` mutation. */
export type GqlUpsertListingCreatorPayloadListingCreatorEdgeArgs = {
  orderBy?: InputMaybe<Array<ListingCreatorsOrderBy>>;
};

/** Where conditions for the upsert `ListingCreator` mutation. */
export type GqlUpsertListingCreatorWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Location` mutation. */
export type GqlUpsertLocationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Location` to be upserted by this mutation. */
  location: GqlLocationInput;
};

/** The output of our upsert `Location` mutation. */
export type GqlUpsertLocationPayload = {
  __typename?: 'UpsertLocationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Location` that was upserted by this mutation. */
  location: Maybe<GqlLocation>;
  /** An edge for our `Location`. May be used by Relay 1. */
  locationEdge: Maybe<GqlLocationsEdge>;
  /** Reads a single `Organization` that is related to this `Location`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `Location` mutation. */
export type GqlUpsertLocationPayloadLocationEdgeArgs = {
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};

/** Where conditions for the upsert `Location` mutation. */
export type GqlUpsertLocationWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Notification` mutation. */
export type GqlUpsertNotificationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Notification` to be upserted by this mutation. */
  notification: GqlNotificationInput;
};

/** The output of our upsert `Notification` mutation. */
export type GqlUpsertNotificationPayload = {
  __typename?: 'UpsertNotificationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Notification` that was upserted by this mutation. */
  notification: Maybe<GqlNotification>;
  /** An edge for our `Notification`. May be used by Relay 1. */
  notificationEdge: Maybe<GqlNotificationsEdge>;
  /** Reads a single `Organization` that is related to this `Notification`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `Notification`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `Notification` mutation. */
export type GqlUpsertNotificationPayloadNotificationEdgeArgs = {
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** Where conditions for the upsert `Notification` mutation. */
export type GqlUpsertNotificationWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `NoviMember` mutation. */
export type GqlUpsertNoviMemberInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NoviMember` to be upserted by this mutation. */
  noviMember: GqlNoviMemberInput;
};

/** The output of our upsert `NoviMember` mutation. */
export type GqlUpsertNoviMemberPayload = {
  __typename?: 'UpsertNoviMemberPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `NoviMember` that was upserted by this mutation. */
  noviMember: Maybe<GqlNoviMember>;
  /** An edge for our `NoviMember`. May be used by Relay 1. */
  noviMemberEdge: Maybe<GqlNoviMembersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `NoviMember`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `NoviMember` mutation. */
export type GqlUpsertNoviMemberPayloadNoviMemberEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviMembersOrderBy>>;
};

/** Where conditions for the upsert `NoviMember` mutation. */
export type GqlUpsertNoviMemberWhere = {
  noviMemberId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `NoviOrganization` mutation. */
export type GqlUpsertNoviOrganizationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `NoviOrganization` to be upserted by this mutation. */
  noviOrganization: GqlNoviOrganizationInput;
};

/** The output of our upsert `NoviOrganization` mutation. */
export type GqlUpsertNoviOrganizationPayload = {
  __typename?: 'UpsertNoviOrganizationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `NoviOrganization` that was upserted by this mutation. */
  noviOrganization: Maybe<GqlNoviOrganization>;
  /** An edge for our `NoviOrganization`. May be used by Relay 1. */
  noviOrganizationEdge: Maybe<GqlNoviOrganizationsEdge>;
  /** Reads a single `Organization` that is related to this `NoviOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `NoviOrganization` mutation. */
export type GqlUpsertNoviOrganizationPayloadNoviOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<NoviOrganizationsOrderBy>>;
};

/** Where conditions for the upsert `NoviOrganization` mutation. */
export type GqlUpsertNoviOrganizationWhere = {
  organizationId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Organization` mutation. */
export type GqlUpsertOrganizationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Organization` to be upserted by this mutation. */
  organization: GqlOrganizationInput;
};

/** All input for the upsert `OrganizationListing` mutation. */
export type GqlUpsertOrganizationListingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrganizationListing` to be upserted by this mutation. */
  organizationListing: GqlOrganizationListingInput;
};

/** The output of our upsert `OrganizationListing` mutation. */
export type GqlUpsertOrganizationListingPayload = {
  __typename?: 'UpsertOrganizationListingPayload';
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  association: Maybe<GqlOrganization>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `OrganizationListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `Organization` that is related to this `OrganizationListing`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationListing` that was upserted by this mutation. */
  organizationListing: Maybe<GqlOrganizationListing>;
  /** An edge for our `OrganizationListing`. May be used by Relay 1. */
  organizationListingEdge: Maybe<GqlOrganizationListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `OrganizationListing` mutation. */
export type GqlUpsertOrganizationListingPayloadOrganizationListingEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationListingsOrderBy>>;
};

/** Where conditions for the upsert `OrganizationListing` mutation. */
export type GqlUpsertOrganizationListingWhere = {
  associationId?: InputMaybe<Scalars['UUID']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our upsert `Organization` mutation. */
export type GqlUpsertOrganizationPayload = {
  __typename?: 'UpsertOrganizationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Term` that is related to this `Organization`. */
  mainTerm: Maybe<GqlTerm>;
  /** The `Organization` that was upserted by this mutation. */
  organization: Maybe<GqlOrganization>;
  /** An edge for our `Organization`. May be used by Relay 1. */
  organizationEdge: Maybe<GqlOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `Organization` mutation. */
export type GqlUpsertOrganizationPayloadOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};

/** All input for the upsert `OrganizationTechstack` mutation. */
export type GqlUpsertOrganizationTechstackInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `OrganizationTechstack` to be upserted by this mutation. */
  organizationTechstack: GqlOrganizationTechstackInput;
};

/** The output of our upsert `OrganizationTechstack` mutation. */
export type GqlUpsertOrganizationTechstackPayload = {
  __typename?: 'UpsertOrganizationTechstackPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `OrganizationTechstack`. */
  organization: Maybe<GqlOrganization>;
  /** The `OrganizationTechstack` that was upserted by this mutation. */
  organizationTechstack: Maybe<GqlOrganizationTechstack>;
  /** An edge for our `OrganizationTechstack`. May be used by Relay 1. */
  organizationTechstackEdge: Maybe<GqlOrganizationTechstacksEdge>;
  /** Reads a single `Product` that is related to this `OrganizationTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `OrganizationTechstack` mutation. */
export type GqlUpsertOrganizationTechstackPayloadOrganizationTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<OrganizationTechstacksOrderBy>>;
};

/** Where conditions for the upsert `OrganizationTechstack` mutation. */
export type GqlUpsertOrganizationTechstackWhere = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Organization` mutation. */
export type GqlUpsertOrganizationWhere = {
  auth0OrgId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `PersonalTechstack` mutation. */
export type GqlUpsertPersonalTechstackInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PersonalTechstack` to be upserted by this mutation. */
  personalTechstack: GqlPersonalTechstackInput;
};

/** The output of our upsert `PersonalTechstack` mutation. */
export type GqlUpsertPersonalTechstackPayload = {
  __typename?: 'UpsertPersonalTechstackPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PersonalTechstack` that was upserted by this mutation. */
  personalTechstack: Maybe<GqlPersonalTechstack>;
  /** An edge for our `PersonalTechstack`. May be used by Relay 1. */
  personalTechstackEdge: Maybe<GqlPersonalTechstacksEdge>;
  /** Reads a single `Product` that is related to this `PersonalTechstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `PersonalTechstack`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `PersonalTechstack` mutation. */
export type GqlUpsertPersonalTechstackPayloadPersonalTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};

/** Where conditions for the upsert `PersonalTechstack` mutation. */
export type GqlUpsertPersonalTechstackWhere = {
  productId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `PracticeGroup` mutation. */
export type GqlUpsertPracticeGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PracticeGroup` to be upserted by this mutation. */
  practiceGroup: GqlPracticeGroupInput;
};

/** The output of our upsert `PracticeGroup` mutation. */
export type GqlUpsertPracticeGroupPayload = {
  __typename?: 'UpsertPracticeGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PracticeGroup` that was upserted by this mutation. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** An edge for our `PracticeGroup`. May be used by Relay 1. */
  practiceGroupEdge: Maybe<GqlPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `PracticeGroup` mutation. */
export type GqlUpsertPracticeGroupPayloadPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};

/** Where conditions for the upsert `PracticeGroup` mutation. */
export type GqlUpsertPracticeGroupWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `PremiumInfoToTerm` mutation. */
export type GqlUpsertPremiumInfoToTermInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PremiumInfoToTerm` to be upserted by this mutation. */
  premiumInfoToTerm: GqlPremiumInfoToTermInput;
};

/** The output of our upsert `PremiumInfoToTerm` mutation. */
export type GqlUpsertPremiumInfoToTermPayload = {
  __typename?: 'UpsertPremiumInfoToTermPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PremiumProductInfo` that is related to this `PremiumInfoToTerm`. */
  premiumInfo: Maybe<GqlPremiumProductInfo>;
  /** The `PremiumInfoToTerm` that was upserted by this mutation. */
  premiumInfoToTerm: Maybe<GqlPremiumInfoToTerm>;
  /** An edge for our `PremiumInfoToTerm`. May be used by Relay 1. */
  premiumInfoToTermEdge: Maybe<GqlPremiumInfoToTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `PremiumInfoToTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our upsert `PremiumInfoToTerm` mutation. */
export type GqlUpsertPremiumInfoToTermPayloadPremiumInfoToTermEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumInfoToTermsOrderBy>>;
};

/** Where conditions for the upsert `PremiumInfoToTerm` mutation. */
export type GqlUpsertPremiumInfoToTermWhere = {
  premiumInfoId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `PremiumProductInfo` mutation. */
export type GqlUpsertPremiumProductInfoInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PremiumProductInfo` to be upserted by this mutation. */
  premiumProductInfo: GqlPremiumProductInfoInput;
};

/** The output of our upsert `PremiumProductInfo` mutation. */
export type GqlUpsertPremiumProductInfoPayload = {
  __typename?: 'UpsertPremiumProductInfoPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `PremiumProductInfo` that was upserted by this mutation. */
  premiumProductInfo: Maybe<GqlPremiumProductInfo>;
  /** An edge for our `PremiumProductInfo`. May be used by Relay 1. */
  premiumProductInfoEdge: Maybe<GqlPremiumProductInfosEdge>;
  /** Reads a single `Product` that is related to this `PremiumProductInfo`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `PremiumProductInfo` mutation. */
export type GqlUpsertPremiumProductInfoPayloadPremiumProductInfoEdgeArgs = {
  orderBy?: InputMaybe<Array<PremiumProductInfosOrderBy>>;
};

/** Where conditions for the upsert `PremiumProductInfo` mutation. */
export type GqlUpsertPremiumProductInfoWhere = {
  id?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductAwardDetail` mutation. */
export type GqlUpsertProductAwardDetailInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductAwardDetail` to be upserted by this mutation. */
  productAwardDetail: GqlProductAwardDetailInput;
};

/** The output of our upsert `ProductAwardDetail` mutation. */
export type GqlUpsertProductAwardDetailPayload = {
  __typename?: 'UpsertProductAwardDetailPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductAwardDetail`. */
  product: Maybe<GqlProduct>;
  /** The `ProductAwardDetail` that was upserted by this mutation. */
  productAwardDetail: Maybe<GqlProductAwardDetail>;
  /** An edge for our `ProductAwardDetail`. May be used by Relay 1. */
  productAwardDetailEdge: Maybe<GqlProductAwardDetailsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductAwardDetail` mutation. */
export type GqlUpsertProductAwardDetailPayloadProductAwardDetailEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductAwardDetailsOrderBy>>;
};

/** Where conditions for the upsert `ProductAwardDetail` mutation. */
export type GqlUpsertProductAwardDetailWhere = {
  productId?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductFeatureByTerm` mutation. */
export type GqlUpsertProductFeatureByTermInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductFeatureByTerm` to be upserted by this mutation. */
  productFeatureByTerm: GqlProductFeatureByTermInput;
};

/** The output of our upsert `ProductFeatureByTerm` mutation. */
export type GqlUpsertProductFeatureByTermPayload = {
  __typename?: 'UpsertProductFeatureByTermPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `ProductFeatureByTerm`. */
  network: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductFeatureByTerm`. */
  product: Maybe<GqlProduct>;
  /** The `ProductFeatureByTerm` that was upserted by this mutation. */
  productFeatureByTerm: Maybe<GqlProductFeatureByTerm>;
  /** An edge for our `ProductFeatureByTerm`. May be used by Relay 1. */
  productFeatureByTermEdge: Maybe<GqlProductFeatureByTermsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `ProductFeatureByTerm`. */
  term: Maybe<GqlTerm>;
};


/** The output of our upsert `ProductFeatureByTerm` mutation. */
export type GqlUpsertProductFeatureByTermPayloadProductFeatureByTermEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductFeatureByTermsOrderBy>>;
};

/** Where conditions for the upsert `ProductFeatureByTerm` mutation. */
export type GqlUpsertProductFeatureByTermWhere = {
  networkId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Product` mutation. */
export type GqlUpsertProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Product` to be upserted by this mutation. */
  product: GqlProductInput;
};

/** All input for the upsert `ProductListing` mutation. */
export type GqlUpsertProductListingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductListing` to be upserted by this mutation. */
  productListing: GqlProductListingInput;
};

/** The output of our upsert `ProductListing` mutation. */
export type GqlUpsertProductListingPayload = {
  __typename?: 'UpsertProductListingPayload';
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  association: Maybe<GqlOrganization>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `ConnectPurchase` that is related to this `ProductListing`. */
  connectPurchase: Maybe<GqlConnectPurchase>;
  /** Reads a single `Organization` that is related to this `ProductListing`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductListing` that was upserted by this mutation. */
  productListing: Maybe<GqlProductListing>;
  /** An edge for our `ProductListing`. May be used by Relay 1. */
  productListingEdge: Maybe<GqlProductListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductListing` mutation. */
export type GqlUpsertProductListingPayloadProductListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductListingsOrderBy>>;
};

/** Where conditions for the upsert `ProductListing` mutation. */
export type GqlUpsertProductListingWhere = {
  associationId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** The output of our upsert `Product` mutation. */
export type GqlUpsertProductPayload = {
  __typename?: 'UpsertProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `Product` that was upserted by this mutation. */
  product: Maybe<GqlProduct>;
  /** An edge for our `Product`. May be used by Relay 1. */
  productEdge: Maybe<GqlProductsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `Product` mutation. */
export type GqlUpsertProductPayloadProductEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};

/** All input for the upsert `ProductSection` mutation. */
export type GqlUpsertProductSectionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductSection` to be upserted by this mutation. */
  productSection: GqlProductSectionInput;
};

/** The output of our upsert `ProductSection` mutation. */
export type GqlUpsertProductSectionPayload = {
  __typename?: 'UpsertProductSectionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** The `ProductSection` that was upserted by this mutation. */
  productSection: Maybe<GqlProductSection>;
  /** An edge for our `ProductSection`. May be used by Relay 1. */
  productSectionEdge: Maybe<GqlProductSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductSection` mutation. */
export type GqlUpsertProductSectionPayloadProductSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductSectionsOrderBy>>;
};

/** Where conditions for the upsert `ProductSection` mutation. */
export type GqlUpsertProductSectionWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToAssocSection` mutation. */
export type GqlUpsertProductToAssocSectionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToAssocSection` to be upserted by this mutation. */
  productToAssocSection: GqlProductToAssocSectionInput;
};

/** The output of our upsert `ProductToAssocSection` mutation. */
export type GqlUpsertProductToAssocSectionPayload = {
  __typename?: 'UpsertProductToAssocSectionPayload';
  /** Reads a single `AssocSection` that is related to this `ProductToAssocSection`. */
  assocSection: Maybe<GqlAssocSection>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToAssocSection`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAssocSection` that was upserted by this mutation. */
  productToAssocSection: Maybe<GqlProductToAssocSection>;
  /** An edge for our `ProductToAssocSection`. May be used by Relay 1. */
  productToAssocSectionEdge: Maybe<GqlProductToAssocSectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToAssocSection` mutation. */
export type GqlUpsertProductToAssocSectionPayloadProductToAssocSectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAssocSectionsOrderBy>>;
};

/** Where conditions for the upsert `ProductToAssocSection` mutation. */
export type GqlUpsertProductToAssocSectionWhere = {
  assocSectionId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToAwardBadge` mutation. */
export type GqlUpsertProductToAwardBadgeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToAwardBadge` to be upserted by this mutation. */
  productToAwardBadge: GqlProductToAwardBadgeInput;
};

/** The output of our upsert `ProductToAwardBadge` mutation. */
export type GqlUpsertProductToAwardBadgePayload = {
  __typename?: 'UpsertProductToAwardBadgePayload';
  /** Reads a single `AwardBadge` that is related to this `ProductToAwardBadge`. */
  awardBadge: Maybe<GqlAwardBadge>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToAwardBadge`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToAwardBadge` that was upserted by this mutation. */
  productToAwardBadge: Maybe<GqlProductToAwardBadge>;
  /** An edge for our `ProductToAwardBadge`. May be used by Relay 1. */
  productToAwardBadgeEdge: Maybe<GqlProductToAwardBadgesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToAwardBadge` mutation. */
export type GqlUpsertProductToAwardBadgePayloadProductToAwardBadgeEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToAwardBadgesOrderBy>>;
};

/** Where conditions for the upsert `ProductToAwardBadge` mutation. */
export type GqlUpsertProductToAwardBadgeWhere = {
  awardBadgeId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToClient` mutation. */
export type GqlUpsertProductToClientInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToClient` to be upserted by this mutation. */
  productToClient: GqlProductToClientInput;
};

/** The output of our upsert `ProductToClient` mutation. */
export type GqlUpsertProductToClientPayload = {
  __typename?: 'UpsertProductToClientPayload';
  /** Reads a single `Organization` that is related to this `ProductToClient`. */
  client: Maybe<GqlOrganization>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToClient`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToClient` that was upserted by this mutation. */
  productToClient: Maybe<GqlProductToClient>;
  /** An edge for our `ProductToClient`. May be used by Relay 1. */
  productToClientEdge: Maybe<GqlProductToClientsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToClient` mutation. */
export type GqlUpsertProductToClientPayloadProductToClientEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToClientsOrderBy>>;
};

/** Where conditions for the upsert `ProductToClient` mutation. */
export type GqlUpsertProductToClientWhere = {
  clientId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToCompetitor` mutation. */
export type GqlUpsertProductToCompetitorInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToCompetitor` to be upserted by this mutation. */
  productToCompetitor: GqlProductToCompetitorInput;
};

/** The output of our upsert `ProductToCompetitor` mutation. */
export type GqlUpsertProductToCompetitorPayload = {
  __typename?: 'UpsertProductToCompetitorPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  competitor: Maybe<GqlProduct>;
  /** Reads a single `Organization` that is related to this `ProductToCompetitor`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToCompetitor`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToCompetitor` that was upserted by this mutation. */
  productToCompetitor: Maybe<GqlProductToCompetitor>;
  /** An edge for our `ProductToCompetitor`. May be used by Relay 1. */
  productToCompetitorEdge: Maybe<GqlProductToCompetitorsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToCompetitor` mutation. */
export type GqlUpsertProductToCompetitorPayloadProductToCompetitorEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToCompetitorsOrderBy>>;
};

/** Where conditions for the upsert `ProductToCompetitor` mutation. */
export type GqlUpsertProductToCompetitorWhere = {
  competitorId?: InputMaybe<Scalars['Int']>;
  locked?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToIntegration` mutation. */
export type GqlUpsertProductToIntegrationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToIntegration` to be upserted by this mutation. */
  productToIntegration: GqlProductToIntegrationInput;
};

/** The output of our upsert `ProductToIntegration` mutation. */
export type GqlUpsertProductToIntegrationPayload = {
  __typename?: 'UpsertProductToIntegrationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  integration: Maybe<GqlProduct>;
  /** Reads a single `Product` that is related to this `ProductToIntegration`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToIntegration` that was upserted by this mutation. */
  productToIntegration: Maybe<GqlProductToIntegration>;
  /** An edge for our `ProductToIntegration`. May be used by Relay 1. */
  productToIntegrationEdge: Maybe<GqlProductToIntegrationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToIntegration` mutation. */
export type GqlUpsertProductToIntegrationPayloadProductToIntegrationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToIntegrationsOrderBy>>;
};

/** Where conditions for the upsert `ProductToIntegration` mutation. */
export type GqlUpsertProductToIntegrationWhere = {
  integrationId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToOrganization` mutation. */
export type GqlUpsertProductToOrganizationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToOrganization` to be upserted by this mutation. */
  productToOrganization: GqlProductToOrganizationInput;
};

/** The output of our upsert `ProductToOrganization` mutation. */
export type GqlUpsertProductToOrganizationPayload = {
  __typename?: 'UpsertProductToOrganizationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `ProductToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `ProductToOrganization`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToOrganization` that was upserted by this mutation. */
  productToOrganization: Maybe<GqlProductToOrganization>;
  /** An edge for our `ProductToOrganization`. May be used by Relay 1. */
  productToOrganizationEdge: Maybe<GqlProductToOrganizationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToOrganization` mutation. */
export type GqlUpsertProductToOrganizationPayloadProductToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToOrganizationsOrderBy>>;
};

/** Where conditions for the upsert `ProductToOrganization` mutation. */
export type GqlUpsertProductToOrganizationWhere = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToPracticeGroup` mutation. */
export type GqlUpsertProductToPracticeGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToPracticeGroup` to be upserted by this mutation. */
  productToPracticeGroup: GqlProductToPracticeGroupInput;
};

/** The output of our upsert `ProductToPracticeGroup` mutation. */
export type GqlUpsertProductToPracticeGroupPayload = {
  __typename?: 'UpsertProductToPracticeGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PracticeGroup` that is related to this `ProductToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Reads a single `Product` that is related to this `ProductToPracticeGroup`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToPracticeGroup` that was upserted by this mutation. */
  productToPracticeGroup: Maybe<GqlProductToPracticeGroup>;
  /** An edge for our `ProductToPracticeGroup`. May be used by Relay 1. */
  productToPracticeGroupEdge: Maybe<GqlProductToPracticeGroupsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
};


/** The output of our upsert `ProductToPracticeGroup` mutation. */
export type GqlUpsertProductToPracticeGroupPayloadProductToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToPracticeGroupsOrderBy>>;
};

/** Where conditions for the upsert `ProductToPracticeGroup` mutation. */
export type GqlUpsertProductToPracticeGroupWhere = {
  practiceGroupId?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToSuiteListing` mutation. */
export type GqlUpsertProductToSuiteListingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToSuiteListing` to be upserted by this mutation. */
  productToSuiteListing: GqlProductToSuiteListingInput;
};

/** The output of our upsert `ProductToSuiteListing` mutation. */
export type GqlUpsertProductToSuiteListingPayload = {
  __typename?: 'UpsertProductToSuiteListingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToSuiteListing`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToSuiteListing` that was upserted by this mutation. */
  productToSuiteListing: Maybe<GqlProductToSuiteListing>;
  /** An edge for our `ProductToSuiteListing`. May be used by Relay 1. */
  productToSuiteListingEdge: Maybe<GqlProductToSuiteListingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `ProductToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
};


/** The output of our upsert `ProductToSuiteListing` mutation. */
export type GqlUpsertProductToSuiteListingPayloadProductToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToSuiteListingsOrderBy>>;
};

/** Where conditions for the upsert `ProductToSuiteListing` mutation. */
export type GqlUpsertProductToSuiteListingWhere = {
  productId?: InputMaybe<Scalars['Int']>;
  suiteListingId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `ProductToUser` mutation. */
export type GqlUpsertProductToUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `ProductToUser` to be upserted by this mutation. */
  productToUser: GqlProductToUserInput;
};

/** The output of our upsert `ProductToUser` mutation. */
export type GqlUpsertProductToUserPayload = {
  __typename?: 'UpsertProductToUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `ProductToUser`. */
  product: Maybe<GqlProduct>;
  /** The `ProductToUser` that was upserted by this mutation. */
  productToUser: Maybe<GqlProductToUser>;
  /** An edge for our `ProductToUser`. May be used by Relay 1. */
  productToUserEdge: Maybe<GqlProductToUsersEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `ProductToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `ProductToUser` mutation. */
export type GqlUpsertProductToUserPayloadProductToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};

/** Where conditions for the upsert `ProductToUser` mutation. */
export type GqlUpsertProductToUserWhere = {
  productId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Product` mutation. */
export type GqlUpsertProductWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Rfp` mutation. */
export type GqlUpsertRfpInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Rfp` to be upserted by this mutation. */
  rfp: GqlRfpInput;
};

/** The output of our upsert `Rfp` mutation. */
export type GqlUpsertRfpPayload = {
  __typename?: 'UpsertRfpPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Rfp` that was upserted by this mutation. */
  rfp: Maybe<GqlRfp>;
  /** An edge for our `Rfp`. May be used by Relay 1. */
  rfpEdge: Maybe<GqlRfpsEdge>;
  /** Reads a single `User` that is related to this `Rfp`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `Rfp` mutation. */
export type GqlUpsertRfpPayloadRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};

/** All input for the upsert `RfpToProduct` mutation. */
export type GqlUpsertRfpToProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RfpToProduct` to be upserted by this mutation. */
  rfpToProduct: GqlRfpToProductInput;
};

/** The output of our upsert `RfpToProduct` mutation. */
export type GqlUpsertRfpToProductPayload = {
  __typename?: 'UpsertRfpToProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `RfpToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `RfpToProduct`. */
  rfp: Maybe<GqlRfp>;
  /** The `RfpToProduct` that was upserted by this mutation. */
  rfpToProduct: Maybe<GqlRfpToProduct>;
  /** An edge for our `RfpToProduct`. May be used by Relay 1. */
  rfpToProductEdge: Maybe<GqlRfpToProductsEdge>;
};


/** The output of our upsert `RfpToProduct` mutation. */
export type GqlUpsertRfpToProductPayloadRfpToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<RfpToProductsOrderBy>>;
};

/** Where conditions for the upsert `RfpToProduct` mutation. */
export type GqlUpsertRfpToProductWhere = {
  productId?: InputMaybe<Scalars['Int']>;
  rfpId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Rfp` mutation. */
export type GqlUpsertRfpWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Scheduler` mutation. */
export type GqlUpsertSchedulerInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Scheduler` to be upserted by this mutation. */
  scheduler: GqlSchedulerInput;
};

/** The output of our upsert `Scheduler` mutation. */
export type GqlUpsertSchedulerPayload = {
  __typename?: 'UpsertSchedulerPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Scheduler` that was upserted by this mutation. */
  scheduler: Maybe<GqlScheduler>;
  /** An edge for our `Scheduler`. May be used by Relay 1. */
  schedulerEdge: Maybe<GqlSchedulersEdge>;
  /** Reads a single `User` that is related to this `Scheduler`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `Scheduler` mutation. */
export type GqlUpsertSchedulerPayloadSchedulerEdgeArgs = {
  orderBy?: InputMaybe<Array<SchedulersOrderBy>>;
};

/** Where conditions for the upsert `Scheduler` mutation. */
export type GqlUpsertSchedulerWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `SectionLayout` mutation. */
export type GqlUpsertSectionLayoutInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SectionLayout` to be upserted by this mutation. */
  sectionLayout: GqlSectionLayoutInput;
};

/** The output of our upsert `SectionLayout` mutation. */
export type GqlUpsertSectionLayoutPayload = {
  __typename?: 'UpsertSectionLayoutPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SectionLayout` that was upserted by this mutation. */
  sectionLayout: Maybe<GqlSectionLayout>;
  /** An edge for our `SectionLayout`. May be used by Relay 1. */
  sectionLayoutEdge: Maybe<GqlSectionLayoutsEdge>;
};


/** The output of our upsert `SectionLayout` mutation. */
export type GqlUpsertSectionLayoutPayloadSectionLayoutEdgeArgs = {
  orderBy?: InputMaybe<Array<SectionLayoutsOrderBy>>;
};

/** Where conditions for the upsert `SectionLayout` mutation. */
export type GqlUpsertSectionLayoutWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `SimpleService` mutation. */
export type GqlUpsertSimpleServiceInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SimpleService` to be upserted by this mutation. */
  simpleService: GqlSimpleServiceInput;
};

/** The output of our upsert `SimpleService` mutation. */
export type GqlUpsertSimpleServicePayload = {
  __typename?: 'UpsertSimpleServicePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `SimpleService`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `SimpleService` that was upserted by this mutation. */
  simpleService: Maybe<GqlSimpleService>;
  /** An edge for our `SimpleService`. May be used by Relay 1. */
  simpleServiceEdge: Maybe<GqlSimpleServicesEdge>;
  /** Reads a single `Term` that is related to this `SimpleService`. */
  term: Maybe<GqlTerm>;
};


/** The output of our upsert `SimpleService` mutation. */
export type GqlUpsertSimpleServicePayloadSimpleServiceEdgeArgs = {
  orderBy?: InputMaybe<Array<SimpleServicesOrderBy>>;
};

/** Where conditions for the upsert `SimpleService` mutation. */
export type GqlUpsertSimpleServiceWhere = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `StackshareOption` mutation. */
export type GqlUpsertStackshareOptionInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StackshareOption` to be upserted by this mutation. */
  stackshareOption: GqlStackshareOptionInput;
};

/** The output of our upsert `StackshareOption` mutation. */
export type GqlUpsertStackshareOptionPayload = {
  __typename?: 'UpsertStackshareOptionPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StackshareOption` that was upserted by this mutation. */
  stackshareOption: Maybe<GqlStackshareOption>;
  /** An edge for our `StackshareOption`. May be used by Relay 1. */
  stackshareOptionEdge: Maybe<GqlStackshareOptionsEdge>;
};


/** The output of our upsert `StackshareOption` mutation. */
export type GqlUpsertStackshareOptionPayloadStackshareOptionEdgeArgs = {
  orderBy?: InputMaybe<Array<StackshareOptionsOrderBy>>;
};

/** Where conditions for the upsert `StackshareOption` mutation. */
export type GqlUpsertStackshareOptionWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `StripeAccount` mutation. */
export type GqlUpsertStripeAccountInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripeAccount` to be upserted by this mutation. */
  stripeAccount: GqlStripeAccountInput;
};

/** The output of our upsert `StripeAccount` mutation. */
export type GqlUpsertStripeAccountPayload = {
  __typename?: 'UpsertStripeAccountPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeAccount`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeAccount` that was upserted by this mutation. */
  stripeAccount: Maybe<GqlStripeAccount>;
  /** An edge for our `StripeAccount`. May be used by Relay 1. */
  stripeAccountEdge: Maybe<GqlStripeAccountsEdge>;
  /** Reads a single `User` that is related to this `StripeAccount`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `StripeAccount` mutation. */
export type GqlUpsertStripeAccountPayloadStripeAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};

/** Where conditions for the upsert `StripeAccount` mutation. */
export type GqlUpsertStripeAccountWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `StripeCustomer` mutation. */
export type GqlUpsertStripeCustomerInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripeCustomer` to be upserted by this mutation. */
  stripeCustomer: GqlStripeCustomerInput;
};

/** The output of our upsert `StripeCustomer` mutation. */
export type GqlUpsertStripeCustomerPayload = {
  __typename?: 'UpsertStripeCustomerPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeCustomer`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeCustomer` that was upserted by this mutation. */
  stripeCustomer: Maybe<GqlStripeCustomer>;
  /** An edge for our `StripeCustomer`. May be used by Relay 1. */
  stripeCustomerEdge: Maybe<GqlStripeCustomersEdge>;
  /** Reads a single `User` that is related to this `StripeCustomer`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `StripeCustomer` mutation. */
export type GqlUpsertStripeCustomerPayloadStripeCustomerEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** Where conditions for the upsert `StripeCustomer` mutation. */
export type GqlUpsertStripeCustomerWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `StripePurchase` mutation. */
export type GqlUpsertStripePurchaseInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripePurchase` to be upserted by this mutation. */
  stripePurchase: GqlStripePurchaseInput;
};

/** The output of our upsert `StripePurchase` mutation. */
export type GqlUpsertStripePurchasePayload = {
  __typename?: 'UpsertStripePurchasePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripePurchase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `User` that is related to this `StripePurchase`. */
  owner: Maybe<GqlUser>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripePurchase` that was upserted by this mutation. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** An edge for our `StripePurchase`. May be used by Relay 1. */
  stripePurchaseEdge: Maybe<GqlStripePurchasesEdge>;
};


/** The output of our upsert `StripePurchase` mutation. */
export type GqlUpsertStripePurchasePayloadStripePurchaseEdgeArgs = {
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};

/** Where conditions for the upsert `StripePurchase` mutation. */
export type GqlUpsertStripePurchaseWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `StripeSeat` mutation. */
export type GqlUpsertStripeSeatInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `StripeSeat` to be upserted by this mutation. */
  stripeSeat: GqlStripeSeatInput;
};

/** The output of our upsert `StripeSeat` mutation. */
export type GqlUpsertStripeSeatPayload = {
  __typename?: 'UpsertStripeSeatPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `StripeSeat`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `StripeSeat` that was upserted by this mutation. */
  stripeSeat: Maybe<GqlStripeSeat>;
  /** An edge for our `StripeSeat`. May be used by Relay 1. */
  stripeSeatEdge: Maybe<GqlStripeSeatsEdge>;
  /** Reads a single `User` that is related to this `StripeSeat`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `StripeSeat` mutation. */
export type GqlUpsertStripeSeatPayloadStripeSeatEdgeArgs = {
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** Where conditions for the upsert `StripeSeat` mutation. */
export type GqlUpsertStripeSeatWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `SuiteListing` mutation. */
export type GqlUpsertSuiteListingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `SuiteListing` to be upserted by this mutation. */
  suiteListing: GqlSuiteListingInput;
};

/** The output of our upsert `SuiteListing` mutation. */
export type GqlUpsertSuiteListingPayload = {
  __typename?: 'UpsertSuiteListingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `SuiteListing`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `StripePurchase` that is related to this `SuiteListing`. */
  stripePurchase: Maybe<GqlStripePurchase>;
  /** The `SuiteListing` that was upserted by this mutation. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** An edge for our `SuiteListing`. May be used by Relay 1. */
  suiteListingEdge: Maybe<GqlSuiteListingsEdge>;
};


/** The output of our upsert `SuiteListing` mutation. */
export type GqlUpsertSuiteListingPayloadSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<SuiteListingsOrderBy>>;
};

/** Where conditions for the upsert `SuiteListing` mutation. */
export type GqlUpsertSuiteListingWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Taxonomy` mutation. */
export type GqlUpsertTaxonomyInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Taxonomy` to be upserted by this mutation. */
  taxonomy: GqlTaxonomyInput;
};

/** The output of our upsert `Taxonomy` mutation. */
export type GqlUpsertTaxonomyPayload = {
  __typename?: 'UpsertTaxonomyPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Taxonomy` that is related to this `Taxonomy`. */
  parent: Maybe<GqlTaxonomy>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Taxonomy` that was upserted by this mutation. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** An edge for our `Taxonomy`. May be used by Relay 1. */
  taxonomyEdge: Maybe<GqlTaxonomiesEdge>;
};


/** The output of our upsert `Taxonomy` mutation. */
export type GqlUpsertTaxonomyPayloadTaxonomyEdgeArgs = {
  orderBy?: InputMaybe<Array<TaxonomiesOrderBy>>;
};

/** Where conditions for the upsert `Taxonomy` mutation. */
export type GqlUpsertTaxonomyWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Techstack` mutation. */
export type GqlUpsertTechstackInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Techstack` to be upserted by this mutation. */
  techstack: GqlTechstackInput;
};

/** The output of our upsert `Techstack` mutation. */
export type GqlUpsertTechstackPayload = {
  __typename?: 'UpsertTechstackPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `Techstack`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `Techstack`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Techstack` that was upserted by this mutation. */
  techstack: Maybe<GqlTechstack>;
  /** An edge for our `Techstack`. May be used by Relay 1. */
  techstackEdge: Maybe<GqlTechstacksEdge>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByAddedBy: Maybe<GqlUser>;
  /** Reads a single `User` that is related to this `Techstack`. */
  userByOwnedBy: Maybe<GqlUser>;
};


/** The output of our upsert `Techstack` mutation. */
export type GqlUpsertTechstackPayloadTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** Where conditions for the upsert `Techstack` mutation. */
export type GqlUpsertTechstackWhere = {
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  productId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TempDatum` mutation. */
export type GqlUpsertTempDatumInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TempDatum` to be upserted by this mutation. */
  tempDatum: GqlTempDatumInput;
};

/** The output of our upsert `TempDatum` mutation. */
export type GqlUpsertTempDatumPayload = {
  __typename?: 'UpsertTempDatumPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TempDatum` that was upserted by this mutation. */
  tempDatum: Maybe<GqlTempDatum>;
  /** An edge for our `TempDatum`. May be used by Relay 1. */
  tempDatumEdge: Maybe<GqlTempDataEdge>;
};


/** The output of our upsert `TempDatum` mutation. */
export type GqlUpsertTempDatumPayloadTempDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<TempDataOrderBy>>;
};

/** Where conditions for the upsert `TempDatum` mutation. */
export type GqlUpsertTempDatumWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Term` mutation. */
export type GqlUpsertTermInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Term` to be upserted by this mutation. */
  term: GqlTermInput;
};

/** The output of our upsert `Term` mutation. */
export type GqlUpsertTermPayload = {
  __typename?: 'UpsertTermPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Taxonomy` that is related to this `Term`. */
  taxonomy: Maybe<GqlTaxonomy>;
  /** The `Term` that was upserted by this mutation. */
  term: Maybe<GqlTerm>;
  /** An edge for our `Term`. May be used by Relay 1. */
  termEdge: Maybe<GqlTermsEdge>;
};


/** The output of our upsert `Term` mutation. */
export type GqlUpsertTermPayloadTermEdgeArgs = {
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};

/** All input for the upsert `TermToOrganization` mutation. */
export type GqlUpsertTermToOrganizationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToOrganization` to be upserted by this mutation. */
  termToOrganization: GqlTermToOrganizationInput;
};

/** The output of our upsert `TermToOrganization` mutation. */
export type GqlUpsertTermToOrganizationPayload = {
  __typename?: 'UpsertTermToOrganizationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToOrganization`. */
  term: Maybe<GqlTerm>;
  /** The `TermToOrganization` that was upserted by this mutation. */
  termToOrganization: Maybe<GqlTermToOrganization>;
  /** An edge for our `TermToOrganization`. May be used by Relay 1. */
  termToOrganizationEdge: Maybe<GqlTermToOrganizationsEdge>;
};


/** The output of our upsert `TermToOrganization` mutation. */
export type GqlUpsertTermToOrganizationPayloadTermToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToOrganizationsOrderBy>>;
};

/** Where conditions for the upsert `TermToOrganization` mutation. */
export type GqlUpsertTermToOrganizationWhere = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TermToProduct` mutation. */
export type GqlUpsertTermToProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToProduct` to be upserted by this mutation. */
  termToProduct: GqlTermToProductInput;
};

/** The output of our upsert `TermToProduct` mutation. */
export type GqlUpsertTermToProductPayload = {
  __typename?: 'UpsertTermToProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TermToProduct`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToProduct`. */
  term: Maybe<GqlTerm>;
  /** The `TermToProduct` that was upserted by this mutation. */
  termToProduct: Maybe<GqlTermToProduct>;
  /** An edge for our `TermToProduct`. May be used by Relay 1. */
  termToProductEdge: Maybe<GqlTermToProductsEdge>;
};


/** The output of our upsert `TermToProduct` mutation. */
export type GqlUpsertTermToProductPayloadTermToProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToProductsOrderBy>>;
};

/** Where conditions for the upsert `TermToProduct` mutation. */
export type GqlUpsertTermToProductWhere = {
  productId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TermToRfp` mutation. */
export type GqlUpsertTermToRfpInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToRfp` to be upserted by this mutation. */
  termToRfp: GqlTermToRfpInput;
};

/** The output of our upsert `TermToRfp` mutation. */
export type GqlUpsertTermToRfpPayload = {
  __typename?: 'UpsertTermToRfpPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Rfp` that is related to this `TermToRfp`. */
  rfp: Maybe<GqlRfp>;
  /** Reads a single `Term` that is related to this `TermToRfp`. */
  term: Maybe<GqlTerm>;
  /** The `TermToRfp` that was upserted by this mutation. */
  termToRfp: Maybe<GqlTermToRfp>;
  /** An edge for our `TermToRfp`. May be used by Relay 1. */
  termToRfpEdge: Maybe<GqlTermToRfpsEdge>;
};


/** The output of our upsert `TermToRfp` mutation. */
export type GqlUpsertTermToRfpPayloadTermToRfpEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToRfpsOrderBy>>;
};

/** Where conditions for the upsert `TermToRfp` mutation. */
export type GqlUpsertTermToRfpWhere = {
  rfpId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TermToSuiteListing` mutation. */
export type GqlUpsertTermToSuiteListingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToSuiteListing` to be upserted by this mutation. */
  termToSuiteListing: GqlTermToSuiteListingInput;
};

/** The output of our upsert `TermToSuiteListing` mutation. */
export type GqlUpsertTermToSuiteListingPayload = {
  __typename?: 'UpsertTermToSuiteListingPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `SuiteListing` that is related to this `TermToSuiteListing`. */
  suiteListing: Maybe<GqlSuiteListing>;
  /** Reads a single `Term` that is related to this `TermToSuiteListing`. */
  term: Maybe<GqlTerm>;
  /** The `TermToSuiteListing` that was upserted by this mutation. */
  termToSuiteListing: Maybe<GqlTermToSuiteListing>;
  /** An edge for our `TermToSuiteListing`. May be used by Relay 1. */
  termToSuiteListingEdge: Maybe<GqlTermToSuiteListingsEdge>;
};


/** The output of our upsert `TermToSuiteListing` mutation. */
export type GqlUpsertTermToSuiteListingPayloadTermToSuiteListingEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToSuiteListingsOrderBy>>;
};

/** Where conditions for the upsert `TermToSuiteListing` mutation. */
export type GqlUpsertTermToSuiteListingWhere = {
  suiteListingId?: InputMaybe<Scalars['Int']>;
  termId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TermToTestDrive` mutation. */
export type GqlUpsertTermToTestDriveInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToTestDrive` to be upserted by this mutation. */
  termToTestDrive: GqlTermToTestDriveInput;
};

/** The output of our upsert `TermToTestDrive` mutation. */
export type GqlUpsertTermToTestDrivePayload = {
  __typename?: 'UpsertTermToTestDrivePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToTestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TermToTestDrive` that was upserted by this mutation. */
  termToTestDrive: Maybe<GqlTermToTestDrive>;
  /** An edge for our `TermToTestDrive`. May be used by Relay 1. */
  termToTestDriveEdge: Maybe<GqlTermToTestDrivesEdge>;
  /** Reads a single `TestDrive` that is related to this `TermToTestDrive`. */
  testDrive: Maybe<GqlTestDrive>;
};


/** The output of our upsert `TermToTestDrive` mutation. */
export type GqlUpsertTermToTestDrivePayloadTermToTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToTestDrivesOrderBy>>;
};

/** Where conditions for the upsert `TermToTestDrive` mutation. */
export type GqlUpsertTermToTestDriveWhere = {
  termId?: InputMaybe<Scalars['Int']>;
  testDriveId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TermToUser` mutation. */
export type GqlUpsertTermToUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToUser` to be upserted by this mutation. */
  termToUser: GqlTermToUserInput;
};

/** The output of our upsert `TermToUser` mutation. */
export type GqlUpsertTermToUserPayload = {
  __typename?: 'UpsertTermToUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToUser`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUser`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUser` that was upserted by this mutation. */
  termToUser: Maybe<GqlTermToUser>;
  /** An edge for our `TermToUser`. May be used by Relay 1. */
  termToUserEdge: Maybe<GqlTermToUsersEdge>;
  /** Reads a single `User` that is related to this `TermToUser`. */
  user: Maybe<GqlUser>;
};


/** The output of our upsert `TermToUser` mutation. */
export type GqlUpsertTermToUserPayloadTermToUserEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** All input for the upsert `TermToUserStory` mutation. */
export type GqlUpsertTermToUserStoryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToUserStory` to be upserted by this mutation. */
  termToUserStory: GqlTermToUserStoryInput;
};

/** The output of our upsert `TermToUserStory` mutation. */
export type GqlUpsertTermToUserStoryPayload = {
  __typename?: 'UpsertTermToUserStoryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToUserStory`. */
  term: Maybe<GqlTerm>;
  /** The `TermToUserStory` that was upserted by this mutation. */
  termToUserStory: Maybe<GqlTermToUserStory>;
  /** An edge for our `TermToUserStory`. May be used by Relay 1. */
  termToUserStoryEdge: Maybe<GqlTermToUserStoriesEdge>;
  /** Reads a single `UserStory` that is related to this `TermToUserStory`. */
  userStory: Maybe<GqlUserStory>;
};


/** The output of our upsert `TermToUserStory` mutation. */
export type GqlUpsertTermToUserStoryPayloadTermToUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};

/** Where conditions for the upsert `TermToUserStory` mutation. */
export type GqlUpsertTermToUserStoryWhere = {
  termId?: InputMaybe<Scalars['Int']>;
  userStoryId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `TermToUser` mutation. */
export type GqlUpsertTermToUserWhere = {
  termId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TermToVendorStackshare` mutation. */
export type GqlUpsertTermToVendorStackshareInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TermToVendorStackshare` to be upserted by this mutation. */
  termToVendorStackshare: GqlTermToVendorStackshareInput;
};

/** The output of our upsert `TermToVendorStackshare` mutation. */
export type GqlUpsertTermToVendorStacksharePayload = {
  __typename?: 'UpsertTermToVendorStacksharePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `TermToVendorStackshare`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TermToVendorStackshare`. */
  term: Maybe<GqlTerm>;
  /** The `TermToVendorStackshare` that was upserted by this mutation. */
  termToVendorStackshare: Maybe<GqlTermToVendorStackshare>;
  /** An edge for our `TermToVendorStackshare`. May be used by Relay 1. */
  termToVendorStackshareEdge: Maybe<GqlTermToVendorStacksharesEdge>;
};


/** The output of our upsert `TermToVendorStackshare` mutation. */
export type GqlUpsertTermToVendorStacksharePayloadTermToVendorStackshareEdgeArgs = {
  orderBy?: InputMaybe<Array<TermToVendorStacksharesOrderBy>>;
};

/** Where conditions for the upsert `TermToVendorStackshare` mutation. */
export type GqlUpsertTermToVendorStackshareWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `Term` mutation. */
export type GqlUpsertTermWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `Termscout` mutation. */
export type GqlUpsertTermscoutInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Termscout` to be upserted by this mutation. */
  termscout: GqlTermscoutInput;
};

/** The output of our upsert `Termscout` mutation. */
export type GqlUpsertTermscoutPayload = {
  __typename?: 'UpsertTermscoutPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `Termscout`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `Termscout` that was upserted by this mutation. */
  termscout: Maybe<GqlTermscout>;
  /** An edge for our `Termscout`. May be used by Relay 1. */
  termscoutEdge: Maybe<GqlTermscoutsEdge>;
};


/** The output of our upsert `Termscout` mutation. */
export type GqlUpsertTermscoutPayloadTermscoutEdgeArgs = {
  orderBy?: InputMaybe<Array<TermscoutsOrderBy>>;
};

/** Where conditions for the upsert `Termscout` mutation. */
export type GqlUpsertTermscoutWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TestDrive` mutation. */
export type GqlUpsertTestDriveInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TestDrive` to be upserted by this mutation. */
  testDrive: GqlTestDriveInput;
};

/** The output of our upsert `TestDrive` mutation. */
export type GqlUpsertTestDrivePayload = {
  __typename?: 'UpsertTestDrivePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Product` that is related to this `TestDrive`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `TestDrive`. */
  term: Maybe<GqlTerm>;
  /** The `TestDrive` that was upserted by this mutation. */
  testDrive: Maybe<GqlTestDrive>;
  /** An edge for our `TestDrive`. May be used by Relay 1. */
  testDriveEdge: Maybe<GqlTestDrivesEdge>;
};


/** The output of our upsert `TestDrive` mutation. */
export type GqlUpsertTestDrivePayloadTestDriveEdgeArgs = {
  orderBy?: InputMaybe<Array<TestDrivesOrderBy>>;
};

/** Where conditions for the upsert `TestDrive` mutation. */
export type GqlUpsertTestDriveWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `TheoremProduct` mutation. */
export type GqlUpsertTheoremProductInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `TheoremProduct` to be upserted by this mutation. */
  theoremProduct: GqlTheoremProductInput;
};

/** The output of our upsert `TheoremProduct` mutation. */
export type GqlUpsertTheoremProductPayload = {
  __typename?: 'UpsertTheoremProductPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `TheoremProduct` that was upserted by this mutation. */
  theoremProduct: Maybe<GqlTheoremProduct>;
  /** An edge for our `TheoremProduct`. May be used by Relay 1. */
  theoremProductEdge: Maybe<GqlTheoremProductsEdge>;
};


/** The output of our upsert `TheoremProduct` mutation. */
export type GqlUpsertTheoremProductPayloadTheoremProductEdgeArgs = {
  orderBy?: InputMaybe<Array<TheoremProductsOrderBy>>;
};

/** Where conditions for the upsert `TheoremProduct` mutation. */
export type GqlUpsertTheoremProductWhere = {
  id?: InputMaybe<Scalars['Int']>;
  stripeProductId?: InputMaybe<Scalars['String']>;
  testStripeProductId?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `UseCase` mutation. */
export type GqlUpsertUseCaseInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UseCase` to be upserted by this mutation. */
  useCase: GqlUseCaseInput;
};

/** The output of our upsert `UseCase` mutation. */
export type GqlUpsertUseCasePayload = {
  __typename?: 'UpsertUseCasePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UseCase`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UseCase`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UseCase`. */
  termByPracticeGroup: Maybe<GqlTerm>;
  /** The `UseCase` that was upserted by this mutation. */
  useCase: Maybe<GqlUseCase>;
  /** An edge for our `UseCase`. May be used by Relay 1. */
  useCaseEdge: Maybe<GqlUseCasesEdge>;
  /** Reads a single `User` that is related to this `UseCase`. */
  userByAuthor: Maybe<GqlUser>;
};


/** The output of our upsert `UseCase` mutation. */
export type GqlUpsertUseCasePayloadUseCaseEdgeArgs = {
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** Where conditions for the upsert `UseCase` mutation. */
export type GqlUpsertUseCaseWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `User` mutation. */
export type GqlUpsertUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be upserted by this mutation. */
  user: GqlUserInput;
};

/** The output of our upsert `User` mutation. */
export type GqlUpsertUserPayload = {
  __typename?: 'UpsertUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `User`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByCurrentOrganization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `User` that was upserted by this mutation. */
  user: Maybe<GqlUser>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge: Maybe<GqlUsersEdge>;
};


/** The output of our upsert `User` mutation. */
export type GqlUpsertUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the upsert `UserStory` mutation. */
export type GqlUpsertUserStoryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserStory` to be upserted by this mutation. */
  userStory: GqlUserStoryInput;
};

/** The output of our upsert `UserStory` mutation. */
export type GqlUpsertUserStoryPayload = {
  __typename?: 'UpsertUserStoryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UserStory`. */
  organization: Maybe<GqlOrganization>;
  /** Reads a single `Product` that is related to this `UserStory`. */
  product: Maybe<GqlProduct>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserStory`. */
  userByAuthor: Maybe<GqlUser>;
  /** The `UserStory` that was upserted by this mutation. */
  userStory: Maybe<GqlUserStory>;
  /** An edge for our `UserStory`. May be used by Relay 1. */
  userStoryEdge: Maybe<GqlUserStoriesEdge>;
};


/** The output of our upsert `UserStory` mutation. */
export type GqlUpsertUserStoryPayloadUserStoryEdgeArgs = {
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** Where conditions for the upsert `UserStory` mutation. */
export type GqlUpsertUserStoryWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `UserToOrgStack` mutation. */
export type GqlUpsertUserToOrgStackInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserToOrgStack` to be upserted by this mutation. */
  userToOrgStack: GqlUserToOrgStackInput;
};

/** The output of our upsert `UserToOrgStack` mutation. */
export type GqlUpsertUserToOrgStackPayload = {
  __typename?: 'UpsertUserToOrgStackPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `UserToOrgStack`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UserToOrgStack`. */
  user: Maybe<GqlUser>;
  /** The `UserToOrgStack` that was upserted by this mutation. */
  userToOrgStack: Maybe<GqlUserToOrgStack>;
  /** An edge for our `UserToOrgStack`. May be used by Relay 1. */
  userToOrgStackEdge: Maybe<GqlUserToOrgStacksEdge>;
};


/** The output of our upsert `UserToOrgStack` mutation. */
export type GqlUpsertUserToOrgStackPayloadUserToOrgStackEdgeArgs = {
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};

/** Where conditions for the upsert `UserToOrgStack` mutation. */
export type GqlUpsertUserToOrgStackWhere = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** Where conditions for the upsert `User` mutation. */
export type GqlUpsertUserWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `UsersToOrganization` mutation. */
export type GqlUpsertUsersToOrganizationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UsersToOrganization` to be upserted by this mutation. */
  usersToOrganization: GqlUsersToOrganizationInput;
};

/** The output of our upsert `UsersToOrganization` mutation. */
export type GqlUpsertUsersToOrganizationPayload = {
  __typename?: 'UpsertUsersToOrganizationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Location` that is related to this `UsersToOrganization`. */
  location: Maybe<GqlLocation>;
  /** Reads a single `Organization` that is related to this `UsersToOrganization`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Term` that is related to this `UsersToOrganization`. */
  termByJobTitle: Maybe<GqlTerm>;
  /** Reads a single `User` that is related to this `UsersToOrganization`. */
  user: Maybe<GqlUser>;
  /** The `UsersToOrganization` that was upserted by this mutation. */
  usersToOrganization: Maybe<GqlUsersToOrganization>;
  /** An edge for our `UsersToOrganization`. May be used by Relay 1. */
  usersToOrganizationEdge: Maybe<GqlUsersToOrganizationsEdge>;
};


/** The output of our upsert `UsersToOrganization` mutation. */
export type GqlUpsertUsersToOrganizationPayloadUsersToOrganizationEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** Where conditions for the upsert `UsersToOrganization` mutation. */
export type GqlUpsertUsersToOrganizationWhere = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `UsersToPracticeGroup` mutation. */
export type GqlUpsertUsersToPracticeGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UsersToPracticeGroup` to be upserted by this mutation. */
  usersToPracticeGroup: GqlUsersToPracticeGroupInput;
};

/** The output of our upsert `UsersToPracticeGroup` mutation. */
export type GqlUpsertUsersToPracticeGroupPayload = {
  __typename?: 'UpsertUsersToPracticeGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `PracticeGroup` that is related to this `UsersToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `User` that is related to this `UsersToPracticeGroup`. */
  user: Maybe<GqlUser>;
  /** The `UsersToPracticeGroup` that was upserted by this mutation. */
  usersToPracticeGroup: Maybe<GqlUsersToPracticeGroup>;
  /** An edge for our `UsersToPracticeGroup`. May be used by Relay 1. */
  usersToPracticeGroupEdge: Maybe<GqlUsersToPracticeGroupsEdge>;
};


/** The output of our upsert `UsersToPracticeGroup` mutation. */
export type GqlUpsertUsersToPracticeGroupPayloadUsersToPracticeGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};

/** Where conditions for the upsert `UsersToPracticeGroup` mutation. */
export type GqlUpsertUsersToPracticeGroupWhere = {
  practiceGroupId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `UsersToTechstack` mutation. */
export type GqlUpsertUsersToTechstackInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UsersToTechstack` to be upserted by this mutation. */
  usersToTechstack: GqlUsersToTechstackInput;
};

/** The output of our upsert `UsersToTechstack` mutation. */
export type GqlUpsertUsersToTechstackPayload = {
  __typename?: 'UpsertUsersToTechstackPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** Reads a single `Techstack` that is related to this `UsersToTechstack`. */
  techstack: Maybe<GqlTechstack>;
  /** Reads a single `User` that is related to this `UsersToTechstack`. */
  user: Maybe<GqlUser>;
  /** The `UsersToTechstack` that was upserted by this mutation. */
  usersToTechstack: Maybe<GqlUsersToTechstack>;
  /** An edge for our `UsersToTechstack`. May be used by Relay 1. */
  usersToTechstackEdge: Maybe<GqlUsersToTechstacksEdge>;
};


/** The output of our upsert `UsersToTechstack` mutation. */
export type GqlUpsertUsersToTechstackPayloadUsersToTechstackEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};

/** Where conditions for the upsert `UsersToTechstack` mutation. */
export type GqlUpsertUsersToTechstackWhere = {
  techstackId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** All input for the upsert `VendorStackshareLogo` mutation. */
export type GqlUpsertVendorStackshareLogoInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `VendorStackshareLogo` to be upserted by this mutation. */
  vendorStackshareLogo: GqlVendorStackshareLogoInput;
};

/** The output of our upsert `VendorStackshareLogo` mutation. */
export type GqlUpsertVendorStackshareLogoPayload = {
  __typename?: 'UpsertVendorStackshareLogoPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Organization` that is related to this `VendorStackshareLogo`. */
  organization: Maybe<GqlOrganization>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<GqlQuery>;
  /** The `VendorStackshareLogo` that was upserted by this mutation. */
  vendorStackshareLogo: Maybe<GqlVendorStackshareLogo>;
  /** An edge for our `VendorStackshareLogo`. May be used by Relay 1. */
  vendorStackshareLogoEdge: Maybe<GqlVendorStackshareLogosEdge>;
};


/** The output of our upsert `VendorStackshareLogo` mutation. */
export type GqlUpsertVendorStackshareLogoPayloadVendorStackshareLogoEdgeArgs = {
  orderBy?: InputMaybe<Array<VendorStackshareLogosOrderBy>>;
};

/** Where conditions for the upsert `VendorStackshareLogo` mutation. */
export type GqlUpsertVendorStackshareLogoWhere = {
  id?: InputMaybe<Scalars['Int']>;
};

export type GqlUseCase = GqlNode & {
  __typename?: 'UseCase';
  action: Maybe<Scalars['String']>;
  author: Scalars['Int'];
  createdAt: Maybe<Scalars['Datetime']>;
  details: Maybe<Scalars['JSON']>;
  feature: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `UseCase`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  ownerCreated: Scalars['Boolean'];
  practiceGroup: Maybe<Scalars['Int']>;
  /** Reads a single `Product` that is related to this `UseCase`. */
  product: Maybe<GqlProduct>;
  productId: Maybe<Scalars['Int']>;
  /** Reads a single `Term` that is related to this `UseCase`. */
  termByPracticeGroup: Maybe<GqlTerm>;
  trigger: Maybe<Scalars['String']>;
  updatedAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `UseCase`. */
  userByAuthor: Maybe<GqlUser>;
};

/** A condition to be used against `UseCase` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlUseCaseCondition = {
  /** Checks for equality with the object’s `action` field. */
  action?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `author` field. */
  author?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `feature` field. */
  feature?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ownerCreated` field. */
  ownerCreated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `practiceGroup` field. */
  practiceGroup?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `trigger` field. */
  trigger?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `UseCase` object types. All fields are combined with a logical ‘and.’ */
export type GqlUseCaseFilter = {
  /** Filter by the object’s `action` field. */
  action?: InputMaybe<GqlStringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUseCaseFilter>>;
  /** Filter by the object’s `author` field. */
  author?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `feature` field. */
  feature?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUseCaseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUseCaseFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `ownerCreated` field. */
  ownerCreated?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `practiceGroup` field. */
  practiceGroup?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `trigger` field. */
  trigger?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `UseCase` */
export type GqlUseCaseInput = {
  action?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  feature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerCreated?: InputMaybe<Scalars['Boolean']>;
  practiceGroup?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  trigger?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `UseCase`. Fields that are set will be updated. */
export type GqlUseCasePatch = {
  action?: InputMaybe<Scalars['String']>;
  author?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  feature?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerCreated?: InputMaybe<Scalars['Boolean']>;
  practiceGroup?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['Int']>;
  trigger?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `UseCase` values. */
export type GqlUseCasesConnection = {
  __typename?: 'UseCasesConnection';
  /** A list of edges which contains the `UseCase` and cursor to aid in pagination. */
  edges: Array<GqlUseCasesEdge>;
  /** A list of `UseCase` objects. */
  nodes: Array<Maybe<GqlUseCase>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UseCase` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UseCase` edge in the connection. */
export type GqlUseCasesEdge = {
  __typename?: 'UseCasesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UseCase` at the end of the edge. */
  node: Maybe<GqlUseCase>;
};

/** Methods to use when ordering `UseCase`. */
export enum UseCasesOrderBy {
  ActionAsc = 'ACTION_ASC',
  ActionDesc = 'ACTION_DESC',
  AuthorAsc = 'AUTHOR_ASC',
  AuthorDesc = 'AUTHOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  FeatureAsc = 'FEATURE_ASC',
  FeatureDesc = 'FEATURE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OwnerCreatedAsc = 'OWNER_CREATED_ASC',
  OwnerCreatedDesc = 'OWNER_CREATED_DESC',
  PracticeGroupAsc = 'PRACTICE_GROUP_ASC',
  PracticeGroupDesc = 'PRACTICE_GROUP_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  TriggerAsc = 'TRIGGER_ASC',
  TriggerDesc = 'TRIGGER_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlUser = GqlNode & {
  __typename?: 'User';
  appMetadata: Scalars['JSON'];
  auth0Id: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomers: Array<GqlConnectCustomer>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomersConnection: GqlConnectCustomersConnection;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOwnerId: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesByOwnerIdConnection: GqlConnectPurchasesConnection;
  createdAt: Scalars['Datetime'];
  currentOrganization: Maybe<Scalars['UUID']>;
  details: Scalars['JSON'];
  email: Scalars['String'];
  first: Scalars['String'];
  id: Scalars['Int'];
  issubscribed: Maybe<Scalars['Boolean']>;
  jobTitle: Scalars['String'];
  last: Scalars['String'];
  /** Reads a single `Location` that is related to this `User`. */
  location: Maybe<GqlLocation>;
  locationId: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUsersToOrganizationUserIdAndLocationId: GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Location`. */
  locationsByUsersToOrganizationUserIdAndLocationIdList: Array<GqlLocation>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Array<GqlNotification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection: GqlNotificationsConnection;
  /** Reads and enables pagination through a set of `NoviMember`. */
  noviMembers: Array<GqlNoviMember>;
  /** Reads and enables pagination through a set of `NoviMember`. */
  noviMembersConnection: GqlNoviMembersConnection;
  /** Reads a single `Organization` that is related to this `User`. */
  organizationByCurrentOrganization: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByConnectCustomerUserIdAndOrganizationId: GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByConnectCustomerUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByConnectPurchaseOwnerIdAndOrganizationId: GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByConnectPurchaseOwnerIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByNotificationUserIdAndOrganizationId: GqlUserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByNotificationUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripeAccountUserIdAndOrganizationId: GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripeAccountUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripeCustomerUserIdAndOrganizationId: GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripeCustomerUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripePurchaseOwnerIdAndOrganizationId: GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripePurchaseOwnerIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripeSeatUserIdAndOrganizationId: GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByStripeSeatUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTechstackAddedByAndOrganizationId: GqlUserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTechstackAddedByAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTechstackOwnedByAndOrganizationId: GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTechstackOwnedByAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToUserUserIdAndOrganizationId: GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByTermToUserUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUseCaseAuthorAndOrganizationId: GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUseCaseAuthorAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserStoryAuthorAndOrganizationId: GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserStoryAuthorAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserToOrgStackUserIdAndOrganizationId: GqlUserOrganizationsByUserToOrgStackUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUserToOrgStackUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUsersToOrganizationUserIdAndOrganizationId: GqlUserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Organization`. */
  organizationsByUsersToOrganizationUserIdAndOrganizationIdList: Array<GqlOrganization>;
  /** Reads and enables pagination through a set of `PersonalTechstack`. */
  personalTechstacks: Array<GqlPersonalTechstack>;
  /** Reads and enables pagination through a set of `PersonalTechstack`. */
  personalTechstacksConnection: GqlPersonalTechstacksConnection;
  /** Reads and enables pagination through a set of `PracticeGroup`. */
  practiceGroupsByUsersToPracticeGroupUserIdAndPracticeGroupId: GqlUserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdManyToManyConnection;
  /** Reads and enables pagination through a set of `PracticeGroup`. */
  practiceGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdList: Array<GqlPracticeGroup>;
  /** Reads and enables pagination through a set of `ProductToUser`. */
  productToUsers: Array<GqlProductToUser>;
  /** Reads and enables pagination through a set of `ProductToUser`. */
  productToUsersConnection: GqlProductToUsersConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByPersonalTechstackUserIdAndProductId: GqlUserProductsByPersonalTechstackUserIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByPersonalTechstackUserIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToUserUserIdAndProductId: GqlUserProductsByProductToUserUserIdAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByProductToUserUserIdAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTechstackAddedByAndProductId: GqlUserProductsByTechstackAddedByAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTechstackAddedByAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTechstackOwnedByAndProductId: GqlUserProductsByTechstackOwnedByAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByTechstackOwnedByAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUseCaseAuthorAndProductId: GqlUserProductsByUseCaseAuthorAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUseCaseAuthorAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUserStoryAuthorAndProductId: GqlUserProductsByUserStoryAuthorAndProductIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Product`. */
  productsByUserStoryAuthorAndProductIdList: Array<GqlProduct>;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfps: Array<GqlRfp>;
  /** Reads and enables pagination through a set of `Rfp`. */
  rfpsConnection: GqlRfpsConnection;
  role: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Scheduler`. */
  schedulers: Array<GqlScheduler>;
  /** Reads and enables pagination through a set of `Scheduler`. */
  schedulersConnection: GqlSchedulersConnection;
  status: UserStatus;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccounts: Array<GqlStripeAccount>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccountsConnection: GqlStripeAccountsConnection;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomers: Array<GqlStripeCustomer>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersConnection: GqlStripeCustomersConnection;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesByOwnerId: Array<GqlStripePurchase>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesByOwnerIdConnection: GqlStripePurchasesConnection;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeats: Array<GqlStripeSeat>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatsConnection: GqlStripeSeatsConnection;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedByConnection: GqlTechstacksConnection;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedByConnection: GqlTechstacksConnection;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByUsersToTechstackUserIdAndTechstackId: GqlUserTechstacksByUsersToTechstackUserIdAndTechstackIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByUsersToTechstackUserIdAndTechstackIdList: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToUserUserIdAndTermId: GqlUserTermsByTermToUserUserIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToUserUserIdAndTermIdList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUseCaseAuthorAndPracticeGroup: GqlUserTermsByUseCaseAuthorAndPracticeGroupManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUseCaseAuthorAndPracticeGroupList: Array<GqlTerm>;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUsersToOrganizationUserIdAndJobTitle: GqlUserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByUsersToOrganizationUserIdAndJobTitleList: Array<GqlTerm>;
  testMode: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthor: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByAuthorConnection: GqlUseCasesConnection;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByAuthor: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesByAuthorConnection: GqlUserStoriesConnection;
  /** Reads and enables pagination through a set of `UserToOrgStack`. */
  userToOrgStacks: Array<GqlUserToOrgStack>;
  /** Reads and enables pagination through a set of `UserToOrgStack`. */
  userToOrgStacksConnection: GqlUserToOrgStacksConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackAddedByAndOwnedBy: GqlUserUsersByTechstackAddedByAndOwnedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackAddedByAndOwnedByList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackOwnedByAndAddedBy: GqlUserUsersByTechstackOwnedByAndAddedByManyToManyConnection;
  /** Reads and enables pagination through a set of `User`. */
  usersByTechstackOwnedByAndAddedByList: Array<GqlUser>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
  /** Reads and enables pagination through a set of `UsersToPracticeGroup`. */
  usersToPracticeGroups: Array<GqlUsersToPracticeGroup>;
  /** Reads and enables pagination through a set of `UsersToPracticeGroup`. */
  usersToPracticeGroupsConnection: GqlUsersToPracticeGroupsConnection;
  /** Reads and enables pagination through a set of `UsersToTechstack`. */
  usersToTechstacks: Array<GqlUsersToTechstack>;
  /** Reads and enables pagination through a set of `UsersToTechstack`. */
  usersToTechstacksConnection: GqlUsersToTechstacksConnection;
};


export type GqlUserConnectCustomersArgs = {
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


export type GqlUserConnectCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


export type GqlUserConnectPurchasesByOwnerIdArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlUserConnectPurchasesByOwnerIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


export type GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdListArgs = {
  condition: InputMaybe<GqlLocationCondition>;
  filter: InputMaybe<GqlLocationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<LocationsOrderBy>>;
};


export type GqlUserNotificationsArgs = {
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NotificationsOrderBy>>;
};


export type GqlUserNotificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};


export type GqlUserNoviMembersArgs = {
  condition: InputMaybe<GqlNoviMemberCondition>;
  filter: InputMaybe<GqlNoviMemberFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NoviMembersOrderBy>>;
};


export type GqlUserNoviMembersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNoviMemberCondition>;
  filter: InputMaybe<GqlNoviMemberFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NoviMembersOrderBy>>;
};


export type GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByNotificationUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByNotificationUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByTechstackAddedByAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByTechstackAddedByAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUserToOrgStackUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUserToOrgStackUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdListArgs = {
  condition: InputMaybe<GqlOrganizationCondition>;
  filter: InputMaybe<GqlOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<OrganizationsOrderBy>>;
};


export type GqlUserPersonalTechstacksArgs = {
  condition: InputMaybe<GqlPersonalTechstackCondition>;
  filter: InputMaybe<GqlPersonalTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};


export type GqlUserPersonalTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPersonalTechstackCondition>;
  filter: InputMaybe<GqlPersonalTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PersonalTechstacksOrderBy>>;
};


export type GqlUserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlPracticeGroupCondition>;
  filter: InputMaybe<GqlPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PracticeGroupsOrderBy>>;
};


export type GqlUserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdListArgs = {
  condition: InputMaybe<GqlPracticeGroupCondition>;
  filter: InputMaybe<GqlPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<PracticeGroupsOrderBy>>;
};


export type GqlUserProductToUsersArgs = {
  condition: InputMaybe<GqlProductToUserCondition>;
  filter: InputMaybe<GqlProductToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductToUsersOrderBy>>;
};


export type GqlUserProductToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductToUserCondition>;
  filter: InputMaybe<GqlProductToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductToUsersOrderBy>>;
};


export type GqlUserProductsByPersonalTechstackUserIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByPersonalTechstackUserIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByProductToUserUserIdAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByProductToUserUserIdAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByTechstackAddedByAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByTechstackAddedByAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByTechstackOwnedByAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByTechstackOwnedByAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByUseCaseAuthorAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByUseCaseAuthorAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByUserStoryAuthorAndProductIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserProductsByUserStoryAuthorAndProductIdListArgs = {
  condition: InputMaybe<GqlProductCondition>;
  filter: InputMaybe<GqlProductFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ProductsOrderBy>>;
};


export type GqlUserRfpsArgs = {
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<RfpsOrderBy>>;
};


export type GqlUserRfpsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlRfpCondition>;
  filter: InputMaybe<GqlRfpFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RfpsOrderBy>>;
};


export type GqlUserSchedulersArgs = {
  condition: InputMaybe<GqlSchedulerCondition>;
  filter: InputMaybe<GqlSchedulerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<SchedulersOrderBy>>;
};


export type GqlUserSchedulersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlSchedulerCondition>;
  filter: InputMaybe<GqlSchedulerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SchedulersOrderBy>>;
};


export type GqlUserStripeAccountsArgs = {
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeAccountsOrderBy>>;
};


export type GqlUserStripeAccountsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};


export type GqlUserStripeCustomersArgs = {
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type GqlUserStripeCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};


export type GqlUserStripePurchasesByOwnerIdArgs = {
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripePurchasesOrderBy>>;
};


export type GqlUserStripePurchasesByOwnerIdConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};


export type GqlUserStripeSeatsArgs = {
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeSeatsOrderBy>>;
};


export type GqlUserStripeSeatsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};


export type GqlUserTechstacksByAddedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlUserTechstacksByAddedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlUserTechstacksByOwnedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlUserTechstacksByOwnedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlUserTechstacksByUsersToTechstackUserIdAndTechstackIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlUserTechstacksByUsersToTechstackUserIdAndTechstackIdListArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


export type GqlUserTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


export type GqlUserTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};


export type GqlUserTermsByTermToUserUserIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserTermsByTermToUserUserIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserTermsByUseCaseAuthorAndPracticeGroupArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserTermsByUseCaseAuthorAndPracticeGroupListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserTermsByUsersToOrganizationUserIdAndJobTitleArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserTermsByUsersToOrganizationUserIdAndJobTitleListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserUseCasesByAuthorArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlUserUseCasesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};


export type GqlUserUserStoriesByAuthorArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlUserUserStoriesByAuthorConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};


export type GqlUserUserToOrgStacksArgs = {
  condition: InputMaybe<GqlUserToOrgStackCondition>;
  filter: InputMaybe<GqlUserToOrgStackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};


export type GqlUserUserToOrgStacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserToOrgStackCondition>;
  filter: InputMaybe<GqlUserToOrgStackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserToOrgStacksOrderBy>>;
};


export type GqlUserUsersByTechstackAddedByAndOwnedByArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlUserUsersByTechstackAddedByAndOwnedByListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlUserUsersByTechstackOwnedByAndAddedByArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlUserUsersByTechstackOwnedByAndAddedByListArgs = {
  condition: InputMaybe<GqlUserCondition>;
  filter: InputMaybe<GqlUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersOrderBy>>;
};


export type GqlUserUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


export type GqlUserUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


export type GqlUserUsersToPracticeGroupsArgs = {
  condition: InputMaybe<GqlUsersToPracticeGroupCondition>;
  filter: InputMaybe<GqlUsersToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};


export type GqlUserUsersToPracticeGroupsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToPracticeGroupCondition>;
  filter: InputMaybe<GqlUsersToPracticeGroupFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToPracticeGroupsOrderBy>>;
};


export type GqlUserUsersToTechstacksArgs = {
  condition: InputMaybe<GqlUsersToTechstackCondition>;
  filter: InputMaybe<GqlUsersToTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};


export type GqlUserUsersToTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToTechstackCondition>;
  filter: InputMaybe<GqlUsersToTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToTechstacksOrderBy>>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GqlUserCondition = {
  /** Checks for equality with the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `auth0Id` field. */
  auth0Id?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `currentOrganization` field. */
  currentOrganization?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `email` field. */
  email?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `first` field. */
  first?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `issubscribed` field. */
  issubscribed?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `last` field. */
  last?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<UserStatus>;
  /** Checks for equality with the object’s `testMode` field. */
  testMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type GqlUserFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUserFilter>>;
  /** Filter by the object’s `appMetadata` field. */
  appMetadata?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `auth0Id` field. */
  auth0Id?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `currentOrganization` field. */
  currentOrganization?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `email` field. */
  email?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `first` field. */
  first?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `issubscribed` field. */
  issubscribed?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `last` field. */
  last?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUserFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlUserStatusFilter>;
  /** Filter by the object’s `testMode` field. */
  testMode?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
};

/** An input for mutations affecting `User` */
export type GqlUserInput = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  auth0Id?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currentOrganization?: InputMaybe<Scalars['UUID']>;
  details?: InputMaybe<Scalars['JSON']>;
  email: Scalars['String'];
  first?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  issubscribed?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<UserStatus>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `Location` values, with data from `UsersToOrganization`. */
export type GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyConnection = {
  __typename?: 'UserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyConnection';
  /** A list of edges which contains the `Location`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyEdge>;
  /** A list of `Location` objects. */
  nodes: Array<Maybe<GqlLocation>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Location` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyEdge = {
  __typename?: 'UserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Location` at the end of the edge. */
  node: Maybe<GqlLocation>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizations: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsConnection: GqlUsersToOrganizationsConnection;
};


/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyEdgeUsersToOrganizationsArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Location` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserLocationsByUsersToOrganizationUserIdAndLocationIdManyToManyEdgeUsersToOrganizationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ConnectCustomer`. */
export type GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ConnectCustomer`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ConnectCustomer`. */
export type GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomers: Array<GqlConnectCustomer>;
  /** Reads and enables pagination through a set of `ConnectCustomer`. */
  connectCustomersConnection: GqlConnectCustomersConnection;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};


/** A `Organization` edge in the connection, with data from `ConnectCustomer`. */
export type GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyEdgeConnectCustomersArgs = {
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectCustomersOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ConnectCustomer`. */
export type GqlUserOrganizationsByConnectCustomerUserIdAndOrganizationIdManyToManyEdgeConnectCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectCustomerCondition>;
  filter: InputMaybe<GqlConnectCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectCustomersOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `ConnectPurchase`. */
export type GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `ConnectPurchase`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `ConnectPurchase`. */
export type GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyEdge';
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchases: Array<GqlConnectPurchase>;
  /** Reads and enables pagination through a set of `ConnectPurchase`. */
  connectPurchasesConnection: GqlConnectPurchasesConnection;
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};


/** A `Organization` edge in the connection, with data from `ConnectPurchase`. */
export type GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyEdgeConnectPurchasesArgs = {
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `ConnectPurchase`. */
export type GqlUserOrganizationsByConnectPurchaseOwnerIdAndOrganizationIdManyToManyEdgeConnectPurchasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlConnectPurchaseCondition>;
  filter: InputMaybe<GqlConnectPurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConnectPurchasesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `Notification`. */
export type GqlUserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Notification`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `Notification`. */
export type GqlUserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Array<GqlNotification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notificationsConnection: GqlNotificationsConnection;
};


/** A `Organization` edge in the connection, with data from `Notification`. */
export type GqlUserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyEdgeNotificationsArgs = {
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<NotificationsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Notification`. */
export type GqlUserOrganizationsByNotificationUserIdAndOrganizationIdManyToManyEdgeNotificationsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlNotificationCondition>;
  filter: InputMaybe<GqlNotificationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `StripeAccount`. */
export type GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `StripeAccount`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `StripeAccount`. */
export type GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccounts: Array<GqlStripeAccount>;
  /** Reads and enables pagination through a set of `StripeAccount`. */
  stripeAccountsConnection: GqlStripeAccountsConnection;
};


/** A `Organization` edge in the connection, with data from `StripeAccount`. */
export type GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyEdgeStripeAccountsArgs = {
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeAccountsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `StripeAccount`. */
export type GqlUserOrganizationsByStripeAccountUserIdAndOrganizationIdManyToManyEdgeStripeAccountsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeAccountCondition>;
  filter: InputMaybe<GqlStripeAccountFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeAccountsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `StripeCustomer`. */
export type GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `StripeCustomer`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `StripeCustomer`. */
export type GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomers: Array<GqlStripeCustomer>;
  /** Reads and enables pagination through a set of `StripeCustomer`. */
  stripeCustomersConnection: GqlStripeCustomersConnection;
};


/** A `Organization` edge in the connection, with data from `StripeCustomer`. */
export type GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyEdgeStripeCustomersArgs = {
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeCustomersOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `StripeCustomer`. */
export type GqlUserOrganizationsByStripeCustomerUserIdAndOrganizationIdManyToManyEdgeStripeCustomersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeCustomerCondition>;
  filter: InputMaybe<GqlStripeCustomerFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeCustomersOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `StripePurchase`. */
export type GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `StripePurchase`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `StripePurchase`. */
export type GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchases: Array<GqlStripePurchase>;
  /** Reads and enables pagination through a set of `StripePurchase`. */
  stripePurchasesConnection: GqlStripePurchasesConnection;
};


/** A `Organization` edge in the connection, with data from `StripePurchase`. */
export type GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyEdgeStripePurchasesArgs = {
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripePurchasesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `StripePurchase`. */
export type GqlUserOrganizationsByStripePurchaseOwnerIdAndOrganizationIdManyToManyEdgeStripePurchasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripePurchaseCondition>;
  filter: InputMaybe<GqlStripePurchaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripePurchasesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `StripeSeat`. */
export type GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `StripeSeat`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `StripeSeat`. */
export type GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeats: Array<GqlStripeSeat>;
  /** Reads and enables pagination through a set of `StripeSeat`. */
  stripeSeatsConnection: GqlStripeSeatsConnection;
};


/** A `Organization` edge in the connection, with data from `StripeSeat`. */
export type GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyEdgeStripeSeatsArgs = {
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<StripeSeatsOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `StripeSeat`. */
export type GqlUserOrganizationsByStripeSeatUserIdAndOrganizationIdManyToManyEdgeStripeSeatsConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlStripeSeatCondition>;
  filter: InputMaybe<GqlStripeSeatFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StripeSeatsOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacks: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: GqlTechstacksConnection;
};


/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyEdgeTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackAddedByAndOrganizationIdManyToManyEdgeTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacks: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: GqlTechstacksConnection;
};


/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyEdgeTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `Techstack`. */
export type GqlUserOrganizationsByTechstackOwnedByAndOrganizationIdManyToManyEdgeTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `TermToUser`. */
export type GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `TermToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `TermToUser`. */
export type GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsers: Array<GqlTermToUser>;
  /** Reads and enables pagination through a set of `TermToUser`. */
  termToUsersConnection: GqlTermToUsersConnection;
};


/** A `Organization` edge in the connection, with data from `TermToUser`. */
export type GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyEdgeTermToUsersArgs = {
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUsersOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `TermToUser`. */
export type GqlUserOrganizationsByTermToUserUserIdAndOrganizationIdManyToManyEdgeTermToUsersConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserCondition>;
  filter: InputMaybe<GqlTermToUserFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUsersOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UseCase`. */
export type GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
};


/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyEdgeUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UseCase`. */
export type GqlUserOrganizationsByUseCaseAuthorAndOrganizationIdManyToManyEdgeUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UserStory`. */
export type GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UserStory`. */
export type GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStories: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: GqlUserStoriesConnection;
};


/** A `Organization` edge in the connection, with data from `UserStory`. */
export type GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyEdgeUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** A `Organization` edge in the connection, with data from `UserStory`. */
export type GqlUserOrganizationsByUserStoryAuthorAndOrganizationIdManyToManyEdgeUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

/** A connection to a list of `Organization` values, with data from `UserToOrgStack`. */
export type GqlUserOrganizationsByUserToOrgStackUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByUserToOrgStackUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UserToOrgStack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByUserToOrgStackUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UserToOrgStack`. */
export type GqlUserOrganizationsByUserToOrgStackUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByUserToOrgStackUserIdAndOrganizationIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
};

/** A connection to a list of `Organization` values, with data from `UsersToOrganization`. */
export type GqlUserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdManyToManyConnection = {
  __typename?: 'UserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdManyToManyConnection';
  /** A list of edges which contains the `Organization`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlUserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdManyToManyEdge>;
  /** A list of `Organization` objects. */
  nodes: Array<Maybe<GqlOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Organization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Organization` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdManyToManyEdge = {
  __typename?: 'UserOrganizationsByUsersToOrganizationUserIdAndOrganizationIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  jobTitle: Maybe<Scalars['Int']>;
  locationId: Maybe<Scalars['Int']>;
  /** The `Organization` at the end of the edge. */
  node: Maybe<GqlOrganization>;
  role: UserRole;
  status: MemberStatus;
  updatedAt: Scalars['Datetime'];
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type GqlUserPatch = {
  appMetadata?: InputMaybe<Scalars['JSON']>;
  auth0Id?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  currentOrganization?: InputMaybe<Scalars['UUID']>;
  details?: InputMaybe<Scalars['JSON']>;
  email?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  issubscribed?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<UserStatus>;
  testMode?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PracticeGroup` values, with data from `UsersToPracticeGroup`. */
export type GqlUserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdManyToManyConnection = {
  __typename?: 'UserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdManyToManyConnection';
  /** A list of edges which contains the `PracticeGroup`, info from the `UsersToPracticeGroup`, and the cursor to aid in pagination. */
  edges: Array<GqlUserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdManyToManyEdge>;
  /** A list of `PracticeGroup` objects. */
  nodes: Array<Maybe<GqlPracticeGroup>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `PracticeGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `PracticeGroup` edge in the connection, with data from `UsersToPracticeGroup`. */
export type GqlUserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdManyToManyEdge = {
  __typename?: 'UserPracticeGroupsByUsersToPracticeGroupUserIdAndPracticeGroupIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `PracticeGroup` at the end of the edge. */
  node: Maybe<GqlPracticeGroup>;
};

/** A connection to a list of `Product` values, with data from `PersonalTechstack`. */
export type GqlUserProductsByPersonalTechstackUserIdAndProductIdManyToManyConnection = {
  __typename?: 'UserProductsByPersonalTechstackUserIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `PersonalTechstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserProductsByPersonalTechstackUserIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `PersonalTechstack`. */
export type GqlUserProductsByPersonalTechstackUserIdAndProductIdManyToManyEdge = {
  __typename?: 'UserProductsByPersonalTechstackUserIdAndProductIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  organizationId: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `Product` values, with data from `ProductToUser`. */
export type GqlUserProductsByProductToUserUserIdAndProductIdManyToManyConnection = {
  __typename?: 'UserProductsByProductToUserUserIdAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `ProductToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlUserProductsByProductToUserUserIdAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `ProductToUser`. */
export type GqlUserProductsByProductToUserUserIdAndProductIdManyToManyEdge = {
  __typename?: 'UserProductsByProductToUserUserIdAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
};

/** A connection to a list of `Product` values, with data from `Techstack`. */
export type GqlUserProductsByTechstackAddedByAndProductIdManyToManyConnection = {
  __typename?: 'UserProductsByTechstackAddedByAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserProductsByTechstackAddedByAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlUserProductsByTechstackAddedByAndProductIdManyToManyEdge = {
  __typename?: 'UserProductsByTechstackAddedByAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacks: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: GqlTechstacksConnection;
};


/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlUserProductsByTechstackAddedByAndProductIdManyToManyEdgeTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlUserProductsByTechstackAddedByAndProductIdManyToManyEdgeTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `Techstack`. */
export type GqlUserProductsByTechstackOwnedByAndProductIdManyToManyConnection = {
  __typename?: 'UserProductsByTechstackOwnedByAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserProductsByTechstackOwnedByAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlUserProductsByTechstackOwnedByAndProductIdManyToManyEdge = {
  __typename?: 'UserProductsByTechstackOwnedByAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacks: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksConnection: GqlTechstacksConnection;
};


/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlUserProductsByTechstackOwnedByAndProductIdManyToManyEdgeTechstacksArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `Product` edge in the connection, with data from `Techstack`. */
export type GqlUserProductsByTechstackOwnedByAndProductIdManyToManyEdgeTechstacksConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `UseCase`. */
export type GqlUserProductsByUseCaseAuthorAndProductIdManyToManyConnection = {
  __typename?: 'UserProductsByUseCaseAuthorAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlUserProductsByUseCaseAuthorAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlUserProductsByUseCaseAuthorAndProductIdManyToManyEdge = {
  __typename?: 'UserProductsByUseCaseAuthorAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCases: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesConnection: GqlUseCasesConnection;
};


/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlUserProductsByUseCaseAuthorAndProductIdManyToManyEdgeUseCasesArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Product` edge in the connection, with data from `UseCase`. */
export type GqlUserProductsByUseCaseAuthorAndProductIdManyToManyEdgeUseCasesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Product` values, with data from `UserStory`. */
export type GqlUserProductsByUserStoryAuthorAndProductIdManyToManyConnection = {
  __typename?: 'UserProductsByUserStoryAuthorAndProductIdManyToManyConnection';
  /** A list of edges which contains the `Product`, info from the `UserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlUserProductsByUserStoryAuthorAndProductIdManyToManyEdge>;
  /** A list of `Product` objects. */
  nodes: Array<Maybe<GqlProduct>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Product` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Product` edge in the connection, with data from `UserStory`. */
export type GqlUserProductsByUserStoryAuthorAndProductIdManyToManyEdge = {
  __typename?: 'UserProductsByUserStoryAuthorAndProductIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Product` at the end of the edge. */
  node: Maybe<GqlProduct>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStories: Array<GqlUserStory>;
  /** Reads and enables pagination through a set of `UserStory`. */
  userStoriesConnection: GqlUserStoriesConnection;
};


/** A `Product` edge in the connection, with data from `UserStory`. */
export type GqlUserProductsByUserStoryAuthorAndProductIdManyToManyEdgeUserStoriesArgs = {
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UserStoriesOrderBy>>;
};


/** A `Product` edge in the connection, with data from `UserStory`. */
export type GqlUserProductsByUserStoryAuthorAndProductIdManyToManyEdgeUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUserStoryCondition>;
  filter: InputMaybe<GqlUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserStoriesOrderBy>>;
};

export enum UserRole {
  Admin = 'ADMIN',
  Invite = 'INVITE',
  Owner = 'OWNER',
  Personal = 'PERSONAL',
  SuperAdmin = 'SUPER_ADMIN',
  User = 'USER',
  Vendor = 'VENDOR'
}

/** A filter to be used against UserRole fields. All fields are combined with a logical ‘and.’ */
export type GqlUserRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserRole>>;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  AssocStack = 'ASSOC_STACK',
  AssocUser = 'ASSOC_USER',
  Blocked = 'BLOCKED',
  CreateOrg = 'CREATE_ORG',
  CreatePersonalUser = 'CREATE_PERSONAL_USER',
  CreateProduct = 'CREATE_PRODUCT',
  CreateUser = 'CREATE_USER',
  Inactive = 'INACTIVE',
  Invite = 'INVITE',
  JoinOrg = 'JOIN_ORG',
  LawfirmPayment = 'LAWFIRM_PAYMENT',
  LawfirmPlans = 'LAWFIRM_PLANS',
  PersonalPayment = 'PERSONAL_PAYMENT',
  PersonalSuccess = 'PERSONAL_SUCCESS',
  RequestScreen = 'REQUEST_SCREEN',
  SelectRole = 'SELECT_ROLE',
  SetApps = 'SET_APPS',
  SetLawfirmStack = 'SET_LAWFIRM_STACK',
  SetLawfirmUserStack = 'SET_LAWFIRM_USER_STACK',
  SetLocation = 'SET_LOCATION',
  SetOrg = 'SET_ORG',
  SetProducts = 'SET_PRODUCTS',
  TermsConditions = 'TERMS_CONDITIONS',
  Unconfirmed = 'UNCONFIRMED',
  VendorPayment = 'VENDOR_PAYMENT'
}

/** A filter to be used against UserStatus fields. All fields are combined with a logical ‘and.’ */
export type GqlUserStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<UserStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<UserStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<UserStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<UserStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<UserStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<UserStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<UserStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<UserStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<UserStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<UserStatus>>;
};

/** A connection to a list of `UserStory` values. */
export type GqlUserStoriesConnection = {
  __typename?: 'UserStoriesConnection';
  /** A list of edges which contains the `UserStory` and cursor to aid in pagination. */
  edges: Array<GqlUserStoriesEdge>;
  /** A list of `UserStory` objects. */
  nodes: Array<Maybe<GqlUserStory>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UserStory` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserStory` edge in the connection. */
export type GqlUserStoriesEdge = {
  __typename?: 'UserStoriesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UserStory` at the end of the edge. */
  node: Maybe<GqlUserStory>;
};

/** Methods to use when ordering `UserStory`. */
export enum UserStoriesOrderBy {
  AuthorAsc = 'AUTHOR_ASC',
  AuthorDesc = 'AUTHOR_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  OwnerCreatedAsc = 'OWNER_CREATED_ASC',
  OwnerCreatedDesc = 'OWNER_CREATED_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProductIdAsc = 'PRODUCT_ID_ASC',
  ProductIdDesc = 'PRODUCT_ID_DESC',
  ToAsc = 'TO_ASC',
  ToDesc = 'TO_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  WhenAsc = 'WHEN_ASC',
  WhenDesc = 'WHEN_DESC'
}

export type GqlUserStory = GqlNode & {
  __typename?: 'UserStory';
  author: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  details: Scalars['JSON'];
  id: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `UserStory`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Maybe<Scalars['UUID']>;
  ownerCreated: Scalars['Boolean'];
  /** Reads a single `Product` that is related to this `UserStory`. */
  product: Maybe<GqlProduct>;
  productId: Scalars['Int'];
  /** Reads and enables pagination through a set of `TermToUserStory`. */
  termToUserStories: Array<GqlTermToUserStory>;
  /** Reads and enables pagination through a set of `TermToUserStory`. */
  termToUserStoriesConnection: GqlTermToUserStoriesConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToUserStoryUserStoryIdAndTermId: GqlUserStoryTermsByTermToUserStoryUserStoryIdAndTermIdManyToManyConnection;
  /** Reads and enables pagination through a set of `Term`. */
  termsByTermToUserStoryUserStoryIdAndTermIdList: Array<GqlTerm>;
  to: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserStory`. */
  userByAuthor: Maybe<GqlUser>;
  when: Scalars['String'];
};


export type GqlUserStoryTermToUserStoriesArgs = {
  condition: InputMaybe<GqlTermToUserStoryCondition>;
  filter: InputMaybe<GqlTermToUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};


export type GqlUserStoryTermToUserStoriesConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermToUserStoryCondition>;
  filter: InputMaybe<GqlTermToUserStoryFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermToUserStoriesOrderBy>>;
};


export type GqlUserStoryTermsByTermToUserStoryUserStoryIdAndTermIdArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TermsOrderBy>>;
};


export type GqlUserStoryTermsByTermToUserStoryUserStoryIdAndTermIdListArgs = {
  condition: InputMaybe<GqlTermCondition>;
  filter: InputMaybe<GqlTermFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TermsOrderBy>>;
};

/**
 * A condition to be used against `UserStory` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GqlUserStoryCondition = {
  /** Checks for equality with the object’s `author` field. */
  author?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `details` field. */
  details?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `ownerCreated` field. */
  ownerCreated?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `productId` field. */
  productId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `to` field. */
  to?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `when` field. */
  when?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against `UserStory` object types. All fields are combined with a logical ‘and.’ */
export type GqlUserStoryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUserStoryFilter>>;
  /** Filter by the object’s `author` field. */
  author?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `details` field. */
  details?: InputMaybe<GqlJsonFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUserStoryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUserStoryFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `ownerCreated` field. */
  ownerCreated?: InputMaybe<GqlBooleanFilter>;
  /** Filter by the object’s `productId` field. */
  productId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `to` field. */
  to?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `when` field. */
  when?: InputMaybe<GqlStringFilter>;
};

/** An input for mutations affecting `UserStory` */
export type GqlUserStoryInput = {
  author?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerCreated?: InputMaybe<Scalars['Boolean']>;
  productId: Scalars['Int'];
  to: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  when: Scalars['String'];
};

/** Represents an update to a `UserStory`. Fields that are set will be updated. */
export type GqlUserStoryPatch = {
  author?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  details?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  ownerCreated?: InputMaybe<Scalars['Boolean']>;
  productId?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  when?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `Term` values, with data from `TermToUserStory`. */
export type GqlUserStoryTermsByTermToUserStoryUserStoryIdAndTermIdManyToManyConnection = {
  __typename?: 'UserStoryTermsByTermToUserStoryUserStoryIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToUserStory`, and the cursor to aid in pagination. */
  edges: Array<GqlUserStoryTermsByTermToUserStoryUserStoryIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToUserStory`. */
export type GqlUserStoryTermsByTermToUserStoryUserStoryIdAndTermIdManyToManyEdge = {
  __typename?: 'UserStoryTermsByTermToUserStoryUserStoryIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
};

/** A connection to a list of `Techstack` values, with data from `UsersToTechstack`. */
export type GqlUserTechstacksByUsersToTechstackUserIdAndTechstackIdManyToManyConnection = {
  __typename?: 'UserTechstacksByUsersToTechstackUserIdAndTechstackIdManyToManyConnection';
  /** A list of edges which contains the `Techstack`, info from the `UsersToTechstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserTechstacksByUsersToTechstackUserIdAndTechstackIdManyToManyEdge>;
  /** A list of `Techstack` objects. */
  nodes: Array<Maybe<GqlTechstack>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Techstack` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Techstack` edge in the connection, with data from `UsersToTechstack`. */
export type GqlUserTechstacksByUsersToTechstackUserIdAndTechstackIdManyToManyEdge = {
  __typename?: 'UserTechstacksByUsersToTechstackUserIdAndTechstackIdManyToManyEdge';
  createdAt: Scalars['Datetime'];
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  logins: Scalars['Int'];
  /** The `Techstack` at the end of the edge. */
  node: Maybe<GqlTechstack>;
  updatedAt: Scalars['Datetime'];
};

/** A connection to a list of `Term` values, with data from `TermToUser`. */
export type GqlUserTermsByTermToUserUserIdAndTermIdManyToManyConnection = {
  __typename?: 'UserTermsByTermToUserUserIdAndTermIdManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `TermToUser`, and the cursor to aid in pagination. */
  edges: Array<GqlUserTermsByTermToUserUserIdAndTermIdManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `TermToUser`. */
export type GqlUserTermsByTermToUserUserIdAndTermIdManyToManyEdge = {
  __typename?: 'UserTermsByTermToUserUserIdAndTermIdManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  organizationId: Maybe<Scalars['UUID']>;
};

/** A connection to a list of `Term` values, with data from `UseCase`. */
export type GqlUserTermsByUseCaseAuthorAndPracticeGroupManyToManyConnection = {
  __typename?: 'UserTermsByUseCaseAuthorAndPracticeGroupManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `UseCase`, and the cursor to aid in pagination. */
  edges: Array<GqlUserTermsByUseCaseAuthorAndPracticeGroupManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlUserTermsByUseCaseAuthorAndPracticeGroupManyToManyEdge = {
  __typename?: 'UserTermsByUseCaseAuthorAndPracticeGroupManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroup: Array<GqlUseCase>;
  /** Reads and enables pagination through a set of `UseCase`. */
  useCasesByPracticeGroupConnection: GqlUseCasesConnection;
};


/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlUserTermsByUseCaseAuthorAndPracticeGroupManyToManyEdgeUseCasesByPracticeGroupArgs = {
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UseCasesOrderBy>>;
};


/** A `Term` edge in the connection, with data from `UseCase`. */
export type GqlUserTermsByUseCaseAuthorAndPracticeGroupManyToManyEdgeUseCasesByPracticeGroupConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUseCaseCondition>;
  filter: InputMaybe<GqlUseCaseFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UseCasesOrderBy>>;
};

/** A connection to a list of `Term` values, with data from `UsersToOrganization`. */
export type GqlUserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyConnection = {
  __typename?: 'UserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyConnection';
  /** A list of edges which contains the `Term`, info from the `UsersToOrganization`, and the cursor to aid in pagination. */
  edges: Array<GqlUserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyEdge>;
  /** A list of `Term` objects. */
  nodes: Array<Maybe<GqlTerm>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `Term` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyEdge = {
  __typename?: 'UserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Term` at the end of the edge. */
  node: Maybe<GqlTerm>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitle: Array<GqlUsersToOrganization>;
  /** Reads and enables pagination through a set of `UsersToOrganization`. */
  usersToOrganizationsByJobTitleConnection: GqlUsersToOrganizationsConnection;
};


/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyEdgeUsersToOrganizationsByJobTitleArgs = {
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};


/** A `Term` edge in the connection, with data from `UsersToOrganization`. */
export type GqlUserTermsByUsersToOrganizationUserIdAndJobTitleManyToManyEdgeUsersToOrganizationsByJobTitleConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlUsersToOrganizationCondition>;
  filter: InputMaybe<GqlUsersToOrganizationFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersToOrganizationsOrderBy>>;
};

export type GqlUserToOrgStack = GqlNode & {
  __typename?: 'UserToOrgStack';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `UserToOrgStack`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `UserToOrgStack`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UserToOrgStack` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlUserToOrgStackCondition = {
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UserToOrgStack` object types. All fields are combined with a logical ‘and.’ */
export type GqlUserToOrgStackFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUserToOrgStackFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUserToOrgStackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUserToOrgStackFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `UserToOrgStack` */
export type GqlUserToOrgStackInput = {
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
};

/** Represents an update to a `UserToOrgStack`. Fields that are set will be updated. */
export type GqlUserToOrgStackPatch = {
  organizationId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `UserToOrgStack` values. */
export type GqlUserToOrgStacksConnection = {
  __typename?: 'UserToOrgStacksConnection';
  /** A list of edges which contains the `UserToOrgStack` and cursor to aid in pagination. */
  edges: Array<GqlUserToOrgStacksEdge>;
  /** A list of `UserToOrgStack` objects. */
  nodes: Array<Maybe<GqlUserToOrgStack>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UserToOrgStack` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserToOrgStack` edge in the connection. */
export type GqlUserToOrgStacksEdge = {
  __typename?: 'UserToOrgStacksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UserToOrgStack` at the end of the edge. */
  node: Maybe<GqlUserToOrgStack>;
};

/** Methods to use when ordering `UserToOrgStack`. */
export enum UserToOrgStacksOrderBy {
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

/** A connection to a list of `User` values, with data from `Techstack`. */
export type GqlUserUsersByTechstackAddedByAndOwnedByManyToManyConnection = {
  __typename?: 'UserUsersByTechstackAddedByAndOwnedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserUsersByTechstackAddedByAndOwnedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlUserUsersByTechstackAddedByAndOwnedByManyToManyEdge = {
  __typename?: 'UserUsersByTechstackAddedByAndOwnedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByOwnedByConnection: GqlTechstacksConnection;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlUserUsersByTechstackAddedByAndOwnedByManyToManyEdgeTechstacksByOwnedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlUserUsersByTechstackAddedByAndOwnedByManyToManyEdgeTechstacksByOwnedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `User` values, with data from `Techstack`. */
export type GqlUserUsersByTechstackOwnedByAndAddedByManyToManyConnection = {
  __typename?: 'UserUsersByTechstackOwnedByAndAddedByManyToManyConnection';
  /** A list of edges which contains the `User`, info from the `Techstack`, and the cursor to aid in pagination. */
  edges: Array<GqlUserUsersByTechstackOwnedByAndAddedByManyToManyEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlUserUsersByTechstackOwnedByAndAddedByManyToManyEdge = {
  __typename?: 'UserUsersByTechstackOwnedByAndAddedByManyToManyEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedBy: Array<GqlTechstack>;
  /** Reads and enables pagination through a set of `Techstack`. */
  techstacksByAddedByConnection: GqlTechstacksConnection;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlUserUsersByTechstackOwnedByAndAddedByManyToManyEdgeTechstacksByAddedByArgs = {
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy: InputMaybe<Array<TechstacksOrderBy>>;
};


/** A `User` edge in the connection, with data from `Techstack`. */
export type GqlUserUsersByTechstackOwnedByAndAddedByManyToManyEdgeTechstacksByAddedByConnectionArgs = {
  after: InputMaybe<Scalars['Cursor']>;
  before: InputMaybe<Scalars['Cursor']>;
  condition: InputMaybe<GqlTechstackCondition>;
  filter: InputMaybe<GqlTechstackFilter>;
  first: InputMaybe<Scalars['Int']>;
  last: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TechstacksOrderBy>>;
};

/** A connection to a list of `Int` values. */
export type GqlUserWithinOrgConnection = {
  __typename?: 'UserWithinOrgConnection';
  /** A list of edges which contains the `Int` and cursor to aid in pagination. */
  edges: Array<GqlUserWithinOrgEdge>;
  /** A list of `Int` objects. */
  nodes: Array<Maybe<Scalars['Int']>>;
  /** The count of *all* `Int` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Int` edge in the connection. */
export type GqlUserWithinOrgEdge = {
  __typename?: 'UserWithinOrgEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Int` at the end of the edge. */
  node: Maybe<Scalars['Int']>;
};

/** A connection to a list of `User` values. */
export type GqlUsersConnection = {
  __typename?: 'UsersConnection';
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<GqlUsersEdge>;
  /** A list of `User` objects. */
  nodes: Array<Maybe<GqlUser>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `User` edge in the connection. */
export type GqlUsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: Maybe<GqlUser>;
};

/** Methods to use when ordering `User`. */
export enum UsersOrderBy {
  AppMetadataAsc = 'APP_METADATA_ASC',
  AppMetadataDesc = 'APP_METADATA_DESC',
  Auth0IdAsc = 'AUTH0_ID_ASC',
  Auth0IdDesc = 'AUTH0_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  CurrentOrganizationAsc = 'CURRENT_ORGANIZATION_ASC',
  CurrentOrganizationDesc = 'CURRENT_ORGANIZATION_DESC',
  DetailsAsc = 'DETAILS_ASC',
  DetailsDesc = 'DETAILS_DESC',
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  FirstAsc = 'FIRST_ASC',
  FirstDesc = 'FIRST_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IssubscribedAsc = 'ISSUBSCRIBED_ASC',
  IssubscribedDesc = 'ISSUBSCRIBED_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  LastAsc = 'LAST_ASC',
  LastDesc = 'LAST_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TestModeAsc = 'TEST_MODE_ASC',
  TestModeDesc = 'TEST_MODE_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type GqlUsersToOrganization = GqlNode & {
  __typename?: 'UsersToOrganization';
  createdAt: Scalars['Datetime'];
  jobTitle: Maybe<Scalars['Int']>;
  /** Reads a single `Location` that is related to this `UsersToOrganization`. */
  location: Maybe<GqlLocation>;
  locationId: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Organization` that is related to this `UsersToOrganization`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
  role: UserRole;
  status: MemberStatus;
  /** Reads a single `Term` that is related to this `UsersToOrganization`. */
  termByJobTitle: Maybe<GqlTerm>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UsersToOrganization`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UsersToOrganization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlUsersToOrganizationCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `locationId` field. */
  locationId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<UserRole>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<MemberStatus>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UsersToOrganization` object types. All fields are combined with a logical ‘and.’ */
export type GqlUsersToOrganizationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUsersToOrganizationFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `jobTitle` field. */
  jobTitle?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `locationId` field. */
  locationId?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUsersToOrganizationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUsersToOrganizationFilter>>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<GqlUserRoleFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<GqlMemberStatusFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `UsersToOrganization` */
export type GqlUsersToOrganizationInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  jobTitle?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
  role?: InputMaybe<UserRole>;
  status?: InputMaybe<MemberStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['Int'];
};

/** Represents an update to a `UsersToOrganization`. Fields that are set will be updated. */
export type GqlUsersToOrganizationPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  jobTitle?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
  role?: InputMaybe<UserRole>;
  status?: InputMaybe<MemberStatus>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `UsersToOrganization` values. */
export type GqlUsersToOrganizationsConnection = {
  __typename?: 'UsersToOrganizationsConnection';
  /** A list of edges which contains the `UsersToOrganization` and cursor to aid in pagination. */
  edges: Array<GqlUsersToOrganizationsEdge>;
  /** A list of `UsersToOrganization` objects. */
  nodes: Array<Maybe<GqlUsersToOrganization>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UsersToOrganization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UsersToOrganization` edge in the connection. */
export type GqlUsersToOrganizationsEdge = {
  __typename?: 'UsersToOrganizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UsersToOrganization` at the end of the edge. */
  node: Maybe<GqlUsersToOrganization>;
};

/** Methods to use when ordering `UsersToOrganization`. */
export enum UsersToOrganizationsOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  JobTitleAsc = 'JOB_TITLE_ASC',
  JobTitleDesc = 'JOB_TITLE_DESC',
  LocationIdAsc = 'LOCATION_ID_ASC',
  LocationIdDesc = 'LOCATION_ID_DESC',
  Natural = 'NATURAL',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleAsc = 'ROLE_ASC',
  RoleDesc = 'ROLE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlUsersToPracticeGroup = GqlNode & {
  __typename?: 'UsersToPracticeGroup';
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `PracticeGroup` that is related to this `UsersToPracticeGroup`. */
  practiceGroup: Maybe<GqlPracticeGroup>;
  practiceGroupId: Scalars['Int'];
  /** Reads a single `User` that is related to this `UsersToPracticeGroup`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UsersToPracticeGroup` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlUsersToPracticeGroupCondition = {
  /** Checks for equality with the object’s `practiceGroupId` field. */
  practiceGroupId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UsersToPracticeGroup` object types. All fields are combined with a logical ‘and.’ */
export type GqlUsersToPracticeGroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUsersToPracticeGroupFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUsersToPracticeGroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUsersToPracticeGroupFilter>>;
  /** Filter by the object’s `practiceGroupId` field. */
  practiceGroupId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `UsersToPracticeGroup` */
export type GqlUsersToPracticeGroupInput = {
  practiceGroupId: Scalars['Int'];
  userId: Scalars['Int'];
};

/** Represents an update to a `UsersToPracticeGroup`. Fields that are set will be updated. */
export type GqlUsersToPracticeGroupPatch = {
  practiceGroupId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `UsersToPracticeGroup` values. */
export type GqlUsersToPracticeGroupsConnection = {
  __typename?: 'UsersToPracticeGroupsConnection';
  /** A list of edges which contains the `UsersToPracticeGroup` and cursor to aid in pagination. */
  edges: Array<GqlUsersToPracticeGroupsEdge>;
  /** A list of `UsersToPracticeGroup` objects. */
  nodes: Array<Maybe<GqlUsersToPracticeGroup>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UsersToPracticeGroup` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UsersToPracticeGroup` edge in the connection. */
export type GqlUsersToPracticeGroupsEdge = {
  __typename?: 'UsersToPracticeGroupsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UsersToPracticeGroup` at the end of the edge. */
  node: Maybe<GqlUsersToPracticeGroup>;
};

/** Methods to use when ordering `UsersToPracticeGroup`. */
export enum UsersToPracticeGroupsOrderBy {
  Natural = 'NATURAL',
  PracticeGroupIdAsc = 'PRACTICE_GROUP_ID_ASC',
  PracticeGroupIdDesc = 'PRACTICE_GROUP_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlUsersToTechstack = GqlNode & {
  __typename?: 'UsersToTechstack';
  createdAt: Scalars['Datetime'];
  logins: Scalars['Int'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Techstack` that is related to this `UsersToTechstack`. */
  techstack: Maybe<GqlTechstack>;
  techstackId: Scalars['Int'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UsersToTechstack`. */
  user: Maybe<GqlUser>;
  userId: Scalars['Int'];
};

/**
 * A condition to be used against `UsersToTechstack` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GqlUsersToTechstackCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `logins` field. */
  logins?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `techstackId` field. */
  techstackId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against `UsersToTechstack` object types. All fields are combined with a logical ‘and.’ */
export type GqlUsersToTechstackFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlUsersToTechstackFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `logins` field. */
  logins?: InputMaybe<GqlIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlUsersToTechstackFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlUsersToTechstackFilter>>;
  /** Filter by the object’s `techstackId` field. */
  techstackId?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<GqlDatetimeFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<GqlIntFilter>;
};

/** An input for mutations affecting `UsersToTechstack` */
export type GqlUsersToTechstackInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  logins?: InputMaybe<Scalars['Int']>;
  techstackId: Scalars['Int'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId: Scalars['Int'];
};

/** Represents an update to a `UsersToTechstack`. Fields that are set will be updated. */
export type GqlUsersToTechstackPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  logins?: InputMaybe<Scalars['Int']>;
  techstackId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `UsersToTechstack` values. */
export type GqlUsersToTechstacksConnection = {
  __typename?: 'UsersToTechstacksConnection';
  /** A list of edges which contains the `UsersToTechstack` and cursor to aid in pagination. */
  edges: Array<GqlUsersToTechstacksEdge>;
  /** A list of `UsersToTechstack` objects. */
  nodes: Array<Maybe<GqlUsersToTechstack>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `UsersToTechstack` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UsersToTechstack` edge in the connection. */
export type GqlUsersToTechstacksEdge = {
  __typename?: 'UsersToTechstacksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UsersToTechstack` at the end of the edge. */
  node: Maybe<GqlUsersToTechstack>;
};

/** Methods to use when ordering `UsersToTechstack`. */
export enum UsersToTechstacksOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  LoginsAsc = 'LOGINS_ASC',
  LoginsDesc = 'LOGINS_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TechstackIdAsc = 'TECHSTACK_ID_ASC',
  TechstackIdDesc = 'TECHSTACK_ID_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC'
}

export type GqlVendorStackshareLogo = GqlNode & {
  __typename?: 'VendorStackshareLogo';
  id: Scalars['Int'];
  logo: Scalars['String'];
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  order: Scalars['Int'];
  /** Reads a single `Organization` that is related to this `VendorStackshareLogo`. */
  organization: Maybe<GqlOrganization>;
  organizationId: Scalars['UUID'];
};

/**
 * A condition to be used against `VendorStackshareLogo` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GqlVendorStackshareLogoCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `logo` field. */
  logo?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `order` field. */
  order?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `organizationId` field. */
  organizationId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against `VendorStackshareLogo` object types. All fields are combined with a logical ‘and.’ */
export type GqlVendorStackshareLogoFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GqlVendorStackshareLogoFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `logo` field. */
  logo?: InputMaybe<GqlStringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<GqlStringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GqlVendorStackshareLogoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GqlVendorStackshareLogoFilter>>;
  /** Filter by the object’s `order` field. */
  order?: InputMaybe<GqlIntFilter>;
  /** Filter by the object’s `organizationId` field. */
  organizationId?: InputMaybe<GqlUuidFilter>;
};

/** An input for mutations affecting `VendorStackshareLogo` */
export type GqlVendorStackshareLogoInput = {
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
};

/** Represents an update to a `VendorStackshareLogo`. Fields that are set will be updated. */
export type GqlVendorStackshareLogoPatch = {
  id?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  organizationId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `VendorStackshareLogo` values. */
export type GqlVendorStackshareLogosConnection = {
  __typename?: 'VendorStackshareLogosConnection';
  /** A list of edges which contains the `VendorStackshareLogo` and cursor to aid in pagination. */
  edges: Array<GqlVendorStackshareLogosEdge>;
  /** A list of `VendorStackshareLogo` objects. */
  nodes: Array<Maybe<GqlVendorStackshareLogo>>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
  /** The count of *all* `VendorStackshareLogo` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `VendorStackshareLogo` edge in the connection. */
export type GqlVendorStackshareLogosEdge = {
  __typename?: 'VendorStackshareLogosEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `VendorStackshareLogo` at the end of the edge. */
  node: Maybe<GqlVendorStackshareLogo>;
};

/** Methods to use when ordering `VendorStackshareLogo`. */
export enum VendorStackshareLogosOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LogoAsc = 'LOGO_ASC',
  LogoDesc = 'LOGO_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  OrganizationIdAsc = 'ORGANIZATION_ID_ASC',
  OrganizationIdDesc = 'ORGANIZATION_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC'
}

export type GqlUpdateVendorProductMutationVariables = Exact<{
  id: Scalars['Int'];
  excerpt: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlUpdateVendorProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', clientMutationId: string } };

export type GqlCreateProductToVendorMutationVariables = Exact<{
  productId: Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlCreateProductToVendorMutation = { __typename?: 'Mutation', productToVendor: { __typename?: 'CreateProductToOrganizationPayload', clientMutationId: string } };

export type GqlCreateVendorProductMutationVariables = Exact<{
  description: InputMaybe<Scalars['String']>;
  excerpt: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  details: InputMaybe<Scalars['JSON']>;
  testMode: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<ProductType>;
}>;


export type GqlCreateVendorProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'CreateProductPayload', product: { __typename?: 'Product', id: number, slug: string } } };

export type GqlGetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetFeaturesQuery = { __typename?: 'Query', features: Array<{ __typename?: 'Feature', id: number, name: string, nodeId: string, slug: string }> };

export type GqlCreateFeatureMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type GqlCreateFeatureMutation = { __typename?: 'Mutation', createFeature: { __typename?: 'CreateFeaturePayload', feature: { __typename?: 'Feature', id: number } } };

export type GqlDeleteFeatureToProductMutationVariables = Exact<{
  featureId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type GqlDeleteFeatureToProductMutation = { __typename?: 'Mutation', deleteFeatureToProduct: { __typename?: 'DeleteFeatureToProductPayload', clientMutationId: string } };

export type GqlCreateFeatureToProductMutationVariables = Exact<{
  featureId: Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type GqlCreateFeatureToProductMutation = { __typename?: 'Mutation', createFeatureToProduct: { __typename?: 'CreateFeatureToProductPayload', clientMutationId: string } };

export type GqlTermsByTaxonomyIdsQueryVariables = Exact<{
  taxonomyIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GqlTermsByTaxonomyIdsQuery = { __typename?: 'Query', termsByTaxonomyIds: Array<{ __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number }> };

export type GqlCreateCompetitorMutationVariables = Exact<{
  competitorId: Scalars['Int'];
  productId: Scalars['Int'];
  organizationId: InputMaybe<Scalars['UUID']>;
  locked: Scalars['Boolean'];
}>;


export type GqlCreateCompetitorMutation = { __typename?: 'Mutation', createProductToCompetitor: { __typename?: 'CreateProductToCompetitorPayload', clientMutationId: string } };

export type GqlDeleteProductToCompetitorMutationVariables = Exact<{
  productId: Scalars['Int'];
  competitorId: Scalars['Int'];
  locked: Scalars['Boolean'];
}>;


export type GqlDeleteProductToCompetitorMutation = { __typename?: 'Mutation', deleteProductToCompetitor: { __typename?: 'DeleteProductToCompetitorPayload', clientMutationId: string } };

export type GqlOrganizationNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlOrganizationNamesQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: any, name: string }> };

export type GqlCreateProductToClientMutationVariables = Exact<{
  productId: Scalars['Int'];
  clientId: Scalars['UUID'];
}>;


export type GqlCreateProductToClientMutation = { __typename?: 'Mutation', createProductToClient: { __typename?: 'CreateProductToClientPayload', clientMutationId: string } };

export type GqlDeleteProductToClientMutationVariables = Exact<{
  productId: Scalars['Int'];
  clientId: Scalars['UUID'];
}>;


export type GqlDeleteProductToClientMutation = { __typename?: 'Mutation', deleteProductToClient: { __typename?: 'DeleteProductToClientPayload', clientMutationId: string } };

export type GqlCreateProductToTermMutationVariables = Exact<{
  productId: Scalars['Int'];
  termId: Scalars['Int'];
}>;


export type GqlCreateProductToTermMutation = { __typename?: 'Mutation', createTermToProduct: { __typename?: 'CreateTermToProductPayload', clientMutationId: string } };

export type GqlDeleteProductToTermMutationVariables = Exact<{
  productId: Scalars['Int'];
  termId: Scalars['Int'];
}>;


export type GqlDeleteProductToTermMutation = { __typename?: 'Mutation', deleteTermToProduct: { __typename?: 'DeleteTermToProductPayload', clientMutationId: string } };

export type GqlGetPriceTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetPriceTermsQuery = { __typename?: 'Query', terms: Array<{ __typename?: 'Term', id: number, name: string, slug: string }> };

export type GqlCreatePersonalTechstacksMutationVariables = Exact<{
  productIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlCreatePersonalTechstacksMutation = { __typename?: 'Mutation', createPersonalTechstacks: { __typename?: 'CreatePersonalTechstacksPayload', clientMutationId: string } };

export type GqlDeletePersonalTechstacksMutationVariables = Exact<{
  productIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlDeletePersonalTechstacksMutation = { __typename?: 'Mutation', deletePersonalTechstacks: { __typename?: 'DeletePersonalTechstacksPayload', clientMutationId: string } };

export type GqlAddAssocHomeMutationVariables = Exact<{
  organizationId: Scalars['UUID'];
  type: SectionLayoutType;
  order: Scalars['Int'];
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlAddAssocHomeMutation = { __typename?: 'Mutation', createAssocHome: { __typename?: 'CreateAssocHomePayload', assocHome: { __typename?: 'AssocHome', id: number } } };

export type GqlGetAssocHomeQueryVariables = Exact<{
  assocHomeId: Scalars['Int'];
}>;


export type GqlGetAssocHomeQuery = { __typename?: 'Query', assocHomeById: { __typename?: 'AssocHome', id: number, details: any, type: SectionLayoutType, updatedAt: any, createdAt: any, order: number } };

export type GqlAssocHomeSectionsQueryVariables = Exact<{
  organizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlAssocHomeSectionsQuery = { __typename?: 'Query', assocHomes: Array<{ __typename?: 'AssocHome', id: number, details: any, type: SectionLayoutType, updatedAt: any, createdAt: any, order: number }> };

export type GqlDeleteAssocHomeMutationVariables = Exact<{
  assocHomeId: Scalars['Int'];
}>;


export type GqlDeleteAssocHomeMutation = { __typename?: 'Mutation', deleteAssocHomeById: { __typename?: 'DeleteAssocHomePayload', clientMutationId: string } };

export type GqlUpdateAssocHomeMutationVariables = Exact<{
  id: Scalars['Int'];
  details: InputMaybe<Scalars['JSON']>;
  order: InputMaybe<Scalars['Int']>;
}>;


export type GqlUpdateAssocHomeMutation = { __typename?: 'Mutation', updateAssocHomeById: { __typename?: 'UpdateAssocHomePayload', clientMutationId: string } };

export type GqlGetAssocToOrgByOrgIdQueryVariables = Exact<{
  organizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlGetAssocToOrgByOrgIdQuery = { __typename?: 'Query', associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, status: MemberStatus, createdAt: any, updatedAt: any, association: { __typename?: 'Organization', id: any, name: string, slug: string, details: any } }> };

export type GqlCreateAssociationToOrganizationMutationVariables = Exact<{
  associationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  status: InputMaybe<MemberStatus>;
}>;


export type GqlCreateAssociationToOrganizationMutation = { __typename?: 'Mutation', upsertAssociationToOrganization: { __typename?: 'UpsertAssociationToOrganizationPayload', clientMutationId: string } };

export type GqlDeleteAssociationToOrganizationMutationVariables = Exact<{
  associationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
}>;


export type GqlDeleteAssociationToOrganizationMutation = { __typename?: 'Mutation', deleteAssociationToOrganization: { __typename?: 'DeleteAssociationToOrganizationPayload', clientMutationId: string } };

export type GqlGetAssocToOrgQueryVariables = Exact<{
  associationId: InputMaybe<Scalars['UUID']>;
  organizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlGetAssocToOrgQuery = { __typename?: 'Query', associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, status: MemberStatus, createdAt: any, updatedAt: any, association: { __typename?: 'Organization', id: any, name: string, slug: string, details: any } }> };

export type GqlGetAssocToOrgByAssocIdQueryVariables = Exact<{
  associationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlGetAssocToOrgByAssocIdQuery = { __typename?: 'Query', associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', status: MemberStatus, createdAt: any, updatedAt: any, organization: { __typename?: 'Organization', id: any, name: string, type: OrganizationType, domain: string, slug: string, details: any, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', userId: number, status: MemberStatus }> } }> };

export type GqlCreateCertMutationVariables = Exact<{
  orgId: Scalars['UUID'];
  taxName: InputMaybe<Scalars['String']>;
  certNumber: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  expirationDate: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  provider: InputMaybe<Scalars['String']>;
}>;


export type GqlCreateCertMutation = { __typename?: 'Mutation', createDiversityCertification: { __typename?: 'CreateDiversityCertificationPayload', diversityCertification: { __typename?: 'DiversityCertification', id: number } } };

export type GqlGetCertificationsQueryVariables = Exact<{
  orgId: Scalars['UUID'];
}>;


export type GqlGetCertificationsQuery = { __typename?: 'Query', diversityCertifications: Array<{ __typename?: 'DiversityCertification', name: string, provider: string, description: string }> };

export type GqlCurrentOrgFragment = { __typename?: 'Organization', nodeId: string, id: any, slug: string, details: any, name: string, type: OrganizationType, subtype: OrganizationSubtype, domain: string, updatedAt: any, createdAt: any, testMode: boolean, auth0OrgId: string, appMetadata: any, mainTermId: number, associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, association: { __typename?: 'Organization', id: any, name: string, slug: string, details: any } }>, productToOrganizations: Array<{ __typename?: 'ProductToOrganization', product: { __typename?: 'Product', description: string, nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, productToIntegrations: Array<{ __typename?: 'ProductToIntegration', integration: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }>, featureToProducts: Array<{ __typename?: 'FeatureToProduct', feature: { __typename?: 'Feature', id: number, name: string, slug: string, nodeId: string } }>, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', nodeId: string, id: number, name: string, slug: string } } }>, productToClients: Array<{ __typename?: 'ProductToClient', client: { __typename?: 'Organization', id: any, name: string } }>, productToCompetitors: Array<{ __typename?: 'ProductToCompetitor', locked: boolean, competitor: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> } }>, locations: Array<{ __typename?: 'Location', city: string, country: string, id: number, organizationId: any, state: string, isHeadquarter: boolean }>, useCases: Array<{ __typename?: 'UseCase', action: string, id: number, trigger: string, practiceGroup: number, ownerCreated: boolean, details: any, feature: string, product: { __typename?: 'Product', name: string, id: number, slug: string } }>, termToOrganizations: Array<{ __typename?: 'TermToOrganization', nodeId: string, organizationId: any, termId: number, term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number } }>, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } }> };

export type GqlOrgCoreFragment = { __typename?: 'Organization', nodeId: string, id: any, slug: string, details: any, name: string, type: OrganizationType, subtype: OrganizationSubtype, domain: string, updatedAt: any, createdAt: any, testMode: boolean, auth0OrgId: string, appMetadata: any, mainTermId: number };

export type GqlViewerOrgFragment = { __typename?: 'Organization', associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, association: { __typename?: 'Organization', id: any, name: string, slug: string, details: any } }>, productToOrganizations: Array<{ __typename?: 'ProductToOrganization', product: { __typename?: 'Product', description: string, nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, productToIntegrations: Array<{ __typename?: 'ProductToIntegration', integration: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }>, featureToProducts: Array<{ __typename?: 'FeatureToProduct', feature: { __typename?: 'Feature', id: number, name: string, slug: string, nodeId: string } }>, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', nodeId: string, id: number, name: string, slug: string } } }>, productToClients: Array<{ __typename?: 'ProductToClient', client: { __typename?: 'Organization', id: any, name: string } }>, productToCompetitors: Array<{ __typename?: 'ProductToCompetitor', locked: boolean, competitor: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> } }>, locations: Array<{ __typename?: 'Location', city: string, country: string, id: number, organizationId: any, state: string, isHeadquarter: boolean }>, useCases: Array<{ __typename?: 'UseCase', action: string, id: number, trigger: string, practiceGroup: number, ownerCreated: boolean, details: any, feature: string, product: { __typename?: 'Product', name: string, id: number, slug: string } }>, termToOrganizations: Array<{ __typename?: 'TermToOrganization', nodeId: string, organizationId: any, termId: number, term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number } }>, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } }> };

export type GqlProductCoreFragment = { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType };

export type GqlViewerProductFragment = { __typename?: 'Product', description: string, nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, productToIntegrations: Array<{ __typename?: 'ProductToIntegration', integration: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }>, featureToProducts: Array<{ __typename?: 'FeatureToProduct', feature: { __typename?: 'Feature', id: number, name: string, slug: string, nodeId: string } }>, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', nodeId: string, id: number, name: string, slug: string } } }>, productToClients: Array<{ __typename?: 'ProductToClient', client: { __typename?: 'Organization', id: any, name: string } }>, productToCompetitors: Array<{ __typename?: 'ProductToCompetitor', locked: boolean, competitor: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> };

export type GqlTermCoreFragment = { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number };

export type GqlUserCoreFragment = { __typename?: 'User', id: number, first: string, email: string, details: any, createdAt: any, last: string, locationId: number, status: UserStatus, currentOrganization: any, updatedAt: any, testMode: boolean, jobTitle: string, role: number };

export type GqlUserToOrgCoreFragment = { __typename?: 'UsersToOrganization', userId: number, organizationId: any, role: UserRole, jobTitle: number, status: MemberStatus, createdAt: any, updatedAt: any };

export type GqlOrganizationListingQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
  associationId: Scalars['UUID'];
}>;


export type GqlOrganizationListingQuery = { __typename?: 'Query', organizationListing: { __typename?: 'OrganizationListing', description: string, details: any, excerpt: string } };

export type GqlAddRemoveHeadquarterMutationVariables = Exact<{
  oldId: Scalars['Int'];
  newId: Scalars['Int'];
}>;


export type GqlAddRemoveHeadquarterMutation = { __typename?: 'Mutation', oldLocation: { __typename?: 'UpdateLocationPayload', location: { __typename?: 'Location', id: number } }, newLocation: { __typename?: 'UpdateLocationPayload', location: { __typename?: 'Location', id: number } } };

export type GqlCreateLocationMutationVariables = Exact<{
  city: InputMaybe<Scalars['String']>;
  country: InputMaybe<Scalars['String']>;
  state: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  isHeadquarter: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlCreateLocationMutation = { __typename: 'Mutation', createLocation: { __typename: 'CreateLocationPayload', clientMutationId: string, location: { __typename?: 'Location', id: number } } };

export type GqlDeleteLocationMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlDeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: { __typename?: 'DeleteLocationPayload', location: { __typename?: 'Location', city: string, id: number, isHeadquarter: boolean, country: string, state: string } } };

export type GqlGetLocationsQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GqlGetLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', city: string, country: string, id: number, state: string }> };

export type GqlSetHeadquarterMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlSetHeadquarterMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'UpdateLocationPayload', location: { __typename?: 'Location', id: number } } };

export type GqlUpdateLocationMutationVariables = Exact<{
  id: Scalars['Int'];
  city: Scalars['String'];
  state: Scalars['String'];
  country: Scalars['String'];
}>;


export type GqlUpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'UpdateLocationPayload', location: { __typename?: 'Location', city: string, country: string, id: number, isHeadquarter: boolean, state: string } } };

export type GqlCreateNoviOrganizationMutationVariables = Exact<{
  noviId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  status?: InputMaybe<NoviStatus>;
}>;


export type GqlCreateNoviOrganizationMutation = { __typename?: 'Mutation', createNoviOrganization: { __typename?: 'CreateNoviOrganizationPayload', clientMutationId: string } };

export type GqlGetNoviOrganizationQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GqlGetNoviOrganizationQuery = { __typename?: 'Query', noviOrganization: { __typename?: 'NoviOrganization', noviId: any, status: NoviStatus } };

export type GqlViewerCurrentOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlViewerCurrentOrgQuery = { __typename?: 'Query', viewersCurrentOrganization: { __typename?: 'Organization', nodeId: string, id: any, slug: string, details: any, name: string, type: OrganizationType, subtype: OrganizationSubtype, domain: string, updatedAt: any, createdAt: any, testMode: boolean, auth0OrgId: string, appMetadata: any, mainTermId: number, associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, association: { __typename?: 'Organization', id: any, name: string, slug: string, details: any } }>, productToOrganizations: Array<{ __typename?: 'ProductToOrganization', product: { __typename?: 'Product', description: string, nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, productToIntegrations: Array<{ __typename?: 'ProductToIntegration', integration: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }>, featureToProducts: Array<{ __typename?: 'FeatureToProduct', feature: { __typename?: 'Feature', id: number, name: string, slug: string, nodeId: string } }>, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', nodeId: string, id: number, name: string, slug: string } } }>, productToClients: Array<{ __typename?: 'ProductToClient', client: { __typename?: 'Organization', id: any, name: string } }>, productToCompetitors: Array<{ __typename?: 'ProductToCompetitor', locked: boolean, competitor: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> } }>, locations: Array<{ __typename?: 'Location', city: string, country: string, id: number, organizationId: any, state: string, isHeadquarter: boolean }>, useCases: Array<{ __typename?: 'UseCase', action: string, id: number, trigger: string, practiceGroup: number, ownerCreated: boolean, details: any, feature: string, product: { __typename?: 'Product', name: string, id: number, slug: string } }>, termToOrganizations: Array<{ __typename?: 'TermToOrganization', nodeId: string, organizationId: any, termId: number, term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number } }>, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } }> } };

export type GqlUpdateOrgTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  type: OrganizationType;
  subtype: InputMaybe<OrganizationSubtype>;
}>;


export type GqlUpdateOrgTypeMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', organization: { __typename?: 'Organization', id: any } } };

export type GqlCreateOrganizationMutationVariables = Exact<{
  name: InputMaybe<Scalars['String']>;
  type: OrganizationType;
  subtype: InputMaybe<OrganizationSubtype>;
  domain: InputMaybe<Scalars['String']>;
  details: InputMaybe<Scalars['JSON']>;
  testMode: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlCreateOrganizationMutation = { __typename: 'Mutation', createOrganization: { __typename?: 'CreateOrganizationPayload', organization: { __typename?: 'Organization', id: any } } };

export type GqlGetAllOrganizationsQueryVariables = Exact<{
  offset?: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GqlGetAllOrganizationsQuery = { __typename?: 'Query', organizationsConnection: { __typename?: 'OrganizationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Organization', id: any, name: string, slug: string, type: OrganizationType, details: any, domain: string, createdAt: any }> } };

export type GqlGetAllOrganizationsByTypeQueryVariables = Exact<{
  offset?: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type: OrganizationType;
}>;


export type GqlGetAllOrganizationsByTypeQuery = { __typename?: 'Query', organizationsConnection: { __typename?: 'OrganizationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Organization', id: any, name: string, slug: string, type: OrganizationType, details: any, domain: string, createdAt: any }> } };

export type GqlOrganizationByDomainQueryVariables = Exact<{
  domain: InputMaybe<Scalars['String']>;
}>;


export type GqlOrganizationByDomainQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: any, details: any, name: string, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', role: UserRole, status: MemberStatus, userId: number }> }> };

export type GqlOrgVendorStackshareQueryVariables = Exact<{
  orgId: Scalars['UUID'];
}>;


export type GqlOrgVendorStackshareQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, name: string, slug: string, details: any, vendorStackshareLogos: Array<{ __typename?: 'VendorStackshareLogo', id: number, logo: string, name: string, order: number }>, termToVendorStackshares: Array<{ __typename?: 'TermToVendorStackshare', order: number, termId: number, term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number } }> } };

export type GqlGetOrgByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GqlGetOrgByIdQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, name: string, slug: string, type: OrganizationType, details: any, domain: string, createdAt: any, excerpt: string, description: string, testMode: boolean, subtype: OrganizationSubtype, termToOrganizations: Array<{ __typename?: 'TermToOrganization', termId: number, term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, updatedAt: any, createdAt: any, order: number } }>, termToVendorStackshares: Array<{ __typename?: 'TermToVendorStackshare', id: number, order: number, term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number } }>, vendorStackshareLogos: Array<{ __typename?: 'VendorStackshareLogo', id: number, logo: string, name: string, order: number }> } };

export type GqlSuperAdminUpdateOrgMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: InputMaybe<Scalars['String']>;
  excerpt: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  domain: InputMaybe<Scalars['String']>;
  details: InputMaybe<Scalars['JSON']>;
  type: InputMaybe<OrganizationType>;
  subtype: InputMaybe<OrganizationSubtype>;
}>;


export type GqlSuperAdminUpdateOrgMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', organization: { __typename?: 'Organization', id: any } } };

export type GqlUpdateOrganizationMutationVariables = Exact<{
  id: Scalars['UUID'];
  name: InputMaybe<Scalars['String']>;
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlUpdateOrganizationMutation = { __typename: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', organization: { __typename?: 'Organization', id: any } } };

export type GqlUpdateOrgAppMetadataMutationVariables = Exact<{
  appMetadata: InputMaybe<Scalars['JSON']>;
  organizationId: Scalars['UUID'];
}>;


export type GqlUpdateOrgAppMetadataMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'UpdateOrganizationPayload', clientMutationId: string } };

export type GqlSearchOrgsQueryVariables = Exact<{
  searchString: InputMaybe<Scalars['String']>;
  offset: Scalars['Int'];
  type: InputMaybe<OrganizationType>;
  domain: InputMaybe<Scalars['String']>;
}>;


export type GqlSearchOrgsQuery = { __typename?: 'Query', organizationsConnection: { __typename?: 'OrganizationsConnection', totalCount: number, nodes: Array<{ __typename?: 'Organization', details: any, id: any, domain: string, name: string, slug: string, type: OrganizationType, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', userId: number }>, associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any }> }> } };

export type GqlCreateOrgListingMutationVariables = Exact<{
  organizationId: Scalars['UUID'];
  associationId: Scalars['UUID'];
  status: InputMaybe<CompanyListingStatus>;
  type: InputMaybe<Scalars['String']>;
}>;


export type GqlCreateOrgListingMutation = { __typename?: 'Mutation', upsertOrganizationListing: { __typename?: 'UpsertOrganizationListingPayload', clientMutationId: string } };

export type GqlHasOrganizationListingsQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GqlHasOrganizationListingsQuery = { __typename?: 'Query', organizationListings: Array<{ __typename?: 'OrganizationListing', associationId: any, association: { __typename?: 'Organization', slug: string, name: string, details: any, id: any } }> };

export type GqlOrganizationListingByAssocIdQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
  associationId: Scalars['UUID'];
}>;


export type GqlOrganizationListingByAssocIdQuery = { __typename?: 'Query', organizationListings: Array<{ __typename?: 'OrganizationListing', associationId: any, details: any, description: string, excerpt: string, association: { __typename?: 'Organization', slug: string, name: string, details: any, id: any }, organization: { __typename?: 'Organization', details: any, id: any, name: string, slug: string, type: OrganizationType } }> };

export type GqlUpdateShowOrgListingMutationVariables = Exact<{
  show: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['UUID'];
  associationId: Scalars['UUID'];
}>;


export type GqlUpdateShowOrgListingMutation = { __typename?: 'Mutation', updateOrganizationListing: { __typename?: 'UpdateOrganizationListingPayload', clientMutationId: string } };

export type GqlUpsertOrganizationListingMutationVariables = Exact<{
  organizationId: Scalars['UUID'];
  associationId: Scalars['UUID'];
  excerpt: InputMaybe<Scalars['String']>;
  description: InputMaybe<Scalars['String']>;
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlUpsertOrganizationListingMutation = { __typename?: 'Mutation', upsertOrganizationListing: { __typename?: 'UpsertOrganizationListingPayload', clientMutationId: string } };

export type GqlAllProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlAllProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', id: number, excerpt: string, details: any, description: string, createdAt: any, name: string, slug: string, state: ProductState, updatedAt: any }> };

export type GqlCreateEmptyProductMutationVariables = Exact<{
  type?: InputMaybe<ProductType>;
}>;


export type GqlCreateEmptyProductMutation = { __typename?: 'Mutation', createProduct: { __typename?: 'CreateProductPayload', clientMutationId: string } };

export type GqlGetAdminProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetAdminProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'Product', createdAt: any, description: string, details: any, excerpt: string, id: number, slug: string, name: string, state: ProductState, updatedAt: any, testMode: boolean, productToOrganizations: Array<{ __typename?: 'ProductToOrganization', organization: { __typename?: 'Organization', name: string, id: any } }> }> };

export type GqlCreateProductToIntegrationsMutationVariables = Exact<{
  integrationIds: Array<Scalars['Int']> | Scalars['Int'];
  productId: Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlCreateProductToIntegrationsMutation = { __typename?: 'Mutation', createProductToIntegrations: { __typename?: 'CreateProductToIntegrationsPayload', clientMutationId: string } };

export type GqlDeleteProductToIntegrationsMutationVariables = Exact<{
  integrationIds: Array<Scalars['Int']> | Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type GqlDeleteProductToIntegrationsMutation = { __typename?: 'Mutation', deleteProductToIntegrations: { __typename?: 'DeleteProductToIntegrationsPayload', clientMutationId: string } };

export type GqlUpdateVendorProductDetailsMutationVariables = Exact<{
  id: Scalars['Int'];
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlUpdateVendorProductDetailsMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', clientMutationId: string } };

export type GqlGetProductByIdQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type GqlGetProductByIdQuery = { __typename?: 'Query', product: { __typename?: 'Product', description: string, nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, productToIntegrations: Array<{ __typename?: 'ProductToIntegration', integration: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }>, featureToProducts: Array<{ __typename?: 'FeatureToProduct', feature: { __typename?: 'Feature', id: number, name: string, slug: string, nodeId: string } }>, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', nodeId: string, id: number, name: string, slug: string } } }>, productToClients: Array<{ __typename?: 'ProductToClient', client: { __typename?: 'Organization', id: any, name: string } }>, productToCompetitors: Array<{ __typename?: 'ProductToCompetitor', locked: boolean, competitor: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> } };

export type GqlSearchByProductIdQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type GqlSearchByProductIdQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: number, name: string, details: any } };

export type GqlSearchByProductIdsQueryVariables = Exact<{
  productIds: Array<Scalars['Int']> | Scalars['Int'];
}>;


export type GqlSearchByProductIdsQuery = { __typename?: 'Query', productIds: Array<{ __typename?: 'Product', id: number, name: string, details: any }> };

export type GqlToggleShowProductMutationVariables = Exact<{
  productId: Scalars['Int'];
  show: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlToggleShowProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', clientMutationId: string } };

export type GqlUpdateProductDescriptionMutationVariables = Exact<{
  id: Scalars['Int'];
  description: InputMaybe<Scalars['String']>;
}>;


export type GqlUpdateProductDescriptionMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', clientMutationId: string } };

export type GqlUpdateProductStatusMutationVariables = Exact<{
  productId: Scalars['Int'];
  status: InputMaybe<ProductStatus>;
}>;


export type GqlUpdateProductStatusMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', clientMutationId: string } };

export type GqlCreateProductListingMutationVariables = Exact<{
  associationId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
  state?: InputMaybe<ProductState>;
  type: InputMaybe<Scalars['String']>;
}>;


export type GqlCreateProductListingMutation = { __typename?: 'Mutation', createProductListing: { __typename?: 'CreateProductListingPayload', clientMutationId: string } };

export type GqlGetNewProductListingQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GqlGetNewProductListingQuery = { __typename?: 'Query', productListings: Array<{ __typename?: 'ProductListing', id: number, productId: number }> };

export type GqlGetListingsQueryVariables = Exact<{
  organizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlGetListingsQuery = { __typename?: 'Query', productListings: Array<{ __typename?: 'ProductListing', appMetadata: any, id: number, type: string, state: ProductState, show: boolean, association: { __typename?: 'Organization', details: any, id: any, name: string, slug: string }, product: { __typename?: 'Product', id: number, name: string, details: any, type: ProductType, slug: string } }>, organizationListings: Array<{ __typename?: 'OrganizationListing', type: string, status: CompanyListingStatus, show: boolean, association: { __typename?: 'Organization', id: any, name: string, slug: string } }> };

export type GqlOrgProductsQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GqlOrgProductsQuery = { __typename?: 'Query', productToOrganizations: Array<{ __typename?: 'ProductToOrganization', productId: number, product: { __typename?: 'Product', createdAt: any, description: string, details: any, excerpt: string, id: number, name: string, show: boolean, slug: string, state: ProductState, status: ProductStatus, type: ProductType, updatedAt: any, productListings: Array<{ __typename?: 'ProductListing', associationId: any, createdAt: any, details: any, id: number, show: boolean, state: ProductState, type: string, updatedAt: any, theoremPurchaseId: number, connectPurchaseId: number, appMetadata: any, association: { __typename?: 'Organization', auth0OrgId: string, id: any, details: any, name: string, slug: string, subtype: OrganizationSubtype, type: OrganizationType } }> } }> };

export type GqlProductListingQueryVariables = Exact<{
  productListingId: Scalars['Int'];
}>;


export type GqlProductListingQuery = { __typename?: 'Query', productListing: { __typename?: 'ProductListing', details: any, id: number, productId: number, product: { __typename?: 'Product', name: string, slug: string, type: ProductType }, association: { __typename?: 'Organization', name: string } } };

export type GqlProductListingsQueryVariables = Exact<{
  organizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlProductListingsQuery = { __typename?: 'Query', productListings: Array<{ __typename?: 'ProductListing', id: number, type: string, state: ProductState, association: { __typename?: 'Organization', id: any, name: string, slug: string }, product: { __typename?: 'Product', name: string, slug: string, type: ProductType, id: number, details: any } }> };

export type GqlUpdateProductListingMutationVariables = Exact<{
  productListingId: Scalars['Int'];
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlUpdateProductListingMutation = { __typename?: 'Mutation', updateProductListing: { __typename?: 'UpdateProductListingPayload', clientMutationId: string } };

export type GqlUpdateProductListingShowMutationVariables = Exact<{
  id: Scalars['Int'];
  show: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlUpdateProductListingShowMutation = { __typename?: 'Mutation', updateProductListing: { __typename?: 'UpdateProductListingPayload', clientMutationId: string } };

export type GqlCreateProductsToOrganizationMutationVariables = Exact<{
  productIds: Array<Scalars['Int']> | Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlCreateProductsToOrganizationMutation = { __typename?: 'Mutation', createProductsToOrganization: { __typename?: 'CreateProductsToOrganizationPayload', clientMutationId: string } };

export type GqlCreateProductToUserMutationVariables = Exact<{
  productId: Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlCreateProductToUserMutation = { __typename?: 'Mutation', createProductToUser: { __typename?: 'CreateProductToUserPayload', clientMutationId: string } };

export type GqlGetAllRfpsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetAllRfpsQuery = { __typename?: 'Query', rfps: Array<{ __typename?: 'Rfp', createdAt: any, details: any, id: number, rfpToProducts: Array<{ __typename?: 'RfpToProduct', product: { __typename?: 'Product', name: string, id: number, productToOrganizations: Array<{ __typename?: 'ProductToOrganization', organizationId: any }> } }>, termToRfps: Array<{ __typename?: 'TermToRfp', term: { __typename?: 'Term', name: string, id: number, slug: string, taxonomyId: number } }>, user: { __typename?: 'User', email: string, first: string, last: string, id: number, currentOrganization: any } }> };

export type GqlCreateRfpMutationVariables = Exact<{
  details: InputMaybe<Scalars['JSON']>;
  userId: InputMaybe<Scalars['Int']>;
}>;


export type GqlCreateRfpMutation = { __typename?: 'Mutation', createRfp: { __typename?: 'CreateRfpPayload', rfp: { __typename?: 'Rfp', id: number } } };

export type GqlCreateTermsToRfpMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  rfpId: Scalars['Int'];
}>;


export type GqlCreateTermsToRfpMutation = { __typename?: 'Mutation', createTermsToRfp: { __typename?: 'CreateTermsToRfpPayload', clientMutationId: string } };

export type GqlCreateRfpToProductsMutationVariables = Exact<{
  productIds: Array<Scalars['Int']> | Scalars['Int'];
  rfpId: Scalars['Int'];
}>;


export type GqlCreateRfpToProductsMutation = { __typename?: 'Mutation', createRfpToProducts: { __typename?: 'CreateRfpToProductsPayload', clientMutationId: string } };

export type GqlGetTermsQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetTermsQuery = { __typename?: 'Query', terms: Array<{ __typename?: 'Term', id: number, name: string, slug: string }> };

export type GqlCreateTermsToOrganizationMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlCreateTermsToOrganizationMutation = { __typename?: 'Mutation', createTermsToOrganization: { __typename?: 'CreateTermsToOrganizationPayload', clientMutationId: string } };

export type GqlDeleteTermsToOrganizationMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlDeleteTermsToOrganizationMutation = { __typename?: 'Mutation', deleteTermsToOrganization: { __typename?: 'DeleteTermsToOrganizationPayload', clientMutationId: string } };

export type GqlCreateTermsToProductMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type GqlCreateTermsToProductMutation = { __typename?: 'Mutation', createTermsToProduct: { __typename?: 'CreateTermsToProductPayload', clientMutationId: string } };

export type GqlDeleteTermsToProductMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  productId: Scalars['Int'];
}>;


export type GqlDeleteTermsToProductMutation = { __typename?: 'Mutation', deleteTermsToProduct: { __typename?: 'DeleteTermsToProductPayload', clientMutationId: string } };

export type GqlCreateTermsToUserMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlCreateTermsToUserMutation = { __typename?: 'Mutation', createTermsToUser: { __typename?: 'CreateTermsToUserPayload', clientMutationId: string } };

export type GqlDeleteTermsToUserMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlDeleteTermsToUserMutation = { __typename?: 'Mutation', deleteTermsToUser: { __typename?: 'DeleteTermsToUserPayload', clientMutationId: string } };

export type GqlGetTaxonomyTermsQueryVariables = Exact<{
  taxonomyId: Scalars['Int'];
}>;


export type GqlGetTaxonomyTermsQuery = { __typename?: 'Query', terms: Array<{ __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, order: number }> };

export type GqlCreateOrganizationTechstackMutationVariables = Exact<{
  organizationId: Scalars['UUID'];
  productId: Scalars['Int'];
  addedBy: InputMaybe<Scalars['Int']>;
}>;


export type GqlCreateOrganizationTechstackMutation = { __typename?: 'Mutation', createTechstack: { __typename?: 'CreateTechstackPayload', techstack: { __typename?: 'Techstack', id: number, productId: number } } };

export type GqlGetTechstackQueryVariables = Exact<{
  selectedOrganizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlGetTechstackQuery = { __typename?: 'Query', techstacks: Array<{ __typename?: 'Techstack', id: number, metadata: any, access: TechstackAccess, stage: TechstackStage, ownedBy: number, product: { __typename?: 'Product', id: number, details: any, slug: string, name: string, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', id: number, name: string, slug: string, createdAt: any, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }> }, userByAddedBy: { __typename?: 'User', first: string, email: string, last: string, details: any, id: number }, userByOwnedBy: { __typename?: 'User', id: number, details: any, email: string, first: string, last: string } }> };

export type GqlOrganizationTechstackFilterQueryVariables = Exact<{
  selectedOrganizationId: Scalars['UUID'];
  userIds: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type GqlOrganizationTechstackFilterQuery = { __typename?: 'Query', techstackFilter: Array<{ __typename?: 'Techstack', id: number, addedBy: number, access: TechstackAccess, metadata: any, product: { __typename?: 'Product', id: number, name: string, details: any, createdAt: any, slug: string, updatedAt: any, excerpt: string, termToProducts: Array<{ __typename?: 'TermToProduct', termId: number, term: { __typename?: 'Term', taxonomyId: number, id: number, name: string } }>, testDrives: Array<{ __typename?: 'TestDrive', id: number, details: any, termId: number, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }> }> }, usersToTechstacks: Array<{ __typename?: 'UsersToTechstack', user: { __typename?: 'User', id: number, email: string, first: string, last: string, details: any } }> }> };

export type GqlCreateTermToVendorStackshareMutationVariables = Exact<{
  termId: Scalars['Int'];
  organizationId: Scalars['UUID'];
  order: InputMaybe<Scalars['Int']>;
}>;


export type GqlCreateTermToVendorStackshareMutation = { __typename?: 'Mutation', createTermToVendorStackshare: { __typename?: 'CreateTermToVendorStacksharePayload', termToVendorStackshare: { __typename?: 'TermToVendorStackshare', id: number } } };

export type GqlDeleteTermToVendorStackshareMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlDeleteTermToVendorStackshareMutation = { __typename?: 'Mutation', deleteTermToVendorStackshare: { __typename?: 'DeleteTermToVendorStacksharePayload', clientMutationId: string } };

export type GqlOrgInTermToVendorStacksharesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlOrgInTermToVendorStacksharesQuery = { __typename?: 'Query', termToVendorStackshares: Array<{ __typename?: 'TermToVendorStackshare', organizationId: any, organization: { __typename?: 'Organization', id: any, name: string, slug: string, domain: string, details: any } }> };

export type GqlUpdateTermToVendorStackshareMutationVariables = Exact<{
  id: Scalars['Int'];
  termId: InputMaybe<Scalars['Int']>;
  order: InputMaybe<Scalars['Int']>;
}>;


export type GqlUpdateTermToVendorStackshareMutation = { __typename?: 'Mutation', updateTermToVendorStackshare: { __typename?: 'UpdateTermToVendorStacksharePayload', clientMutationId: string } };

export type GqlCreateTermsToTestDriveMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  testDriveId: Scalars['Int'];
}>;


export type GqlCreateTermsToTestDriveMutation = { __typename?: 'Mutation', createTermsToTestDrive: { __typename?: 'CreateTermsToTestDrivePayload', clientMutationId: string } };

export type GqlCreateTestDriveMutationVariables = Exact<{
  productId: Scalars['Int'];
  organizationId: InputMaybe<Scalars['UUID']>;
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlCreateTestDriveMutation = { __typename?: 'Mutation', createTestDrive: { __typename?: 'CreateTestDrivePayload', testDrive: { __typename?: 'TestDrive', id: number } } };

export type GqlDeleteTermsToTestDriveMutationVariables = Exact<{
  termIds: Array<Scalars['Int']> | Scalars['Int'];
  testDriveId: Scalars['Int'];
}>;


export type GqlDeleteTermsToTestDriveMutation = { __typename?: 'Mutation', deleteTermsToTestDrive: { __typename?: 'DeleteTermsToTestDrivePayload', clientMutationId: string } };

export type GqlDeleteTestDriveMutationVariables = Exact<{
  testDriveId: Scalars['Int'];
}>;


export type GqlDeleteTestDriveMutation = { __typename?: 'Mutation', deleteTestDrive: { __typename?: 'DeleteTestDrivePayload', deletedTestDriveNodeId: string } };

export type GqlGetTestDriveQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlGetTestDriveQuery = { __typename?: 'Query', testDrive: { __typename?: 'TestDrive', createdAt: any, id: number, order: number, productId: number, termId: number, updatedAt: any, details: any, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number } }>, product: { __typename?: 'Product', id: number, name: string, slug: string, details: any, excerpt: string, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', taxonomyId: number, id: number, slug: string, nodeId: string } }> }, term: { __typename?: 'Term', id: number, name: string, slug: string } } };

export type GqlGetTestDriveListQueryVariables = Exact<{
  isTestMode: InputMaybe<Scalars['Boolean']>;
}>;


export type GqlGetTestDriveListQuery = { __typename?: 'Query', testDrives: Array<{ __typename?: 'TestDrive', createdAt: any, id: number, order: number, productId: number, termId: number, updatedAt: any, details: any, testMode: boolean, product: { __typename?: 'Product', id: number, name: string, slug: string, details: any, excerpt: string }, term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number }, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }> }> };

export type GqlTestDriveListQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type GqlTestDriveListQuery = { __typename?: 'Query', testDrives: Array<{ __typename?: 'TestDrive', details: any, id: number, createdAt: any, updatedAt: any, product: { __typename?: 'Product', details: any, id: number, name: string, slug: string, excerpt: string, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number } }> }, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', name: string, id: number, slug: string } }> }> };

export type GqlUpdateTestDriveMutationVariables = Exact<{
  id: Scalars['Int'];
  details: InputMaybe<Scalars['JSON']>;
}>;


export type GqlUpdateTestDriveMutation = { __typename?: 'Mutation', updateTestDrive: { __typename?: 'UpdateTestDrivePayload', clientMutationId: string } };

export type GqlDeleteUserMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlDeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserPayload', deletedUserNodeId: string } };

export type GqlGetUserByEmailQueryVariables = Exact<{
  email: InputMaybe<Scalars['String']>;
}>;


export type GqlGetUserByEmailQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: number }> };

export type GqlGetUserQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlGetUserQuery = { __typename?: 'Query', user: { __typename?: 'User', email: string, first: string, last: string, issubscribed: boolean, id: number, details: any, testMode: boolean, usersToTechstacks: Array<{ __typename?: 'UsersToTechstack', logins: number, updatedAt: any, techstack: { __typename?: 'Techstack', id: number, organizationId: any, product: { __typename?: 'Product', name: string, slug: string, details: any, show: boolean, id: number, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', name: string, id: number, taxonomyId: number } }> } } }>, termToUsers: Array<{ __typename?: 'TermToUser', term: { __typename?: 'Term', taxonomyId: number, name: string, id: number } }>, location: { __typename?: 'Location', city: string, country: string, state: string }, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', termByJobTitle: { __typename?: 'Term', name: string, id: number } }>, personalTechstacks: Array<{ __typename?: 'PersonalTechstack', createdAt: any, product: { __typename?: 'Product', name: string, slug: string, details: any, show: boolean, id: number, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', name: string, id: number, taxonomyId: number } }> } }> } };

export type GqlAddTermsToStoryMutationVariables = Exact<{
  terms: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
  story: InputMaybe<Scalars['Int']>;
}>;


export type GqlAddTermsToStoryMutation = { __typename?: 'Mutation', addUserStoryTerms: { __typename?: 'AddUserStoryTermsPayload', clientMutationId: string } };

export type GqlCreateUserStoryMutationVariables = Exact<{
  productId: Scalars['Int'];
  when: Scalars['String'];
  to: Scalars['String'];
  ownerCreated: Scalars['Boolean'];
  organizationId: Scalars['UUID'];
  details: InputMaybe<Scalars['JSON']>;
  userId: Scalars['Int'];
}>;


export type GqlCreateUserStoryMutation = { __typename?: 'Mutation', createUserStory: { __typename?: 'CreateUserStoryPayload', userStory: { __typename?: 'UserStory', id: number } } };

export type GqlDeleteUserStoryMutationVariables = Exact<{
  userStoryId: Scalars['Int'];
}>;


export type GqlDeleteUserStoryMutation = { __typename: 'Mutation', deleteUserStory: { __typename?: 'DeleteUserStoryPayload', clientMutationId: string } };

export type GqlUpdateUserStoryMutationVariables = Exact<{
  id: Scalars['Int'];
  details: InputMaybe<Scalars['JSON']>;
  productId: InputMaybe<Scalars['Int']>;
  to: InputMaybe<Scalars['String']>;
  when: InputMaybe<Scalars['String']>;
  terms: Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>;
}>;


export type GqlUpdateUserStoryMutation = { __typename?: 'Mutation', updateUserStory: { __typename?: 'UpdateUserStoryPayload', clientMutationId: string }, replaceTermToUserStory: { __typename?: 'ReplaceTermToUserStoryPayload', clientMutationId: string } };

export type GqlGetUserStoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetUserStoriesQuery = { __typename?: 'Query', userStories: Array<{ __typename?: 'UserStory', to: string, updatedAt: any, createdAt: any, details: any, id: number, organizationId: any, ownerCreated: boolean, when: string, userByAuthor: { __typename?: 'User', id: number, first: string, last: string, testMode: boolean, details: any }, organization: { __typename?: 'Organization', associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, status: MemberStatus }> }, product: { __typename?: 'Product', id: number, name: string, details: any, slug: string, testMode: boolean }, termToUserStories: Array<{ __typename?: 'TermToUserStory', term: { __typename?: 'Term', id: number, name: string, taxonomyId: number } }> }> };

export type GqlAddUserToOrgMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
  role?: InputMaybe<UserRole>;
  status?: InputMaybe<MemberStatus>;
}>;


export type GqlAddUserToOrgMutation = { __typename?: 'Mutation', upsertUsersToOrganization: { __typename?: 'UpsertUsersToOrganizationPayload', clientMutationId: string } };

export type GqlGetAllTeamQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
  status: InputMaybe<MemberStatus>;
  role: InputMaybe<UserRole>;
}>;


export type GqlGetAllTeamQuery = { __typename?: 'Query', usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } }> };

export type GqlProductFieldsFragment = { __typename?: 'Product', details: any, name: string, id: number, slug: string, excerpt: string, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }>, testDrives: Array<{ __typename?: 'TestDrive', id: number, details: any, termId: number, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }> }> };

export type GqlGetActiveAssocUsersQueryVariables = Exact<{
  organizationId: InputMaybe<Scalars['UUID']>;
}>;


export type GqlGetActiveAssocUsersQuery = { __typename?: 'Query', usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', role: UserRole, jobTitle: number, userId: number, user: { __typename?: 'User', email: string, first: string, id: number, last: string, createdAt: any, updatedAt: any, details: any, testMode: boolean, personalTechstacks: Array<{ __typename?: 'PersonalTechstack', product: { __typename?: 'Product', details: any, name: string, id: number, slug: string, excerpt: string, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }>, testDrives: Array<{ __typename?: 'TestDrive', id: number, details: any, termId: number, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }> }> } }>, usersToTechstacks: Array<{ __typename?: 'UsersToTechstack', techstackId: number, techstack: { __typename?: 'Techstack', productId: number, product: { __typename?: 'Product', details: any, name: string, id: number, slug: string, excerpt: string, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }>, testDrives: Array<{ __typename?: 'TestDrive', id: number, details: any, termId: number, termToTestDrives: Array<{ __typename?: 'TermToTestDrive', term: { __typename?: 'Term', id: number, name: string, slug: string, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', id: number, name: string, slug: string } } }> }> } } }> } }> };

export type GqlCreateUserToOrganizationMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
  role: InputMaybe<UserRole>;
  jobTitle: InputMaybe<Scalars['Int']>;
}>;


export type GqlCreateUserToOrganizationMutation = { __typename?: 'Mutation', createUsersToOrganization: { __typename?: 'CreateUsersToOrganizationPayload', organization: { __typename?: 'Organization', id: any, type: OrganizationType } } };

export type GqlDeleteUsersToOrganizationMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlDeleteUsersToOrganizationMutation = { __typename?: 'Mutation', deleteUsersToOrganization: { __typename?: 'DeleteUsersToOrganizationPayload', clientMutationId: string } };

export type GqlGetInvitedOrgIdsQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GqlGetInvitedOrgIdsQuery = { __typename?: 'Query', usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', organizationId: any, organization: { __typename?: 'Organization', name: string, type: OrganizationType, details: any } }> };

export type GqlGetUserToOrgQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
  userId: Scalars['Int'];
}>;


export type GqlGetUserToOrgQuery = { __typename?: 'Query', usersToOrganization: { __typename?: 'UsersToOrganization', role: UserRole, status: MemberStatus } };

export type GqlMatchUserToOrganizationMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
  locationId: InputMaybe<Scalars['Int']>;
  role: InputMaybe<UserRole>;
  userStatus: InputMaybe<UserStatus>;
}>;


export type GqlMatchUserToOrganizationMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', clientMutationId: string }, createUsersToOrganization: { __typename?: 'CreateUsersToOrganizationPayload', organization: { __typename?: 'Organization', id: any, type: OrganizationType } } };

export type GqlTeamFragmentFragment = { __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } };

export type GqlGetTeamQueryVariables = Exact<{
  first: InputMaybe<Scalars['Int']>;
  offset: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
}>;


export type GqlGetTeamQuery = { __typename?: 'Query', usersToOrganizationsConnection: { __typename?: 'UsersToOrganizationsConnection', totalCount: number, nodes: Array<{ __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, createdAt: any, updatedAt: any, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } }> } };

export type GqlUpdateOrgJobTitleMutationVariables = Exact<{
  jobTitle: InputMaybe<Scalars['Int']>;
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlUpdateOrgJobTitleMutation = { __typename?: 'Mutation', updateUsersToOrganization: { __typename?: 'UpdateUsersToOrganizationPayload', clientMutationId: string } };

export type GqlUpdateMemberStatusMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
  status: InputMaybe<MemberStatus>;
}>;


export type GqlUpdateMemberStatusMutation = { __typename?: 'Mutation', upsertUsersToOrganization: { __typename?: 'UpsertUsersToOrganizationPayload', clientMutationId: string } };

export type GqlUpdateUserRoleMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
  role: InputMaybe<UserRole>;
}>;


export type GqlUpdateUserRoleMutation = { __typename?: 'Mutation', updateUsersToOrganization: { __typename?: 'UpdateUsersToOrganizationPayload', clientMutationId: string } };

export type GqlUpdateUserToOrganizationLocationMutationVariables = Exact<{
  orgId: Scalars['UUID'];
  userId: Scalars['Int'];
  locationId: Scalars['Int'];
}>;


export type GqlUpdateUserToOrganizationLocationMutation = { __typename?: 'Mutation', updateUsersToOrganization: { __typename?: 'UpdateUsersToOrganizationPayload', clientMutationId: string } };

export type GqlCreateUserToTechstackMutationVariables = Exact<{
  userId: Scalars['Int'];
  techstackId: Scalars['Int'];
}>;


export type GqlCreateUserToTechstackMutation = { __typename?: 'Mutation', createUsersToTechstack: { __typename?: 'CreateUsersToTechstackPayload', clientMutationId: string } };

export type GqlCreateUsersToTechstacksMutationVariables = Exact<{
  techstackIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlCreateUsersToTechstacksMutation = { __typename?: 'Mutation', createUsersToTechstacks: { __typename?: 'CreateUsersToTechstacksPayload', clientMutationId: string } };

export type GqlDeleteUsersToTechstacksMutationVariables = Exact<{
  techstackIds: Array<Scalars['Int']> | Scalars['Int'];
  userId: Scalars['Int'];
}>;


export type GqlDeleteUsersToTechstacksMutation = { __typename?: 'Mutation', deleteUsersToTechstacks: { __typename?: 'DeleteUsersToTechstacksPayload', clientMutationId: string } };

export type GqlUpdateLoginsMutationVariables = Exact<{
  logins: Scalars['Int'];
  userId: Scalars['Int'];
  techstackId: Scalars['Int'];
}>;


export type GqlUpdateLoginsMutation = { __typename?: 'Mutation', updateUsersToTechstack: { __typename?: 'UpdateUsersToTechstackPayload', clientMutationId: string } };

export type GqlGetUserToTechstacksQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type GqlGetUserToTechstacksQuery = { __typename?: 'Query', usersToTechstacks: Array<{ __typename?: 'UsersToTechstack', logins: number, techstack: { __typename?: 'Techstack', id: number, product: { __typename?: 'Product', id: number } } }> };

export type GqlCreateVendorStackshareLogoMutationVariables = Exact<{
  logo: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  order: InputMaybe<Scalars['Int']>;
  organizationId: Scalars['UUID'];
}>;


export type GqlCreateVendorStackshareLogoMutation = { __typename?: 'Mutation', createVendorStackshareLogo: { __typename?: 'CreateVendorStackshareLogoPayload', vendorStackshareLogo: { __typename?: 'VendorStackshareLogo', id: number } } };

export type GqlDeleteVendorStackshareLogoMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GqlDeleteVendorStackshareLogoMutation = { __typename?: 'Mutation', deleteVendorStackshareLogo: { __typename?: 'DeleteVendorStackshareLogoPayload', clientMutationId: string } };

export type GqlUpdateVendorStackshareLogoMutationVariables = Exact<{
  id: Scalars['Int'];
  logo: InputMaybe<Scalars['String']>;
  name: InputMaybe<Scalars['String']>;
  order: InputMaybe<Scalars['Int']>;
}>;


export type GqlUpdateVendorStackshareLogoMutation = { __typename?: 'Mutation', updateVendorStackshareLogo: { __typename?: 'UpdateVendorStackshareLogoPayload', clientMutationId: string } };

export type GqlViewerAppMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlViewerAppMetadataQuery = { __typename?: 'Query', viewer: { __typename?: 'User', appMetadata: any } };

export type GqlUpdateUserMutationVariables = Exact<{
  first: InputMaybe<Scalars['String']>;
  last: InputMaybe<Scalars['String']>;
  jobTitle: InputMaybe<Scalars['String']>;
  currentOrganizationId: InputMaybe<Scalars['UUID']>;
  details: InputMaybe<Scalars['JSON']>;
  appMetadata: InputMaybe<Scalars['JSON']>;
  locationId: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
}>;


export type GqlUpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', clientMutationId: string } };

export type GqlSetCurrentOrganizationMutationVariables = Exact<{
  userId: Scalars['Int'];
  organizationId: Scalars['UUID'];
}>;


export type GqlSetCurrentOrganizationMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', clientMutationId: string } };

export type GqlViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlViewerQuery = { __typename?: 'Query', viewer: { __typename?: 'User', appMetadata: any, id: number, first: string, email: string, details: any, createdAt: any, last: string, locationId: number, status: UserStatus, currentOrganization: any, updatedAt: any, testMode: boolean, jobTitle: string, role: number, organizationByCurrentOrganization: { __typename?: 'Organization', nodeId: string, id: any, slug: string, details: any, name: string, type: OrganizationType, subtype: OrganizationSubtype, domain: string, updatedAt: any, createdAt: any, testMode: boolean, auth0OrgId: string, appMetadata: any, mainTermId: number, associationToOrganizations: Array<{ __typename?: 'AssociationToOrganization', associationId: any, association: { __typename?: 'Organization', id: any, name: string, slug: string, details: any } }>, productToOrganizations: Array<{ __typename?: 'ProductToOrganization', product: { __typename?: 'Product', description: string, nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, productToIntegrations: Array<{ __typename?: 'ProductToIntegration', integration: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }>, featureToProducts: Array<{ __typename?: 'FeatureToProduct', feature: { __typename?: 'Feature', id: number, name: string, slug: string, nodeId: string } }>, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number, taxonomy: { __typename?: 'Taxonomy', nodeId: string, id: number, name: string, slug: string } } }>, productToClients: Array<{ __typename?: 'ProductToClient', client: { __typename?: 'Organization', id: any, name: string } }>, productToCompetitors: Array<{ __typename?: 'ProductToCompetitor', locked: boolean, competitor: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> } }>, locations: Array<{ __typename?: 'Location', city: string, country: string, id: number, organizationId: any, state: string, isHeadquarter: boolean }>, useCases: Array<{ __typename?: 'UseCase', action: string, id: number, trigger: string, practiceGroup: number, ownerCreated: boolean, details: any, feature: string, product: { __typename?: 'Product', name: string, id: number, slug: string } }>, termToOrganizations: Array<{ __typename?: 'TermToOrganization', nodeId: string, organizationId: any, termId: number, term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number } }>, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', jobTitle: number, role: UserRole, status: MemberStatus, userId: number, user: { __typename?: 'User', id: number, email: string, details: any, first: string, last: string, updatedAt: any } }> }, location: { __typename?: 'Location', id: number, city: string, country: string, state: string }, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', userId: number, organizationId: any, role: UserRole, jobTitle: number, status: MemberStatus, createdAt: any, updatedAt: any, organization: { __typename?: 'Organization', nodeId: string, id: any, slug: string, details: any, name: string, type: OrganizationType, subtype: OrganizationSubtype, domain: string, updatedAt: any, createdAt: any, testMode: boolean, auth0OrgId: string, appMetadata: any, mainTermId: number, usersToOrganizations: Array<{ __typename?: 'UsersToOrganization', status: MemberStatus, role: UserRole }> } }>, usersToTechstacks: Array<{ __typename?: 'UsersToTechstack', logins: number, updatedAt: any, techstack: { __typename?: 'Techstack', organizationId: any, id: number, product: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType, termToProducts: Array<{ __typename?: 'TermToProduct', term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number } }> } } }>, termToUsers: Array<{ __typename?: 'TermToUser', termId: number, term: { __typename?: 'Term', nodeId: string, id: number, name: string, slug: string, order: number, taxonomyId: number } }>, personalTechstacks: Array<{ __typename?: 'PersonalTechstack', productId: number, product: { __typename?: 'Product', nodeId: string, id: number, name: string, slug: string, details: any, state: ProductState, show: boolean, excerpt: string, updatedAt: any, createdAt: any, testMode: boolean, type: ProductType } }> } };

export type GqlSetUserStatusMutationVariables = Exact<{
  userId: Scalars['Int'];
  status: InputMaybe<UserStatus>;
}>;


export type GqlSetUserStatusMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'UpdateUserPayload', clientMutationId: string } };
